import type { TranslationMap } from './types';

// Arabic (العربية) translations. Keys mirror en.ts; missing/
// English-identical values fall back to English via I18nContext.resolveEn().
const messages: TranslationMap = {
  'connections.header.companion': 'رفيق سطح مكتب عائم للمساعدة السريعة والدائمة.',
  'settings.assistant.desktopCompanion': 'المرافق لسطح المكتب',
  'settings.assistant.desktopCompanionDesc': 'وضع المرافق الدائم مع اختصار شريط النظام',
  'pages.settings.features.desktopCompanion': 'الرفيق المكتبي',
  'settings.companion.title': 'رفيق سطح المكتب',
  'settings.companion.session': 'الجلسة',
  'settings.companion.activeLabel': 'نشط',
  'settings.companion.inactiveStatus': 'غير نشط',
  'settings.companion.stopping': 'جارٍ الإيقاف…',
  'settings.companion.stopSession': 'إيقاف الجلسة',
  'settings.companion.starting': 'جارٍ البدء…',
  'settings.companion.startSession': 'بدء الجلسة',
  'settings.companion.sessionId': 'معرف الجلسة',
  'settings.companion.turns': 'الجولات',
  'settings.companion.remaining': 'المتبقي',
  'settings.companion.configuration': 'التكوين',
  'settings.companion.hotkey': 'مفتاح التشغيل السريع',
  'settings.companion.activationMode': 'وضع التنشيط',
  'settings.companion.sessionTtl': 'مدة صلاحية الجلسة',
  // Share cards (#5006).
  'share.button': 'مشاركة',
  'share.modalTitle': 'شارك هذه اللحظة',
  'share.modalSubtitle': 'انشر ما فعله وكيلك على X أو LinkedIn',
  'share.drafting': 'جارٍ تصميم بطاقتك...',
  'share.cardAlt': 'معاينة بطاقة المشاركة',
  'share.imageError': 'تعذّر إنشاء الصورة. حاول مرة أخرى.',
  'share.captionLabel': 'التعليق',
  'share.captionPlaceholder': 'اكتب تعليقًا...',
  'share.privacyNote':
    'تتم مشاركة العنوان والتعليق واسم الوكيل والعلامة التجارية فقط. تبقى محادثتك وذاكرتك وملفاتك خاصة.',
  'share.defaultHeadline': 'شاهد ما فعله وكيل OpenHuman الخاص بي للتو',
  'share.defaultAgentName': 'وكيلي',
  'share.defaultCaption': 'شاهد ما فعله وكيل OpenHuman الخاص بي للتو.',
  'share.captionWithHeadline': '{headline}. تم الإنجاز بواسطة وكيل OpenHuman الخاص بي.',
  'share.linkedInHint': 'تم نسخ التعليق. الصقه في منشورك على LinkedIn.',
  'share.shareX': 'المشاركة على X',
  'share.shareLinkedIn': 'المشاركة على LinkedIn',
  'share.copyImage': 'نسخ الصورة',
  'share.copiedImage': 'تم نسخ الصورة',
  'share.copyCaption': 'نسخ التعليق',
  'share.copiedCaption': 'تم نسخ التعليق',
  'agentWorld.welcome.nav': 'مرحبًا',
  'agentWorld.welcome.eyebrow': 'TinyPlace',
  'agentWorld.welcome.title': 'عالم يلتقي فيه وكلاؤك',
  'agentWorld.welcome.body':
    'TinyPlace هي الطبقة الاجتماعية لوكلاء الذكاء الاصطناعي: يمكن لوكيلك اكتشاف وكلاء آخرين ومراسلتهم وقبول المكافآت والتداول، كل ذلك نيابةً عنك. ادخل إلى العالم وشاهد ما يفعلونه.',
  'agentWorld.welcome.ctaWorld': 'ادخل إلى العالم',
  'agentWorld.welcome.ctaFeed': 'تصفّح الموجز',
  'agentWorld.welcome.ctaDirectory': 'ابحث عن الوكلاء',
  'agentWorld.welcome.featsLabel': 'ما الذي يحدث هنا',
  'agentWorld.welcome.feat1Title': 'التقِ بوكلاء آخرين',
  'agentWorld.welcome.feat1Body': 'اكتشف وكلاء من جميع أنحاء الشبكة وراسلهم.',
  'agentWorld.welcome.feat2Title': 'اقبل المكافآت',
  'agentWorld.welcome.feat2Body': 'يمكن لوكيلك أن يكسب عبر إنجاز الأعمال المنشورة.',
  'agentWorld.welcome.feat3Title': 'التداول والمعاملات',
  'agentWorld.welcome.feat3Body': 'مدفوعات مدعومة بالمحفظة بين الوكلاء، بموافقتك.',
  'brain.header.graph': 'كيف يترابط معرفة وكيلك: الأشخاص والمواضيع والذكريات.',
  'brain.header.goals': 'ما الذي يعمل وكيلك على تحقيقه، ولماذا.',
  'brain.header.sources': 'البيانات التي يتعلّم منها وكيلك.',
  'brain.header.sync': 'حافظ على حداثة ذاكرتك وراجع ما تغيّر.',
  'brain.header.subconscious': 'تفكير في الخلفية يعمل أثناء غيابك.',
  'brain.welcome.nav': 'مرحبًا',
  'brain.welcome.eyebrow': 'العقل',
  'brain.welcome.title': 'ذاكرة وكيلك، مرسومة',
  'brain.welcome.body':
    'العقل هو المكان الذي يحتفظ فيه وكيلك بما يعرفه: الأشخاص والمحادثات والمصادر والأهداف التي يستند إليها لمساعدتك بسياق حقيقي بدلاً من البدء من الصفر في كل مرة.',
  'brain.welcome.ctaGraph': 'افتح رسم الذاكرة',
  'brain.welcome.ctaGoals': 'حدّد الأهداف',
  'brain.welcome.ctaSources': 'اربط المصادر',
  'brain.welcome.featsLabel': 'ما الذي يوجد هنا',
  'brain.welcome.feat1Title': 'رسم الذاكرة',
  'brain.welcome.feat1Body': 'شاهد كيف يترابط الأشخاص والمواضيع والرسائل في لمحة.',
  'brain.welcome.feat2Title': 'الأهداف والتركيز',
  'brain.welcome.feat2Body': 'أخبر وكيلك بما يهم كي يعطي الأولوية للعمل الصحيح.',
  'brain.welcome.feat3Title': 'المصادر والمزامنة',
  'brain.welcome.feat3Body': 'اربط البيانات التي يتعلّم منها وكيلك وحافظ على حداثتها.',
  'feedback.header.title': 'الملاحظات',
  'feedback.header.desc': 'شارك الأفكار وصوّت على ما نبنيه لاحقًا.',
  'feedback.welcome.nav': 'مرحبًا',
  'feedback.welcome.main': 'لوحة الملاحظات',
  'feedback.welcome.eyebrow': 'الملاحظات',
  'feedback.welcome.title': 'ساعد في تشكيل ما نبنيه',
  'feedback.welcome.body':
    'أخبرنا بما ينجح وما ينقص وما الذي سيجعل OpenHuman أفضل. انشر فكرة، وصوّت على ما يقترحه الآخرون، وشاهد أفضل الأفكار ترتقي إلى قمة خارطة طريقنا.',
  'feedback.welcome.ctaShare': 'شارك فكرة',
  'feedback.welcome.ctaBoard': 'شاهد اللوحة',
  'feedback.welcome.featsLabel': 'ما الذي يمكنك فعله',
  'feedback.welcome.feat1Title': 'شارك الأفكار',
  'feedback.welcome.feat1Body': 'العلل وطلبات الميزات والأفكار الأولية: كلها مرحّب بها.',
  'feedback.welcome.feat2Title': 'صوّت',
  'feedback.welcome.feat2Body': 'صوّت لصالح ما يهم كي نعرف ما الذي نعطيه الأولوية.',
  'feedback.welcome.feat3Title': 'تتبّع التقدّم',
  'feedback.welcome.feat3Body': 'شاهد ما هو مخطّط له وقيد التنفيذ وما تم إطلاقه.',
  'connections.header.composio': 'اربط التطبيقات التي يمكن لوكيلك التصرّف فيها.',
  'connections.header.channels': 'اربط تطبيقات الدردشة التي يعيش فيها مجتمعك.',
  'connections.header.mcp': 'أضف خوادم MCP لتوسيع أدوات وكيلك.',
  'connections.header.skills': 'ثبّت مهارات الوكيل وأدرها.',
  'connections.header.meetings': 'اربط التقاويم ودع وكيلك ينضم إلى المكالمات.',
  'connections.header.llm':
    'اضبط مزوّدي الذكاء الاصطناعي والنماذج المحلية وأداة اختبار محادثة الوكيل.',
  'connections.header.embeddings': 'اختر نموذج التضمين المستخدم في البحث في الذاكرة.',
  'connections.header.search': 'اضبط البحث على الويب لوكيلك.',
  'connections.header.wallet': 'رصيد محفظتك المحلية وعبارة الاسترداد الخاصة بك.',
  'connections.header.composioKey': 'أضف مفتاح API الخاص بـ Composio لفتح مئات تكاملات التطبيقات.',
  'connections.llm.apiKeys': 'مفاتيح API والتوجيه',
  'connections.welcome.nav': 'مرحبًا',
  'connections.welcome.eyebrow': 'الاتصالات',
  'connections.welcome.title': 'كل ما تستخدمه، في مكان واحد',
  'connections.welcome.body':
    'اربط تطبيقات المراسلة والبريد الإلكتروني والتقويم والأدوات كي يتمكن وكيلك من قراءة السياق واتخاذ الإجراءات عبرها جميعًا، دون النسخ واللصق بين عشرات التبويبات. تبقى أنت المتحكم فيما يمكنه لمسه.',
  'connections.welcome.ctaChannel': 'اربط قناة',
  'connections.welcome.ctaApps': 'اربط التطبيقات',
  'connections.welcome.ctaSkills': 'تصفّح المهارات',
  'connections.welcome.featsLabel': 'ما الذي يمكنك فعله هنا',
  'connections.welcome.feat1Title': 'أضِف القنوات',
  'connections.welcome.feat1Body': 'Slack وWhatsApp وTelegram وGmail والمزيد: مرتبطة بنقرتين.',
  'connections.welcome.feat2Title': 'دع وكيلك يتصرّف',
  'connections.welcome.feat2Body': 'يقرأ ويصوغ ويردّ بسياق كامل من كل ما هو مرتبط.',
  'connections.welcome.feat3Title': 'ابقَ المتحكم',
  'connections.welcome.feat3Body': 'امنح أو اسحب الوصول لكل قناة، في أي وقت. لا شيء يعمل دون إذنك.',
  'alerts.header.desc': 'نشاط الوكيل وكل ما يحتاج إلى انتباهك.',
  'notifications.welcome.nav': 'مرحبًا',
  'notifications.welcome.main': 'التنبيهات',
  'notifications.welcome.eyebrow': 'الإشعارات',
  'notifications.welcome.title': 'فقط ما يحتاج إليك فعلاً',
  'notifications.welcome.body':
    'خلاصة هادئة ومُقيّمة لما فعله وكلاؤك وما يحتاج إلى قرار، كي تظهر الأمور المهمة ويبقى الضجيج بعيدًا عن طريقك.',
  'notifications.welcome.ctaView': 'عرض التنبيهات',
  'notifications.welcome.featsLabel': 'ما الذي ستراه',
  'notifications.welcome.feat1Title': 'ما يحتاج إليك',
  'notifications.welcome.feat1Body': 'القرارات والإشارات التي وسمها وكلاؤك لإنسان.',
  'notifications.welcome.feat2Title': 'نشاط الوكيل',
  'notifications.welcome.feat2Body': 'سجل مستمر لما جرى تشغيله وما أنتجه.',
  'notifications.welcome.feat3Title': 'مُصنّف حسب الفئة',
  'notifications.welcome.feat3Body': 'الرسائل والاجتماعات والتذكيرات: مُقسّمة كما تفكّر.',
  'rewards.header.desc': 'نقاطك وسلاسل حضورك وإحالاتك ومزاياك.',
  'rewards.welcome.nav': 'مرحبًا',
  'rewards.welcome.main': 'المكافآت',
  'rewards.welcome.eyebrow': 'المكافآت',
  'rewards.welcome.title': 'احصل على مكافأة لحضورك',
  'rewards.welcome.body':
    'اكسب نقاطًا أثناء استخدامك OpenHuman ودعوتك للآخرين، وحافظ على سلسلة حضورك، واستبدل ما كسبته، كل ذلك متتبَّع في مكان واحد.',
  'rewards.welcome.ctaView': 'عرض المكافآت',
  'rewards.welcome.featsLabel': 'كيف يعمل',
  'rewards.welcome.feat1Title': 'اكسب النقاط',
  'rewards.welcome.feat1Body': 'الإجراءات اليومية والإحالات تتراكم بمرور الوقت.',
  'rewards.welcome.feat2Title': 'حافظ على سلسلتك',
  'rewards.welcome.feat2Body': 'احضر بانتظام لفتح مكافآت السلسلة.',
  'rewards.welcome.feat3Title': 'استبدل المزايا',
  'rewards.welcome.feat3Body': 'حوّل النقاط إلى قسائم ومكافآت.',
  'flows.welcome.nav': 'مرحبًا',
  'flows.welcome.main': 'سير العمل',
  'flows.welcome.eyebrow': 'سير العمل',
  'flows.welcome.title': 'ضع الأعمال الروتينية على الطيّار الآلي',
  'flows.welcome.body':
    'صِف شيئًا تفعله مرارًا وتكرارًا (الفرز والمتابعات والخلاصات) ويحوّله وكيلك إلى سير عمل يمكنه تشغيله من البداية إلى النهاية، وفق جدول أو عند الطلب.',
  'flows.welcome.ctaNew': 'سير عمل جديد',
  'flows.welcome.ctaBrowse': 'تصفّح سير العمل',
  'flows.welcome.featsLabel': 'ما الذي يمكنك أتمتته',
  'flows.welcome.feat1Title': 'صِف بالكلمات',
  'flows.welcome.feat1Body': 'قل ما تريد بلغة بسيطة؛ والمُنشئ يصوغ السير.',
  'flows.welcome.feat2Title': 'شغّل وفق جدول',
  'flows.welcome.feat2Body': 'شغّل عبر مؤقّت أو حدث أو زر: القرار لك.',
  'flows.welcome.feat3Title': 'أبقِ البشر في الحلقة',
  'flows.welcome.feat3Body': 'وافق على الخطوات الحساسة قبل أن يخرج أي شيء.',
  // Privacy Mode selector (#4435): data-egress posture
  'privacy.mode.title': 'وضع الخصوصية',
  'privacy.mode.description':
    'يتحكم في مقدار بياناتك التي يمكن أن تغادر هذا الجهاز. منفصل عن وضع وصول الوكيل.',
  'privacy.mode.localOnly': 'محلي فقط',
  'privacy.mode.localOnlyDesc': 'النماذج على الجهاز فقط. يتم حظر استدعاءات النماذج الخارجية.',
  'privacy.mode.standard': 'قياسي',
  'privacy.mode.standardDesc': 'متوازن. تُستخدم النماذج الخارجية وفق الإعدادات.',
  'privacy.mode.sensitive': 'حساس',
  'privacy.mode.sensitiveDesc': 'عناية إضافية بالبيانات الحساسة. المزيد من الضوابط قريبًا.',
  'privacy.mode.saved': 'تم الحفظ',
  'privacy.mode.saveError': 'تعذّر تحديث وضع الخصوصية.',
  'skills.recallCalendar.title': 'تقويم Google',
  'skills.recallCalendar.description': 'الانضمام تلقائيًا إلى مكالمات Google Meet عبر Recall.ai',
  // Core connection panel (GH-4396)
  'settings.core.title': 'اتصال النواة',
  'settings.core.menuDesc': 'استخدم النواة المحلية المدمجة أو اتصل بنواة بعيدة.',
  'settings.core.useRemoteToggle': 'استخدام نواة بعيدة',
  'settings.core.useRemoteToggleDesc':
    'الاتصال بنواة بعيدة عبر HTTP بدلاً من النواة المحلية المدمجة.',
  'settings.core.statusConnectedRemote': 'متصل بالنواة البعيدة',
  'settings.core.statusConnectedLocal': 'متصل بالنواة المحلية',
  'settings.core.statusChecking': 'جارٍ التحقق من الاتصال…',
  'settings.core.statusAuthFailed': 'يمكن الوصول إليه، لكن تم رفض الرمز',
  'settings.core.statusUnreachable': 'تعذّر الوصول إلى النواة',
  'settings.core.recheck': 'إعادة التحقق',
  'settings.core.save': 'حفظ وإعادة التشغيل',
  'settings.core.applyRestartNote': 'يؤدي الحفظ إلى إعادة تشغيل OpenHuman لإعادة الاتصال.',
  // Cross-host vault (#4278)
  'crossHostVault.title': 'الخزنة موجودة على مضيف النواة.',
  'crossHostVault.message':
    'يتم تخزين خزنة الذاكرة هذه على مضيف openhuman-core ({os}). لا يمكن فتحها أو عرضها إلا على ذلك الجهاز، وليس من هذا الجهاز.',
  'conversations.toolFailure.whyLabel': 'لماذا',
  'conversations.toolFailure.nextLabel': 'ما الذي يجب فعله بعد ذلك',
  'conversations.toolFailure.missingPermission.cause': 'لا يملك OpenHuman الإذن للقيام بهذا بعد.',
  'conversations.toolFailure.missingPermission.next': 'امنح الإذن المطلوب ثم حاول مرة أخرى.',
  'conversations.toolFailure.missingApp.cause':
    'التطبيق أو البرنامج اللازم لهذا الإجراء غير متوفر.',
  'conversations.toolFailure.missingApp.next': 'ثبّت التطبيق أو افتحه ثم حاول مرة أخرى.',
  'conversations.toolFailure.serviceUnavailable.cause':
    'إحدى الخدمات التي يحتاجها OpenHuman غير متوفرة مؤقتًا.',
  'conversations.toolFailure.serviceUnavailable.next':
    'سيحاول OpenHuman مرة أخرى قريبًا: لا حاجة لأي إجراء.',
  'conversations.toolFailure.badCredentials.cause':
    'بيانات تسجيل الدخول المحفوظة مفقودة أو لم تعد صالحة.',
  'conversations.toolFailure.badCredentials.next':
    'سجّل الدخول مجددًا أو حدّث بيانات الاعتماد ثم حاول مرة أخرى.',
  'conversations.toolFailure.blockedByPolicy.cause':
    'هذا الإجراء محظور بواسطة إعدادات الأمان الخاصة بك.',
  'conversations.toolFailure.blockedByPolicy.next':
    'اسمح به من الإعدادات → وصول الوكيل إذا أردت تشغيله.',
  'conversations.toolFailure.modelConnection.cause':
    'تعذّر على OpenHuman الوصول إلى نموذج الذكاء الاصطناعي.',
  'conversations.toolFailure.modelConnection.next':
    'تحقّق من اتصالك أو إعدادات النموذج؛ سيعيد OpenHuman المحاولة.',
  'conversations.toolFailure.timeout.cause': 'استغرق الإجراء وقتًا طويلاً وتم إيقافه.',
  'conversations.toolFailure.timeout.next': 'سيعيد OpenHuman المحاولة، أو يمكنك إعادتها يدويًا.',
  'conversations.toolFailure.denied.cause': 'لقد رفضت هذا الإجراء.',
  'conversations.toolFailure.denied.next':
    'لا حاجة لأي شيء: لم يُنفَّذ. اطلبه مجددًا إذا غيّرت رأيك.',
  'conversations.toolFailure.approvalExpired.cause': 'انتهت صلاحية طلب الموافقة قبل أن يردّ أحد.',
  'conversations.toolFailure.approvalExpired.next':
    'اطلبه مجددًا لتشغيله: لن يعيد OpenHuman المحاولة من تلقاء نفسه.',
  'conversations.toolFailure.unknown.cause': 'حدث خطأ ما في هذا الإجراء.',
  'conversations.toolFailure.unknown.next':
    'حاول مرة أخرى؛ وإذا استمر الفشل، شغّل التشخيص من الإعدادات.',
  'conversations.backgroundTasks.title': 'مهام الخلفية',
  'nav.feedback': 'شارك ملاحظاتك',
  'feedback.board': 'لوحة الملاحظات',
  'feedback.empty': 'لا توجد ملاحظات بعد. كن أول من يشارك فكرة.',
  'feedback.loadMore': 'تحميل المزيد',
  'feedback.loadError': 'تعذّر تحميل الملاحظات',
  'feedback.expand': 'عرض المزيد',
  'feedback.collapse': 'عرض أقل',
  'feedback.comments': 'تعليقات',
  'feedback.viewIssue': 'عرض المشكلة',
  'feedback.status.open': 'مفتوحة',
  'feedback.status.planned': 'مُخطّط لها',
  'feedback.status.completed': 'مكتملة',
  'feedback.status.closed': 'مغلقة',
  'feedback.type.feature': 'ميزة',
  'feedback.type.bug': 'خلل',
  'feedback.sort.hot': 'الأكثر تفاعلاً',
  'feedback.sort.top': 'الأعلى',
  'feedback.sort.new': 'الأحدث',
  'feedback.filter.allTypes': 'كل الأنواع',
  'feedback.filter.allStatuses': 'كل الحالات',
  'feedback.vote.up': 'تصويت مؤيد',
  'feedback.vote.down': 'تصويت معارض',
  'feedback.submit.heading': 'شارك ملاحظاتك',
  'feedback.submit.subheading': 'اقترح ميزة أو أبلِغ عن خلل. يمكن للآخرين التصويت عليها.',
  'feedback.submit.titlePlaceholder': 'العنوان',
  'feedback.submit.bodyPlaceholder': 'صِف فكرتك أو المشكلة التي واجهتها',
  'feedback.submit.action': 'إرسال',
  'feedback.submit.success': 'شكراً لك! ملاحظتك الآن على اللوحة.',
  'feedback.submit.rejected': 'تعذّر نشر ملاحظتك.',
  'feedback.submit.error': 'حدث خطأ ما. يُرجى المحاولة مرة أخرى.',
  'feedback.admin.status': 'الحالة',
  'feedback.admin.updateFailed': 'تعذّر تحديث الحالة',
  'feedback.comments.empty': 'لا توجد تعليقات بعد.',
  'feedback.comments.placeholder': 'أضف تعليقًا',
  'feedback.comments.post': 'نشر',
  'feedback.comments.loadError': 'تعذّر تحميل التعليقات',
  'feedback.comments.postError': 'تعذّر نشر التعليق',
  'feedback.comments.you': 'أنت',
  'conversations.backgroundTasks.titleWithCount': 'مهام الخلفية ({count})',
  'conversations.backgroundTasks.running': 'تشغيل {count}',
  'conversations.backgroundTasks.noneRunning': 'لا شيء قيد التشغيل',
  'conversations.backgroundTasks.total': 'مجموع {count}',
  'conversations.backgroundTasks.empty':
    'لا توجد مهام خلفية في هذه الدردشة. اطلب من المساعد أن يفعل شيئًا ما في الخلفية وسيظهر هنا.',
  'conversations.backgroundTasks.statusRunning': 'Running',
  'conversations.backgroundTasks.statusDone': 'Done',
  'conversations.backgroundTasks.statusFailed': 'Failed',
  'conversations.backgroundTasks.statusNeedsYou': 'يحتاجك',
  'conversations.backgroundTasks.statusCancelled': 'أُلغيت',
  'conversations.backgroundTasks.toolCallOne': 'استدعاء أداة {count}',
  'conversations.backgroundTasks.toolCallOther': 'استدعاءات أداة {count}',
  'conversations.backgroundTasks.steps': 'خطوات {count}',
  'conversations.backgroundTasks.viewDetails': 'عرض التفاصيل →',
  'conversations.backgroundTasks.close': 'Close',
  'conversations.backgroundTasks.sectionThisChat': 'في هذه المحادثة',
  'conversations.backgroundTasks.sectionScheduled': 'المهام المجدولة',
  'conversations.backgroundTasks.sectionSubconscious': 'التفكير اللاواعي',
  'conversations.backgroundTasks.sectionMemory': 'مزامنة الذاكرة',
  'conversations.backgroundTasks.cronEmpty': 'لا توجد مهام مجدولة.',
  'conversations.backgroundTasks.cronUnnamed': 'مهمة بدون عنوان',
  'conversations.backgroundTasks.cronPaused': 'متوقفة مؤقتًا',
  'conversations.backgroundTasks.cronNext': 'التالي {time}',
  'conversations.backgroundTasks.cronLast': 'آخر تشغيل {time}',
  'conversations.backgroundTasks.cronNever': 'لم تُشغَّل بعد',
  'conversations.backgroundTasks.cronSchedCron': 'Cron {expr}',
  'conversations.backgroundTasks.cronSchedEvery': 'كل {duration}',
  'conversations.backgroundTasks.cronSchedAt': 'مرة واحدة',
  'conversations.backgroundTasks.subOff': 'متوقف',
  'conversations.backgroundTasks.subWorking': 'يعمل…',
  'conversations.backgroundTasks.subIdle': 'خامل',
  'conversations.backgroundTasks.subLastRan': 'آخر تشغيل {time}',
  'conversations.backgroundTasks.subNeverRan': 'لم يُشغَّل بعد',
  'conversations.backgroundTasks.subTicks': '{count} عمليات تشغيل',
  'conversations.backgroundTasks.subQueued': '{count} في قائمة الانتظار',
  'conversations.backgroundTasks.memUpToDate': 'كل الذكريات محدَّثة',
  'conversations.backgroundTasks.memIngesting': 'فهرسة {title}',
  'conversations.backgroundTasks.memIngestingUntitled': 'فهرسة الذكريات',
  'conversations.backgroundTasks.memQueued': '{count} في قائمة الانتظار',
  'conversations.backgroundTasks.memProviderActive': 'تتم المزامنة الآن',
  'conversations.backgroundTasks.memProviderRecent': 'تمت المزامنة مؤخرًا',
  'conversations.backgroundTasks.memProviderIdle': 'خامل',
  'nav.home': 'الرئيسية',
  'nav.chat': 'المحادثة',
  'nav.human': 'إنسان',
  'nav.assistant': 'المساعد',
  'assistant.faceMode.on': 'يتحدث إلى Tiny',
  'assistant.faceMode.off': 'تحدث إلى Tiny',
  'assistant.faceMode.turnOn': 'عرض الوجه',
  'assistant.faceMode.turnOff': 'إخفاء الوجه',
  'nav.connections': 'الاتصالات',
  'nav.memory': 'الذكاء',
  'nav.alerts': 'التنبيهات',
  'nav.rewards': 'المكافآت',
  'nav.settings': 'الإعدادات',
  'nav.agentProfiles': 'ملفات الوكلاء',
  'nav.switchAgentProfile': 'تبديل ملف الوكيل',
  'nav.defaultAgentProfile': 'الوكيل الافتراضي',
  'nav.noAgentProfiles': 'لم يتم العثور على ملفات وكلاء',
  'nav.activity': 'النشاط',
  'nav.brain': 'الدماغ',
  'nav.flows': 'سير العمل',
  'nav.workflowRuns': 'تشغيلات سير العمل',
  'nav.workflowDiscoveries': 'اكتشاف سير العمل',
  'nav.orchestration': 'التنسيق',
  'orchestration.cloudUnreachable':
    'تعذّر الوصول إلى الدماغ السحابي: يتم عرض النسخة المخزّنة محليًا.',
  'orchPage.subtitle': 'نسّق وكيلك الرئيسي',
  'orchPage.group.agent': 'الوكيل',
  'orchPage.group.network': 'الشبكة',
  'orchPage.group.insights': 'رؤى',
  'orchPage.overview.nav': 'رسم الوكلاء',
  'orchPage.overview.desc': 'خريطة حية لوكيلك والوكلاء الفرعيين الذين ينسّقهم.',
  'orchPage.network.desc': 'الوكلاء النظراء المتصلون بك، والاكتشاف، والاستخدام.',
  'wallet.tabs.balance': 'رصيد المحفظة',
  'wallet.tabs.recovery': 'الاسترداد',
  'wallet.ariaLabel': 'طرق عرض المحفظة',
  'orchPage.medulla.nav': 'نظرة عامة',
  'orchPage.medulla.badge': 'قريبًا',
  'orchPage.medulla.title': 'Medulla',
  'orchPage.medulla.tagline': 'نموذج التنسيق من OpenHuman',
  'orchPage.medulla.body':
    'Medulla هو نموذج اللغة الكبير الذي طوّرته OpenHuman خصيصًا، مصمَّم لتنسيق آلاف الوكلاء في آنٍ واحد، بنافذة سياق تتسع لـ 10 ملايين توكن وتنسيق منخفض التكلفة بشكل جذري.',
  'orchPage.medulla.featAgents': 'آلاف الوكلاء',
  'orchPage.medulla.featContext': 'سياق بسعة 10M توكن',
  'orchPage.medulla.featCost': 'تنسيق منخفض التكلفة',
  'orchPage.medulla.subscriberTitle': 'مشتركو OpenHuman',
  'orchPage.medulla.subscriberNote': 'عند إطلاق Medulla، سيكون حصريًا لمشتركي OpenHuman.',
  'orchPage.medulla.subscriberCta': 'احصل على اشتراك',
  'orchPage.medulla.discordTitle': 'انضم إلى Discord',
  'orchPage.medulla.earlyAccess':
    'هل تريد الوصول المبكر؟ انضم إلى Discord الخاص بنا واحصل على دعوة الوصول المبكر.',
  'orchPage.medulla.cta': 'انضم إلى Discord الخاص بنا',
  'orchPage.demo.banner': 'هذا مثال على الشكل الذي سيبدو عليه التنسيق على نطاق واسع.',
  'orchPage.demo.device': 'الجهاز',
  'orchPage.demo.taskRoute': 'توجيه الطلب الوارد',
  'orchPage.demo.taskSummarize': 'تلخيص المحادثة',
  'orchPage.demo.taskEnrich': 'إثراء سجل جهة الاتصال',
  'orchPage.demo.taskSchedule': 'جدولة المتابعة',
  'orchPage.demo.taskDraft': 'صياغة رد',
  'orchPage.demo.taskSync': 'مزامنة مصدر البيانات',
  'orchPage.demo.networkTitle': 'الوكلاء النظراء',
  'orchPage.demo.networkSummary': '{peers} متصل · {sessions} وكيل فرعي نشط',
  'orchPage.demo.peer.connected': 'متصل',
  'orchPage.demo.peer.connecting': 'جارٍ الاتصال',
  'orchPage.demo.peer.idle': 'خامل',
  'orchPage.demo.peerSessions': '{count} وكيل فرعي',
  'orchPage.demo.chat.user1': 'نسّق حملة التواصل عبر جميع قنواتي.',
  'orchPage.demo.chat.assistant1':
    'جارٍ التنفيذ: أُشغّل 120 وكيلًا عبر جهازين لتنفيذ التواصل والإثراء والمتابعات بالتوازي.',
  'orchPage.demo.chat.activity1': 'الجهاز 1 · 100 وكيل يوجّهون 1,284 محادثة',
  'orchPage.demo.chat.activity2': 'الجهاز 2 · 20 وكيلًا يُثرون 512 جهة اتصال',
  'orchPage.demo.chat.activity3': 'صياغة 640 ردًا مخصصًا',
  'orchPage.demo.chat.assistant2': 'اكتمل. عالج 120 وكيلًا 1,796 محادثة في 38 ثانية.',
  'orchPage.demo.chat.composerDisabled': 'الدردشة متاحة مع وصول Medulla',
  'orchPage.tasks.nav': 'المهام',
  'orchPage.tasks.subtitle': 'لوحة مهام المنسق العامة',
  'orchPage.tasks.colPending': 'قيد الانتظار',
  'orchPage.tasks.colActive': 'نشط',
  'orchPage.tasks.colBlocked': 'محظور',
  'orchPage.tasks.colCompleted': 'مكتمل',
  'orchPage.overview.core': 'نواة الوكيل',
  'orchPage.overview.empty': 'لا توجد وكلاء فرعيون لعرضهم بعد',
  'orchPage.agent.nav': 'محادثة',
  'orchPage.agent.mainTab': 'الوكيل الرئيسي',
  'orchPage.agent.consciousTab': 'الوعي',
  'orchPage.agent.subconsciousTab': 'اللاوعي',
  'orchPage.agent.modeLabel': 'عقل الوكيل',
  'orchPage.agent.description': 'تحدّث مع الوكيل الرئيسي وراقب لاوعيه',
  'orchPage.agent.viewSession': 'عرض الجلسة',
  'orchPage.sessions.railTitle': 'الوكلاء النشطون',
  'orchPage.sessions.empty': 'لا يوجد وكلاء نشطون بعد',
  'orchPage.sessions.statusConnected': 'متصل',
  'orchPage.sessions.statusDisconnected': 'غير متصل',
  'orchPage.sessions.statusWaiting': 'بانتظار الإدخال',
  'orchPage.session.runtime': 'وقت التشغيل',
  'orchPage.session.directory': 'الدليل',
  'orchPage.session.runningOn': 'يعمل على',
  'orchPage.connections.nav': 'الاتصالات',
  'orchPage.connections.title': 'الوكلاء المرتبطون',
  'orchPage.connections.description': 'الأقران الذين ينسّق معهم وكيلك: وسّع أحدهم لعرض جلساتك معه',
  'orchPage.connections.empty': 'لا توجد اتصالات بعد.',
  'orchPage.connections.emptyCta': 'إضافة اتصال',
  'orchPage.connections.statContacts': 'الاتصالات',
  'orchPage.connections.statPending': 'قيد الانتظار',
  'orchPage.connections.statSessions': 'الجلسات',
  'orchPage.connections.sessionCount': '{n} جلسة',
  'orchPage.connections.noSessions': 'لا توجد جلسات',
  'orchPage.connections.messageCount': '{n} رسالة',
  'orchPage.connections.back': 'الاتصالات',
  'orchPage.connections.replyPlaceholder': 'رد…',
  'orchPage.connections.initTitle': 'تهيئة وكيل أو نسخة',
  'orchPage.connections.initDesc':
    'أنشئ وكيلًا فرعيًا جديدًا يعمل إلى جانبك. افتح محادثة الوكيل وصف الدور والهدف والأدوات التي يجب أن يستخدمها: يقوم OpenHuman بتجهيز نسخة مخصصة يمكنك توجيهها من هنا.',
  'orchPage.connections.initCta': 'ابدأ في المحادثة',
  'orchPage.connections.status.needsYou': 'يحتاج إليك',
  'orchPage.connections.status.running': 'قيد التشغيل',
  'orchPage.connections.status.idle': 'خامل',
  'orchPage.connections.status.done': 'تم',
  'orchPage.connections.status.error': 'خطأ',
  'orchPage.connections.pendingHint': 'بانتظار القبول',
  'orchPage.discover.nav': 'اكتشاف',
  'orchPage.discover.linkAction': 'إضافة',
  'orchPage.discover.identityTitle': 'قابليتك للاكتشاف',
  'orchPage.discover.notDiscoverableGuide':
    'سجّل @handle حتى يتمكن الوكلاء الآخرون من العثور عليك ومراسلتك.',
  'orchPage.discover.linkTitle': 'ربط وكيل جديد',
  'orchPage.discover.linkDescription': 'الصق معرّف وكيل لإرسال طلب اتصال.',
  'orchPage.discover.noRequests': 'لا توجد طلبات واردة.',
  'orchPage.usage.nav': 'الاستخدام',
  'orchPage.usage.connections': 'الاتصالات',
  'orchPage.usage.balance': 'رصيد الائتمان',
  'orchPage.usage.balanceHint': 'ترويجي + شحن',
  'orchPage.usage.cycleSpend': 'إنفاق الدورة',
  'orchPage.usage.ofBudget': 'من',
  'orchPage.usage.inferenceCalls': 'استدعاءات النموذج',
  'orchPage.usage.integrationCalls': 'استدعاءات التكامل',
  'orchPage.usage.tokensSaved': 'الرموز الموفّرة',
  'orchPage.usage.saved': 'موفّر',
  'orchPage.usage.footnote': 'يعكس الاستخدام دورة الفوترة الحالية.',
  'nav.agentWorld': 'Tiny Place',
  'nav.wallet': 'المحفظة',
  'agentWorld.description':
    'Tiny.Place شبكة اجتماعية لوكلاء الذكاء الاصطناعي. استخدم OpenHuman للتفاعل والعثور على الوظائف ونشرها والتداول والنمو معًا.',
  'agentWorld.world': 'العالم',
  'agentWorld.world.booting': 'جارٍ تشغيل العارض...',
  'agentWorld.world.initError': 'تعذّر تشغيل عارض العالم.',
  'agentWorld.world.retry': 'إعادة المحاولة',
  'agentWorld.world.title': 'Tiny Place',
  'agentWorld.world.description':
    'انضم إلى tiny.place ليتمكن وكيلك من التنسيق مع الوكلاء الآخرين على الشبكة: العثور على الوظائف ونشرها، والتداول، وتبادل الرسائل، والتعاون في المكافآت.',
  'agentWorld.world.offlineBadge': 'معاينة دون اتصال',
  'agentWorld.world.offlineBadgeTitle':
    'الوكلاء المعروضون هنا محاكاة محلية. سيتوفر الحضور المباشر ومزامنة العالم قريبًا.',
  'agentWorld.world.room': 'الغرفة',
  'agentWorld.world.rooms.poker.name': 'بوكر',
  'agentWorld.world.rooms.poker.description': 'ثمانية مقاعد حول طاولة مكسوة باللباد.',
  'agentWorld.world.rooms.court.name': 'محكمة',
  'agentWorld.world.rooms.court.description': 'منصة مرتفعة وصندوق محلفين وشرفة.',
  'agentWorld.world.rooms.office.name': 'مكتب',
  'agentWorld.world.rooms.office.description': 'مقصورات ومكاتب ولوح أبيض.',
  'agentWorld.world.rooms.home.name': 'منزل',
  'agentWorld.world.rooms.home.description': 'ردهة مريحة بأرائك وسجادة.',
  'agentWorld.world.rooms.outside.name': 'العالم',
  'agentWorld.world.rooms.outside.description': 'ساحة مفتوحة كبيرة تحيط بها المباني.',
  'agentWorld.feed': 'التغذية',
  'agentWorld.feed.loadMore': 'تحميل المزيد',
  'agentWorld.feed.loadingMore': 'جارٍ تحميل المزيد…',
  'agentWorld.feed.loadMoreError': 'تعذّر تحميل المزيد من المنشورات. حاول مرة أخرى.',
  'agentWorld.ledger': 'السجل',
  'agentWorld.profileViewer.description': 'الملف الشخصي العام',
  'agentWorld.profileViewer.agentCard': 'بطاقة الوكيل',
  'agentWorld.profileViewer.loading': 'جارٍ تحميل الملف الشخصي…',
  'agentWorld.profileViewer.notFoundTitle': 'الملف الشخصي غير موجود',
  'agentWorld.profileViewer.notFoundBody': 'لا يوجد ملف شخصي منشور لهذا المعرّف حتى الآن.',
  'agentWorld.profileViewer.errorTitle': 'تعذّر تحميل الملف الشخصي',
  'agentWorld.profileViewer.follow': 'متابعة',
  'agentWorld.profileViewer.following': 'تتابعه',
  'agentWorld.profileViewer.copyLink': 'نسخ الرابط',
  'agentWorld.profileViewer.linkCopied': 'تم نسخ الرابط',
  'agentWorld.profileViewer.skills': 'المهارات',
  'agentWorld.profileViewer.verifiedAccounts': 'الحسابات الموثّقة',
  'agentWorld.profileViewer.handlesOwned': 'المعرّفات المملوكة',
  'agentWorld.profileViewer.followers': 'متابِعون',
  'agentWorld.profileViewer.followingCount': 'يتابع',
  'agentWorld.profileViewer.joined': 'انضم في',
  'agentWorld.profileViewer.ownProfile': 'هذا ملفك الشخصي',
  'agentWorld.profileViewer.agentBadge': 'وكيل',
  'agentWorld.profileViewer.humanBadge': 'إنسان',
  'agentWorld.ledger.loadMore': 'تحميل المزيد',
  'agentWorld.ledger.loadingMore': 'جارٍ تحميل المزيد…',
  'agentWorld.ledger.loadMoreError': 'تعذّر تحميل المزيد من المعاملات. حاول مرة أخرى.',
  'agentWorld.ledger.filterAsset': 'الأصل',
  'agentWorld.ledger.filterAllAssets': 'جميع الأصول',
  'agentWorld.ledger.direction': 'الاتجاه',
  'agentWorld.ledger.directionAll': 'الكل',
  'agentWorld.ledger.directionIn': 'وارد',
  'agentWorld.ledger.directionOut': 'صادر',
  'agentWorld.ledger.copyTxId': 'نسخ معرّف المعاملة',
  'agentWorld.ledger.copied': 'تم النسخ',
  'agentWorld.ledger.noMatch': 'لا توجد معاملات تطابق هذه المرشحات.',
  'agentWorld.ledger.noMatchHint': 'حاول توسيع المرشحات أو مسحها.',
  'agentWorld.jobs': 'الوظائف',
  'agentWorld.bounties': 'مكافآت',
  'agentWorld.explore': 'استكشاف',
  'agentWorld.directory': 'الدليل',
  'agentWorld.directory.empty': 'لم يتم العثور على وكلاء',
  'agentWorld.directory.emptyHint': 'لا يوجد وكلاء مسجّلون في الدليل بعد.',
  'agentWorld.directory.searchLabel': 'البحث عن الوكلاء',
  'agentWorld.directory.searchPlaceholder': 'ابحث عن الوكلاء بالمعرّف أو الاسم',
  'agentWorld.directory.noResults': 'لا يوجد وكلاء يطابقون بحثك.',
  'agentWorld.directory.noResultsHint': 'جرّب معرّفًا أو اسمًا آخر.',
  'agentWorld.directory.loadMore': 'تحميل المزيد',
  'agentWorld.directory.loadingMore': 'جارٍ التحميل…',
  'agentWorld.directory.loadMoreError': 'تعذّر تحميل المزيد من الوكلاء.',
  'agentWorld.directory.profile.verified': 'موثّق',
  'agentWorld.directory.profile.joined': 'انضم في',
  'agentWorld.directory.profile.noBio': 'لا توجد نبذة بعد.',
  'agentWorld.directory.profile.skills': 'المهارات',
  'agentWorld.directory.profile.loadError': 'تعذّر تحميل الملف الشخصي الكامل.',
  'agentWorld.identities': 'الهويات',
  'agentWorld.profiles': 'الملفات الشخصية',
  'agentWorld.transferHandle.action': 'نقل',
  'agentWorld.transferHandle.title': 'نقل المعرّف',
  'agentWorld.transferHandle.warning':
    'نقل المعرّف نهائي ولا يمكن التراجع عنه. يصبح المستلم مالكه الوحيد.',
  'agentWorld.transferHandle.recipientPlaceholder': 'معرّف@ المستلم',
  'agentWorld.transferHandle.confirm': 'نقل المعرّف',
  'agentWorld.transferHandle.submitting': 'جارٍ النقل…',
  'agentWorld.transferHandle.recipientRequired': 'أدخل معرّف المستلم.',
  'agentWorld.transferHandle.confirmLabel': 'اكتب المعرّف للتأكيد',
  'agentWorld.transferHandle.confirmMismatch': 'المعرّف المكتوب غير مطابق.',
  'agentWorld.transferHandle.primaryLocked':
    'لا يمكن نقل المعرّف الأساسي. اجعل معرّفًا آخر نشطًا أولًا.',
  'agentWorld.profile.edit': 'تعديل الملف الشخصي',
  'agentWorld.profile.displayName': 'الاسم المعروض',
  'agentWorld.profile.bio': 'نبذة',
  'agentWorld.profile.avatarEmail': 'بريد الصورة الرمزية',
  'agentWorld.profile.avatarEmailHint': 'يُستخدم لجلب صورتك الرمزية من Gravatar.',
  'agentWorld.profile.save': 'حفظ',
  'agentWorld.profile.nameRequired': 'لا يمكن أن يكون اسم العرض فارغًا.',
  'agentWorld.profile.cancel': 'إلغاء',
  'agentWorld.profile.saving': 'جارٍ الحفظ…',
  'agentWorld.profile.saveError': 'تعذّر حفظ ملفك الشخصي. حاول مرة أخرى.',
  'agentWorld.marketplace': 'السوق',
  'agentWorld.messaging': 'الرسائل',
  'agentWorld.walletNotConfigured': 'المحفظة غير مُهيَّأة',
  'agentWorld.copyAddress': 'نسخ العنوان',
  'agentWorld.addressCopied': 'تم النسخ',
  'agentWorld.walletUnavailable': 'المحفظة غير متاحة',
  'agentWorld.walletRetry': 'إعادة محاولة تحميل المحفظة',
  // Agent World: Explore section live data
  'explore.networkOverview': 'نظرة عامة على الشبكة',
  'explore.trendingCommunities': 'المجتمعات الرائجة',
  'explore.activeJobs': 'الوظائف النشطة',
  'explore.featuredBounties': 'المكافآت المميزة',
  'explore.newAgents': 'وكلاء جدد',
  'explore.viewAll': 'عرض الكل',
  'explore.noCommunities': 'لا توجد مجتمعات بعد',
  'explore.noJobs': 'لا توجد وظائف نشطة',
  'explore.noBounties': 'لا توجد مكافآت مفتوحة',
  'explore.noAgents': 'لم يتم تسجيل أي وكلاء',
  'agentWorld.jobs.deadlineFuture': 'يجب أن يكون الموعد النهائي للمقترح في المستقبل',
  'nav.avatarMenu.account': 'الحساب',
  'nav.avatarMenu.billing': 'الفواتير',
  'nav.avatarMenu.rewards': 'المكافآت',
  'nav.avatarMenu.invites': 'دعوة صديق',
  'nav.avatarMenu.wallet': 'المحفظة',

  // Brain: full-page memory knowledge-graph surface
  'brain.subtitle': 'خريطة معرفتك ومصادر الذاكرة وعناصر التحكم.',
  'brain.tabs.memory': 'الذاكرة',
  'brain.tabs.subconscious': 'اللاوعي',
  'brain.tabs.graph': 'الرسم البياني',
  'brain.tabs.goals': 'الأهداف',
  'brain.goals.title': 'الأهداف طويلة المدى',
  'brain.goals.description': 'أهداف الوكيل الدائمة للعمل معك. عدّلها هنا أو دع التأمل يحدّثها.',
  'brain.goals.reflect': 'تأمّل',
  'brain.goals.reflecting': 'جارٍ التأمل…',
  'brain.goals.reflectDone': 'تم تحديث الأهداف.',
  'brain.goals.add': 'إضافة',
  'brain.goals.addPlaceholder': 'أضف هدفًا طويل المدى…',
  'brain.goals.empty': 'لا توجد أهداف بعد. أضف هدفًا أو استخدم التأمل لملئها من السياق الأخير.',
  'brain.goals.editGoal': 'تعديل الهدف',
  'brain.goals.deleteGoal': 'حذف الهدف',
  'brain.goals.actionError': 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  'brain.tabs.sources': 'المصادر',
  'brain.tabs.sync': 'المزامنة',
  'brain.tabs.orchestration': 'التنسيق',
  'tinyplaceOrchestration.title': 'مرحّل TinyPlace',
  'tinyplaceOrchestration.subtitle': 'قنوات الوكلاء المثبتة ودردشات جلسات التطبيق',
  'tinyplaceOrchestration.refresh': 'تحديث',
  'tinyplaceOrchestration.newInstance': 'نسخة جديدة',
  'tinyplaceOrchestration.newInstanceSoon': 'قريبًا',
  'tinyplaceOrchestration.pinned': 'مثبتة',
  'tinyplaceOrchestration.sessions': 'الجلسات',
  'tinyplaceOrchestration.contacts': 'جهات الاتصال',
  'tinyplaceOrchestration.noContacts': 'لا توجد جهات اتصال بعد.',
  'tinyplaceOrchestration.newSession': 'جلسة جديدة',
  'tinyplaceOrchestration.otherSessions': 'جلسات أخرى',
  'tinyplaceOrchestration.loading': 'جارٍ تحميل دردشات TinyPlace…',
  'tinyplaceOrchestration.paymentRequired': 'يتطلب الوصول إلى TinyPlace دفعًا.',
  'tinyplaceOrchestration.failedToLoad': 'تعذّر تحميل دردشات TinyPlace',
  'tinyplaceOrchestration.noSessions': 'لا توجد جلسات تطبيق TinyPlace بعد.',
  'tinyplaceOrchestration.noMessages': 'لا توجد رسائل في هذه الدردشة بعد.',
  'tinyplaceOrchestration.active': 'نشطة',
  'tinyplaceOrchestration.inactive': 'غير نشطة',
  'tinyplaceOrchestration.encryptedBody': 'رسالة TinyPlace مشفرة',
  'tinyplaceOrchestration.unknownSender': 'مرسل غير معروف',
  'tinyplaceOrchestration.master.title': 'وكيل / إنسان',
  'tinyplaceOrchestration.master.subtitle': 'الدردشة الرئيسية',
  'tinyplaceOrchestration.master.preview': 'تنسيق مباشر بينك وبين OpenHuman.',
  'tinyplaceOrchestration.subconscious.title': 'اللاوعي',
  'tinyplaceOrchestration.subconscious.subtitle': 'دردشات الوكلاء الداخلية',
  'tinyplaceOrchestration.subconscious.preview': 'تنسيق الوكلاء في الخلفية وحلقات الذاكرة.',
  'tinyplaceOrchestration.session.subtitle': 'جلسة تطبيق TinyPlace',
  'tinyplaceOrchestration.pairing.linkLabel': 'ربط جلسة',
  'tinyplaceOrchestration.pairing.linkPlaceholder': 'ألصق معرف وكيل الجلسة',
  'tinyplaceOrchestration.pairing.linkAction': 'ربط',
  'tinyplaceOrchestration.pairing.requests': 'طلبات الاتصال',
  'tinyplaceOrchestration.pairing.accept': 'قبول',
  'tinyplaceOrchestration.pairing.decline': 'رفض',
  'tinyplaceOrchestration.pairing.block': 'حظر',
  'tinyplaceOrchestration.pairing.linked': 'مرتبط',
  'tinyplaceOrchestration.pairing.pending': 'معلق',
  'tinyplaceOrchestration.pairing.unlinked': 'غير مرتبط',
  'tinyplaceOrchestration.pairing.incoming': 'واردة',
  'tinyplaceOrchestration.pairing.outgoing': 'صادرة',
  'tinyplaceOrchestration.master.you': 'أنت',
  'tinyplaceOrchestration.composer.placeholder': 'راسل OpenHuman…',
  'tinyplaceOrchestration.composer.send': 'إرسال',
  'tinyplaceOrchestration.composer.sendFailed': 'فشل إرسال الرسالة',
  'tinyplaceOrchestration.steering.label': 'التوجيه',
  'tinyplaceOrchestration.relay.staging': 'بيئة التجهيز',
  'tinyplaceOrchestration.relay.prod': 'الإنتاج',
  'tinyplaceOrchestration.identity.loading': 'جارٍ تحميل الهوية…',
  'tinyplaceOrchestration.identity.noHandle': 'لا يوجد @handle بعد',
  'tinyplaceOrchestration.identity.copy': 'نسخ',
  'tinyplaceOrchestration.identity.copied': 'تم النسخ',
  'tinyplaceOrchestration.identity.discoverable': 'قابل للاكتشاف',
  'tinyplaceOrchestration.identity.undiscoverable': 'غير قابل للاكتشاف',
  'tinyplaceOrchestration.identity.undiscoverableHint':
    'انشر بطاقة الدليل ومفتاح التشفير حتى يتمكن الآخرون من مراسلتك.',
  'tinyplaceOrchestration.identity.makeDiscoverable': 'اجعله قابلاً للاكتشاف',
  'tinyplaceOrchestration.identity.republish': 'إعادة نشر المفاتيح',
  'tinyplaceOrchestration.identity.publishing': 'جارٍ النشر…',
  'tinyplaceOrchestration.identity.publishFailed': 'فشل النشر: أعد المحاولة',
  'tinyplaceOrchestration.identity.card': 'بطاقة الدليل',
  'tinyplaceOrchestration.identity.key': 'مفتاح التشفير',
  'tinyplaceOrchestration.identity.published': 'منشور',
  'tinyplaceOrchestration.identity.notPublished': 'غير منشور',
  'tinyplaceOrchestration.roster.instances': 'مثيلات',
  'tinyplaceOrchestration.roster.empty': 'لا توجد مثيلات وكيل بعد',
  'tinyplaceOrchestration.roster.other': 'أخرى',
  'tinyplaceOrchestration.status.running': 'قيد التشغيل',
  'tinyplaceOrchestration.status.idle': 'خامل',
  'tinyplaceOrchestration.status.waitingApproval': 'في انتظار الموافقة',
  'tinyplaceOrchestration.status.errored': 'خطأ',
  'tinyplaceOrchestration.status.stopped': 'متوقف',
  'tinyplaceOrchestration.attention.title': 'يحتاج إليك',
  'tinyplaceOrchestration.attention.empty': 'أنجزت كل شيء',
  'tinyplaceOrchestration.attention.unread': 'رسائل غير مقروءة',
  'tinyplaceOrchestration.attention.review': 'مراجعة',
  'tinyplaceOrchestration.attention.open': 'فتح',
  'tinyplaceOrchestration.attention.kind.approval': 'موافقة',
  'tinyplaceOrchestration.attention.kind.needsInput': 'بحاجة إلى مُدخل',
  'tinyplaceOrchestration.attention.kind.unread': 'غير مقروء',
  'brain.empty': 'دماغك فارغ في الوقت الحالي: قم بربط مصدر لبدء بناء الذاكرة.',
  'brain.error': 'تعذّر تحميل دماغك. يرجى المحاولة مرة أخرى.',
  'common.cancel': 'إلغاء',
  'common.save': 'حفظ',
  'common.confirm': 'تأكيد',
  'common.delete': 'حذف',
  'common.edit': 'تعديل',
  'common.create': 'إنشاء',
  'common.search': 'بحث',
  'common.loading': 'جارٍ التحميل…',
  'sync.runs': 'عمليات مزامنة',
  'sync.totalCost': 'الإجمالي',
  'sync.when': 'الوقت',
  'sync.source': 'المصدر',
  'sync.items': 'العناصر',
  'sync.tokens': 'الرموز',
  'sync.cost': 'التكلفة',
  'sync.duration': 'المدة',
  'sync.noAuditEntries': 'لم تُسجَّل أي عمليات مزامنة بعد.',
  'sync.timeAgo.justNow': 'الآن',
  'sync.timeAgo.minutes': 'قبل {n} د',
  'sync.timeAgo.hours': 'قبل {n} س',
  'sync.timeAgo.days': 'قبل {n} ي',
  'sync.status.success': 'نجاح',
  'sync.status.failed': 'فشل',
  'common.error': 'خطأ',
  'common.success': 'نجاح',
  'common.back': 'رجوع',
  'common.next': 'التالي',
  'common.finish': 'إنهاء',
  'common.close': 'إغلاق',
  'common.enabled': 'مفعّل',
  'common.disabled': 'معطّل',
  'common.on': 'تشغيل',
  'common.off': 'إيقاف',
  'common.yes': 'نعم',
  'common.no': 'لا',
  'common.ok': 'حسنًا',
  'common.name': 'الاسم',
  'common.retry': 'حاول مرة أخرى',
  'common.copy': 'نسخ',
  'common.copied': 'تم النسخ',
  'common.learnMore': 'معرفة المزيد',
  'common.seeAll': 'عرض',
  'common.dismiss': 'تجاهل',
  'common.clear': 'مسح',
  'common.reset': 'إعادة ضبط',
  'common.refresh': 'تحديث',
  'common.export': 'تصدير',
  'common.import': 'استيراد',
  'common.upload': 'رفع',
  'common.download': 'تنزيل',
  'common.add': 'إضافة',
  'common.remove': 'إزالة',
  'common.showMore': 'عرض المزيد',
  'common.showLess': 'عرض أقل',
  'common.submit': 'إرسال',
  'common.continue': 'متابعة',
  'common.comingSoon': 'قريبًا',
  'common.breadcrumb': 'مسار التنقل',
  'common.beta': 'تجريبي',
  'common.betaDisclaimer':
    'هذه الميزة في مرحلة تجريبية. قد تتغير أو تحتوي على بعض المشاكل: ملاحظاتك تساعدنا على تحسينها.',
  'settings.general': 'عام',
  // Settings layman groups (Phase 4 IA revamp)
  'settings.groups.account': 'الحساب',
  'settings.groups.assistant': 'المساعد',
  'settings.groups.privacySecurity': 'الخصوصية والأمان',
  'settings.groups.notifications': 'الإشعارات',
  'settings.groups.about': 'حول',
  'settings.assistant.personality': 'الشخصية',
  'settings.personalityFace.title': 'الشخصية والوجه',
  'settings.personalityFace.menuDesc': 'اضبط شخصية مساعدك واختر وجهه',
  'settings.assistant.voice': 'الصوت',
  'settings.assistant.voiceDesc': 'إعدادات التحويل من كلام إلى نص ومن نص إلى كلام',
  'settings.assistant.faceMascot': 'الوجه / الشخصية',
  'settings.assistant.backgroundActivity': 'اللاوعي',
  'settings.assistant.backgroundActivityDesc': 'تحكم في مدى نشاط مساعدك في الخلفية',
  'settings.assistant.permissions': 'الأذونات',
  'settings.assistant.permissionsDesc': 'اختر ما يمكن للمساعد فعله والمكان الذي يمكنه العمل فيه',
  'settings.privacySecurity.privacy': 'الخصوصية',
  'settings.privacySecurity.privacyDesc': 'تحكم في البيانات التي تغادر جهازك',
  'settings.privacySecurity.security': 'الأمان',
  'settings.privacySecurity.securityDesc': 'الجلسات وخيارات تسجيل الدخول',
  'settings.privacySecurity.approvalsHistory': 'الموافقات والسجل',
  'settings.privacySecurity.approvalsHistoryDesc': 'مراجعة قرارات الموافقة الأخيرة على الأدوات',
  'settings.notifications.menuTitle': 'الإشعارات',
  'settings.notifications.menuDesc': 'صندوق التنبيهات وتفضيلات الإشعارات',
  'settings.devGroups.knowledgeMemory': 'المعرفة والذاكرة',
  'settings.devGroups.agentsAutonomy': 'الوكلاء والاستقلالية',
  'settings.devGroups.modelsInference': 'النماذج والاستنتاج',
  'settings.devGroups.automationIntegrations': 'الأتمتة والتكاملات',
  'settings.devGroups.toolsCapabilities': 'الأدوات والقدرات',
  'settings.devGroups.council': 'المجلس',
  'settings.analysisViews.title': 'طرق العرض التحليلية',
  'settings.analysisViews.menuDesc':
    'تحليل رسم الذاكرة البياني: المخطط، والمركزية، والتماسك، والارتباطات، والحداثة، والجدول الزمني، والمسارات، والمساحات',
  'settings.buildInfo.title': 'معلومات الإصدار / البناء',
  'settings.buildInfo.menuDesc': 'تفاصيل بناء التطبيق وإصداره واتصال النواة',
  'settings.tokenUsage.title': 'الرموز والتكلفة',
  'settings.tokenUsage.menuDesc': 'إعدادات الضغط ومقدار ما وفّرته من رموز ودولارات',
  'settings.tokenUsage.saving': 'جارٍ الحفظ…',
  'settings.tokenUsage.saved': 'تم الحفظ',
  'settings.tokenUsage.savingsTitle': 'التوفير',
  'settings.tokenUsage.attributedTo': 'تم تسعير التكلفة لـ {model}',
  'settings.tokenUsage.tokensSaved': 'الرموز الموفّرة',
  'settings.tokenUsage.costSaved': 'التكلفة الموفّرة',
  'settings.tokenUsage.cacheOccupancy': 'النسخ الأصلية المخزّنة مؤقتًا',
  'settings.tokenUsage.compactions': 'عمليات الضغط',
  'settings.tokenUsage.overEvents': 'عبر {count} عملية ضغط',
  'settings.tokenUsage.byCompressor': 'حسب الضاغط',
  'settings.tokenUsage.refresh': 'تحديث',
  'settings.tokenUsage.reset': 'إعادة تعيين الإحصائيات',
  'settings.tokenUsage.compressionTitle': 'الضغط',
  'settings.tokenUsage.compressionDesc':
    'ضغط واعٍ بالمحتوى لمخرجات الأدوات الكبيرة قبل دخولها سياق النموذج.',
  'settings.tokenUsage.routerEnabled': 'تمكين الضغط',
  'settings.tokenUsage.routerEnabledDesc': 'المفتاح الرئيسي لموجّه المحتوى.',
  'settings.tokenUsage.search': 'نتائج البحث',
  'settings.tokenUsage.searchDesc':
    'ترتيب مخرجات grep/البحث حسب الصلة، مع الاحتفاظ بأفضل التطابقات.',
  'settings.tokenUsage.code': 'الشيفرة المصدرية',
  'settings.tokenUsage.codeDesc': 'الاحتفاظ بالتواقيع وطيّ أجسام الدوال.',
  'settings.tokenUsage.html': 'HTML',
  'settings.tokenUsage.htmlDesc': 'إزالة الترميز لإظهار نص قابل للقراءة.',
  'settings.tokenUsage.ml': 'ضاغط النص بالتعلّم الآلي',
  'settings.tokenUsage.mlDesc': 'نموذج ModernBERT محلي للنص العادي (يتطلب بيئة تشغيل Python).',
  'settings.tokenUsage.ccrTitle': 'التخزين المؤقت والاسترجاع (CCR)',
  'settings.tokenUsage.ccrDesc':
    'يتم تخزين النسخ الأصلية المضغوطة مؤقتًا حتى يتمكّن الوكيل من جلب النص الكامل عند الطلب.',
  'settings.tokenUsage.ccrEnabled': 'الاحتفاظ بالنسخ الأصلية للاسترجاع',
  'settings.tokenUsage.ccrEnabledDesc':
    'تفريغ النسخة الأصلية وإضافة علامة استرجاع حتى لا يضيع أي شيء.',
  'settings.tokenUsage.ccrMinTokens': 'الحد الأدنى للحجم المراد تخزينه',
  'settings.tokenUsage.ccrMinTokensDesc':
    'لا يتم التخزين والضغط مع الفقد إلا للنتائج المقدّرة بهذا العدد من الرموز أو أكثر.',
  'settings.tokenUsage.tokensUnit': 'رمز',
  'settings.tokenUsage.ccrDisk': 'حفظ التخزين المؤقت على القرص',
  'settings.tokenUsage.ccrDiskDesc':
    'الاحتفاظ بالنسخ الأصلية القابلة للاسترجاع عبر عمليات إعادة التشغيل.',
  'settings.dataSync.title': 'مزامنة البيانات',
  'settings.dataSync.menuDesc': 'ما يقوم مساعدك بمزامنته: المصادر والحداثة والحالة',
  'settings.dataSync.description':
    'تحكم في ما تتم مزامنته في ذاكرة مساعدك: كل مصدر متصل مع وقت آخر مزامنة له، ومقدار ما تمت مزامنته، وما إذا كان قيد المزامنة الآن.',
  'settings.devGroups.diagnosticsLogs': 'التشخيصات والسجلات',
  'settings.featuresAndAI': 'الميزات والذكاء الاصطناعي',
  'settings.billingAndRewards': 'الفوترة والمكافآت',
  'settings.support': 'الدعم',
  'settings.advanced': 'متقدم',
  'settings.dangerZone': 'منطقة الخطر',
  'settings.account': 'الحساب',
  'settings.accountDesc': 'عبارة الاسترداد والفريق والاتصالات والخصوصية',
  'settings.notifications': 'الإشعارات',
  'settings.notificationsDesc': 'عدم الإزعاج وضوابط الإشعارات لكل حساب',
  'settings.notifications.tabs.preferences': 'التفضيلات',
  'settings.notifications.tabs.routing': 'التوجيه',
  'settings.features': 'الميزات',
  'settings.aiModels': 'الذكاء الاصطناعي والنماذج',
  'settings.aiModelsDesc': 'إعداد نموذج الذكاء الاصطناعي المحلي وتنزيلاته ومزود LLM',
  'settings.ai': 'إعداد الذكاء الاصطناعي',
  'settings.aiDesc': 'مزودو السحابة ونماذج Ollama المحلية والتوجيه لكل عبء عمل',
  'settings.billingUsage': 'الفوترة والاستخدام',
  'settings.billingUsageDesc': 'خطة الاشتراك والرصيد وطرق الدفع',
  'settings.rewards': 'المكافآت',
  'settings.rewardsDesc': 'الإحالات والقسائم والرصيد المكتسب',
  'settings.restartTour': 'إعادة الجولة التعريفية',
  'settings.restartTourDesc': 'إعادة تشغيل جولة المنتج من البداية',
  'settings.about': 'حول',
  'settings.aboutDesc': 'إصدار التطبيق وتحديثات البرنامج',
  'settings.developerOptions': 'متقدم',
  'settings.developerOptionsDesc':
    'إعداد الذكاء الاصطناعي وقنوات المراسلة والأدوات والتشخيص ولوحات التصحيح',
  'settings.developerDiagnostics': 'المطور والتشخيص',
  'settings.developerDiagnosticsDesc':
    'أدوات المطور المتقدمة والتشخيص والذاكرة والوكلاء ولوحات التصحيح',
  'settings.developerMode.title': 'وضع المطور',
  'settings.developerMode.description': 'إظهار أدوات المطور والتشخيص المتقدمة',
  'settings.developerMode.enabledByBuild': 'مفعّل دائمًا في إصدارات التطوير',
  'settings.clearAppData': 'مسح بيانات التطبيق',
  'settings.clearAppDataDesc': 'تسجيل الخروج وحذف جميع البيانات المحلية للتطبيق نهائيًا',
  'settings.logOut': 'تسجيل الخروج',
  'settings.logOutDesc': 'تسجيل الخروج من حسابك',
  'settings.exitLocalSession': 'الخروج من الجلسة المحلية',
  'settings.exitLocalSessionDesc': 'العودة إلى شاشة تسجيل الدخول',
  'settings.language': 'اللغة',
  'settings.navGroups.general': 'عام',
  'settings.navGroups.assistant': 'المساعد',
  'settings.navGroups.data': 'البيانات',
  'settings.navGroups.connections': 'الاتصالات',
  'settings.navGroups.system': 'النظام',
  'settings.betaBuild': 'الإصدار التجريبي - v{version}',
  'settings.languageDesc': 'لغة عرض واجهة التطبيق',
  'settings.alerts': 'التنبيهات',
  'settings.alertsDesc': 'عرض التنبيهات الأخيرة والنشاط في صندوق الوارد',
  'settings.account.profile': 'الملف الشخصي',
  'settings.account.profileDesc': 'الاسم والبريد الإلكتروني والصورة الرمزية',
  'settings.account.devices': 'الأجهزة',
  'settings.account.devicesDesc': 'إقران الأجهزة المحمولة وإدارتها',
  'settings.account.teamMembers': 'الفريق والأعضاء',
  'settings.account.teamMembersDesc': 'إدارة وصول الفريق وأدوار الأعضاء',
  'settings.account.dataMigration': 'البيانات والترحيل',
  'settings.account.dataMigrationDesc': 'استيراد الذاكرة من مساعد آخر',
  'settings.account.recoveryPhrase': 'عبارة الاسترداد',
  'settings.account.recoveryPhraseDesc': 'عرض عبارة استرداد الحساب ونسخها احتياطيًا',
  'settings.account.team': 'الفريق',
  'settings.account.teamDesc': 'إدارة أعضاء الفريق والأذونات',
  'settings.account.connections': 'الاتصالات',
  'settings.account.connectionsDesc': 'إدارة الحسابات والخدمات المرتبطة',
  'settings.account.privacy': 'الخصوصية',
  'settings.account.privacyDesc': 'التحكم في البيانات التي تغادر جهازك',
  'migration.title': 'استيراد من مساعد آخر',
  'migration.description':
    'انقل الذاكرة والملاحظات من مساعد محلي آخر إلى مساحة العمل هذه. ابدأ بـ«معاينة» لرؤية ما سيتغير، ثم اضغط «تطبيق» لنسخ البيانات. يتم نسخ ذاكرتك الحالية احتياطيًا أولًا.',
  'migration.vendorLabel': 'المصدر',
  'migration.vendor.openclaw': 'OpenClaw',
  'migration.vendor.hermes': 'Hermes Agent',
  'migration.sourceLabel': 'مسار مساحة العمل المصدر (اختياري)',
  'migration.sourcePlaceholder': 'اتركه فارغًا للاكتشاف التلقائي (مثال: ~/.openclaw/workspace)',
  'migration.sourcePlaceholderHermes': 'اتركه فارغاً للاكتشاف التلقائي (مثال: ~/.hermes)',
  'migration.sourceHint':
    'يستخدم الموقع الافتراضي للمصدر عند تركه فارغًا. حدد مسارًا صريحًا إذا نقلت مساحة العمل إلى مكان آخر.',
  'migration.previewAction': 'معاينة',
  'migration.previewRunning': 'جاري المعاينة…',
  'migration.applyAction': 'تطبيق الاستيراد',
  'migration.applyRunning': 'جاري الاستيراد…',
  'migration.applyDisclaimer':
    'يُفتح التطبيق فقط بعد معاينة ناجحة لنفس المصدر. يتم نسخ الذاكرة الحالية احتياطيًا قبل أي استيراد.',
  'migration.reportTitlePreview': 'معاينة: لم يُستورد شيء بعد',
  'migration.reportTitleApplied': 'اكتمل الاستيراد',
  'migration.report.source': 'مساحة العمل المصدر',
  'migration.report.target': 'مساحة العمل الهدف',
  'migration.report.fromSqlite': 'من SQLite (brain.db)',
  'migration.report.fromMarkdown': 'من Markdown',
  'migration.report.imported': 'مُستورد',
  'migration.report.skippedUnchanged': 'تم تخطّيه (دون تغيير)',
  'migration.report.renamedConflicts': 'تمت إعادة التسمية عند التعارض',
  'migration.report.warnings': 'تحذيرات',
  'migration.report.previewHint': 'لم تُستورد أي بيانات بعد. اضغط «تطبيق الاستيراد» للنسخ.',
  'migration.report.appliedHint':
    'العناصر المستوردة أصبحت الآن في ذاكرتك. أعد تشغيل «المعاينة» للمقارنة مرة أخرى.',
  'migration.confirmImport.singular':
    'استيراد {count} عنصر إلى مساحة العمل الحالية؟\n\nالمصدر: {source}\nالهدف: {target}\n\nسيتم نسخ الذاكرة الحالية احتياطيًا قبل بدء الاستيراد.',
  'migration.confirmImport.plural':
    'استيراد {count} عنصر إلى مساحة العمل الحالية؟\n\nالمصدر: {source}\nالهدف: {target}\n\nسيتم نسخ الذاكرة الحالية احتياطيًا قبل بدء الاستيراد.',
  'settings.notifications.doNotDisturb': 'عدم الإزعاج',
  'settings.notifications.doNotDisturbDesc': 'إيقاف جميع الإشعارات مؤقتًا لفترة محددة',
  'settings.notifications.channelControls': 'ضوابط لكل قناة',
  'settings.notifications.channelControlsDesc': 'ضبط تفضيلات الإشعارات لكل قناة',
  'settings.features.messaging': 'المراسلة',
  'settings.features.messagingDesc': 'إعدادات تكامل القنوات والمراسلة',
  'settings.features.tools': 'الأدوات',
  'settings.features.toolsDesc': 'إدارة الأدوات والتكاملات المتصلة',
  'settings.ai.localSetup': 'إعداد الذكاء الاصطناعي المحلي',
  'settings.ai.localSetupDesc': 'تنزيل نماذج الذكاء الاصطناعي المحلية وضبطها',
  'settings.ai.llmProvider': 'مزود LLM',
  'settings.ai.llmProviderDesc': 'اختيار مزود الذكاء الاصطناعي وضبطه',
  'clearData.title': 'مسح بيانات التطبيق',
  'clearData.warning': 'سيؤدي هذا إلى تسجيل خروجك وحذف بيانات التطبيق المحلية نهائيًا، بما فيها:',
  'clearData.bulletSettings': 'إعدادات التطبيق والمحادثات',
  'clearData.bulletCache': 'جميع بيانات ذاكرة التخزين المؤقت للتكاملات المحلية',
  'clearData.bulletWorkspace': 'بيانات مساحة العمل',
  'clearData.bulletOther': 'جميع البيانات المحلية الأخرى',
  'clearData.irreversible': 'لا يمكن التراجع عن هذا الإجراء.',
  'clearData.clearing': 'جارٍ مسح بيانات التطبيق...',
  'clearData.failed': 'فشل مسح البيانات وتسجيل الخروج. يرجى المحاولة مرة أخرى.',
  'clearData.failedLogout': 'فشل تسجيل الخروج. يرجى المحاولة مرة أخرى.',
  'clearData.failedPersist': 'فشل مسح حالة التطبيق المحفوظة. يرجى المحاولة مرة أخرى.',
  'welcome.logoAlt': 'OpenHuman',
  'welcome.title': 'مرحبًا بك في OpenHuman',
  'welcome.subtitle': 'مساعدك الذكي الشخصي. خاص وبسيط وبالغ القوة.',
  'welcome.connectPrompt': 'ضبط عنوان URL للـ RPC (متقدم)',
  'welcome.selectRuntime': 'اختر بيئة التشغيل',
  'welcome.clearingAppData': 'مسح بيانات التطبيق...',
  'welcome.clearAppDataAndRestart': 'مسح بيانات التطبيق وإعادة تشغيله',
  'welcome.clearAppDataWarning':
    'سيؤدي هذا إلى مسح الأسرار والحسابات المخزنة محلياً على هذا الجهاز. حسابك السحابي غير متأثر: يمكنك تسجيل الدخول مجدداً فوراً بعد ذلك.',
  'welcome.resetErrorFallback':
    'تعذّر مسح بيانات التطبيق. يرجى إنهاء OpenHuman وإعادة فتحه، ثم حاول مجدداً.',
  'welcome.signingIn': 'تسجيل دخولك...',
  'welcome.termsIntro': 'من خلال المتابعة، فإنك توافق على',
  'welcome.termsOfUse': 'الشروط',
  'welcome.termsJoiner': 'و',
  'welcome.privacyPolicy': 'سياسة الخصوصية',
  'welcome.termsOutro': '.',
  'welcome.urlPlaceholder': 'http://localhost:8089',
  'welcome.invalidUrl': 'يرجى إدخال عنوان URL صالح لـ HTTP أو HTTPS',
  'welcome.connecting': 'اختبار',
  'welcome.connect': 'اختبار',
  'home.greeting': 'صباح الخير',
  'home.greetingAfternoon': 'مساء الخير',
  'home.greetingEvening': 'مساء النور',
  'home.askAssistant': 'اسأل مساعدك أي شيء...',
  'home.statusOk': 'مساعدك جاهز متى كنت مستعدًا. اكتب شيئًا في الأسفل للبدء.',
  'home.statusBackendOnly': 'جارٍ إعادة الاتصال بالخادم… سيتوفر وكيلك قريبًا.',
  'home.statusCoreUnreachable':
    'العملية الأساسية المحلية لا تستجيب. قد تكون عملية OpenHuman في الخلفية قد تعطلت أو فشلت في البدء.',
  'home.statusInternetOffline':
    'جهازك غير متصل بالإنترنت حاليًا. تحقق من شبكتك أو أعد تشغيل التطبيق لإعادة الاتصال.',
  'home.restartCore': 'إعادة تشغيل النواة',
  'home.restartingCore': 'جارٍ إعادة تشغيل النواة…',
  'home.themeToggle.toLight': 'التبديل إلى الوضع الفاتح',
  'home.themeToggle.toDark': 'التبديل إلى الوضع الداكن',
  'home.usageExhaustedTitle': 'لقد استنفدت حصتك',
  'home.usageExhaustedBody': 'لقد نفدت حصتك المضمنة حالياً. ابدأ اشتراكاً لفتح سعة إضافية مستمرة.',
  'home.usageExhaustedCta': 'ابدأ الاشتراك',
  'openrouterFree.cta': 'استخدم نماذج OpenRouter المجانية',
  'openrouterFree.saving': 'جارٍ الاتصال بـ OpenRouter...',
  'openrouterFree.error':
    'تعذر التبديل إلى نماذج OpenRouter المجانية. تحقق من تسجيل الدخول إلى OpenRouter وحاول مرة أخرى.',
  'home.routinesCard': 'روتيناتك',
  'home.routinesActive': '{count} نشطة',
  'routines.title': 'روتيناتك',
  'routines.subtitle': 'الأشياء التي يقوم بها مساعدك تلقائياً',
  'routines.loading': 'روتينات تحميل...',
  'routines.empty': 'لا روتينات بعد',
  'routines.emptyHint':
    'ويمكن لمساعدكم أن يدير مهامه على جدول زمني - مثل جلسات الإحاطة الصباحية أو الملخصات اليومية.',
  'routines.refresh': 'التجديد',
  'routines.nextRun': 'الجولة التالية',
  'routines.lastRunSuccess': 'آخر مرة نجحت',
  'routines.lastRunFailed': 'آخر مرة فشلت',
  'routines.notRunYet': 'لم يهرب بعد',
  'routines.runNow': 'اركض الآن',
  'routines.running': 'تشغيل...',
  'routines.runNowTimedOut': 'انتهت مهلة التشغيل: يرجى التحديث والمحاولة مرة أخرى.',
  'routines.viewHistory': 'تاريخ الرؤية',
  'routines.loadingHistory': 'التعبئة...',
  'routines.noHistory': 'لا يوجد تاريخ بعد',
  'routines.statusSuccess': 'النجاح',
  'routines.statusError': 'خطأ',
  'routines.showOutput': 'النواتج',
  'routines.hideOutput': 'الناتج الخفي',
  'routines.toggleEnabled': 'هذا الروتيني',
  'routines.typeAgent': 'الوكيل',
  'routines.typeCommand': 'القيادة',
  'nav.routines': 'Routines',
  'chat.newThread': 'محادثة جديدة',
  'chat.newConversation': 'محادثة جديدة',
  'chat.newWindowWelcome1': 'مرحبًا، {name} 👋',
  'chat.newWindowWelcome2': 'لنبدأ العمل، {name} 🧑‍🍳.',
  'chat.newWindowWelcome3': 'حان وقت التركيز 🧘🏻',
  'chat.typeMessage': 'كيف يمكنني مساعدتك اليوم؟',
  'chat.send': 'إرسال الرسالة',
  'chat.stopGeneration': 'إيقاف التوليد',
  'chat.stoppedByUser': 'تم الإيقاف',
  'chat.parallelBranchHint': 'فرع متوازٍ: ⌘/Ctrl+Enter للإرسال',
  'chat.followupHint': 'أضِف متابعة إلى القائمة: تُرسَل بعد هذا الرد · ⌘/Ctrl+Enter لفرع متوازٍ',
  'chat.queuedFollowups.label': 'متابعات في قائمة الانتظار',
  'chat.queuedFollowups.clear': 'مسح',
  'chat.queuedFollowups.clearFailed': 'تعذّر مسح القائمة: حاول مرة أخرى.',
  'chat.createThreadFailed': 'تعذّر إنشاء محادثة جديدة: حاول مرة أخرى.',
  'chat.parallelBranchLabel': 'فرع متوازٍ',
  'chat.thinking': 'جارٍ التفكير...',
  'chat.noMessages': 'لا توجد رسائل بعد',
  'chat.startConversation': 'ابدأ محادثة',
  'chat.regenerate': 'إعادة التوليد',
  'chat.copyResponse': 'نسخ الرد',
  'chat.citations': 'المراجع',
  'chat.toolUsed': 'الأداة المستخدمة',
  'scope.legacy': 'قديم',
  'scope.user': 'مستخدم',
  'scope.project': 'مشروع',
  'skills.title': 'الاتصالات',
  'skills.search': 'البحث في الاتصالات...',
  'skills.noResults': 'لم يتم العثور على اتصالات',
  'skills.loadingIntegrations': 'جارٍ تحميل التكاملات…',
  'skills.connect': 'توصيل',
  'skills.disconnect': 'قطع الاتصال',
  'skills.configure': 'إدارة',
  'skills.connected': 'متصل',
  'skills.available': 'متاح',
  'skills.addAccount': 'إضافة حساب',
  'skills.channels': 'المراسلة',
  'skills.explorer.emptyCta': 'التثبيت من رابط',
  'skills.explorer.emptyDescription':
    'ثبّت حزمة SKILL.md أو ضع مجلدات بنمط Hermes داخل ~/.openhuman/skills.',
  'skills.explorer.emptyTitle': 'لم يتم العثور على مهارات',
  'skills.explorer.installFromUrl': 'التثبيت من رابط',
  'skills.explorer.newSkill': 'مهارة جديدة',
  'skills.explorer.subtitle':
    'تصفح حزم SKILL.md، بما في ذلك markdown والسكربتات والمراجع والقوالب والأمثلة والمطالبات بنمط Hermes.',
  'skills.explorer.title': 'مستكشف المهارات',
  'skills.explorer.searchPlaceholder': 'ابحث في المهارات...',
  'skills.explorer.scopeUser': 'User',
  'skills.explorer.scopeProject': 'Project',
  'skills.explorer.scopeLegacy': 'Legacy',
  'skills.explorer.noDescription': 'لم يتم تقديم وصف.',
  'skills.explorer.uninstallSuccess': 'تم إلغاء تثبيت المهارة بنجاح.',
  'skills.explorer.registryTab': 'السجل',
  'skills.explorer.installedTab': 'المثبتة',
  'skills.explorer.allFormats': 'جميع الأنماط',
  'skills.explorer.refreshRegistry': 'تحديث السجل',
  'skills.explorer.registryEmptyTitle': 'لا توجد إدخالات في السجل',
  'skills.explorer.registryEmptyDescription':
    'تعذر تحميل سجل المهارات. تحقق من اتصالك وحاول التحديث.',
  'skills.explorer.showingOf': 'عرض {shown} من {total} نتيجة. حسّن بحثك لرؤية المزيد.',
  'skills.explorer.installed': 'مثبت',
  'skills.explorer.install': 'تثبيت',
  'skills.explorer.installing': 'جارٍ التثبيت…',
  'skills.integrations': 'تكاملات Composio',
  'skills.integrationsSubtitle':
    'اتصالات OAuth السحابية: سجّل الدخول بحسابك ويتولى Composio إدارة الرموز حتى يتمكن الوكلاء من القراءة والتصرف نيابةً عنك. لا حاجة لإدارة مفاتيح API.',
  'skills.composio.noApiKeyTitle': 'لم يتم إعداد مفتاح Composio API',
  'skills.composio.noApiKeyDescription':
    'يستخدم الوضع المحلي مفتاح Composio API الخاص بك. افتح الإعدادات ← الخيارات المتقدمة ← Composio لإضافته قبل توصيل التكاملات هنا.',
  'skills.composio.noApiKeyCta': 'افتح في الإعدادات',
  'skills.tabs.composio': 'Composio',
  'skills.tabs.channels': 'القنوات',
  'skills.tabs.explorer': 'المهارات',
  'skills.tabs.meetings': 'اجتماعات Google Meet',
  'skills.tabs.mcp': 'MCP الخوادم',
  'connections.tabs.composio': 'Composio',
  'connections.tabs.channels': 'القنوات',
  'connections.tabs.mcp': 'خوادم MCP',
  'connections.tabs.skills': 'المهارات',
  'connections.tabs.meetings': 'الاجتماعات',
  'connections.groups.integrations': 'التكاملات',
  'connections.groups.desktop': 'سطح المكتب',
  'connections.tabs.oauth': 'OAuth',
  'connections.tabs.composioKey': 'Composio',
  'connections.groups.apiKeys': 'مفاتيح API',
  'connections.groups.intelligence': 'الذكاء',
  'memory.title': 'الذاكرة',
  'memory.search': 'البحث في الذكريات...',
  'memory.noResults': 'لم يتم العثور على ذكريات',
  'memory.empty': 'لا توجد ذكريات بعد. تُنشأ الذكريات تلقائيًا أثناء تفاعلك.',
  'memory.tab.memory': 'الذاكرة',
  'memory.tab.memoryTree': 'شجرة الذاكرة',
  'memory.tab.tasks': 'المهام',
  'memory.tab.tasksDescription':
    'أنشئ المهام وتتبعها: مهامك الخاصة بالإضافة إلى اللوحات التي يبنيها وكلاؤك عبر المحادثات.',
  'memory.tab.subconscious': 'اللاوعي',
  'memory.tab.agentWork': 'عمل الوكيل',
  'memory.tab.agentWorkDescription':
    'مركز قيادة لكل تشغيل وكيل في الخلفية: مُجمّع حسب ما يحتاج إلى مُدخلاتك، وما يعمل الآن، وما اكتمل.',
  'memory.tab.worktrees': 'أشجار العمل',
  'memory.tab.worktreesDescription':
    'أشجار عمل git معزولة من عُمّال الوكلاء المتوازين: افحص التغييرات، أو افتحها، أو نظّفها.',
  'memory.tab.teams': 'الفِرَق',
  'memory.tab.teamsDescription':
    'فِرَق وكلاء منسَّقة: مَن يملك كل مهمة، وما المحظور، وما الذي يقوله الزملاء لبعضهم البعض.',
  'memory.tab.agents': 'المكتبة',
  'memory.tab.agentsDescription':
    'تصفّح وشغّل الوكلاء المتاحين: لكل منهم أدواته وقدراته ومجال تركيزه.',
  'memory.tab.workflows': 'Workflows',
  'memory.tab.workflowsDescription':
    'إجراءات قابلة لإعادة الاستخدام والتشغيل: هدف مع خطوات تحقيقه. أنشئ واحدة، أو ثبّتها من رابط، أو افتح سير عمل لتشغيله.',
  'memory.tab.dreams': 'الأحلام',
  'memory.tab.calls': 'المكالمات',
  'memory.tab.diagram': 'Diagram',
  'memory.tab.centrality': 'Centrality',
  'memory.tab.namespaces': 'مساحات الأسماء',
  'memory.tab.timeline': 'Timeline',
  'memory.tab.settings': 'الإعدادات',
  'memory.analyzeNow': 'تحليل الآن',
  'memoryTimeline.title': 'الجدول الزمني للذاكرة',
  'memoryTimeline.intro':
    'متى تعلّم المساعد عنك: حقائق مجمّعة حسب الشهر الذي تم فيه تعزيزها آخر مرة. تُظهر النمو وفترات النشاط والهدوء.',
  'memoryTimeline.loading': 'جارٍ بناء الجدول الزمني…',
  'memoryTimeline.errorPrefix': 'تعذّر تحميل الرسم البياني:',
  'memoryTimeline.retry': 'إعادة المحاولة',
  'memoryTimeline.namespaceLabel': 'مساحة الاسم',
  'memoryTimeline.namespaceAll': 'جميع مساحات الأسماء',
  'memoryTimeline.empty': 'لا يوجد رسم بياني للمعرفة بعد.',
  'memoryTimeline.emptyHint': 'عندما يسجّل المساعد حقائق عنك، سيظهر الجدول الزمني هنا.',
  'memoryTimeline.metricTotal': 'الحقائق',
  'memoryTimeline.metricMonths': 'الأشهر النشطة',
  'memoryTimeline.metricRecent': 'آخر 30 يومًا',
  'memoryTimeline.heading': 'الحقائق المكتسبة شهريًا',
  'memoryTimeline.busiestCaption': 'الأكثر نشاطًا: {period} ({count})',
  'memoryTimeline.undatedNote': '{count} حقيقة بدون تاريخ مسجّل.',
  'memoryTimeline.truncated': 'عرض أحدث {shown} من {total} شهر.',
  'namespaceOverview.title': 'نظرة عامة على مساحات الأسماء',
  'namespaceOverview.intro':
    'كيفية توزيع معرفتك عبر السياقات: عدد الحقائق والكيانات المتميزة المسجَّلة في كل مساحة اسم.',
  'namespaceOverview.loading': 'تجميع مساحات الأسماء…',
  'namespaceOverview.errorPrefix': 'لا يمكن تحميل الرسم البياني:',
  'namespaceOverview.retry': 'إعادة المحاولة',
  'namespaceOverview.empty': 'لا يوجد رسم بياني للمعرفة بعد.',
  'namespaceOverview.emptyHint': 'عندما يسجّل المساعد حقائق عبر السياقات، ستظهر كل مساحة اسم هنا.',
  'namespaceOverview.metricNamespaces': 'مساحات الأسماء',
  'namespaceOverview.metricFacts': 'الحقائق',
  'namespaceOverview.metricEntities': 'الكيانات',
  'namespaceOverview.heading': 'حسب مساحة الاسم',
  'namespaceOverview.unnamespaced': '(بدون مساحة اسم)',
  'namespaceOverview.factsLabel': '{count} حقيقة',
  'namespaceOverview.entitiesLabel': '{count} كيان',
  'namespaceOverview.entitiesShort': '{count} كيان',
  'namespaceOverview.truncated': 'عرض أعلى {shown} من أصل {total} مساحة اسم.',
  'graphCentrality.title': 'مركز المعرفة',
  'graphCentrality.intro':
    'ويظهر الإرسال على صور ذاكرتك مراكز الحمل - والكيانات الموصلة التي تربط المجموعات المنفصلة عن بعضها البعض، والتي لا يمكن لإحصاء الترددات الخام أن يكشف عنها.',
  'graphCentrality.loading': 'مركزية الكمبيوتر...',
  'graphCentrality.errorPrefix': 'لا يمكن تحميل الرسم البياني:',
  'graphCentrality.retry': 'Retry',
  'graphCentrality.empty': 'لا يوجد رسم بياني بعد',
  'graphCentrality.emptyHint': 'كما يسجل المساعد الحقائق عنك، أكثر الكيانات صلة سوف تظهر هنا.',
  'graphCentrality.namespaceLabel': 'الاسم الفضائي',
  'graphCentrality.namespaceAll': 'جميع أماكن الاسم',
  'graphCentrality.metricEntities': 'الكيانات',
  'graphCentrality.metricConnections': 'الارتباطات',
  'graphCentrality.metricClusters': 'المجموعات',
  'graphCentrality.clustersCaption': 'مجموعة &quot; Xqx0xxx &quot; ؛ أكبر الحاويات Xqx1x',
  'graphCentrality.approximateBadge': 'تقريبا',
  'graphCentrality.approximateTitle': 'وقفت في غطاء التكسير قبل التقارب الكامل',
  'graphCentrality.rankedHeading': 'الكيانات الرئيسية بالنفوذ',
  'graphCentrality.colRank': '#',
  'graphCentrality.colEntity': 'الكيان',
  'graphCentrality.colInfluence': 'التأثير',
  'graphCentrality.colLinks': 'الروابط',
  'graphCentrality.bridgeBadge': 'التوصيل',
  'graphCentrality.bridgeTitle': 'موصّل: أكثر تأثيرًا مما يوحي به عدد روابطه',
  'graphCentrality.degreeTitle': 'Xqx0xxx في ×1x',
  'memory.tab.associations': 'Associations',
  'entityAssociations.title': 'ارتباطات الكيانات',
  'entityAssociations.intro':
    'الكيانات التي تتشارك العديد من الروابط نفسها تكون مرتبطة، حتى لو لم تربطها حقيقة واحدة مباشرة. تشابه Jaccard يكشف هذه الارتباطات المخفية.',
  'entityAssociations.loading': 'جارٍ حساب الارتباطات…',
  'entityAssociations.errorPrefix': 'تعذّر تحميل الرسم البياني:',
  'entityAssociations.retry': 'إعادة المحاولة',
  'entityAssociations.empty': 'لا توجد ارتباطات بعد.',
  'entityAssociations.emptyHint': 'عندما تبدأ الكيانات بمشاركة الروابط، ستظهر أقوى الارتباطات هنا.',
  'entityAssociations.namespaceLabel': 'مساحة الاسم',
  'entityAssociations.namespaceAll': 'جميع مساحات الأسماء',
  'entityAssociations.metricEntities': 'الكيانات',
  'entityAssociations.metricPairs': 'الارتباطات',
  'entityAssociations.rankedHeading': 'أقوى الارتباطات',
  'entityAssociations.linkedBadge': 'مرتبط',
  'entityAssociations.inferredBadge': 'مُستنتج',
  'entityAssociations.linkedTitle': 'هذه الكيانات متصلة مباشرة.',
  'entityAssociations.inferredTitle': 'لا رابط مباشر: مرتبطة فقط من خلال روابط مشتركة.',
  'entityAssociations.sharedLabel': '{shared} مشترك',
  'entityAssociations.pairTitle': '{jaccard}% تشابه · {shared} من {union} رابط مشترك',
  'entityAssociations.truncated': 'عرض {shown} من {total}: الأقوى أولاً.',
  'memory.tab.freshness': 'Freshness',
  'memoryFreshness.title': 'حداثة المعرفة',
  'memoryFreshness.intro':
    'الحقائق التي لم يُعد المساعد تأكيدها مؤخرًا تتلاشى وفق منحنى النسيان. هذا يُظهر ما أصبح قديمًا ويستحق إعادة التحقق، لتجنب معاملة الحقائق القديمة على أنها مؤكدة.',
  'memoryFreshness.loading': 'جارٍ حساب الحداثة…',
  'memoryFreshness.errorPrefix': 'تعذّر تحميل الرسم البياني:',
  'memoryFreshness.retry': 'إعادة المحاولة',
  'memoryFreshness.empty': 'لا يوجد رسم بياني للمعرفة بعد.',
  'memoryFreshness.emptyHint': 'عندما يسجّل المساعد حقائق عنك، سيتم تتبع حداثتها هنا.',
  'memoryFreshness.namespaceLabel': 'مساحة الاسم',
  'memoryFreshness.namespaceAll': 'جميع مساحات الأسماء',
  'memoryFreshness.metricFresh': 'حديثة',
  'memoryFreshness.metricFading': 'تتلاشى',
  'memoryFreshness.metricStale': 'قديمة',
  'memoryFreshness.recallCaption': 'متوسط الاسترجاع {recall}% من أصل {total} حقيقة',
  'memoryFreshness.queueHeading': 'قائمة إعادة التأكيد',
  'memoryFreshness.queueTruncated': 'عرض {shown} من {total}: عالج هذه أولاً.',
  'memoryFreshness.allFresh': 'جميع الحقائق لا تزال حديثة: لا حاجة لإعادة التأكيد.',
  'memoryFreshness.statusFading': 'تتلاشى',
  'memoryFreshness.statusStale': 'قديمة',
  'memoryFreshness.ageLabel': 'منذ {days} يوم',
  'memoryFreshness.recallTitle': '{recall}% استرجاع · عمر النصف {halfLife} يوم',
  'memory.tab.path': 'المسارات',
  'connectionPath.title': 'مسار الاتصال',
  'connectionPath.intro':
    'تتبّع أقصر سلسلة من العلاقات التي تربط أي كيانين: كيف يربط بينهما الرسم البياني، حتى عبر عدة قفزات.',
  'connectionPath.loading': 'جارٍ تحميل الرسم البياني…',
  'connectionPath.errorPrefix': 'تعذّر تحميل الرسم البياني:',
  'connectionPath.retry': 'إعادة المحاولة',
  'connectionPath.namespaceLabel': 'مساحة الأسماء',
  'connectionPath.namespaceAll': 'جميع مساحات الأسماء',
  'connectionPath.sourceLabel': 'من',
  'connectionPath.targetLabel': 'إلى',
  'connectionPath.sourcePlaceholder': 'كيان البداية',
  'connectionPath.targetPlaceholder': 'كيان النهاية',
  'connectionPath.prompt': 'اختر كيانين لتتبّع كيفية ارتباطهما.',
  'connectionPath.empty': 'لا يوجد رسم بياني معرفي بعد.',
  'connectionPath.emptyHint': 'بمجرد أن يسجّل المساعد حقائق مترابطة، يمكنك تتبّع الاتصالات هنا.',
  'connectionPath.resultHeading': 'أقصر مسار',
  'connectionPath.pathSummary': 'يفصل بينهما {length} قفزة/قفزات',
  'connectionPath.sameMessage': 'اختر كيانين مختلفين.',
  'connectionPath.missingSource': '‏«{entity}» غير موجود في الرسم البياني.',
  'connectionPath.missingTarget': '‏«{entity}» غير موجود في الرسم البياني.',
  'connectionPath.noPath': 'لم يُعثر على أي اتصال بين «{source}» و«{target}».',
  'memoryTree.status.title': 'شجرة الذاكرة',
  'memoryTree.status.autoSyncLabel': 'النظام الآلي',
  'memoryTree.status.autoSyncDescription': 'توقف عن الابتلاع (ويكي) الحالي يبقى قابلاً للتساؤل',
  'memoryTree.status.statusTile': 'الحالة',
  'memoryTree.status.lastSyncTile': 'آخر تزامن',
  'memoryTree.status.totalChunksTile': 'مجموع الشرائح',
  'memoryTree.status.wikiSizeTile': 'حجم ويك',
  'memoryTree.status.statusRunning': 'تشغيل',
  'memoryTree.status.statusPaused': 'مدفوع',
  'memoryTree.status.statusSyncing': 'الموسم',
  'memoryTree.status.statusError': 'خطأ',
  'memoryTree.status.statusIdle': 'Idle',
  'memoryTree.status.never': 'أبداً',
  'memoryTree.status.fetchError': 'لم أستطع الحصول على وضعية شجرة الذاكرة',
  'memoryTree.status.retry': 'Retry',
  'memoryTree.status.retryFailed': 'إعادة تشغيل المهام الفاشلة',
  'memoryTree.status.retryFailedBusy': 'جارٍ إعادة المحاولة...',
  'memoryTree.status.retryFailedDone': 'تمت إعادة إدراج المهام الفاشلة',
  'memoryTree.status.retryFailedCount': 'تمت جدولة {count} مهمة للتشغيل من جديد.',
  'memoryTree.status.retryFailedError': 'تعذّرت إعادة إدراج المهام الفاشلة',
  'memoryTree.status.toggleFailed': 'لا يمكن أن نهز السيرة الذاتية',
  'memoryTree.status.justNow': 'الآن',
  'memoryTree.status.secondsAgo': 'اكساكسوكس قبل',
  'memoryTree.status.minuteAgo': 'قبل 1 دقائق',
  'memoryTree.status.minutesAgo': 'منذ {count} دقيقة',
  'memoryTree.status.hourAgo': 'قبل شهر',
  'memoryTree.status.hoursAgo': 'قبل شهر',
  'memoryTree.status.dayAgo': 'قبل يوم واحد',
  'memoryTree.status.daysAgo': 'قبل أيام',
  'memoryTree.status.integrationsTitle': 'حالة التكاملات',
  'memoryTree.status.integrationsEmpty': 'لا توجد تكاملات متصلة',
  'memoryTree.status.integrationActive': 'نشط',
  'memoryTree.status.integrationStale': 'قديم',
  'memoryTree.status.integrationChunks': 'الشرائح: {count}',
  'alerts.title': 'التنبيهات',
  'alerts.empty': 'لا توجد تنبيهات بعد',
  'alerts.markAllRead': 'تحديد الكل كمقروء',
  'alerts.unread': 'غير مقروء',
  'rewards.title': 'المكافآت',
  'rewards.referrals': 'الإحالات',
  'rewards.coupons': 'استرداد',
  'rewards.localUnavailable':
    'تسجيل الدخول المحلي لا يمنح مكافآت أو قسائم أو رصيد إحالة. لكسب المكافآت، سجّل الخروج ثم تابِع بتسجيل الدخول باستخدام حساب OpenHuman.',
  'rewards.localUnavailableCta': 'افتح إعدادات الحساب',
  'rewards.credits': 'الرصيد',
  'rewards.referralCode': 'رمز الإحالة الخاص بك',
  'rewards.copyCode': 'نسخ الرمز',
  'rewards.share': 'مشاركة',
  'onboarding.welcome': 'مرحبًا. أنا OpenHuman.',
  'onboarding.welcomeDesc': 'مساعدك الذكي الفائق الذي يعمل على جهازك. خاص وبسيط وبالغ القوة.',
  'onboarding.context': 'جمع السياق',
  'onboarding.contextDesc': 'اربط الأدوات والخدمات التي تستخدمها يوميًا.',
  'onboarding.localAI': 'الذكاء الاصطناعي المحلي',
  'onboarding.localAIDesc': 'إعداد نموذج ذكاء اصطناعي محلي يعمل على جهازك.',
  'onboarding.chatProvider': 'مزود المحادثة',
  'onboarding.chatProviderDesc': 'اختر طريقة تفاعلك مع مساعدك.',
  'onboarding.referral': 'الإحالة',
  'onboarding.referralDesc': 'أدخل رمز إحالة إن كان لديك واحد.',
  'onboarding.finish': 'إتمام الإعداد',
  'onboarding.finishDesc': 'انتهيت! ابدأ استخدام OpenHuman.',
  'onboarding.skip': 'تخطي',
  'onboarding.getStarted': 'ابدأ الآن',
  'onboarding.runtimeChoice.title': 'كيف تريد تشغيل OpenHuman؟',
  'onboarding.runtimeChoice.subtitle':
    'اختر الإعداد الأنسب لك. يمكنك تغيير هذا لاحقًا في الإعدادات.',
  'onboarding.runtimeChoice.cloud.title': 'بسيط',
  'onboarding.runtimeChoice.cloud.tagline': 'دع OpenHuman يدير كل شيء نيابةً عنك.',
  'onboarding.runtimeChoice.cloud.f1': 'أمان مدمج',
  'onboarding.runtimeChoice.cloud.f2': 'ضغط الرموز لتمديد استخدامك',
  'onboarding.runtimeChoice.cloud.f3': 'اشتراك واحد يشمل جميع النماذج',
  'onboarding.runtimeChoice.cloud.f4': 'لا حاجة لإدارة مفاتيح API',
  'onboarding.runtimeChoice.cloud.f5': 'سهل الإعداد',
  'onboarding.runtimeChoice.custom.title': 'تشغيل مخصص',
  'onboarding.runtimeChoice.custom.tagline': 'استخدم مفاتيحك الخاصة. تحكم كامل في ما تستخدمه.',
  'onboarding.runtimeChoice.custom.f1': 'ستحتاج إلى مفاتيح API لمعظم الميزات',
  'onboarding.runtimeChoice.custom.f2': 'يُعيد استخدام الخدمات التي تدفع لها مسبقًا',
  'onboarding.runtimeChoice.custom.f3': 'يمكن أن يكون مجانيًا إذا شغّلت كل شيء محليًا',
  'onboarding.runtimeChoice.custom.f4': 'إعداد أكثر وخيارات أوسع',
  'onboarding.runtimeChoice.custom.f5': 'الأفضل للمستخدمين المتمرسين والمطورين',
  'onboarding.runtimeChoice.cloud.creditHighlight': 'رصيد مجاني عند التسجيل',
  'onboarding.runtimeChoice.continueCloud': 'المتابعة بالخيار البسيط',
  'onboarding.runtimeChoice.continueCustom': 'المتابعة بالخيار المخصص',
  'onboarding.runtimeChoice.recommended': 'موصى به',
  'onboarding.runtimeChoice.exitError': 'تعذّر إتمام الإعداد. يُرجى المحاولة مجددًا.',
  'onboarding.apiKeys.title': 'لنضف مفاتيح API الخاصة بك',
  'onboarding.apiKeys.subtitle':
    'يمكنك لصقها الآن أو تخطيها وإضافتها لاحقًا من الاتصالات › مفاتيح API. تُحفظ المفاتيح على هذا الجهاز مشفرةً.',
  'onboarding.apiKeys.openaiLabel': 'مفتاح OpenAI API',
  'onboarding.apiKeys.openaiPlaceholder': 'sk-...',
  'onboarding.apiKeys.openaiOauthHint':
    'استخدم ChatGPT Plus/Pro (اشتراك) أو مفتاح OpenAI API - ليس كلاهما مطلوبًا.',
  'onboarding.apiKeys.openaiOauthOpening': 'فتح تسجيل الدخول...',
  'onboarding.apiKeys.openaiOauthConnect': 'تسجيل الدخول باستخدام ChatGPT',
  'onboarding.apiKeys.openaiOauthConnected': 'تم الاتصال عبر ChatGPT',
  'onboarding.apiKeys.openaiOauthCallbackHint':
    'بعد تسجيل الدخول، الصق عنوان URL الكامل لإعادة التوجيه من متصفحك (يبدأ بـ {url}).',
  'onboarding.apiKeys.oauthDesktopOnly': 'تسجيل الدخول إلى ChatGPT متاح فقط في تطبيق سطح المكتب.',
  'onboarding.apiKeys.oauthStartFailed':
    'تعذّر بدء تسجيل الدخول إلى ChatGPT. حاول مرة أخرى أو استخدم مفتاح API.',
  'onboarding.apiKeys.oauthPasteRedirect':
    'الصق عنوان URL لإعادة التوجيه من متصفحك بعد تسجيل الدخول.',
  'onboarding.apiKeys.oauthCompleteFailed':
    'لم يكتمل تسجيل الدخول إلى ChatGPT. تحقق من عنوان URL لإعادة التوجيه وحاول مرة أخرى.',
  'onboarding.apiKeys.finishSignIn': 'إنهاء تسجيل الدخول إلى ChatGPT',
  'onboarding.apiKeys.orApiKey': 'أو مفتاح API',
  'onboarding.apiKeys.anthropicLabel': 'مفتاح Anthropic API',
  'onboarding.apiKeys.anthropicPlaceholder': 'sk-ant-...',
  'onboarding.apiKeys.saveError': 'تعذّر حفظ هذا المفتاح. يرجى مراجعته والمحاولة مرة أخرى.',
  'onboarding.apiKeys.skipForNow': 'تخطي في الوقت الحالي',
  'onboarding.apiKeys.continue': 'حفظ ومتابعة',
  'onboarding.apiKeys.saving': 'جارٍ الحفظ…',
  'onboarding.custom.stepperInference': 'الاستدلال',
  'onboarding.custom.stepperVoice': 'الصوت',
  'onboarding.custom.stepperOAuth': 'OAuth',
  'onboarding.custom.stepperSearch': 'البحث',
  'onboarding.custom.stepperEmbeddings': 'Embeddings',
  'onboarding.custom.stepperMemory': 'الذاكرة',
  'onboarding.custom.stepCounter': 'الخطوة {n} من {total}',
  'onboarding.custom.defaultTitle': 'افتراضي',
  'onboarding.custom.defaultSubtitle': 'دع OpenHuman يديره نيابةً عنك.',
  'onboarding.custom.configureTitle': 'ضبط',
  'onboarding.custom.configureSubtitle': 'سأختار ما يُستخدم بنفسي.',
  'onboarding.custom.progressAriaLabel': 'تقدم الإعداد الأولي',
  'onboarding.custom.continue': 'متابعة',
  'onboarding.custom.back': 'رجوع',
  'onboarding.custom.finish': 'إتمام الإعداد',
  'onboarding.custom.configureLater':
    'يمكنك إكمال الإعداد بعد انتهاء الإعداد الأولي. سننقلك إلى صفحة الإعدادات المناسبة عند الانتهاء.',
  'onboarding.custom.openSettings': 'فتح في الإعدادات',
  'onboarding.custom.inference.title': 'الاستدلال (النص)',
  'onboarding.custom.inference.subtitle': 'أي نموذج لغوي يجب أن يُجيب على أسئلتك ويشغّل وكلاءك؟',
  'onboarding.custom.inference.defaultDesc':
    'يُوجّه OpenHuman كل عبء عمل إلى نموذج افتراضي مناسب. بدون مفاتيح أو إعداد.',
  'onboarding.custom.inference.configureDesc':
    'استخدم مفتاحك الخاص من OpenAI أو Anthropic. سنستخدمه لجميع أعباء العمل النصية.',
  'onboarding.custom.voice.title': 'الصوت',
  'onboarding.custom.voice.subtitle': 'تحويل الكلام إلى نص والنص إلى كلام لوضع الصوت.',
  'onboarding.custom.voice.defaultDesc':
    'يأتي OpenHuman مع STT/TTS مُدار يعمل تلقائيًا. لا شيء يحتاج إلى إعداد.',
  'onboarding.custom.voice.configureDesc':
    'استخدم ElevenLabs / OpenAI Whisper / إلخ. اضبطه من الإعدادات › الصوت.',
  'onboarding.custom.oauth.title': 'الاتصالات (OAuth)',
  'onboarding.custom.oauth.subtitle': 'Gmail وSlack وNotion وخدمات أخرى متصلة تحتاج إلى OAuth.',
  'onboarding.custom.oauth.defaultDesc':
    'يشغّل OpenHuman مساحة عمل Composio مُدارة. نقرة واحدة لتوصيل كل خدمة لاحقًا.',
  'onboarding.custom.oauth.configureDesc':
    'استخدم حساب Composio الخاص بك / مفتاح API. اضبطه من الإعدادات › الاتصالات.',
  'onboarding.custom.search.title': 'البحث على الويب',
  'onboarding.custom.search.subtitle': 'كيف يبحث OpenHuman على الويب نيابةً عنك.',
  'onboarding.custom.search.defaultDesc': 'يستخدم OpenHuman خادم بحث مُدار. لا حاجة لمفاتيح.',
  'onboarding.custom.search.configureDesc':
    'استخدم مفتاح مزود البحث الخاص بك (Tavily أو Brave إلخ). اضبطه من الإعدادات › الأدوات.',
  'onboarding.custom.embeddings.title': 'Embeddings',
  'onboarding.custom.embeddings.subtitle':
    'كيف يُولِّد OpenHuman تضمينات المتجهات للبحث الدلالي في الذاكرة.',
  'onboarding.custom.embeddings.defaultDesc':
    'يستخدم OpenHuman خدمة تضمين مُدارة. لا حاجة لمفتاح API.',
  'onboarding.custom.embeddings.configureDesc':
    'استخدم موفر التضمين الخاص بك (OpenAI أو Voyage أو Ollama وغيرها).',
  'onboarding.custom.memory.title': 'الذاكرة',
  'onboarding.custom.memory.subtitle': 'كيف يتذكر OpenHuman سياقك وتفضيلاتك ومحادثاتك السابقة.',
  'onboarding.custom.memory.defaultDesc':
    'يدير OpenHuman تخزين الذاكرة واسترجاعها تلقائيًا. لا شيء يحتاج إلى إعداد.',
  'onboarding.custom.memory.configureDesc':
    'افحص الذاكرة أو صدّرها أو امسحها بنفسك. اضبطها من الإعدادات › الذاكرة.',
  'accounts.addAccount': 'إضافة حساب',
  'accounts.addApps': 'إضافة تطبيقات',
  'accounts.manageAccounts': 'إدارة الحسابات',
  'accounts.noAccounts': 'لا توجد حسابات متصلة',
  'accounts.connectAccount': 'اربط حسابًا للبدء',
  'accounts.agent': 'الوكيل',
  'accounts.respondQueue': 'قائمة الردود',
  'accounts.disconnect': 'قطع الاتصال',
  'accounts.disconnectConfirm': 'هل أنت متأكد من أنك تريد قطع الاتصال بهذا الحساب؟',
  'accounts.disconnectClearMemory': 'حذف الذاكرة من هذا المصدر أيضاً',
  'accounts.disconnectClearMemoryHint':
    'يُزيل نهائياً مقاطع الذاكرة المحلية المرتبطة بهذا الاتصال.',
  'accounts.searchAccounts': 'البحث في الحسابات...',
  'channels.title': 'القنوات',
  'channels.configure': 'ضبط القناة',
  'channels.setup': 'إعداد',
  'channels.noChannels': 'لا توجد قنوات مضبوطة',
  'channels.localManagedUnavailable': 'القنوات المُدارة غير متاحة للمستخدمين المحليين.',
  'channels.addChannel': 'إضافة قناة',
  'channels.status.connected': 'متصل',
  'channels.status.disconnected': 'غير متصل',
  'channels.status.error': 'خطأ',
  'channels.status.configuring': 'جارٍ الضبط',
  'channels.defaultMessaging': 'قناة المراسلة الافتراضية',
  'channels.setAsDefault': 'تعيين كافتراضي',
  'channels.defaultBadge': 'افتراضي',
  'webhooks.title': 'الـ Webhooks',
  'webhooks.create': 'إنشاء Webhook',
  'webhooks.noWebhooks': 'لا توجد Webhooks مضبوطة',
  'webhooks.url': 'URL',
  'webhooks.secret': 'المفتاح السري',
  'webhooks.events': 'الأحداث',
  'webhooks.archiveDirectory': 'دليل الأرشيف',
  'webhooks.todayFile': 'ملف اليوم',
  'invites.title': 'الدعوات',
  'invites.create': 'إنشاء دعوة',
  'invites.noInvites': 'لا توجد دعوات معلقة',
  'invites.code': 'رمز الدعوة',
  'invites.copyLink': 'نسخ الرابط',
  'invites.generate': 'إنشاء دعوة',
  'invites.generating': 'جارٍ إنشاء...',
  'invites.refreshing': 'تحديث الدعوات...',
  'invites.loading': 'تحميل الدعوات...',
  'invites.copyCodeAria': 'نسخ رمز الدعوة',
  'invites.revokeAria': 'إلغاء الدعوة',
  'invites.usedUp': 'تم استخدامه',
  'invites.uses': 'الاستخدامات: {current}{max}',
  'invites.expiresOn': 'تنتهي الصلاحية {date}',
  'invites.empty': 'لا توجد دعوات حتى الآن',
  'invites.emptyHint': 'إنشاء رمز دعوة للمشاركة مع الآخرين',
  'invites.revokeTitle': 'إلغاء رمز الدعوة',
  'invites.revokePromptPrefix': 'هل أنت متأكد من رغبتك في إلغاء رمز الدعوة',
  'invites.revokeWarning':
    'لن يكون رمز الدعوة هذا صالحاً بعد الآن ولا يمكن استخدامه للانضمام إلى الفريق.',
  'invites.revoking': 'إلغاء...',
  'invites.revokeAction': 'إلغاء الدعوة',
  'invites.failedGenerate': 'فشل إنشاء الدعوة',
  'invites.failedRevoke': 'فشل إلغاء الدعوة',
  'team.refreshingMembers': 'جارٍ تحديث الأعضاء...',
  'team.loadingMembers': 'جارٍ تحميل الأعضاء...',
  'team.memberCount': '{count} عضو',
  'team.memberCountPlural': '{count} أعضاء',
  'team.you': '(أنت)',
  'team.removeAria': 'إزالة {name}',
  'team.noMembers': 'لم يتم العثور على أعضاء',
  'team.removeTitle': 'إزالة عضو الفريق',
  'team.removePromptPrefix': 'هل أنت متأكد من أنك تريد إزالة',
  'team.removePromptSuffix': 'من الفريق؟',
  'team.removeWarning': 'سيفقدون إمكانية الوصول إلى الفريق وجميع موارد الفريق.',
  'team.removing': 'جارٍ الإزالة...',
  'team.removeAction': 'إزالة العضو',
  'team.changeRoleTitle': 'تغيير دور العضو',
  'team.changeRolePrompt': 'تغيير دور {name} من {oldRole} إلى {newRole}؟',
  'team.changeRoleAdminGrant':
    'سيمنحهم ذلك صلاحيات إدارية كاملة تشمل القدرة على إدارة أعضاء الفريق.',
  'team.changeRoleAdminRemove':
    'سيُزيل ذلك صلاحياتهم الإدارية ولن يتمكنوا بعد الآن من إدارة الفريق.',
  'team.changing': 'جارٍ التغيير...',
  'team.changeRoleAction': 'تغيير الدور',
  'team.failedChangeRole': 'فشل تغيير الدور',
  'team.failedRemoveMember': 'فشلت إزالة العضو',
  'devOptions.title': 'متقدم',
  'devOptions.titleDiagnostics': 'المطور والتشخيص',
  'devOptions.diagnostics': 'التشخيص',
  'devOptions.diagnosticsDesc': 'صحة النظام والسجلات ومقاييس الأداء',
  'devOptions.toolPolicyDiagnosticsDesc':
    'قوائم جرد المواد، ووضع السياسات، والقوائم المسموح بها بx0xx، والوحدات الأخيرة',
  'devOptions.toolPolicyDiagnostics.loading': 'التعبئة...',
  'devOptions.toolPolicyDiagnostics.unavailable': 'التشخيص غير متاح',
  'devOptions.toolPolicyDiagnostics.posture.title': 'وضع السياسات',
  'devOptions.toolPolicyDiagnostics.posture.autonomy': 'الحكم الذاتي:',
  'devOptions.toolPolicyDiagnostics.posture.workspaceOnly': 'مكان العمل فقط:',
  'devOptions.toolPolicyDiagnostics.posture.maxActionsPerHour': 'ماكس Xqx0xx:',
  'devOptions.toolPolicyDiagnostics.posture.approvalMediumRisk': 'الموافقة (مخاطر متوسطة):',
  'devOptions.toolPolicyDiagnostics.posture.blockHighRisk': 'مخاطر كبيرة:',
  'devOptions.toolPolicyDiagnostics.inventory.title': 'المخزون',
  'devOptions.toolPolicyDiagnostics.inventory.totalTools': 'مجموع الأدوات',
  'devOptions.toolPolicyDiagnostics.inventory.enabledTools': 'الأدوات التمكينية',
  'devOptions.toolPolicyDiagnostics.inventory.mcpStdioTools': 'أجهزة الاستديو',
  'devOptions.toolPolicyDiagnostics.inventory.jsonRpcTools':
    'xx0xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx0xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.title': 'القائمة المسموح بها',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.summary':
    'مُفعَّل: {enabled} · الخوادم: {enabledCount}/{totalCount}',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.unnamed': 'اسم مستعار',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.allowDeny':
    'السماح = xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  'devOptions.toolPolicyDiagnostics.mcpWriteAudit.title': 'Xqx0xx',
  'devOptions.toolPolicyDiagnostics.mcpWriteAudit.summary':
    'مُفعَّل: {enabled} · الأخيرة (24 ساعة): {recentRows}',
  'devOptions.toolPolicyDiagnostics.recentBlocked.title': 'النداءات الأخيرة المغلقة',
  'devOptions.toolPolicyDiagnostics.recentBlocked.empty': 'لم تسجل أي مكالمات',
  'devOptions.toolPolicyDiagnostics.redactedSurfaces.title': 'أسطح متفاعلة',
  'devOptions.toolPolicyDiagnostics.redactedSurfaces.summary':
    'القدرة على الشطب: Xqx0xx: مساحات السياسة العامة: Xqx1xx',
  'devOptions.debugPanels': 'لوحات التصحيح',
  'devOptions.debugPanelsDesc': 'أعلام الميزات وفحص الحالة وأدوات التصحيح',
  'devOptions.webhooks': 'الـ Webhooks',
  'devOptions.webhooksDesc': 'ضبط واختبار تكاملات Webhook',
  'devOptions.memoryInspection': 'فحص الذاكرة',
  'devOptions.memoryInspectionDesc': 'تصفح وتساؤل وإدارة إدخالات الذاكرة',
  'voice.pushToTalk': 'اضغط للتحدث',
  'voice.recording': 'جارٍ التسجيل...',
  'voice.processing': 'جارٍ المعالجة...',
  'voice.languageHint': 'اللغة',
  'misc.rehydrating': 'جارٍ تحميل بياناتك...',
  'misc.checkingServices': 'جارٍ التحقق من الخدمات...',
  'misc.serviceUnavailable': 'الخدمة غير متاحة',
  'misc.somethingWentWrong': 'حدث خطأ ما',
  'misc.tryAgainLater': 'يرجى المحاولة مرة أخرى لاحقًا.',
  'misc.restartApp': 'إعادة تشغيل التطبيق',
  'misc.updateAvailable': 'تحديث متاح',
  'misc.updateNow': 'تحديث الآن',
  'misc.updateLater': 'لاحقًا',
  'misc.downloading': 'جارٍ التنزيل...',
  'misc.installing': 'جارٍ التثبيت...',
  'misc.beta':
    'OpenHuman في مرحلة تجريبية مبكرة. لا تتردد في مشاركة ملاحظاتك أو الإبلاغ عن أي أخطاء تواجهها: كل تقرير يساعدنا على الإنجاز بشكل أسرع.',
  'misc.betaFeedback': 'إرسال ملاحظات',
  'mnemonic.title': 'عبارة الاسترداد',
  'mnemonic.warning': 'اكتب هذه الكلمات بالترتيب واحفظها في مكان آمن.',
  'mnemonic.copyWarning':
    'لا تشارك عبارة الاسترداد أبدًا. أي شخص يمتلك هذه الكلمات يمكنه الوصول إلى حسابك.',
  'mnemonic.copied': 'تم نسخ عبارة الاسترداد إلى الحافظة',
  'mnemonic.reveal': 'الكشف عن العبارة',
  'mnemonic.revealPhrase': 'إظهار عبارة الاسترداد',
  'mnemonic.hidden': 'عبارة الاسترداد مخفية',
  'privacy.title': 'الخصوصية والأمان',
  'privacy.description': 'تقرير شفافية البيانات المُرسَلة إلى الخدمات الخارجية.',
  'privacy.empty': 'لم يُرصد أي نقل بيانات خارجي.',
  'privacy.whatLeavesComputer': 'ما يغادر جهازك',
  'privacy.loading': 'جارٍ تحميل تفاصيل الخصوصية...',
  'privacy.loadError': 'تعذّر تحميل قائمة الخصوصية المباشرة. لا تزال ضوابط التحليل أدناه تعمل.',
  'privacy.noCapabilities': 'لا توجد إمكانات تكشف عن حركة بيانات حاليًا.',
  'privacy.sentTo': 'مُرسَل إلى',
  'privacy.leavesDevice': 'يغادر الجهاز',
  'privacy.staysLocal': 'يبقى محليًا',
  'privacy.anonymizedAnalytics': 'تحليلات المنتج',
  'privacy.shareAnonymizedData': 'مشاركة تحليلات المنتج والتشخيصات',
  'privacy.shareAnonymizedDataDesc':
    'ساعد في تحسين OpenHuman من خلال مشاركة تقارير أعطال وأحداث استخدام محدودة الخصوصية، بما في ذلك معرّف حساب ثابت وبيانات إصدار التطبيق. لا تُجمع الرسائل أو مفاتيح المحافظ أو مفاتيح API أو رموز الجلسات أبدًا.',
  'privacy.meetingFollowUps': 'متابعات الاجتماعات',
  'privacy.autoHandoffMeet': 'تسليم نسخ Google Meet تلقائيًا إلى المنسق',
  'privacy.autoHandoffMeetDesc':
    'عند انتهاء مكالمة Google Meet، يمكن لمنسق OpenHuman قراءة النسخة المكتوبة واتخاذ إجراءات كصياغة الرسائل أو جدولة المتابعات أو نشر الملخصات في مساحة عمل Slack المتصلة. معطّل افتراضيًا.',
  'privacy.analyticsDisclaimer':
    'عند التفعيل، قد تتضمن تحليلات المنتج والتشخيصات تقارير أعطال وأحداث استخدام محدودة الخصوصية، ومعرّف حساب ثابتًا، وبيانات إصدار التطبيق. لا تُجمع الرسائل أو مفاتيح المحافظ أو مفاتيح API أو رموز الجلسات أبدًا. يمكنك تغيير هذا الإعداد في أي وقت.',
  'settings.about.version': 'الإصدار',
  'settings.about.updateAvailable': 'متاح',
  'settings.about.softwareUpdates': 'تحديثات البرنامج',
  'settings.about.lastChecked': 'آخر فحص',
  'settings.about.checking': 'جارٍ التحقق...',
  'settings.about.checkForUpdates': 'التحقق من التحديثات',
  'settings.about.releases': 'الإصدارات',
  'settings.about.releasesDesc': 'تصفح ملاحظات الإصدار والإصدارات السابقة على GitHub.',
  'settings.about.openReleases': 'فتح إصدارات GitHub',
  'settings.about.starCta.title': 'هل يعجبك OpenHuman؟',
  'settings.about.starCta.body':
    'امنحنا نجمة على GitHub. هذا يساعد المزيد من الأشخاص على العثور علينا.',
  'settings.about.starCta.star': 'ضع نجمة على GitHub',
  'settings.about.starCta.dismiss': 'ليس الآن',
  'settings.about.connection': 'اتصال',
  'settings.about.connectionMode': 'الوضع',
  'settings.about.connectionModeLocal': 'محلي',
  'settings.about.connectionModeCloud': 'السحابة',
  'settings.about.connectionModeUnset': 'لم يتم التحديد',
  'settings.about.serverUrl': 'الخادم URL',
  'settings.about.serverUrlUnavailable': 'غير متاح',
  'settings.about.connectionHelperLocal':
    'مأخوذة في العملية من قذيفة Xqx1x على عملية الإطلاق يتم اختيار المرفأ في البداية لذا تغيرت هذه الـ (إكسكساكس) بين الإطلاقات',
  'settings.about.connectionHelperCloud':
    'متصلة بقاعدة نائية غيّر هذا في (بوتشيك) أو مُخلّق السحابة.',
  'settings.heartbeat.title': 'نبضات القلب والحلقات',
  'settings.usage.title': 'الاستخدام والحدود',
  'settings.usage.menuDesc': 'التكاليف واستخدام الرموز والميزانيات والنشاط في الخلفية',
  'settings.costDashboard.title': 'لوحة بيانات التكاليف',
  'settings.costDashboard.sevenDayCost': 'التكلفة اليومية',
  'settings.costDashboard.sevenDayTokens': '7 أيام',
  'settings.costDashboard.totalSpend': 'المجموع 7 أيام',
  'settings.costDashboard.monthlyPace': 'الوتيرة الشهرية',
  'settings.costDashboard.budgetLimit': 'الحد الأقصى للميزانية',
  'settings.costDashboard.utilization': 'الاستخدام',
  'settings.costDashboard.modelBreakdown': 'التوزيع حسب النموذج',
  'settings.costDashboard.model': 'النموذج النموذجي',
  'settings.costDashboard.provider': 'Provider',
  'settings.costDashboard.cost': 'التكلفة',
  'settings.costDashboard.tokens': 'Tokens',
  'settings.costDashboard.requests': 'الطلبات',
  'settings.costDashboard.percentOfTotal': 'النسبة المئوية من المجموع',
  'settings.costDashboard.inputTokens': 'الناتج',
  'settings.costDashboard.outputTokens': 'الناتج',
  'settings.costDashboard.budgetNormal': 'على المسار',
  'settings.costDashboard.budgetWarning': 'تحذير',
  'settings.costDashboard.budgetExceeded': 'الميزانية',
  'settings.costDashboard.noBudget': 'لا حد محدد',
  'settings.costDashboard.noData': 'لم تسجل أي تكلفة حتى الآن في الأيام السبعة الماضية.',
  'settings.costDashboard.noModels': 'لا نشاط نموذجي في الأيام السبعة الماضية.',
  'settings.costDashboard.loading': 'لوح التعبئة',
  'settings.costDashboard.disabledHint':
    'خزانة التكاليف معطلة في الدير مجموعة [xx0xx] مُمَكَّنَة = حقيقي في Xqx1x إلى re-enable.',
  'settings.costDashboard.subtitle':
    'نقضي حياتنا ونحترق عبر الحزام ولا حاجة إلى إعادة تحميل الصفحات.',
  'settings.costDashboard.summaryAriaLabel': 'القياسات الموجزة للتكاليف',
  'settings.costDashboard.lastSevenDays': '7 أيام',
  'settings.costDashboard.utilizationOf': 'من',
  'settings.costDashboard.thisMonth': 'هذا الشهر',
  'settings.costDashboard.monthlyPaceHint':
    'الإنفاق الشهري المتوقع في المعدل اليومي الحالي (الساعة × 30).',
  'settings.costDashboard.budgetLimitHint': 'قراءة الميزانية الشهرية من Xqx0xx في Xqx1x.',
  'settings.costDashboard.dailyTarget': 'الهدف اليومي',
  'settings.costDashboard.today': 'اليوم',
  'settings.costDashboard.todayBadge': 'TODAY',
  'settings.costDashboard.unknownProvider': 'لا شيء',
  'settings.costDashboard.justNow': 'الآن',
  'settings.costDashboard.secondsAgo': 'اكساكسوكس قبل',
  'settings.costDashboard.minutesAgo': 'Xqx0xx قبل',
  'settings.costDashboard.hoursAgo': 'Xqx0xx منذ ح',
  'settings.costDashboard.daysAgo': 'Xqx0xx قبل',
  'settings.costDashboard.updated': 'Updated',
  'settings.costDashboard.refresh': 'التجديد',
  'settings.costDashboard.utcNote': '"يوماً مربوطاً في "إكسكساكس',
  'settings.costDashboard.stackedNote': 'الناتج + الناتج',
  'settings.costDashboard.modelBreakdownHint': 'تم تجميعها خلال السبعة أيام الماضية',
  'settings.costDashboard.categoryDistribution': 'الإنفاق حسب الفئة',
  'settings.costDashboard.categoryDistributionHint':
    'مستنتج من سجلات حديثة لمكالمات الدردشة والتضمينات والصوت والصور وإعادة الترتيب.',
  'settings.costDashboard.noCategories': 'لم يتم تسجيل إنفاق حسب الفئة بعد.',
  'settings.costDashboard.categoryMeta': '{requests} طلب • {tokens} رمز',
  'settings.costDashboard.usageLog': 'سجل الاستخدام',
  'settings.costDashboard.usageLogHint': 'أحدث السجلات من آخر {days} يومًا، بحد أقصى {limit} صفًا.',
  'settings.costDashboard.logTotal': '{requests} طلب • {cost}',
  'settings.costDashboard.noUsageLog': 'لم يتم العثور على سجلات استخدام لهذه الفترة.',
  'settings.costDashboard.when': 'الوقت',
  'settings.costDashboard.category': 'الفئة',
  'settings.costDashboard.session': 'الجلسة',
  'settings.costDashboard.noDataHint':
    'إرسال رسالة وكيل - الاستخدام المكسور من النداء القادم للمزود سينشر المخطط في غضون حوالي 10 ثوان.',
  'settings.search.title': 'محرك البحث',
  'settings.search.menuDesc': 'تخلف عن البحث أو التنصت على مزودك الخاص بمفتاح اكسوكس',
  'settings.search.description':
    'اختر محرك البحث الذي يستخدمه الوكيل، أو عطّل أدوات البحث بالكامل. يستخدم الوضع المُدار واجهة خلفية OpenHuman (بدون إعداد). تعمل محركات Parallel وBrave وQuerit وExa مباشرةً من جهازك باستخدام مفتاح API الخاص بك.',
  'settings.search.engineAria': 'محرك البحث',
  'settings.search.engineDisabledLabel': 'Disabled',
  'settings.search.engineDisabledDesc': 'أزل أدوات البحث من سياق الوكيل وقائمة الأدوات المتاحة.',
  'settings.search.engineManagedLabel': 'OpenHuman مُدار',
  'settings.search.engineManagedDesc':
    'الإعداد الافتراضي. يتم توجيهه عبر خادم OpenHuman الخلفي، المدعوم حاليًا بواسطة Exa: لا حاجة إلى مفتاح API.',
  'settings.search.localManagedUnavailable':
    'بحث OpenHuman المُدار غير متاح للمستخدمين المحليين. أضف مفتاح Parallel أو Brave أو Querit أو Exa الخاص بك لتفعيل البحث على الويب.',
  'settings.search.engineParallelLabel': 'Parallel',
  'settings.search.engineParallelDesc':
    'واجهة برمجية متوازية مباشرة: أدوات البحث والاستخراج والمحادثة والبحث المتعمق والإثراء ومجموعات البيانات.',
  'settings.search.engineBraveLabel': 'Brave بحث',
  'settings.search.engineBraveDesc': 'مباشر Brave بحث API: أدوات الويب والأخبار والصور والفيديو.',
  'settings.search.engineQueritLabel': 'Querit',
  'settings.search.engineQueritDesc':
    'واجهة Querit API المباشرة: بحث على الويب مع فلاتر الموقع والنطاق الزمني والبلد واللغة.',
  'settings.search.engineExaLabel': 'Exa',
  'settings.search.engineExaDesc':
    'بحث عصبي مدعوم من Exa. يتطلب مفتاح API الخاص بك من Exa. يضيف أدوات البحث والعثور على صفحات مشابهة واسترجاع محتوى الصفحات.',
  'settings.search.statusConfigured': 'تم تكوينه',
  'settings.search.statusNeedsKey': 'يحتاج إلى مفتاح API',
  'settings.search.fallbackToManaged':
    'ولن يتم تشكيل أي مفتاح - سوف يعود البحث إلى إدارة حتى يتم توفير المفتاح.',
  'settings.search.getApiKey': 'احصل على مفتاح API',
  'settings.search.save': 'احفظ',
  'settings.search.clear': 'مسح',
  'settings.search.show': 'عرض',
  'settings.search.hide': 'إخفاء',
  'settings.search.statusSaving': 'جاري الحفظ…',
  'settings.search.statusSaved': 'تم الحفظ.',
  'settings.search.statusError': 'فشل',
  'settings.search.parallelKeyLabel': 'Parallel API مفتاح',
  'settings.search.braveKeyLabel': 'Brave بحث API مفتاح',
  'settings.search.queritKeyLabel': 'مفتاح API الخاص بـ Querit',
  'settings.search.exaKeyLabel': 'مفتاح API الخاص بـ Exa',
  'settings.search.placeholderStored': '•••••••• (مخزن)',
  'settings.search.placeholderParallel': 'pk_...',
  'settings.search.placeholderBrave': 'BSA...',
  'settings.search.placeholderQuerit': 'مفتاح API الخاص بـ Querit',
  'settings.search.placeholderExa': 'الصق مفتاح API الخاص بـ Exa…',
  'settings.search.allowedSitesLabel': 'المواقع الشبكية المسموح بها',
  'settings.search.allowedSitesHint':
    'المضيفون الذين يُسمح للمساعد بفتحهم وقراءتهم (عبر جلب الويب وأداة المتصفح) مضيف واحد في كل سطر، مثل reuters.com. يشمل المضيف نطاقاته الفرعية أيضًا. البحث على الويب نفسه لا يتقيّد بهذه القائمة.',
  'settings.search.allowedSitesAllOn':
    'يمكن للمساعد فتح أي موقع علني العناوين المحلية والخاصة تبقى مغلقة',
  'settings.search.allowedSitesPlaceholder': 'reuters.com\napnews.com\ngithub.com',
  'settings.search.allowedSitesSave': 'توفير المواقع الشبكية',
  'settings.search.accessModeAria': 'شبكة الإنترنت',
  'settings.search.accessAllowAll': 'السماح للجميع',
  'settings.search.accessCustom': 'العرف',
  'settings.search.accessBlockAll': 'كل شيء',
  'settings.search.accessBlockAllHint':
    'وكل الوصول إلى شبكة الإنترنت مغلق - لا يمكن للمساعد فتح أو قراءة أي موقع على شبكة الإنترنت.',
  // ─── Settings global search bar ────────────────────────────
  'settings.settingsSearch.placeholder': 'بحث في الإعدادات…',
  'settings.settingsSearch.ariaLabel': 'بحث في الإعدادات',
  'settings.settingsSearch.clear': 'مسح البحث',
  'settings.settingsSearch.resultsLabel': 'نتائج البحث',
  'settings.settingsSearch.noResults': 'لا توجد إعدادات مطابقة لـ ”{query}“',
  'settings.embeddings.title': 'التضمينات',
  'settings.embeddings.description':
    'اختر مزود التضمينات الذي يحول الذاكرة إلى متجهات للبحث الدلالي. تغيير المزود أو النموذج أو الأبعاد يبطل المتجهات المخزنة ويتطلب إعادة تعيين كاملة للذاكرة.',
  'settings.embeddings.providerAria': 'مزود التضمينات',
  'settings.embeddings.statusConfigured': 'تم التهيئة',
  'settings.embeddings.statusNeedsKey': 'يحتاج مفتاح API',
  'settings.embeddings.requiresSignIn': 'يتطلب تسجيل الدخول إلى OpenHuman',
  'settings.embeddings.managedLoginRequired':
    'تتطلب التضمينات المُدارة تسجيل الدخول إلى OpenHuman. سجّل الدخول لاستخدام خلفية OpenHuman.',
  'settings.embeddings.managedBannerIntro':
    'تمر التضمينات المُدارة عبر خلفية OpenHuman وتتطلب جلسة حساب OpenHuman.',
  'settings.embeddings.managedBannerLocalSession':
    'اخرج من الجلسة المحلية وسجّل الدخول لاستخدام هذا المزوّد، أو انتقل إلى مزوّد تضمينات محلي أو بمفتاحك الخاص.',
  'settings.embeddings.managedBannerRemoteSession':
    'سجّل الدخول مرة أخرى لتحديث جلسة OpenHuman، أو انتقل إلى مزوّد تضمينات محلي أو بمفتاحك الخاص.',
  'settings.embeddings.signInAgain': 'تسجيل الدخول مرة أخرى',
  'settings.embeddings.apiKeyLabel': 'مفتاح API لـ {provider}',
  'settings.embeddings.apiKeyLabelGeneric': 'مفتاح API',
  'settings.embeddings.placeholderStored': '•••••••• (مخزن)',
  'settings.embeddings.placeholderKey': 'الصق مفتاح API الخاص بك…',
  'settings.embeddings.keyStoredEncrypted': 'يتم تخزين مفتاح API الخاص بك مشفرًا على هذا الجهاز.',
  'settings.embeddings.show': 'إظهار',
  'settings.embeddings.hide': 'إخفاء',
  'settings.embeddings.save': 'حفظ',
  'settings.embeddings.clear': 'مسح',
  'settings.embeddings.model': 'النموذج',
  'settings.embeddings.dimensions': 'الأبعاد',
  'settings.embeddings.customEndpoint': 'نقطة نهاية مخصصة',
  'settings.embeddings.customModelPlaceholder': 'اسم النموذج',
  'settings.embeddings.customDimsPlaceholder': 'الأبعاد',
  'settings.embeddings.applyCustom': 'تطبيق',
  'settings.embeddings.testConnection': 'اختبار الاتصال',
  'settings.embeddings.testing': 'جارٍ الاختبار…',
  'settings.embeddings.testSuccess': 'متصل: {dims} بُعد',
  'settings.embeddings.connectionTestFailed': 'فشل الاختبار',
  'settings.embeddings.verifyFallback':
    'تعذّر التحقق من نقطة نهاية التضمين. تأكد من أنها قيد التشغيل وتوفّر نموذج تضمين، ثم احفظ مرة أخرى.',
  'settings.embeddings.testFailed': 'فشل: {error}',
  'settings.embeddings.saving': 'جارٍ الحفظ…',
  'settings.embeddings.saved': 'تم الحفظ.',
  'settings.embeddings.errorPrefix': 'فشل',
  'settings.embeddings.wipeTitle': 'إعادة تعيين متجهات الذاكرة؟',
  'settings.embeddings.wipeBody':
    'سيؤدي تغيير مزود التضمينات أو النموذج أو الأبعاد إلى مسح جميع متجهات الذاكرة المخزنة. يجب إعادة بناء الذاكرة قبل أن يعمل الاسترجاع مرة أخرى. لا يمكن التراجع عن هذا.',
  'settings.embeddings.cancel': 'إلغاء',
  'settings.embeddings.confirmWipe': 'مسح وتطبيق',
  'settings.embeddings.setupTitle': 'إعداد {provider}',
  'settings.embeddings.saveAndSwitch': 'حفظ والتبديل',
  'settings.embeddings.optional': 'اختياري',
  'settings.embeddings.vectorSearchDisabled':
    'تم تعطيل البحث والتذكير بالذاكرة سيستخدم مضاهاة الكلمات الرئيسية والراحة فقط - لا ترتيب ساكن.',
  'settings.embeddings.clearKey': 'مسح مفتاح API',
  'pages.settings.ai.embeddings': 'التضمينات',
  'pages.settings.ai.embeddingsDesc': 'نموذج ترميز المتجهات لاسترجاع الذاكرة',
  'mcp.alphaBadge': 'ألفا',
  'mcp.alphaBannerText':
    'دعم خادم MCP في مرحلة ألفا المبكرة. قد يتصرف سجل وتدفق التثبيت وربط الأدوات بشكل غير متوقع أو يتغير شكله بين الإصدارات.',
  'mcp.toolList.noTools': 'لا توجد أدوات متاحة.',
  'mcp.setup.secretDialog.title': 'MCP الإعداد - أدخل السر',
  'mcp.setup.secretDialog.bodyPrefix': 'يحتاج وكيل الإعداد MCP',
  'mcp.setup.secretDialog.bodySuffix':
    '. تُرسَل قيمتك مباشرةً إلى العملية الأساسية ولا تدخل محادثة الذكاء الاصطناعي أبداً.',
  'mcp.setup.secretDialog.inputLabel': 'القيمة',
  'mcp.setup.secretDialog.inputPlaceholder': 'الصق هنا',
  'mcp.setup.secretDialog.show': 'عرض',
  'mcp.setup.secretDialog.hide': 'إخفاء',
  'mcp.setup.secretDialog.submit': 'إرسال',
  'mcp.setup.secretDialog.cancel': 'إلغاء',
  'mcp.setup.secretDialog.submitting': 'الإرسال...',
  'mcp.setup.secretDialog.errorPrefix': 'فشل الإرسال:',
  'mcp.setup.secretDialog.privacyNote': 'مسروقة في طاولة الأسرار لم أسجل أو أرسل إلى نموذج',
  'devices.betaBadge': 'تجريبي',
  'devices.betaText':
    'هذه الميزة في مرحلة تجريبية حالياً. اربط هواتف iOS بـ OpenHuman لاستخدامها كعميل بعيد.',
  'devices.comingSoonDescription':
    'إقران الأجهزة قريبًا. ستكون هذه الصفحة مخصصة لإقران أجهزة iPhone وإدارة الأجهزة المتصلة.',
  'devices.title': 'الأجهزة',
  'devices.pairIphone': 'إقران iPhone',
  'devices.noPaired': 'لا توجد أجهزة مقترنة',
  'devices.emptyState': 'قم بمسح QR code على جهاز iPhone الخاص بك لتوصيله بجلسة OpenHuman هذه.',
  'devices.devicePairedTitle': 'تم إقران الجهاز',
  'devices.devicePairedMessage': 'تم توصيل iPhone بنجاح.',
  'devices.deviceRevokedTitle': 'تم إبطال الجهاز',
  'devices.deviceRevokedMessage': '{label} تمت إزالته.',
  'devices.revokeFailedTitle': 'فشل الإلغاء',
  'devices.online': 'متصل',
  'devices.offline': 'غير متصل',
  'devices.lastSeenNever': 'أبدًا',
  'devices.lastSeenNow': 'الآن',
  'devices.lastSeenMinutes': '{count}m منذ',
  'devices.lastSeenHours': '{count} قبل',
  'devices.lastSeenDays': '{count} قبل',
  'devices.revoke': 'إبطال',
  'devices.revokeAria': 'إبطال {label}',
  'devices.confirmRevokeTitle': 'إلغاء الجهاز؟',
  'devices.confirmRevokeBody':
    'لن يتمكن {label} من الاتصال بعد الآن. لا يمكن التراجع عن هذا الإجراء.',
  'devices.loadFailed': 'فشل تحميل الأجهزة: {message}',
  'devices.pairModal.title': 'إقران iPhone',
  'devices.pairModal.loading': 'إنشاء رمز الاقتران...',
  'devices.pairModal.instructions': 'افتح تطبيق OpenHuman على iPhone وامسح هذا الرمز.',
  'devices.pairModal.expiresIn': 'تنتهي صلاحية الرمز خلال ~{count} دقيقة',
  'devices.pairModal.expiresInPlural': 'تنتهي صلاحية الرمز خلال ~{count} دقيقة',
  'devices.pairModal.showDetails': 'إظهار التفاصيل',
  'devices.pairModal.hideDetails': 'إخفاء التفاصيل',
  'devices.pairModal.channelId': 'معرف القناة',
  'devices.pairModal.pairingUrl': 'الاقتران URL',
  'devices.pairModal.expiredTitle': 'QR code انتهت صلاحيته',
  'devices.pairModal.expiredBody': 'أنشئ رمزًا جديدًا لمواصلة الاقتران.',
  'devices.pairModal.generateNewCode': 'إنشاء رمز جديد',
  'devices.pairModal.successTitle': 'مقترن بجهاز iPhone',
  'devices.pairModal.autoClose': 'يتم الإغلاق تلقائيًا...',
  'devices.pairModal.errorPrefix': 'فشل إنشاء الاقتران: {message}',
  'devices.pairModal.errorTitle': 'حدث خطأ ما',
  'devices.pairModal.copyUrl': 'نسخ',
  'mcp.catalog.searchAria': 'البحث في كتالوج الحدادة',
  'mcp.catalog.searchPlaceholder': 'البحث في كتالوج الحدادة...',
  'mcp.catalog.loadFailed': 'فشل تحميل الكتالوج',
  'mcp.registry.error.notFound':
    'لم يتم العثور على الخادم في السجل. تحقق من اسم الخادم وحاول مرة أخرى، أو تصفح خوادم MCP المتاحة، أو أضف الخادم يدويا عبر URL.',
  'mcp.registry.error.network':
    'تعذر الوصول إلى سجل MCP. تحقق من اتصالك وحاول مرة أخرى، أو أضف الخادم يدويا عبر URL.',
  'mcp.registry.error.unavailable':
    'سجل MCP غير متاح حاليا. حاول لاحقا، أو تصفح خوادم MCP المتاحة، أو أضف الخادم يدويا عبر URL.',
  'mcp.catalog.noResults': 'لم يتم العثور على خوادم.',
  'mcp.catalog.noResultsFor': 'لم يتم العثور على خوادم لـ "{query}".',
  'mcp.catalog.loadMore': 'تحميل المزيد',
  'mcp.configAssistant.title': 'مساعد التكوين',
  'mcp.configAssistant.empty': 'اسأل عن التكوين أو متغيرات env المطلوبة أو خطوات الإعداد.',
  'mcp.configAssistant.autoPromptCta': 'احصل على مساعدة الإعداد خطوة بخطوة',
  'mcp.configAssistant.suggestedValues': 'القيم المقترحة:',
  'mcp.configAssistant.valueHidden': '(القيمة مخفية)',
  'mcp.configAssistant.applySuggested': 'تطبيق القيم المقترحة',
  'mcp.configAssistant.reinstallHint': 'أعد التثبيت بهذه القيم لتطبيقها.',
  'mcp.configAssistant.thinking': 'أفكر...',
  'mcp.configAssistant.inputPlaceholder': 'اطرح سؤالاً (أدخل للإرسال، Shift+Enter للسطر الجديد)',
  'mcp.configAssistant.send': 'إرسال',
  'mcp.configAssistant.failedResponse': 'فشل الحصول على الرد',
  'mcp.toolList.availableSingular': '{count} الأداة المتاحة',
  'mcp.toolList.availablePlural': '{count} الأدوات المتاحة',
  'mcp.toolList.tryTool': 'حاول',
  'mcp.toolList.tryToolAria': 'ملعب إعدام مفتوح',
  'mcp.playground.title': 'تشغيل {name}',
  'mcp.playground.close': 'إغلاق الملعب',
  'mcp.playground.inputSchema': 'مخطط الإدخال',
  'mcp.playground.argsLabel': 'المعطيات (JSON)',
  'mcp.playground.argsHelp': 'نوع (إكسكساكس) مطابق للشيما Empty input is treated as {}.',
  'mcp.playground.runShortcut': '⌘/Ctrl + Enter للتشغيل',
  'mcp.playground.format': 'الشكل',
  'mcp.playground.invalidJson': 'JSON غير صالح',
  'mcp.playground.run': 'تشغيل الأداة',
  'mcp.playground.running': 'تشغيل...',
  'mcp.playground.result': 'النتيجة',
  'mcp.playground.resultError': '(تول) أعاد الخطأ',
  'mcp.playground.copyResult': 'النتيجة',
  'mcp.playground.copied': 'Copied',
  'mcp.playground.history': 'التاريخ',
  'mcp.playground.historyEmpty': 'ولا توجد أية احتجاجات حتى الآن في هذه الدورة.',
  'mcp.playground.historyLoad': 'Load',
  'mcp.playground.unexpectedError': 'خطأ غير متوقع يستدعي أداة',
  'mcp.catalog.deployed': 'تم نشرها',
  'mcp.catalog.installCount': '{count} عمليات التثبيت',
  'app.update.dismissNotification': 'تجاهل إشعار التحديث',
  'bootCheck.rpcAuthSuffix': 'في كل RPC.',
  'app.localAiDownload.expandAria': 'توسيع تقدم التنزيل',
  'app.localAiDownload.collapseAria': 'طي تقدم التنزيل',
  'app.localAiDownload.dismissAria': 'تجاهل إشعار التنزيل',
  'mobile.nav.ariaLabel': 'التنقل عبر الهاتف المحمول',
  'progress.stepsAria': 'خطوات التقدم',
  'progress.stepAria': 'الخطوة {current} من {total}',
  'workspace.vaultsTitle': 'خزائن المعرفة',
  'workspace.vaultsDesc': 'أشر إلى مجلد محلي؛ يتم تقسيم الملفات وعكسها في الذاكرة.',
  'calls.title': 'المكالمات',
  'calls.comingSoonBody': 'ستتوفر قريبًا مكالمات مدعومة بالذكاء الاصطناعي. ابقوا متابعين.',
  'art.rotatingTetrahedronAria': 'مركبة فضائية رباعية السطوح دوارة مقلوبة',
  'mcp.installed.title': 'تم التثبيت',
  'mcp.installed.browseCatalog': 'تصفح الكتالوج',
  'mcp.installed.empty': 'لم يتم تثبيت خوادم MCP حتى الآن.',
  'mcp.installed.toolSingular': 'أداة {count}',
  'mcp.installed.toolPlural': 'أدوات {count}',
  'mcp.health.title': 'الصحة',
  'mcp.health.summaryAria': 'موجز الصحة',
  'mcp.health.connectedCount': 'Xqx0x',
  'mcp.health.connectingCount': '{count}connecting',
  'mcp.health.errorCount': '{count}',
  'mcp.health.disconnectedCount': 'Xqx0xxidle',
  'mcp.health.retryAll': 'إعادة المحاولة للكل ({count})',
  'mcp.health.retryAllAria': 'إعادة المحاولة لجميع خوادم MCP {count} التي واجهت أخطاء',
  'mcp.health.disconnectAll': 'قطع كل شيء (xx0xxx)',
  'mcp.health.disconnectAllAria': 'فصل جميع الخواديم متصلة بـ Xqx1xx',
  'mcp.health.disconnectConfirm.title': 'قطع كل خوادم الـ (إكساكس) ؟',
  'mcp.health.disconnectConfirm.body':
    'وسيقطع هذا الربط بين خوادم مكعبة من طراز Xqx0xx. تركيبات وأسرار مثبتة يتم حفظها، يمكنك إعادة ربط أي خادم في وقت لاحق.',
  'mcp.health.disconnectConfirm.cancel': 'إلغاء',
  'mcp.health.disconnectConfirm.confirm': 'انفصال كل شيء',
  'mcp.health.opErrorGeneric': 'عملية الشعب فشلت انظر السجلات',
  'mcp.health.bulkPartialFailure': '×0xx × ×1x خوادم فشل انظر السجلات',
  'mcp.installed.search.landmarkAria': 'حواسيب خواديم مجهزة',
  'mcp.installed.search.inputAria': 'صُوّبت حواسيب خوادم مكعبة بالاسم',
  'mcp.installed.search.placeholder': 'خوادم السينما...',
  'mcp.installed.search.clearAria': 'مرشح واضح',
  'mcp.installed.search.countMatches': 'Xqx0xxxx من خواديم Xqx1x',
  'mcp.installed.search.noMatches': 'لا يوجد خوادم تتطابق مع اكسوكس',
  'mcp.inventory.openButton': 'المخزون',
  'mcp.inventory.openAria': '(أفتح فريق جرد (إكساكسوكساكس',
  'mcp.inventory.title': 'قائمة MCP القابلة للمشاركة',
  'mcp.inventory.subtitle':
    'تصدير خوادم الـ (إكسكساكس) التي تم تركيبها كبيان محمول خال من السرية أو استيراد واحد من زميل الفريق ولا تُدرَج أو تستورد أبداً قيم الحراسة السرية.',
  'mcp.inventory.close': 'فريق الجرد المغلق',
  'mcp.inventory.tablistAria': 'أبواب المخزون',
  'mcp.inventory.tab.export': 'الصادرات',
  'mcp.inventory.tab.import': 'الواردات',
  'mcp.inventory.export.empty':
    'لا يوجد خوادم مكعبة بعد - لا شيء للتصدير. ضع واحداً من الكاتالوج أولاً',
  'mcp.inventory.export.privacyTitle': 'ما في هذا البيان',
  'mcp.inventory.export.privacyBody':
    'أسماء الخادم، أسماء مؤهلة، × ×xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx القيم السرية، أجهزة تحديد الآلات الخاصة بك، والمصابيح المحيطة بالتركيب يتم جردها عمدا.',
  'mcp.inventory.export.serverCount': '{count} خوادم في هذا البيان',
  'mcp.inventory.export.copy': 'نسخ',
  'mcp.inventory.export.copied': 'Copied',
  'mcp.inventory.export.copyAria': 'نسخ البيان Xqx0xx إلى مشبك',
  'mcp.inventory.export.download': 'تحميل',
  'mcp.inventory.export.downloadAria': 'تحميل البيان كملف JSON',
  'mcp.inventory.import.trustTitle': 'التعامل مع البيانات المستوردة كرمز غير موثوق',
  'mcp.inventory.import.trustBody':
    'خادم (إكسكساكس) هو أداة تمنحها لوكيلك فقط بيانات الاستيراد من المصادر التي قمت بها كل تركيبة تتطلب نقرتك الصريحة لا يوجد شيء آلي',
  'mcp.inventory.import.pasteLabel': 'لصق JSON الخاص بالبيان',
  'mcp.inventory.import.pastePlaceholder': 'قدمي بيان هنا أو ارفعي ملف (جيسون)',
  'mcp.inventory.import.preview': 'Preview',
  'mcp.inventory.import.clear': 'آمن',
  'mcp.inventory.import.uploadFile': 'أو تحميل ملف (جيسون)',
  'mcp.inventory.import.uploadFileAria': 'تحميل ملف (جيسون)',
  'mcp.inventory.import.fileTooLarge': 'File is too large (over 1 MB). رفض الحمل',
  'mcp.inventory.import.fileReadFailed': 'لم أستطع قراءة الملف',
  'mcp.inventory.import.parseErrorPrefix': 'لا يمكن أن يكون بياني',
  'mcp.inventory.import.previewHeading': 'Preview',
  'mcp.inventory.import.previewCounts': 'خواديم اكساكساكس - × 1xx جديد، Xqx2x',
  'mcp.inventory.import.previewEmpty': 'لا يوجد خوادم',
  'mcp.inventory.import.exportedFrom': 'مُصدَّر من {exporter}',
  'mcp.inventory.import.exportedAt': 'Xqx0xx',
  'mcp.inventory.import.statusNew': 'جديدة',
  'mcp.inventory.import.statusAlreadyInstalled': 'تم تركيبها',
  'mcp.inventory.import.envKeysLabel': 'مفاتيح Env',
  'mcp.inventory.import.install': 'Install',
  'mcp.inventory.import.installAria': 'تثبيت {name} من هذا البيان',
  'mcp.inventory.import.skipped': 'تخطيت',
  'mcp.inventory.parseError.empty': 'المخلوق فارغ',
  'mcp.inventory.parseError.invalidJson': 'JSON غير صالح.',
  'mcp.inventory.parseError.rootNotObject': 'يجب أن يكون النسيج جسماً من الجذر',
  'mcp.inventory.parseError.unsupportedSchema': 'ولم ينتج هذا الملف مصدر متوافق.',
  'mcp.inventory.parseError.missingExportedAt': 'مفقودة أو غير صحيحة في حقل (إكسكساكس)',
  'mcp.inventory.parseError.missingExportedBy': 'مفقودة أو غير صحيحة في حقل (إكسكساكس)',
  'mcp.inventory.parseError.invalidServers': 'مصفوفة اكسوكساكس أو غير صالحة',
  'mcp.inventory.parseError.serverNotObject': 'دخول الخادم ليس شيئاً',
  'mcp.inventory.parseError.serverMissingQualifiedName': 'دخول الخادم مفقود لقبه المؤهل',
  'mcp.inventory.parseError.serverMissingDisplayName': 'دخول الخادم يفتقد لقبه',
  'mcp.inventory.parseError.serverEnvKeysNotArray':
    'مدخل الخادم لديه حقل للمفاتيح ليس مجموعة من الخيوط',
  'mcp.inventory.parseError.serverContainsEnv':
    'ويحتوي دخول الخادم على خريطة قيمة Xqx0xx. والرفض للواردات - يجب أن لا تحمل البيانات سوى المحركات &quot; المحركات &quot; ، ولا تحمل أبدا قيما سرية.',
  'mcp.inventory.parseError.duplicateQualifiedName':
    'ازدواجية الإسم المؤهل وجد في البيان يجب أن يظهر كل خادم مرة واحدة',
  'mcp.tab.loading': 'جارٍ تحميل خوادم MCP...',
  'mcp.tab.emptyDetail': 'حدد خادمًا أو تصفح الكتالوج.',
  'mcp.tab.filter.all': 'الكل',
  'mcp.tab.filter.installed': 'مثبت ({count})',
  'mcp.tab.filter.registry': 'السجل',
  'mcp.tab.column.name': 'الاسم',
  'mcp.tab.column.description': 'الوصف',
  'mcp.tab.column.type': 'النوع',
  'mcp.tab.column.author': 'المؤلف',
  'mcp.tab.column.action': 'الإجراء',
  'mcp.tab.transport.hosted': 'مستضاف',
  'mcp.tab.transport.local': 'Stdio',
  'mcp.tab.transportFilter.label': 'النوع',
  'mcp.tab.transportFilter.aria': 'تصفية الخوادم حسب وسيلة النقل',
  'mcp.tab.link.website': 'الموقع',
  'mcp.tab.link.repo': 'المستودع',
  'mcp.tab.transport.hostedHint': 'يعمل على خادم بعيد: يُعدّ تسجيل الدخول أو الرمز عند التثبيت',
  'mcp.tab.transport.localHint': 'يعمل على جهازك: قد يحتاج إلى رمز عند التثبيت',
  'mcp.tab.officialBadge': 'رسمي',
  'mcp.tab.officialHint': 'خادم رسمي من المزوّد',
  'mcp.tab.badge.installed': 'مثبت',
  'mcp.tab.badge.registry': 'السجل',
  'mcp.tab.action.manage': 'إدارة',
  'mcp.tab.aria.viewDetails': 'عرض تفاصيل {name}',
  'mcp.tab.aria.installServer': 'تثبيت {name}',
  'mcp.install.loadingDetail': 'جارٍ تحميل تفاصيل الخادم...',
  'mcp.install.back': 'العودة',
  'mcp.install.title': 'تثبيت {name}',
  'mcp.install.requiredEnv': 'متغيرات البيئة المطلوبة',
  'mcp.install.enterValue': 'أدخل {key}',
  'mcp.install.show': 'إظهار',
  'mcp.install.hide': 'إخفاء',
  'mcp.install.configLabel': 'التكوين (اختياري JSON)',
  'mcp.install.configPlaceholder': '{"key": "value"}',
  'mcp.install.missingRequired': 'مطلوب "{key}"',
  'mcp.install.invalidJson': 'تكوين JSON غير صالح JSON',
  'mcp.install.failedDetail': 'فشل تحميل تفاصيل الخادم',
  'mcp.install.failedInstall': 'فشل التثبيت',
  'mcp.install.button': 'تثبيت',
  'mcp.install.installing': 'جارٍ التثبيت...',
  'mcp.install.by': 'بواسطة',
  'mcp.install.useCount': 'عمليات تثبيت {count}',
  'mcp.install.connections': 'الاتصالات المتاحة',
  'mcp.install.published': 'منشور',
  'mcp.install.configureAndInstall': 'تكوين وتثبيت',
  'mcp.install.configureTitle': 'تكوين {name}',
  'mcp.install.advancedConfig': 'تكوين متقدم',
  'mcp.detail.suggestedEnvReady': 'قيم البيئة المقترحة جاهزة',
  'mcp.detail.suggestedEnvBody': 'أعِد تثبيت هذا الخادم بالقيم المقترحة لتطبيقها: {keys}',
  'mcp.detail.connect': 'اتصال',
  'mcp.detail.connecting': 'جارٍ الاتصال...',
  'mcp.detail.authenticate': 'تسجيل الدخول',
  'mcp.detail.authRequired':
    'يتطلب هذا الخادم تسجيل الدخول أو إضافة رمز وصول قبل أن يتمكن من الاتصال. انقر على “تسجيل الدخول” للمصادقة.',
  'mcp.detail.disconnect': 'قطع الاتصال',
  'mcp.detail.hideAssistant': 'إخفاء المساعد',
  'mcp.detail.helpConfigure': 'ساعدني في التهيئة',
  'mcp.detail.confirmUninstall': 'هل تريد تأكيد إلغاء التثبيت؟',
  'mcp.detail.confirmUninstallAction': 'نعم، قم بإلغاء التثبيت',
  'mcp.detail.uninstall': 'قم بإلغاء التثبيت',
  'mcp.detail.envVars': 'متغيرات البيئة',
  'mcp.detail.reconfigure': 'إعادة التهيئة',
  'mcp.detail.reconfigureHint':
    'أدخل قيمًا جديدة لكل متغير، ثم أعد الاتصال. سيؤدي ذلك إلى استبدال القيم المخزَّنة.',
  'mcp.detail.saveReconnect': 'حفظ وإعادة الاتصال',
  'mcp.detail.reconfigureSaving': 'جارٍ الحفظ…',
  'mcp.detail.reconfigureSuccess': 'تم تحديث البيئة وإعادة الاتصال.',
  'mcp.detail.reconfigureReconnectFailed': 'تم الحفظ، لكن فشلت إعادة الاتصال بالقيم الجديدة.',
  'mcp.detail.enable': 'تفعيل',
  'mcp.detail.disable': 'تعطيل',
  'mcp.status.disabled': 'معطّل',
  'mcp.status.unauthorized': 'يلزم تسجيل الدخول',
  'mcp.detail.tools': 'الأدوات',
  'mcp.connectAuth.title': 'الاتصال بـ {name}',
  'mcp.connectAuth.hint':
    'أضف أي مصادقة يحتاجها هذا الخادم، ثم اتصل. يتم تخزين الرموز مشفّرة. اتركها فارغة للخوادم التي لا تحتاج إلى مصادقة.',
  'mcp.connectAuth.requiredLabel': 'مطلوب',
  'mcp.connectAuth.customHeadersLabel': 'رؤوس مخصصة',
  'mcp.connectAuth.customHeadersEmpty':
    'لا توجد رؤوس مخصصة. أضف واحدة إذا كان هذا الخادم يحتاج إلى رأس مصادقة لم يُعلن عنه السجل.',
  'mcp.connectAuth.addHeader': '+ إضافة رأس',
  'mcp.connectAuth.headerName': 'اسم الرأس',
  'mcp.connectAuth.headerValue': 'القيمة',
  'mcp.connectAuth.removeHeader': 'إزالة الرأس',
  'mcp.connectAuth.howToGetToken': 'المساعدة والإعداد',
  'mcp.connectAuth.tokenProvider': 'احصل على الرمز من:',
  'mcp.connectAuth.findToken': 'من أين أحصل على الرمز؟',
  'mcp.connectAuth.hideHelp': 'إخفاء المساعدة',
  'mcp.connectAuth.schemeLabel': 'كيفية إرسال القيمة',
  'mcp.connectAuth.schemeBearer': 'Bearer',
  'mcp.connectAuth.schemeRaw': 'بدون',
  'mcp.connectAuth.reconnectFailed': 'تم حفظ بيانات الاعتماد، لكن فشل الاتصال.',
  'mcp.connectAuth.oauthHint':
    'يستخدم هذا الخادم OAuth. سجّل الدخول عبر متصفحك للسماح لـ OpenHuman.',
  'mcp.connectAuth.signIn': 'تسجيل الدخول عبر المتصفح',
  'mcp.connectAuth.oauthWaiting': 'في انتظار تسجيل الدخول…',
  'mcp.connectAuth.oauthOrToken':
    'هل لديك بالفعل رمز وصول؟ الصقه بدلاً من ذلك كرأس Authorization أدناه.',
  'mcp.connectAuth.oauthTimeout': 'انتهت مهلة انتظار تسجيل الدخول عبر المتصفح. حاول مرة أخرى.',
  'mcp.connectAuth.authError.oauthRequired':
    'يستخدم هذا الخادم OAuth. استخدم “تسجيل الدخول عبر المتصفح”: لن يتم قبول رمز مميز ملصوق.',
  'mcp.connectAuth.authError.tokenRejected':
    'رفض الخادم هذا الرمز المميز. تأكد من أنه صحيح وأن صلاحيته لم تنتهِ.',
  'mcp.connectAuth.authError.credentialRequired':
    'يتطلب هذا الخادم مصادقة. أضف رمزًا مميزًا أو سجّل الدخول.',
  'onboarding.skipForNow': 'التخطي الآن',
  'onboarding.localAI.continueWithCloud': 'متابعة مع السحابة',
  'onboarding.localAI.useLocalAnyway':
    'استخدم الذكاء الاصطناعي المحلي على أي حال (غير موصى به لجهازك)',
  'onboarding.localAI.useLocalInstead':
    'استخدم الذكاء الاصطناعي المحلي بدلاً من ذلك (اربط Ollama الآن)',
  'onboarding.localAI.setupIssue': 'واجه إعداد الذكاء الاصطناعي المحلي مشكلة',
  'autonomy.title': 'استقلالية الوكيل',
  'autonomy.maxActionsLabel': 'الحد الأقصى للإجراءات في الساعة',
  'autonomy.maxActionsHelp':
    'الحد الأقصى لإجراءات الأداة التي يمكن للوكيل تنفيذها في كل ساعة متجددة. تسري القيمة الجديدة على محادثتك التالية. تحتفظ المهام المجدولة ومستمعو القنوات بحدودهم الحالية حتى تعيد تشغيل OpenHuman.',
  'autonomy.statusSaving': 'جارٍ الحفظ...',
  'autonomy.statusSaved': 'تم الحفظ.',
  'autonomy.statusFailed': 'فشل',
  'autonomy.unlimitedNote': 'غير محدود: تم تعطيل تحديد المعدل.',
  'autonomy.invalidIntegerMsg':
    'يجب أن يكون عدداً صحيحاً موجباً (استخدم الإعداد المسبق «غير محدود» لرفع القيد).',
  'autonomy.presetUnlimited': 'غير محدود (افتراضي)',
  'triggers.toggleFailed': '{action} فشل لـ {trigger}: {message}',
  'settings.ai.overview': 'نظرة عامة على نظام الذكاء الاصطناعي',
  'settings.ai.configStatus': 'حالة الإعداد',
  'settings.ai.fallbackMode': 'وضع الاحتياط',
  'settings.ai.loadedFromRuntime': 'مُحمَّل من بيئة التشغيل',
  'settings.ai.loadingDuration': 'مدة التحميل',
  'settings.ai.localRuntime': 'بيئة النموذج المحلي',
  'settings.ai.openManager': 'فتح المدير',
  'settings.ai.retryDownload': 'إعادة محاولة التنزيل',
  'settings.ai.state': 'الحالة',
  'settings.ai.targetModel': 'النموذج المستهدف',
  'settings.ai.download': 'تنزيل',
  'settings.ai.localModelUnavailable': 'حالة النموذج المحلي غير متاحة.',
  'settings.ai.soulConfig': 'إعداد شخصية SOUL',
  'settings.ai.refreshing': 'جارٍ التحديث...',
  'settings.ai.refreshSoul': 'تحديث SOUL',
  'settings.ai.loadingSoul': 'جارٍ تحميل إعداد SOUL...',
  'settings.ai.identity': 'الهوية',
  'settings.ai.personality': 'الشخصية',
  'settings.ai.safetyRules': 'قواعد الأمان',
  'settings.ai.source': 'المصدر',
  'settings.ai.loaded': 'مُحمَّل',
  'settings.ai.toolsConfig': 'إعداد TOOLS',
  'settings.ai.refreshTools': 'تحديث TOOLS',
  'settings.ai.toolsAvailable': 'الأدوات المتاحة',
  'settings.ai.tools': 'أدوات',
  'settings.ai.activeSkills': 'المهارات النشطة',
  'settings.ai.skills': 'مهارات',
  'settings.ai.skillsOverview': 'نظرة عامة على المهارات',
  'settings.ai.refreshingAll': 'جارٍ تحديث الكل...',
  'settings.ai.refreshAll': 'تحديث جميع إعدادات الذكاء الاصطناعي',
  'settings.notifications.suppressAll': 'كتم جميع الإشعارات',
  'settings.notifications.suppressAllDesc':
    'حظر جميع إشعارات نظام التشغيل من التطبيقات المدمجة بغض النظر عن حالة التركيز.',
  'settings.notifications.toggleDnd': 'تفعيل/تعطيل عدم الإزعاج',
  'settings.notifications.categories': 'الفئات',
  'settings.notifications.categoryFooter':
    'يؤدي تعطيل فئة إلى إيقاف ظهور الإشعارات الجديدة من هذا النوع في مركز الإشعارات. تبقى الإشعارات الموجودة حتى مسحها.',
  'settings.billing.movedToWeb': 'انتقلت الفوترة إلى الويب',
  'settings.billing.openDashboard': 'فتح لوحة الفوترة',
  'settings.billing.movedToWebDesc':
    'تغييرات الاشتراك وطرق الدفع والرصيد والفواتير تُدار الآن من TinyHumans على الويب.',
  'settings.billing.backToSettings': 'العودة إلى الإعدادات',
  'settings.billing.openingBrowser': 'جارٍ فتح المتصفح...',
  'settings.billing.browserNotOpen': 'إذا لم يفتح متصفحك، استخدم الزر أعلاه.',
  'settings.billing.browserOpenFailed': 'تعذّر فتح المتصفح تلقائيًا. استخدم الزر أعلاه.',
  'settings.tools.chooseCapabilities':
    'اختر الإمكانات التي يمكن لـ OpenHuman استخدامها نيابةً عنك.',
  'settings.tools.saveChanges': 'حفظ التغييرات',
  'settings.tools.preferencesSaved': 'تم حفظ التفضيلات',
  'settings.tools.saveFailed': 'فشل حفظ التفضيلات. حاول مرة أخرى.',
  'connections.comingSoon': 'قريبًا',
  'connections.setUp': 'إعداد',
  'connections.configured': 'مضبوط',
  'connections.unavailable': 'غير متاح',
  'connections.checking': 'جارٍ التحقق…',
  'connections.walletConfigured': 'تم ضبط هويات EVM وBTC وSolana وTron المحلية من عبارة الاسترداد.',
  'connections.walletReady': 'إعداد هويات EVM وBTC وSolana وTron المحلية من عبارة استرداد واحدة.',
  'connections.walletError':
    'تعذّر التحقق من حالة المحفظة. انقر للمحاولة مرة أخرى من لوحة عبارة الاسترداد.',
  'connections.walletChecking': 'جارٍ التحقق من حالة المحفظة...',
  'connections.walletIdentities': 'هويات المحفظة',
  'connections.walletDerived': 'مشتقة محليًا من عبارة الاسترداد ومحفوظة كبيانات وصفية آمنة فقط.',
  'connections.privacySecurity': 'الخصوصية والأمان',
  'connections.privacySecurityDesc':
    'جميع البيانات والاعتمادات مُخزَّنة محليًا بسياسة عدم الاحتفاظ بالبيانات. معلوماتك مشفرة ولا تُشارك مع أطراف ثالثة.',
  'channels.status.connecting': 'جارٍ الاتصال',
  'channels.status.notConfigured': 'غير مضبوط',
  'channels.noActiveRoute': 'لا يوجد مسار نشط',
  'channels.activeRoute': 'المسار النشط',
  'channels.loadingDefinitions': 'جارٍ تحميل تعريفات القنوات...',
  'channels.channelConnections': 'اتصالات القنوات',
  'channels.configureAuthModes': 'ضبط أوضاع المصادقة لكل قناة مراسلة.',
  'channels.configNotAvailable': 'الإعداد غير متاح لـ',
  'channels.channel': 'قناة',
  'devOptions.coreModeNotSet': 'وضع النواة: غير محدد',
  'devOptions.coreModeNotSetDesc':
    'لم يتم تأكيد محدد بدء التشغيل بعد. استخدم تبديل الوضع في المحدد للاختيار بين المحلي أو السحابي.',
  'devOptions.local': 'محلي',
  'devOptions.embeddedCoreSidecar': 'النواة المدمجة',
  'devOptions.sidecarSpawned': 'تم تشغيله داخل العملية بواسطة غلاف Tauri عند تشغيل التطبيق.',
  'devOptions.cloud': 'سحابي',
  'devOptions.remoteCoreRpc': 'RPC للنواة عن بُعد',
  'devOptions.token': 'الرمز',
  'devOptions.tokenNotSet': 'غير محدد: سيُعيد RPC خطأ 401',
  'devOptions.triggerSentryTest': 'تشغيل اختبار Sentry (تجريبي)',
  'devOptions.triggerSentryTestDesc':
    'يُطلق خطأ مُعلَّمًا للتحقق من خط أنابيب Sentry. المشكلة #1072: احذف بعد التحقق.',
  'devOptions.sendTestEvent': 'إرسال حدث اختبار',
  'devOptions.sending': 'جارٍ الإرسال…',
  'devOptions.eventSent': 'تم إرسال الحدث',
  'devOptions.sentryDisabled': '(بدون معرف - تم تعطيل الحراسة في هذا الإصدار)',
  'devOptions.failed': 'فشل',
  'devOptions.appLogs': 'سجلات التطبيق',
  'devOptions.appLogsDesc':
    'فتح المجلد الذي يحتوي على ملفات السجل اليومية المتداولة. أرفق الملف الأحدث عند الإبلاغ عن مشكلة.',
  'devOptions.openLogsFolder': 'فتح مجلد السجلات',
  'mnemonic.phraseSaved': 'تم حفظ عبارة الاسترداد',
  'mnemonic.walletReady': 'هويات المحفظة متعددة السلاسل جاهزة. جارٍ العودة إلى الإعدادات...',
  'mnemonic.writeDownWords': 'اكتب هذه',
  'mnemonic.wordsInOrder':
    'كلمات بالترتيب واحفظها في مكان آمن. تُؤمِّن هذه العبارة مفتاح التشفير المحلي وهويات محافظ EVM وBTC وSolana وTron.',
  'mnemonic.cannotRecover':
    'لا يمكن استرداد هذه العبارة إذا فُقدت ويجب أن تبقى محلية على جهازك تمامًا.',
  'mnemonic.copyToClipboard': 'نسخ إلى الحافظة',
  'mnemonic.alreadyHavePhrase': 'لدي بالفعل عبارة استرداد',
  'mnemonic.consentSaved': 'حفظت هذه العبارة وأوافق على استخدامها لإعداد المحفظة المحلية',
  'mnemonic.enterPhraseToRestore':
    'أدخل عبارة الاسترداد أدناه لاستعادة هويات محفظتك المحلية، أو الصق العبارة الكاملة في أي حقل (12 كلمة للنسخ الاحتياطية الجديدة؛ عبارات 24 كلمة من الإصدارات القديمة لا تزال تعمل).',
  'mnemonic.words': 'الكلمات',
  'mnemonic.validPhrase': 'عبارة استرداد صالحة',
  'mnemonic.generateNewPhrase': 'توليد عبارة استرداد جديدة بدلاً من ذلك',
  'mnemonic.securingData': 'جارٍ تأمين بياناتك...',
  'mnemonic.saveRecoveryPhrase': 'حفظ عبارة الاسترداد',
  'mnemonic.userNotLoaded': 'لم يتم تحميل المستخدم. يرجى تسجيل الدخول مرة أخرى أو تحديث الصفحة.',
  'mnemonic.invalidPhrase': 'عبارة الاسترداد غير صالحة. يرجى مراجعة كلماتك والمحاولة مرة أخرى.',
  'mnemonic.somethingWentWrong': 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  'mnemonic.walletAlreadyConfigured': 'محفظتك مضبوطة بالفعل.',
  'mnemonic.walletSource': 'المصدر',
  'mnemonic.walletWordCount': 'عدد الكلمات',
  'mnemonic.walletLastUpdated': 'آخر تحديث',
  'mnemonic.replaceWallet': 'استبدال المحفظة',
  'mnemonic.replaceWalletWarning':
    'سيؤدي هذا إلى استبدال محفظتك الحالية نهائيًا. تأكد من احتفاظك بنسخة احتياطية من عبارة الاسترداد قبل المتابعة.',
  'mnemonic.replaceWalletConfirm': 'أفهم، استبدل محفظتي',
  'mnemonic.loadingWalletStatus': 'جارٍ التحقق من حالة المحفظة...',
  'mnemonic.viewAccounts': 'حسابات المحفظة',
  'mnemonic.revealRecoveryPhrase': 'الكشف عن عبارة الاسترداد',
  'mnemonic.hidePhrase': 'إخفاء العبارة',
  'team.failedToCreate': 'فشل إنشاء الفريق',
  'team.invalidInviteCode': 'رمز دعوة غير صالح أو منتهي الصلاحية',
  'team.failedToSwitch': 'فشل تبديل الفريق',
  'team.failedToLeave': 'فشل مغادرة الفريق',
  'team.role.owner': 'المالك',
  'team.role.admin': 'المسؤول',
  'team.role.billingManager': 'مدير الفوترة',
  'team.role.member': 'عضو',
  'team.active': 'نشط',
  'team.personalTeam': 'الفريق الشخصي',
  'team.manageTeam': 'إدارة الفريق',
  'team.switching': 'جارٍ التبديل...',
  'team.switch': 'تبديل',
  'team.leaving': 'جارٍ المغادرة...',
  'team.leave': 'مغادرة',
  'team.yourTeams': 'فرقك',
  'team.createNewTeam': 'إنشاء فريق جديد',
  'team.teamName': 'اسم الفريق',
  'team.creating': 'جارٍ الإنشاء...',
  'team.joinExistingTeam': 'الانضمام إلى فريق موجود',
  'team.personalAutoCreatedNote':
    'يتم إنشاء فريقك الشخصي تلقائيًا. للتعاون، انضم إلى فريق موجود باستخدام رمز دعوة أدناه.',
  'team.inviteCode': 'رمز الدعوة',
  'team.joining': 'جارٍ الانضمام...',
  'team.join': 'انضمام',
  'team.leaveTeam': 'مغادرة الفريق',
  'team.confirmLeave': 'هل أنت متأكد من أنك تريد مغادرة',
  'team.leaveWarning':
    'ستفقد الوصول إلى الفريق وجميع موارده. ستحتاج إلى دعوة جديدة للانضمام مجددًا.',
  'team.management': 'إدارة الفريق',
  'team.notFound': 'الفريق غير موجود',
  'team.accessDenied': 'الوصول مرفوض',
  'team.members': 'الأعضاء',
  'team.membersDesc': 'إدارة أعضاء الفريق وأدواره',
  'team.invites': 'الدعوات',
  'team.invitesDesc': 'إنشاء رموز الدعوة وإدارتها',
  'team.settings': 'إعدادات الفريق',
  'team.settingsDesc': 'تحرير اسم الفريق وإعداداته',
  'team.editSettings': 'تحرير إعدادات الفريق',
  'team.enterName': 'أدخل اسم الفريق',
  'team.saving': 'جاري الحفظ...',
  'team.saveChanges': 'حفظ التغييرات',
  'team.delete': 'حذف الفريق',
  'team.deleteDesc': 'حذف هذا الفريق نهائيًا',
  'team.deleting': 'جارٍ الحذف...',
  'team.failedToUpdate': 'فشل تحديث الفريق',
  'team.failedToDelete': 'فشل حذف الفريق',
  'team.manageTitle': 'إدارة {name}',
  'team.planCreated': '{plan} الخطة • تم الإنشاء {date}',
  'team.confirmDelete': 'هل أنت متأكد من أنك تريد حذف {name}؟',
  'team.deleteWarning': 'لا يمكن التراجع عن هذا الإجراء. ستتم إزالة جميع بيانات الفريق نهائيًا.',
  'voice.title': 'الإملاء الصوتي',
  'voice.settings': 'إعدادات الصوت',
  'voice.settingsDesc': 'اضغط مع الاستمرار على المفتاح الساخن للإملاء وإدراج النص في الحقل النشط.',
  'voice.hotkey': 'المفتاح الساخن',
  'voice.activationMode': 'وضع التفعيل',
  'voice.tapToToggle': 'انقر للتبديل',
  'voice.writingStyle': 'أسلوب الكتابة',
  'voice.verbatimTranscription': 'النسخ الحرفي',
  'voice.naturalCleanup': 'تنظيف طبيعي',
  'voice.autoStart': 'بدء خادم الصوت تلقائيًا مع النواة',
  'voice.customDictionary': 'القاموس المخصص',
  'voice.customDictionaryDesc': 'أضف أسماء ومصطلحات تقنية وكلمات تخصصية لتحسين دقة التعرف.',
  'voice.addWord': 'أضف كلمة...',
  'voice.sttDisabled': 'الإملاء الصوتي معطّل حتى يتم تنزيل نموذج STT المحلي وجاهزيته.',
  'voice.openLocalAiModel': 'فتح نموذج الذكاء الاصطناعي المحلي',
  'voice.serverRestarted': 'تمت إعادة تشغيل خادم الصوت بالإعدادات الجديدة.',
  'voice.settingsSaved': 'تم حفظ إعدادات الصوت.',
  'voice.serverStarted': 'تم تشغيل خادم الصوت.',
  'voice.serverStopped': 'تم إيقاف خادم الصوت.',
  'voice.saveVoiceSettings': 'حفظ إعدادات الصوت',
  'voice.startVoiceServer': 'تشغيل خادم الصوت',
  'voice.stopVoiceServer': 'إيقاف خادم الصوت',
  'voice.debugTitle': 'تصحيح الصوت',
  'voice.failedToLoadSettings': 'فشل تحميل إعدادات الصوت',
  'voice.failedToSaveSettings': 'فشل في حفظ إعدادات الصوت',
  'voice.failedToStartServer': 'فشل في بدء تشغيل خادم الصوت',
  'voice.failedToStopServer': 'فشل في إيقاف خادم الصوت',
  'voice.sttDisabledPrefix': 'الإملاء الصوتي معطّل حتى يتم تنزيل نموذج STT المحلي. استخدم',
  'voice.sttDisabledSuffix': 'أعلاه لتثبيت Whisper.',
  'voice.debug.failedToLoadVoiceDebugData': 'فشل تحميل بيانات تصحيح الأخطاء الصوتية',
  'voice.debug.settingsSaved': 'تم حفظ إعدادات تصحيح الأخطاء.',
  'voice.debug.failedToSaveSettings': 'فشل حفظ إعدادات الصوت',
  'voice.debug.runtimeStatus': 'حالة وقت التشغيل',
  'voice.debug.runtimeStatusDesc': 'تشخيصات مباشرة لخادم الصوت ومحرك تحويل الكلام إلى نص.',
  'voice.debug.server': 'الخادم',
  'voice.debug.unavailable': 'غير متاح',
  'voice.debug.ready': 'جاهز',
  'voice.debug.notReady': 'غير جاهز',
  'voice.debug.hotkey': 'مفتاح التشغيل السريع',
  'voice.debug.notAvailable': 'غير متوفر',
  'voice.debug.mode': 'الوضع',
  'voice.debug.transcriptions': 'النسخ',
  'voice.debug.serverError': 'خطأ في الخادم',
  'voice.debug.advancedSettings': 'الإعدادات المتقدمة',
  'voice.debug.advancedSettingsDesc': 'معاملات ضبط منخفضة المستوى للتسجيل واكتشاف الصمت.',
  'voice.debug.minimumRecordingSeconds': 'الحد الأدنى لثواني التسجيل',
  'voice.debug.silenceThreshold': 'عتبة الصمت (RMS)',
  'voice.debug.silenceThresholdDesc':
    'تُعامَل التسجيلات ذات الطاقة الأدنى من هذا الحد كصمت ويُتخطى فيها. كلما كانت القيمة أصغر، كان النظام أكثر حساسية.',
  'voice.debug.alwaysOn': 'الاستماع الدائم',
  'voice.debug.alwaysOnDesc':
    'أبقِ الميكروفون مفتوحًا وأرسل ما تقوله إلى الوكيل تلقائيًا دون مفتاح اختصار. يتوقف مؤقتًا عند قفل الشاشة.',
  'voice.providers.saved': 'تم حفظ موفري الصوت.',
  'voice.providers.failedToSave': 'فشل في حفظ موفري الصوت',
  'voice.providers.ellipsis': '…',
  'voice.providers.installing': 'تثبيت',
  'voice.providers.installingBusy': 'جارٍ التثبيت...',
  'voice.providers.reinstallLocally': 'إعادة التثبيت محليًا',
  'voice.providers.repair': 'إصلاح',
  'voice.providers.retryLocally': 'أعد المحاولة محليًا',
  'voice.providers.installLocally': 'التثبيت محليًا',
  'voice.providers.whisperReady': 'Whisper جاهز.',
  'voice.providers.whisperInstallStarted': 'بدأ تثبيت Whisper',
  'voice.providers.queued': 'في قائمة الانتظار',
  'voice.providers.failedToInstallWhisper': 'فشل تثبيت Whisper',
  'voice.providers.piperReady': 'Piper جاهز.',
  'voice.providers.piperInstallStarted': 'بدأ تثبيت Piper',
  'voice.providers.failedToInstallPiper': 'فشل تثبيت Piper',
  'voice.mode.title': 'وضع الصوت',
  'voice.mode.desc': 'اختر طريقة تحدث المساعد في تبويب Human.',
  'voice.mode.realtime': 'الصوت في الوقت الفعلي (تجريبي)',
  'voice.mode.realtimeDesc': 'أجرِ محادثة مباشرة ومتدفقة بدلاً من تبادل الأدوار.',
  'voice.mode.start': 'بدء المحادثة الصوتية',
  'voice.mode.stop': 'إنهاء المحادثة الصوتية',
  'voice.mode.connecting': 'جارٍ الاتصال…',
  'voice.mode.listening': 'يستمع',
  'voice.mode.speaking': 'يتحدث',
  'voice.providers.title': 'موفري الصوت',
  'voice.providers.desc':
    'اختر مكان تشغيل النسخ والتوليف. استخدم أزرار «التثبيت محلياً» لتنزيل الملفات الثنائية والنماذج في مساحة عملك. يمكن حفظ الموفرين المحليين قبل اكتمال التثبيت: لا حاجة لإعداد WHISPER_BIN أو PIPER_BIN يدوياً.',
  'voice.providers.sttProvider': 'موفر تحويل الكلام إلى نص',
  'voice.providers.sttProviderAria': 'موفر STT',
  'voice.providers.cloudWhisperProxy': 'السحابة (وكيل الهمس)',
  'voice.providers.localWhisper': 'الهمس المحلي',
  'voice.providers.installRequired': '(يتطلب التثبيت)',
  'voice.providers.whisperInstalledTitle': 'تم تثبيت Whisper. انقر لإعادة التثبيت.',
  'voice.providers.whisperDownloadTitle': 'تنزيل whisper.cpp ونموذج GGML في مساحة عملك.',
  'voice.providers.installed': 'تم التثبيت',
  'voice.providers.installFailed': 'فشل التثبيت',
  'voice.providers.notInstalled': 'غير مثبت',
  'voice.providers.whisperModel': 'نموذج الهمس',
  'voice.providers.whisperModelAria': 'نموذج الهمس',
  'voice.providers.whisperModelTiny': 'صغير (39 ميجابايت، الأسرع)',
  'voice.providers.whisperModelBase': 'أساسي (74 ميجابايت)',
  'voice.providers.whisperModelSmall': 'صغير (244 ميجابايت)',
  'voice.providers.whisperModelMedium': 'متوسط (769 ميجابايت، موصى به)',
  'voice.providers.whisperModelLargeTurbo': 'كبير v3 Turbo (1.5 جيجابايت، أفضل دقة)',
  'voice.providers.ttsProvider': 'موفر خدمة تحويل النص إلى كلام',
  'voice.providers.ttsProviderAria': 'موفر TTS',
  'voice.providers.cloudElevenLabsProxy': 'السحابة (وكيل ElevenLabs)',
  'voice.providers.localPiper': 'تم تثبيت مزمار محلي',
  'voice.providers.piperInstalledTitle': 'مزمار. انقر لإعادة التثبيت.',
  'voice.providers.piperDownloadTitle':
    'تنزيل Piper وصوت en_US-lessac-medium المُجمَّع في مساحة عملك.',
  'voice.providers.piperVoice': 'صوت المزمار',
  'voice.providers.piperVoiceAria': 'صوت المزمار',
  'voice.providers.customVoiceOption': 'أخرى (اكتب أدناه)...',
  'voice.providers.customVoiceAria': 'معرف صوت المزمار (مخصص)',
  'voice.providers.customVoicePlaceholder': 'en_US-lessac-medium',
  'voice.providers.piperVoicesDesc':
    'تأتي الأصوات من huggingface.co/rhasspy/piper-voices. قد يتطلب تبديل الأصوات نقرة تثبيت/إعادة تثبيت لتنزيل ملف .onnx الجديد.',
  'voice.providers.mascotVoice': 'تم تكوين صوت التميمة',
  'voice.providers.mascotVoiceDescPrefix':
    'صوت ElevenLabs الذي تستخدمه الشخصية في الردود الصوتية مُهيَّأ ضمن',
  'voice.providers.mascotSettings': 'إعدادات التميمة',
  'voice.providers.mascotVoiceDescSuffix': '.',
  'voice.providers.hotkeyPlaceholder': 'Fn',
  'voice.providers.piperPreset.lessacMedium': 'الولايات المتحدة · Lessac (محايد، موصى به)',
  'voice.providers.piperPreset.lessacHigh': 'الولايات المتحدة · Lessac (جودة أعلى، أكبر)',
  'voice.providers.piperPreset.ryanMedium': 'الولايات المتحدة · Ryan (ذكر)',
  'voice.providers.piperPreset.amyMedium': 'الولايات المتحدة · Amy (أنثى)',
  'voice.providers.piperPreset.librittsHigh': 'الولايات المتحدة · LibriTTS (متعدد المتحدثين)',
  'voice.providers.piperPreset.alanMedium': 'GB · Alan (ذكر)',
  'voice.providers.piperPreset.jennyDiocoMedium': 'GB · Jenny Dioco (أنثى)',
  'voice.providers.piperPreset.northernEnglishMaleMedium': 'GB · اللغة الإنجليزية الشمالية (ذكر)',
  'voice.providers.chip.cloud': 'OpenHuman (مُدار)',
  'voice.providers.chip.cloudAria': 'موفر OpenHuman المُدار مُفعَّل دائماً',
  'voice.providers.chip.whisper': 'Whisper (محلي)',
  'voice.providers.chip.enableWhisper': 'تفعيل Whisper STT المحلي',
  'voice.providers.chip.disableWhisper': 'تعطيل Whisper STT المحلي',
  'voice.providers.chip.piper': 'Piper (محلي)',
  'voice.providers.chip.enablePiper': 'تفعيل Piper TTS المحلي',
  'voice.providers.chip.disablePiper': 'تعطيل Piper TTS المحلي',
  'voice.providers.chip.enableProvider': 'Enable',
  'voice.providers.chip.disableProvider': 'Disable',
  'voice.providers.chip.apiKeyLabel': 'مفتاح API',
  'voice.providers.chip.apiKeyPlaceholder': 'sk-…',
  'voice.providers.chip.comingSoon': 'قريباً',
  'voice.modal.title': 'Configure',
  'voice.modal.desc': 'أدخل مفتاح API لتفعيل هذا الموفر. يمكنك اختبار الاتصال قبل الحفظ.',
  'voice.modal.testKey': 'اختبار المفتاح',
  'voice.modal.testing': 'جارٍ الاختبار…',
  'voice.modal.saveAndEnable': 'حفظ وتفعيل',
  'voice.modal.enable': 'Enable',
  'voice.modal.whisperDesc':
    'اختر حجم النموذج وثبّت ملف Whisper الثنائي ونموذج GGML في مساحة عملك. النماذج الأكبر أكثر دقة لكنها أبطأ.',
  'voice.modal.piperDesc':
    'اختر صوتاً وثبّت ملف Piper الثنائي ونموذج ONNX في مساحة عملك. يعمل Piper بالكامل دون اتصال بالإنترنت وبزمن استجابة منخفض.',
  'voice.routing.title': 'توجيه الصوت',
  'voice.routing.desc':
    'اختر الموفرين المُفعَّلين الذين يتولون تحويل الكلام إلى نص والنص إلى كلام.',
  'voice.routing.save': 'Save',
  'voice.routing.testStt': 'اختبار STT',
  'voice.routing.testTts': 'اختبار TTS',
  'voice.routing.elevenlabsVoice': 'صوت ElevenLabs',
  'voice.routing.elevenlabsVoiceAria': 'اختيار صوت ElevenLabs',
  'voice.routing.elevenlabsVoiceIdAria': 'معرف صوت ElevenLabs (مخصص)',
  'voice.routing.elevenlabsVoiceDesc':
    'اختر صوتاً منتقىً أو الصق معرف صوت مخصص من لوحة تحكم ElevenLabs.',
  'voice.externalProviders.title': 'موفرو الصوت الخارجيون',
  'voice.externalProviders.desc':
    'اربط واجهات API صوتية تابعة لجهات خارجية مثل Deepgram أو ElevenLabs أو OpenAI مباشرةً.',
  'voice.externalProviders.keySet': 'المفتاح مُعيَّن',
  'voice.externalProviders.noKey': 'لا يوجد مفتاح API',
  'voice.externalProviders.test': 'Test',
  'voice.externalProviders.testing': 'جارٍ الاختبار…',
  'voice.externalProviders.remove': 'Remove',
  'voice.externalProviders.provider': 'Provider',
  'voice.externalProviders.selectProvider': 'اختر موفراً…',
  'voice.externalProviders.apiKey': 'مفتاح API',
  'voice.externalProviders.apiKeyPlaceholder': 'sk-…',
  'voice.externalProviders.add': 'Add',
  'pttSettings.title': 'اضغط للتحدث',
  'pttSettings.description':
    'اضغط مفتاحًا باستمرار للتحدث إلى OpenHuman أثناء وجودك في تطبيق آخر. تحرير المفتاح يُرسل التسجيل؛ إذا كان «قراءة الردود» مفعَّلًا، ينطق OpenHuman الرد بصوت عالٍ.',
  'pttSettings.shortcutLabel': 'اختصار المفتاح',
  'pttSettings.shortcutPlaceholder': 'اضغط مفتاحًا (مثل F13)',
  'pttSettings.shortcutUnsetHint': 'اضغط للتحدث متوقف: اختر اختصارًا لتفعيله.',
  'pttSettings.speakRepliesLabel': 'نطق ردود الوكيل',
  'pttSettings.showOverlayLabel': 'إظهار التراكب أثناء الضغط',
  'pttSettings.errorConflictsWithDictation':
    'هذا الاختصار مُستخدم بالفعل لخاصية الإملاء. اختر مفتاحًا مختلفًا.',
  'pttSettings.errorModifierOnly':
    'اختر مفتاحًا عاديًا (مثل F13): الاختصارات المكونة من مفاتيح تعديل فقط لا تعمل مع اضغط للتحدث.',
  'pttSettings.errorEmpty': 'اختر مفتاحًا للربط.',
  'pttSettings.errorAccessibility':
    'يحتاج macOS إلى إذن إمكانية الوصول لهذا الاختصار. افتح إعدادات النظام ← الخصوصية والأمان ← إمكانية الوصول وفعّل OpenHuman.',
  'pttSettings.errorShortcutInUse': 'يستخدم تطبيق آخر هذا الاختصار بالفعل. اختر اختصارًا مختلفًا.',
  'pttSettings.errorUnsupportedWayland':
    'جلسات Wayland لا تدعم بعد الاختصارات العامة في OpenHuman: انتقل إلى جلسة X11 أو استخدم زر الإملاء داخل التطبيق.',
  'pttSettings.exclusiveFullscreenHint':
    'في ألعاب وضع ملء الشاشة الحصري لن يظهر التراكب: ستسمع التنبيه الصوتي فقط. انتقل إلى وضع ملء الشاشة بلا إطار لرؤية التراكب.',
  'pttOverlay.listening': 'يستمع…',
  'pttOverlay.idle': 'في الانتظار',
  'chat.agentChat': 'محادثة الوكيل',
  'chat.overrides': 'التجاوزات',
  'chat.model': 'النموذج',
  'chat.temperature': 'درجة الحرارة',
  'chat.conversation': 'المحادثة',
  'chat.startAgentConversation': 'ابدأ محادثة مع الوكيل.',
  'chat.you': 'أنت',
  'chat.agent': 'الوكيل',
  'chat.askAgent': 'اسأل الوكيل أي شيء...',
  'chat.sendMessage': 'إرسال الرسالة',
  'composio.triageTitle': 'مشغّلات التكامل',
  'composio.triageDesc':
    'عند التفعيل، يمر كل مشغّل Composio وارد عبر خطوة فرز بالذكاء الاصطناعي تُصنّف الحدث وقد تبدأ إجراءات آلية: دورة LLM محلية واحدة لكل مشغّل. عطّله عالميًا أو لكل تكامل إذا كنت تفضل المراجعة اليدوية. إذا كان متغير البيئة',
  'composio.disableAllTriage': 'تعطيل فرز الذكاء الاصطناعي لجميع المشغّلات',
  'composio.triggersStillRecorded': 'تُسجَّل المشغّلات في السجل: لا تُشغَّل دورة LLM.',
  'composio.disableSpecificIntegrations': 'تعطيل فرز الذكاء الاصطناعي لتكاملات محددة',
  'composio.settingsSaved': 'تم حفظ الإعدادات',
  'composio.saveFailed': 'فشل الحفظ. حاول مرة أخرى.',
  'cron.title': 'مهام Cron',
  'cron.scheduledJobs': 'المهام المجدولة',
  'cron.manageCronJobs': 'إدارة مهام cron من جدولة النواة.',
  'cron.refreshCronJobs': 'تحديث مهام Cron',
  'localModel.modelStatus': 'حالة النموذج',
  'localModel.downloadModels': 'تنزيل النماذج',
  'localModel.usage': 'الاستخدام',
  'localModel.usageDesc':
    'اختر الأنظمة الفرعية التي تعمل على النموذج المحلي. ما هو معطّل يستخدم السحابة.',
  'localModel.enableRuntime': 'تفعيل بيئة الذكاء الاصطناعي المحلي',
  'localModel.enableRuntimeDesc':
    'مفتاح رئيسي. معطّل افتراضيًا: Ollama يبقى خاملاً. عند التشغيل، يستخدم ملخّص الشجرة وذكاء الشاشة والإكمال التلقائي النموذجَ المحلي دائمًا.',
  'localModel.advancedSettings': 'إعدادات متقدمة',
  'localModel.debugTitle': 'تصحيح النموذج المحلي',
  'memory.debugTitle': 'تصحيح الذاكرة',
  'memory.documents': 'المستندات',
  'memory.filterByNamespace': 'التصفية حسب مساحة الاسم...',
  'memory.refresh': 'تحديث',
  'memory.noDocumentsFound': 'لم يتم العثور على مستندات.',
  'memory.delete': 'حذف',
  'memory.rawResponse': 'الاستجابة الأولية',
  'memory.namespaces': 'مساحات الأسماء',
  'memory.noNamespacesFound': 'لم يتم العثور على مساحات أسماء.',
  'memory.queryRecall': 'الاستعلام والاستدعاء',
  'memory.namespace': 'مساحة الاسم',
  'memory.queryText': 'نص الاستعلام...',
  'memory.defaultMaxChunks': '10',
  'memory.maxChunks': 'الحد الأقصى للمجموعات',
  'memory.query': 'الاستعلام',
  'memory.recall': 'استدعاء',
  'memory.queryLabel': 'الاستعلام',
  'memory.recallLabel': 'استدعاء',
  'memory.queryResult': 'نتيجة الاستعلام',
  'memory.recallResult': 'نتيجة الاستدعاء',
  'memory.clearNamespace': 'مسح مساحة الاسم',
  'memory.clearNamespaceDescription': 'حذف جميع المستندات الموجودة في مساحة الاسم نهائيًا.',
  'memory.selectNamespace': 'حدد مساحة الاسم...',
  'memory.exampleNamespace': 'على سبيل المثال. Skill:gmail:user@example.com',
  'memory.clear': 'مسح',
  'memory.deleteConfirm': 'هل تريد حذف المستند "{documentId}" في مساحة الاسم "{namespace}"؟',
  'memory.clearNamespaceConfirm':
    'سيُحذف جميع المستندات في نطاق الاسم "{namespace}" نهائياً. هل تريد المتابعة؟',
  'memory.clearNamespaceSuccess': 'تم مسح مساحة الاسم "{namespace}".',
  'memory.clearNamespaceEmpty': 'لا يوجد شيء يجب مسحه في "{namespace}".',
  'webhooks.debugTitle': 'تصحيح الـ Webhooks',
  'webhooks.failedToLoadDebugData': 'فشل تحميل بيانات تصحيح أخطاء webhook',
  'webhooks.clearLogsConfirm': 'هل تريد مسح جميع سجلات تصحيح أخطاء webhook التي تم التقاطها؟',
  'webhooks.failedToClearLogs': 'فشل في مسح سجلات خطاف الويب',
  'webhooks.loading': 'جارٍ التحميل...',
  'webhooks.refresh': 'تحديث',
  'webhooks.clearing': 'مسح...',
  'webhooks.clearLogs': 'مسح السجلات',
  'webhooks.registered': 'تم تسجيل',
  'webhooks.captured': 'وتم التقاط',
  'webhooks.live': 'مباشرة',
  'webhooks.disconnected': 'تم قطع الاتصال',
  'webhooks.lastEvent': 'آخر حدث',
  'webhooks.at': 'في',
  'webhooks.registeredWebhooks': 'خطافات الويب المسجلة',
  'webhooks.noActiveRegistrations': 'لا توجد تسجيلات نشطة.',
  'webhooks.resolvingBackendUrl': 'حل الواجهة الخلفية URL...',
  'webhooks.capturedRequests': 'الطلبات الملتقطة',
  'webhooks.noRequestsCaptured': 'لم يتم التقاط طلبات خطاف الويب حتى الآن.',
  'webhooks.unrouted': 'تم إلغاء توجيهه',
  'webhooks.pending': 'معلق',
  'webhooks.requestHeaders': 'رؤوس الطلب',
  'webhooks.queryParams': 'معلمات الاستعلام',
  'webhooks.requestBody': 'نص الطلب',
  'webhooks.responseHeaders': 'رؤوس الاستجابة',
  'webhooks.responseBody': 'نص الاستجابة',
  'webhooks.rawPayload': 'الحمولة الأولية',
  'webhooks.empty': '[فارغة]',
  'providerSetup.error.defaultDetails': 'فشل إعداد الموفر.',
  'providerSetup.error.providerFallback': 'رفض الموفر',
  'providerSetup.error.credentialsRejected':
    'رفض {provider} بيانات الاعتماد. تحقق من مفتاح API وحاول مجدداً.',
  'providerSetup.error.endpointNotRecognized':
    'لم يتعرف {provider} على نقطة النهاية. تحقق من عنوان URL الأساسي وحاول مجدداً.',
  'providerSetup.error.providerUnavailable':
    '{provider} غير متاح حالياً. حاول مجدداً أو تحقق من حالة الموفر.',
  'providerSetup.error.unreachable':
    'تعذّر الوصول إلى {provider}. تحقق من عنوان URL لنقطة النهاية واتصال الشبكة، ثم حاول مجدداً.',
  'providerSetup.error.couldNotReachWithMessage': 'تعذر الوصول إلى {provider}: {message}',
  'providerSetup.error.technicalDetails': 'التفاصيل الفنية',
  'notifications.routingTitle': 'توجيه الإشعارات',
  'notifications.routing.pipelineStats': 'إحصائيات المسار',
  'notifications.routing.total': 'الإجمالي',
  'notifications.routing.unread': 'غير مقروء',
  'notifications.routing.unscored': 'غير مسجل',
  'notifications.routing.intelligenceTitle': 'ذكاء الإشعارات',
  'notifications.routing.intelligenceDesc':
    'يُصنَّف كل إشعار من حساباتك المتصلة بواسطة نموذج ذكاء اصطناعي محلي. تُوجَّه الإشعارات عالية الأهمية تلقائياً إلى وكيل المنسق حتى لا يفوتك شيء حرج.',
  'notifications.routing.howItWorks': 'كيف يعمل',
  'notifications.routing.level.drop': 'إسقاط',
  'notifications.routing.level.dropDesc': 'تشويش / بريد عشوائي - تم تخزينه ولكن لم يتم عرضه',
  'notifications.routing.level.acknowledge': 'إقرار',
  'notifications.routing.level.acknowledgeDesc': 'أولوية منخفضة - تظهر في مركز الإشعارات',
  'notifications.routing.level.react': 'التفاعل',
  'notifications.routing.level.reactDesc': 'أولوية متوسطة: تؤدي إلى استجابة مركزة للوكيل',
  'notifications.routing.level.escalate': 'تصعيد',
  'notifications.routing.level.escalateDesc': 'أولوية عالية: يتم إعادة التوجيه إلى الوكيل المنسق',
  'notifications.routing.perProvider': 'التوجيه لكل موفر',
  'notifications.routing.threshold': 'العتبة',
  'notifications.routing.routeToOrchestrator': 'فشل التوجيه إلى المنسق',
  'notifications.routing.loadSettingsError':
    'فشل تحميل الإعدادات. أعد فتح هذا اللوح للمحاولة مجدداً.',
  'common.reload': 'إعادة تحميل',
  'common.skip': 'تخطي',
  'common.disable': 'تعطيل',
  'common.enable': 'تفعيل',
  'chat.safetyTimeout': 'لا استجابة من الوكيل بعد دقيقتين. حاول مرة أخرى أو تحقق من اتصالك.',
  'chat.filter.general': 'عام',
  'chat.filter.subconscious': 'اللاوعي',
  'chat.filter.meetings': 'الاجتماعات',
  'chat.filter.tasks': 'المهام',
  'chat.selectThread': 'اختر محادثة',
  'chat.threads': 'المحادثات',
  'chat.noThreads': 'لا توجد محادثات بعد',
  'chat.noLabelThreads': 'لا توجد محادثات "{label}"',
  'chat.deleteThread': 'حذف المحادثة',
  'chat.deleteThreadConfirm': 'هل أنت متأكد من أنك تريد حذف "{title}"؟',
  'chat.untitledThread': 'محادثة بلا عنوان',
  'chat.editThreadTitle': 'تعديل عنوان المحادثة',
  'chat.hideSidebar': 'إخفاء الشريط الجانبي',
  'chat.showSidebar': 'إظهار الشريط الجانبي',
  'chat.searchThreads': 'البحث في المحادثات',
  'layout.resizeSidebar': 'تغيير حجم الشريط الجانبي',
  'layout.showSidebar': 'إظهار الشريط الجانبي',
  'chat.newThreadShortcut': 'محادثة جديدة (/new)',
  'chat.new': 'جديد',
  'chat.failedToLoadMessages': 'فشل تحميل الرسائل',
  'chat.thinkingIteration': 'جارٍ التفكير... ({n})',
  'chat.thinkingDots': 'جارٍ التفكير...',
  'chat.approachingLimit': 'الاقتراب من حد الاستخدام',
  'chat.approachingLimitMsg': 'لقد استخدمت {pct}% من حصتك المتاحة.',
  'chat.upgrade': 'الترقية',
  'chat.weeklyLimitHit': 'لقد وصلت إلى حدك الأسبوعي.',
  'chat.resets': 'إعادة ضبط',
  'chat.topUpToContinue': 'أضف رصيدًا للمتابعة.',
  'chat.budgetComplete': 'ميزانيتك المشمولة اكتملت. أضف رصيدًا أو قم بالترقية للمتابعة.',
  'chat.topUp': 'إضافة رصيد',
  'chat.cycle': 'الدورة',
  'chat.cycleSpent': 'الإنفاق في هذه الدورة',
  'chat.cycleRemaining': 'المتبقي',
  'chat.left': 'متبقٍ',
  'chat.setup': 'إعداد',
  'chat.switchToText': 'التبديل إلى النص',
  'chat.superContext.label': 'سياق فائق',
  'chat.superContext.hint':
    'يتيح «سياق فائق» لـ OpenHuman جمع وتحضير السياق من جميع البيانات التي يمكنه الوصول إليها لتقديم إجابة وثيقة الصلة للغاية. «سياق فائق» في مرحلة تجريبية مبكرة.',
  'chat.transcribing': 'جارٍ النسخ...',
  'chat.stopAndSend': 'إيقاف وإرسال',
  'chat.startTalking': 'ابدأ الحديث',
  'chat.playingVoiceReply': 'تشغيل الرد الصوتي',
  'chat.voiceHint': 'استخدم الميكروفون للتحدث',
  'chat.micUnavailable': 'الميكروفون غير متاح',
  // Chat mascot: the figure standing on the composer, and its voice stage.
  'chat.mascot.expand': 'تحدّث إلى مساعدك',
  'chat.mascot.collapse': 'العودة إلى المحادثة',
  'chat.mascot.speakReplies': 'نطق الردود بصوت مسموع',
  'chat.mascot.speakRepliesHint':
    'تُقرأ الردود بصوت مسموع طالما التميمة مفتوحة. أوقف هذا الخيار لإبقاء المحادثة صامتة.',
  'chat.mascot.dismiss': 'إخفاء Tiny',
  'chat.mascot.dismissTitle': 'إخفاء Tiny؟',
  'chat.mascot.dismissBody':
    'لا مشكلة إذا كنت تفضّل صندوق الرسائل لنفسك. يمكنك إعادة Tiny في أي وقت من الإعدادات › المظهر › الدردشة.',
  'chat.mascot.dismissConfirm': 'إخفاء Tiny',
  'chat.mascot.dismissCancel': 'الإبقاء على Tiny',
  'chat.turn': 'دورة',
  'chat.turns': 'دورات',
  'chat.openWorkerThread': 'فتح محادثة العامل',
  'chat.attachment.attach': 'إرفاق صورة',
  'chat.attachment.remove': 'إزالة {name}',
  'chat.attachment.tooMany': 'الحد الأقصى {max} صور لكل رسالة',
  'chat.attachment.tooManyFiles': 'الحد الأقصى {max} ملفات لكل رسالة',
  'chat.attachment.tooManyVideos': 'الحد الأقصى {max} مقاطع فيديو لكل رسالة',
  'chat.attachment.videoNotSupported':
    'لا يمكن لهذا النموذج قراءة مقاطع الفيديو. يمكنك استخدام مستوى التفكير من OpenHuman لإرفاق الفيديو.',
  'chat.attachment.dropToAttach': 'أفلت الملفات لإرفاقها',
  'chat.attachment.tooLarge': 'حجم الصورة يتجاوز الحد المسموح {max}',
  'chat.attachment.unsupportedType':
    'نوع ملف غير مدعوم. استخدم صورة (PNG أو JPEG أو WebP أو GIF أو BMP) أو ملف PDF أو TXT أو Markdown.',
  'chat.attachment.imageNotSupported':
    'لا يمكن لهذا النموذج قراءة الصور. يمكنك استخدام مستوى التفكير من OpenHuman لإرفاق صورتك.',
  'chat.attachment.readFailed': 'تعذر قراءة الملف',
  'memory.searchAria': 'البحث في الذاكرة',
  'memory.searchPlaceholder': 'البحث في إدخالات الذاكرة...',
  'memory.sourceFilter.all': 'جميع المصادر',
  'memory.sourceFilter.email': 'البريد الإلكتروني',
  'memory.sourceFilter.calendar': 'التقويم',
  'memory.sourceFilter.telegram': 'Telegram',
  'memory.sourceFilter.aiInsight': 'رؤية الذكاء الاصطناعي',
  'memory.sourceFilter.system': 'النظام',
  'memory.sourceFilter.trading': 'التداول',
  'memory.sourceFilter.security': 'الأمان',
  'memory.ingestionActivity': 'نشاط الاستيعاب',
  'memory.events': 'أحداث',
  'memory.event': 'حدث',
  'memory.overTheLast': 'خلال آخر',
  'memory.months': 'أشهر',
  'memory.peak': 'الذروة',
  'memory.perDay': '/يوم',
  'memory.less': 'أقل',
  'memory.more': 'أكثر',
  'memory.on': 'في',
  'memory.loading': 'جارٍ تحميل الذاكرة',
  'memory.fetching': 'جارٍ جلب إدخالات الذاكرة...',
  'memory.analyzing': 'جارٍ تحليل الذاكرة',
  'memory.analyzingHint': 'جارٍ معالجة ذكرياتك لاستخلاص الرؤى...',
  'memory.noMatches': 'لا توجد نتائج مطابقة',
  'memory.noMatchesHint': 'جرّب تغيير مصطلحات البحث أو المرشحات.',
  'memory.allCaughtUp': 'تم مراجعة الكل',
  'memory.allCaughtUpHint': 'لا توجد إدخالات ذاكرة جديدة للمعالجة.',
  'memory.noAnalysis': 'لا يوجد تحليل بعد',
  'memory.noAnalysisHint': 'شغّل تحليلاً لاكتشاف الأنماط في ذكرياتك.',
  'memory.emptyHint': 'ابدأ التفاعل لإنشاء أول ذكرياتك.',
  'mic.unavailable': 'الميكروفون غير متاح',
  'mic.permissionDenied': 'تم رفض إذن الميكروفون',
  'mic.failedToStartRecorder': 'فشل تشغيل المسجّل',
  'mic.deviceUnavailable': 'الميكروفون المحدد غير متاح: جرّب جهازًا آخر.',
  'mic.deviceInUse': 'الميكروفون قيد الاستخدام من قبل تطبيق آخر.',
  'mic.error': 'خطأ في الميكروفون',
  'mic.transcribing': 'جارٍ النسخ...',
  'mic.retryingTranscription': 'جارٍ إعادة المحاولة… ({attempt} من {max})',
  'mic.tapToSend': 'انقر للإرسال',
  'mic.waitingForAgent': 'في انتظار الوكيل...',
  'mic.tapAndSpeak': 'انقر وتحدث',
  'mic.stopRecording': 'إيقاف التسجيل وإرسال',
  'mic.startRecording': 'بدء التسجيل',
  'mic.deviceSelector': 'جهاز الميكروفون',
  'mic.tapToSendCountdown': 'انقر للإرسال ({seconds} ث)',
  'token.usageLimitReached': 'تم الوصول إلى حد الاستخدام',
  'token.approachingLimit': 'الاقتراب من الحد',
  'token.planClickForDetails': 'الخطة - انقر للتفاصيل',
  'token.sessionTokens': 'وارد: {in} | صادر: {out} | الدورات: {turns}',
  'token.limit': 'تم الوصول إلى الحد',
  'token.inLabel': 'وارد',
  'token.outLabel': 'صادر',
  'token.inputTokens': 'الرموز الواردة في هذه الجلسة',
  'token.outputTokens': 'الرموز الصادرة في هذه الجلسة',
  'token.turnsCount': 'دورات الاستدلال في هذه الجلسة',
  'token.turn': 'دورة',
  'token.turns': 'دورات',
  'token.ctxLabel': 'سياق',
  'token.contextWindow': 'استخدام نافذة السياق (آخر دورة)',
  'token.cachedLabel': 'مخزّن مؤقتًا',
  'token.costLabel': 'التكلفة',
  'token.costTitle': 'التكلفة التقديرية لهذه الجلسة (دولار أمريكي)',
  'token.sessionUsageTitle': 'استخدام الجلسة',
  'token.subAgentsHeading': 'استخدام الوكلاء الفرعيين',
  'token.byAgentHeading': 'حسب الوكيل',
  'token.orchestrator': 'المنسّق',
  'token.noSubAgents': 'لا يوجد استخدام للوكلاء الفرعيين بعد',
  'token.popInput': 'رموز الإدخال',
  'token.popOutput': 'رموز الإخراج',
  'token.popCacheHit': 'إصابة ذاكرة التخزين المؤقت',
  'token.popContext': 'نافذة السياق',
  'token.tipInput': 'الرموز المُرسلة إلى النموذج في هذه الجلسة: مطالباتك إضافةً إلى سجل المحادثة.',
  'token.tipOutput': 'الرموز التي ولّدها النموذج في هذه الجلسة.',
  'token.tipCacheHit': 'رموز إدخال تُقدَّم من بادئة مطالبة مخزّنة مؤقتًا، وتُحتسب بسعر مخفّض.',
  'token.clickForDetails': 'انقر لعرض تفاصيل استخدام الجلسة',
  'catalog.noCapabilityBinding': 'لا يوجد ربط بالإمكانات',
  'catalog.downloadFailed': 'فشل التنزيل',
  'catalog.active': 'نشط',
  'catalog.installed': 'مثبّت',
  'catalog.notDownloaded': 'لم يتم التنزيل',
  'catalog.inUse': 'قيد الاستخدام',
  'catalog.use': 'استخدام',
  'catalog.deleteModel': 'حذف النموذج',
  'catalog.download': 'تنزيل',
  'navigator.recent': 'الأخيرة',
  'navigator.today': 'اليوم',
  'navigator.thisWeek': 'هذا الأسبوع',
  'navigator.sources': 'المصادر',
  'navigator.email': 'البريد الإلكتروني',
  'navigator.slack': 'Slack',
  'navigator.chat': 'المحادثة',
  'navigator.documents': 'المستندات',
  'navigator.people': 'الأشخاص',
  'navigator.topics': 'المواضيع',
  'dreams.description': 'الأحلام هي انعكاسات مُولَّدة بالذكاء الاصطناعي تُركّب الأنماط من ذكرياتك.',
  'dreams.comingSoon': 'قريبًا',
  'assignment.memoryLlm': 'LLM الذاكرة',
  'assignment.memoryLlmAria': 'اختيار LLM الذاكرة',
  'assignment.embedder': 'المُضمِّن',
  'assignment.loaded': 'مُحمَّل',
  'assignment.notDownloaded': 'لم يتم التنزيل',
  'assignment.usedForExtractSummarise': 'مُستخدَم للاستخراج والتلخيص',
  'insights.knownFacts': 'الحقائق المعروفة',
  'insights.preferences': 'التفضيلات',
  'insights.relationships': 'العلاقات',
  'insights.skills': 'المهارات',
  'insights.opinions': 'الآراء',
  'insights.other': 'أخرى',
  'insights.title': 'الرؤى',
  'insights.empty': 'لا توجد رؤى بعد. تُولَّد الرؤى مع نمو ذاكرتك.',
  'insights.description': 'استنادًا إلى {count} علاقة في رسم بياني ذاكرتك.',
  'insights.items': 'عناصر',
  'insights.more': 'المزيد',
  'calls.joiningCall': 'جارٍ الانضمام إلى المكالمة',
  'calls.meetWindowOpening': 'جارٍ فتح نافذة Meet...',
  'calls.failedToStart': 'فشل بدء مكالمة Meet',
  'calls.couldNotStart': 'تعذّر بدء المكالمة',
  'calls.failedToClose': 'فشل إغلاق المكالمة',
  'calls.couldNotClose': 'تعذّر إغلاق المكالمة',
  'calls.joinMeet': 'الانضمام إلى مكالمة Google Meet',
  'calls.joinMeetDescription': 'أدخل رابط Google Meet للانضمام.',
  'calls.meetLink': 'رابط Meet',
  'calls.displayName': 'الاسم المعروض',
  'calls.openingMeet': 'جارٍ فتح Meet...',
  'calls.joinCall': 'انضمام إلى المكالمة',
  'calls.activeCalls': 'المكالمات النشطة',
  'calls.leave': 'مغادرة',
  'workspace.wipeConfirm': 'هل أنت متأكد من أنك تريد مسح جميع الذاكرة؟ لا يمكن التراجع عن هذا.',
  'workspace.resetTreeConfirm': 'هل أنت متأكد من أنك تريد إعادة بناء شجرة الذاكرة؟',
  'workspace.wipeTitle': 'مسح الذاكرة',
  'workspace.resetting': 'جارٍ إعادة الضبط...',
  'workspace.resetMemory': 'إعادة ضبط الذاكرة',
  'workspace.resetTreeTitle': 'إعادة بناء شجرة الذاكرة',
  'workspace.rebuilding': 'جارٍ إعادة البناء...',
  'workspace.resetMemoryTree': 'إعادة ضبط شجرة الذاكرة',
  'workspace.building': 'جارٍ البناء...',
  'workspace.buildSummaryTrees': 'بناء أشجار الملخصات',
  'workspace.viewVault': 'عرض الخزينة',
  'workspace.openingVaultTitle': 'فتح المخزن في Obsidian',
  'workspace.openingVaultMessage':
    'إذا لم يفتح Obsidian، ثبّته من obsidian.md أو استخدم «إظهار المجلد». مسار الخزنة:',
  'workspace.openVaultFailedTitle': 'تعذّر فتح الخزنة في Obsidian',
  'workspace.openVaultFailedMessage': 'استخدم Reveal Folder لفتح دليل المخزن مباشرة. مسار المدفن:',
  'workspace.revealVaultFailed': 'تعذّر إظهار مجلد الخزنة',
  'workspace.revealFolder': 'كشف المجلد',
  'workspace.checkingVault': 'جارٍ التحقق…',
  'workspace.vaultNotRegisteredHelp':
    'يفتح Obsidian فقط المجلدات التي أضفتها كخزنة. في Obsidian، اختر «فتح المجلد كخزنة» واختر المجلد أدناه: تحتاج إلى القيام بذلك مرة واحدة فقط. ثم انقر «عرض الخزنة» مجدداً.',
  'workspace.obsidianNotFoundHelp':
    'لم نتمكن من العثور على Obsidian على هذا الجهاز. ثبّته، أو (إذا كان مثبتاً في مكان غير قياسي) حدد مجلد إعداداته ضمن خيارات متقدمة.',
  'workspace.openAnyway': 'فتح في Obsidian على أي حال',
  'workspace.installObsidian': 'تثبيت Obsidian',
  'workspace.obsidianAdvanced': 'هل Obsidian مثبّت في مكان آخر؟',
  'workspace.obsidianConfigDirLabel': 'مجلد إعدادات Obsidian',
  'workspace.obsidianConfigDirHint':
    'المسار إلى المجلد الذي يحتوي على obsidian.json (مثال: ~/.config/obsidian). اتركه فارغاً للاكتشاف التلقائي.',
  'workspace.obsidianConfigDirPlaceholder': '~/.config/obsidian',
  'workspace.graphLoadFailed': 'فشل تحميل الرسم البياني للذاكرة',
  'workspace.loadingGraph': 'جارٍ تحميل الرسم البياني للذاكرة...',
  'workspace.graphViewMode': 'وضع عرض الرسم البياني للذاكرة',
  'workspace.trees': 'الأشجار',
  'workspace.contacts': 'جهات الاتصال',
  'graph.noContactMentions': 'لا توجد إشارات لجهات اتصال',
  'graph.noMemory': 'لا توجد ذاكرة',
  'graph.source': 'المصدر',
  'graph.topic': 'الموضوع',
  'graph.global': 'عام',
  'graph.document': 'المستند',
  'graph.contact': 'جهة الاتصال',
  'graph.nodes': 'عقد',
  'graph.parentChild': 'أب-ابن',
  'graph.documentContact': 'مستند-جهة اتصال',
  'graph.link': 'رابط',
  'graph.links': 'روابط',
  'graph.children': 'أبناء',
  'graph.clickToOpenObsidian': 'انقر للفتح في Obsidian',
  'graph.person': 'شخص',
  'graph.resetView': 'إعادة ضبط العرض',
  'modal.dontShowAgain': 'لا تظهر اقتراحات مماثلة',
  'reflections.loading': 'جارٍ تحميل التأملات...',
  'reflections.empty': 'لا توجد تأملات بعد',
  'reflections.title': 'التأملات',
  'reflections.proposedAction': 'الإجراء المقترح',
  'reflections.act': 'تنفيذ',
  'reflections.dismiss': 'تجاهل',
  'reflections.viewConversation': 'عرض',
  'subconscious.mode.label': 'وضع اللاوعي',
  'subconscious.mode.off.title': 'إيقاف',
  'subconscious.mode.off.desc': 'اللاوعي معطل.',
  'subconscious.mode.simple.title': 'بسيط',
  'subconscious.mode.simple.desc': 'مراقبة للقراءة فقط. الوصول للذاكرة والملفات فقط.',
  'subconscious.mode.aggressive.title': 'مكثف',
  'subconscious.mode.aggressive.desc':
    'وصول كامل للأدوات. يمكنه الكتابة وإنشاء وكلاء وتفويض المهام.',
  'subconscious.mode.aggressiveWarning':
    'الوضع المكثف يمنح اللاوعي وصولاً كاملاً للأدوات بما في ذلك الكتابة وإنشاء الوكلاء الفرعيين.',
  'subconscious.interval.label': 'التردد',
  'subconscious.interval.minutes': '{n} د',
  'subconscious.interval.hours': '{n} س',
  'subconscious.interval.oneHour': 'ساعة واحدة',
  'subconscious.interval.oneDay': '24 ساعة',
  'whatsapp.chatsSynced': 'محادثات مزامنة',
  'whatsapp.chatSynced': 'محادثة مزامنة',
  'sync.active': 'نشط',
  'sync.recent': 'الأخيرة',
  'sync.idle': 'خامل',
  'sync.memorySources': 'مصادر الذاكرة',
  'sync.noConnectedSources': 'لا توجد مصادر متصلة',
  'sync.chunks': 'أجزاء',
  'sync.lastChunk': 'آخر جزء:',
  'sync.pending': 'معلّق',
  'sync.processed': 'تمت المعالجة',
  'sync.syncing': 'جارٍ المزامنة…',
  'sync.sync': 'مزامنة',
  'sync.failedToLoad': 'فشل تحميل حالة المزامنة',
  'sync.noContent': 'لم تتم مزامنة أي محتوى في الذاكرة بعد. اربط تكاملاً للبدء.',
  'memorySyncInterval.title': 'جدول المزامنة',
  'memorySyncInterval.lastSynced': 'آخر مزامنة',
  'memorySyncInterval.never': 'أبدًا',
  'memorySyncInterval.everyHours': 'كل {h} ساعة',
  'memorySyncInterval.everyMinutes': 'كل {m} دقيقة',
  'memorySyncInterval.manual': 'يدوي فقط',
  'memorySyncInterval.saveFailed': 'فشل تحديث جدول المزامنة',
  'memorySources.title': 'المصادر الذاكرة',
  'memorySources.empty': 'لا توجد مصادر للذاكرة بعد أضف واحدة لبدء تغذية الذاكرة.',
  'memorySources.customSources': 'المصادر العرفية',
  'memorySources.addSource': 'المصدر',
  'memorySources.noCustomSources':
    'لا توجد مصادر عرفية بعد أضف ملفاً، ×1xx repo، ×x0x مكعب، أو صفحة على الشبكة للبدء.',
  'memorySources.loadingConnections': 'علاقات الحب...',
  'memorySources.noConnections': 'لم يتم العثور على أي وصلات اكسكساكسية نشطة. إجمع التكامل أولاً',
  'memorySources.pickConnection': 'اختر اتصال',
  'memorySources.selectConnection': '- اختيار اتصال -',
  'memorySources.comingSoon': 'قريباً',
  'memorySources.composioListFailed': 'فشل في تحميل الأتصالات Xqx0x.',
  'memorySources.browse': '(بروز)...',
  'memorySources.folderPathPlaceholder': '/Users/you/notes',
  'memorySources.globPatternPlaceholder': '**',
  'memorySources.repoUrlPlaceholder': 'https://github.com/org/repo',
  'memorySources.branchPlaceholder': 'main',
  'memorySources.feedUrlPlaceholder': 'https://example.com/feed.xml',
  'memorySources.pageUrlPlaceholder': 'https://example.com/article',
  'memorySources.cssSelectorPlaceholder': 'article',
  'memorySources.searchQueryPlaceholder': 'من:',
  'memorySources.kind.composio': 'التكامل',
  'memorySources.kind.conversation': 'محادثة',
  'memorySources.kind.folder': 'محلي',
  'memorySources.kind.github_repo': 'Xqx0x',
  'memorySources.kind.twitter_query': 'Xqx0x',
  'memorySources.kind.rss_feed': 'Xqx0xq',
  'memorySources.kind.web_page': 'الصفحة',
  'memorySources.sync.successTitle': 'الموسم',
  'memorySources.sync.successMessage': 'وسيظهر التقدم قريبا.',
  'memorySources.sync.failedTitle': 'لقد فشل (سينك)',
  'memorySources.sync.completeTitle': 'تمت المزامنة',
  'memorySources.sync.itemsSynced': 'عناصر تمت مزامنتها',
  'memorySources.sync.upToDate': 'محدّث',
  'memorySources.sync.failedLabel': 'فشل',
  'time.justNow': 'للتو',
  'time.secondsAgoSuffix': 'ثانية مضت',
  'time.minutesAgoSuffix': 'دقيقة مضت',
  'time.hoursAgoSuffix': 'ساعة مضت',
  'time.daysAgoSuffix': 'يوم مضى',
  'memorySources.pickKind': 'أي نوع من المصادر تريد أن تضيفه؟',
  'memorySources.backToKinds': 'العودة إلى أنواع المصادر',
  'memorySources.label': 'Label',
  'memorySources.labelPlaceholder': 'مذكرات بحثي',
  'memorySources.add': 'مضاف',
  'memorySources.adding': 'إضافة...',
  'memorySources.added': 'المصدر مضاف',
  'memorySources.removed': 'المصدر:',
  'memorySources.remove': 'إزالة الألغام',
  'memorySources.enable': 'التمكين',
  'memorySources.disable': 'العجز',
  'memorySources.toggleFailed': 'فشل',
  'memorySources.removeFailed': 'التطهير فشل',
  'memorySources.folderPath': 'طريق الجواد',
  'memorySources.globPattern': 'نمط Glob',
  'memorySources.repoUrl': 'رابط المستودع',
  'memorySources.branch': 'الفرع',
  'memorySources.feedUrl': 'رابط الخلاصة',
  'memorySources.pageUrl': 'رابط الصفحة',
  'memorySources.cssSelector': 'محدد CSS (اختياري)',
  'memorySources.searchQuery': 'استفسار البحث',
  'memorySources.build.title': 'بناء',
  'memorySources.build.building': 'جارٍ البناء…',
  'memorySources.build.successTitle': 'تم بناء الشجرة',
  'memorySources.build.failedTitle': 'فشل البناء',
  'memorySources.build.sealsMessage': 'تم إتمام عملية الختم',
  'memorySources.allIn.button': 'الكل',
  'memorySources.allIn.title': 'هل تريد تفعيل الكل؟',
  'memorySources.allIn.message':
    'سيؤدي هذا إلى تمكين جميع مصادر الذاكرة وإزالة جميع قيود المزامنة. يبني أغنى رسم بياني للذاكرة، لكنه قد يستهلك المزيد من الاعتمادات.',
  'memorySources.allIn.confirm': 'نعم',
  'memorySources.allIn.cancel': 'لا',
  'memorySources.allIn.success': 'تم تمكين جميع المصادر بدون قيود. بدأت المزامنة.',
  'memorySources.allIn.failed': 'تعذّر تطبيق خيار الكل. يرجى المحاولة مرة أخرى.',
  'memorySources.settings.button': 'الإعدادات',
  'memorySources.settings.title': 'إعدادات المزامنة',
  'memorySources.settings.maxPrs': 'أقصى عدد لطلبات السحب',
  'memorySources.settings.maxIssues': 'أقصى عدد للمشكلات',
  'memorySources.settings.maxCommits': 'أقصى عدد للإيداعات',
  'memorySources.settings.maxItems': 'أقصى عدد للعناصر',
  'memorySources.settings.sinceDays': 'فترة البحث (بالأيام)',
  'memorySources.settings.syncDepthDays': 'عمق المزامنة (بالأيام)',
  'memorySources.settings.maxTokens': 'أقصى عدد للرموز لكل مزامنة',
  'memorySources.settings.maxCost': 'الحد الأقصى للتكلفة لكل مزامنة (دولار)',
  'memorySources.settings.unlimited': 'غير محدود',
  'memorySources.settings.unlimitedTooltip':
    'لقد اخترت مزامنة الحد الأقصى لـ {toolkit}. يمكنك تغيير الحدود من هنا.',
  'memorySources.settings.maxed': 'مكتمل',
  'memorySources.settings.save': 'حفظ',
  'memorySources.settings.saving': 'جارٍ الحفظ…',
  'memorySources.settings.saved': 'تم حفظ الإعدادات',
  'memorySources.settings.saveFailed': 'تعذّر حفظ الإعدادات',
  'backend.aiBackend': 'خلفية الذكاء الاصطناعي',
  'backend.cloud': 'سحابي',
  'backend.recommended': 'موصى به',
  'backend.cloudDescription': 'نماذج سريعة وقوية مستضافة على خوادمنا. جاهزة للاستخدام فورًا.',
  'backend.privacyNote': 'لا تُرسَل أي بيانات شخصية أو رسائل أو مفاتيح إلى خوادمنا.',
  'backend.local': 'محلي',
  'backend.advanced': 'متقدم',
  'backend.localDescription':
    'تشغيل النماذج على جهازك باستخدام Ollama. خصوصية كاملة، يتطلب إعدادًا.',
  'backend.ramRecommended': '16 جيجابايت+ RAM موصى به',
  'subconscious.tasks': 'مهام',
  'subconscious.ticks': 'دورات',
  'subconscious.last': 'آخر',
  'subconscious.failed': 'فشل',
  'subconscious.tickInterval': 'فترة الدورة',
  'subconscious.runNow': 'تشغيل الآن',
  'subconscious.instance.on': 'مُفعّل',
  'subconscious.instance.off': 'مُعطّل',
  'subconscious.instance.memory.title': 'عالمك',
  'subconscious.instance.memory.subtitle': 'مصادر الذاكرة المتصلة',
  'subconscious.instance.tinyplace.title': 'توجيه التنسيق',
  'subconscious.instance.tinyplace.subtitle': 'مراجعة جلسات tiny.place',
  'subconscious.instance.tinyplace.disabledHint': 'فعّل التنسيق لتوجيه الجلسات المُدارة.',
  'subconscious.instance.tinyplace.viewDirectives': 'عرض التوجيهات ←',
  'subconscious.runReviewNow': 'شغّل المراجعة الآن',
  'tinyplaceOrchestration.subconsciousBadge': 'اللاوعي · التوجيه',
  'tinyplaceOrchestration.steeringHeader.current': 'توجيه نشط',
  'tinyplaceOrchestration.steeringHeader.none': 'لا يوجد توجيه نشط',
  'tinyplaceOrchestration.steeringHeader.expires': 'ينتهي بعد {n} دورات',
  'tinyplaceOrchestration.steeringHeader.lastReview': 'آخر مراجعة',
  'tinyplaceOrchestration.steeringHeader.runReview': 'شغّل المراجعة الآن',
  'tinyplaceOrchestration.steeringHeader.running': 'جارٍ التشغيل…',
  'subconscious.providerUnavailableTitle': 'تم إيقاف اللاوعي مؤقتًا',
  'subconscious.providerSettings': 'إعدادات الذكاء الاصطناعي',
  'subconscious.scratchpadInfo':
    'في كل دورة، يتحقق اللاوعي مما تغيّر عبر مصادرك المتصلة، ثم يسجّل المهام في قائمة مهامك، أو يحدّث أهدافك، أو ينبّهك عندما يحتاج شيء ما إلى انتباهك. تحقق من الإعدادات → وصول الوكيل لتكوين الوضع والتكرار.',
  'subconscious.approvalNeeded': 'يلزم الموافقة',
  'subconscious.requiresApproval': 'يتطلب الموافقة',
  'subconscious.fixInConnections': 'إصلاح في الاتصالات',
  'subconscious.goAhead': 'تقدّم',
  'subconscious.activeTasks': 'المهام النشطة',
  'subconscious.noActiveTasks': 'لا توجد مهام نشطة',
  'subconscious.default': 'افتراضي',
  'subconscious.addTaskPlaceholder': 'أضف مهمة جديدة...',
  'subconscious.activityLog': 'سجل النشاط',
  'subconscious.noActivity': 'لا يوجد نشاط بعد',
  'subconscious.decision.nothingNew': 'لا جديد',
  'subconscious.decision.completed': 'مكتمل',
  'subconscious.decision.evaluating': 'جارٍ التقييم',
  'subconscious.decision.waitingApproval': 'في انتظار الموافقة',
  'subconscious.decision.failed': 'فشل',
  'subconscious.decision.cancelled': 'ملغي',
  'subconscious.decision.skipped': 'تم تخطيه',
  // Subconscious triggers (event-driven orchestrator) debug panel
  'subconsciousTriggers.title': 'محفزات اللاوعي',
  'subconsciousTriggers.subtitle': 'منسق خلفي مدفوع بالأحداث',
  'subconsciousTriggers.pipeline': 'خط المعالجة',
  'subconsciousTriggers.mode': 'الوضع',
  'subconsciousTriggers.orchestrator': 'المنسق',
  'subconsciousTriggers.running': 'قيد التشغيل',
  'subconsciousTriggers.stopped': 'متوقف',
  'subconsciousTriggers.promotionsPerHour': 'الترقيات / ساعة',
  'subconsciousTriggers.queueDepth': 'عمق الطابور',
  'subconsciousTriggers.orchestratorThread': 'سلسلة المنسق',
  'subconsciousTriggers.userThread': 'سلسلة المستخدم',
  'subconsciousTriggers.disabledHint': 'فعّل الوضع المدفوع بالأحداث لتنشيط خط المعالجة.',
  'subconsciousTriggers.enable': 'تفعيل',
  'subconsciousTriggers.disable': 'تعطيل',
  'actionable.complete': 'إتمام',
  'actionable.dismiss': 'تجاهل',
  'actionable.snooze': 'تأجيل',
  'actionable.new': 'جديد',
  'stats.storage': 'التخزين',
  'stats.files': 'ملفات',
  'stats.documents': 'المستندات',
  'stats.today': 'اليوم',
  'stats.namespaces': 'مساحات الأسماء',
  'stats.relations': 'العلاقات',
  'stats.firstMemory': 'أول ذكرى',
  'stats.latest': 'الأحدث',
  'stats.sessions': 'الجلسات',
  'stats.tokens': 'رموز',
  'bootCheck.invalidUrl': 'يرجى إدخال عنوان URL لبيئة التشغيل.',
  'bootCheck.urlMustStartWith': 'يجب أن يبدأ عنوان URL بـ http:// أو https://',
  'bootCheck.validUrlRequired': 'لا يبدو أن هذا عنوان URL صالح (جرّب https://core.example.com/rpc)',
  'bootCheck.tokenRequired': 'سنحتاج إلى رمز مصادقة للاتصال.',
  'bootCheck.httpPublicWarning':
    'هذا عنوان HTTP عادي على مضيف عام: لن تكون حركة البيانات مشفّرة. استخدم HTTPS ما لم تكن تثق بهذه الشبكة.',
  'bootCheck.chooseCoreMode': 'اختر بيئة التشغيل',
  'bootCheck.connectToCore': 'اتصل ببيئة تشغيلك',
  'bootCheck.desktopDescription': 'يحتاج OpenHuman إلى بيئة تشغيل للعمل. اختر مكانها.',
  'bootCheck.webDescription':
    'على الويب، يتصل OpenHuman ببيئة تشغيل تتحكم فيها. أدخل عنوان URL الخاص بها ورمز المصادقة أدناه، أو احصل على تطبيق سطح المكتب لتشغيلها مباشرة على جهازك.',
  'bootCheck.preferDesktop': 'تفضّل إبقاء كل شيء على جهازك؟',
  'bootCheck.downloadDesktop': 'احصل على تطبيق سطح المكتب',
  'bootCheck.localRecommended': 'التشغيل محليًا (موصى به)',
  'bootCheck.localDescription':
    'يعمل مباشرة على جهازك. الأسرع، خصوصي تمامًا، لا شيء يحتاج إلى إعداد.',
  'bootCheck.cloudMode': 'التشغيل على السحابة (معقد)',
  'bootCheck.cloudDescription':
    'الاتصال ببيئة تشغيل تستضيفها في مكان آخر. تبقى متصلة 24×7 حتى لا تحتاج إلى إبقاء هذا الجهاز يعمل.',
  'bootCheck.coreRpcUrl': 'عنوان URL لبيئة التشغيل',
  'bootCheck.rpcUrlPlaceholder': 'https://core.example.com/rpc',
  'bootCheck.authToken': 'رمز المصادقة',
  'bootCheck.bearerTokenPlaceholder': 'رمز Bearer من بيئة تشغيلك البعيدة',
  'bootCheck.storedLocally': 'يُحفظ على هذا الجهاز فقط. يُرسَل كـ ',
  'bootCheck.testing': 'جارٍ الاختبار…',
  'bootCheck.testConnection': 'اختبار الاتصال',
  'bootCheck.connectedOk': 'متصل. أنت جاهز للانطلاق.',
  'bootCheck.authFailed': 'الرمز لم ينجح. تحقق منه وحاول مرة أخرى.',
  'bootCheck.unreachablePrefix': 'تعذّر الوصول إليه:',
  'bootCheck.checkingCore': 'جارٍ تنشيط بيئة تشغيلك…',
  'bootCheck.cannotReach': 'تعذّر الوصول إلى بيئة التشغيل',
  'bootCheck.cannotReachDesc': 'تعذّر الاتصال ببيئة تشغيلك. هل تريد تجربة بيئة مختلفة؟',
  'bootCheck.switchMode': 'اختر بيئة تشغيل مختلفة',
  'bootCheck.quit': 'خروج',
  'bootCheck.legacyDetected': 'تم اكتشاف بيئة تشغيل خلفية قديمة',
  'bootCheck.legacyDescription':
    'خدمة OpenHuman مثبّتة بشكل منفصل تعمل بالفعل على هذا الجهاز. نحتاج إلى إزالتها قبل أن تتولى بيئة التشغيل المدمجة.',
  'bootCheck.removing': 'جارٍ الإزالة…',
  'bootCheck.removeContinue': 'إزالة ومتابعة',
  'bootCheck.localNeedsRestart': 'بيئة التشغيل المحلية تحتاج إلى إعادة تشغيل',
  'bootCheck.localNeedsRestartDesc':
    'بيئة تشغيلك المحلية على إصدار مختلف عن هذا التطبيق. ستعيد إعادة التشغيل السريعة مزامنتهما.',
  'bootCheck.restarting': 'جارٍ إعادة التشغيل…',
  'bootCheck.restartCore': 'إعادة تشغيل بيئة التشغيل',
  'bootCheck.cloudNeedsUpdate': 'بيئة التشغيل السحابية تحتاج إلى تحديث',
  'bootCheck.cloudNeedsUpdateDesc':
    'بيئة تشغيلك السحابية على إصدار مختلف عن هذا التطبيق. شغّل المحدّث لإعادة مزامنتهما.',
  'bootCheck.updating': 'جارٍ التحديث…',
  'bootCheck.updateCloudCore': 'تحديث بيئة التشغيل السحابية',
  'bootCheck.versionCheckFailed': 'فشل التحقق من إصدار بيئة التشغيل',
  'bootCheck.versionCheckFailedDesc':
    'بيئة تشغيلك تعمل لكنها لا تُبلّغ عن إصدارها. قد تكون قديمة. أعد تشغيلها أو حدّثها للمتابعة.',
  'bootCheck.working': 'جارٍ العمل…',
  'bootCheck.restartUpdateCore': 'إعادة تشغيل / تحديث بيئة التشغيل',
  'bootCheck.unexpectedError': 'خطأ غير متوقع في فحص بدء التشغيل',
  'bootCheck.actionFailed': 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  'bootCheck.portConflictTitle': 'تعذّر تشغيل محرّك التطبيق',
  'bootCheck.portConflictBody':
    'هناك عملية أخرى تستخدم منفذ الشبكة الذي يحتاجه OpenHuman. سنحاول إصلاح ذلك تلقائيًا.',
  'bootCheck.portConflictFixButton': 'إصلاح تلقائي',
  'bootCheck.portConflictFixing': 'جارٍ الإصلاح…',
  'bootCheck.portConflictFixFailed':
    'لم ينجح الإصلاح التلقائي. يُرجى إعادة تشغيل الكمبيوتر والمحاولة مجددًا.',
  'bootCheck.portConflictOwner': '{name} (المعرّف {pid}) يستخدم منفذ الشبكة الذي يحتاجه OpenHuman.',
  'bootCheck.portConflictGuidance':
    'أغلق ذلك البرنامج لتحرير المنفذ، أو افرض إنهاءه أدناه، ثم حاول مرة أخرى.',
  'bootCheck.portConflictForceQuit': 'فرض إنهاء {name}',
  'bootCheck.portConflictForceQuitting': 'جارٍ إغلاق {name}…',
  'bootCheck.portConflictForceQuitFailed':
    'تعذّر إغلاق ذلك البرنامج. قد تحتاج إلى إغلاقه يدويًا ثم إعادة المحاولة.',
  'notifications.justNow': 'الآن',
  'notifications.minAgo': 'منذ {n} د',
  'notifications.hrAgo': 'منذ {n} س',
  'notifications.dayAgo': 'منذ {n} ي',
  'notifications.category.messages': 'الرسائل',
  'notifications.category.agents': 'الوكلاء',
  'notifications.category.skills': 'المهارات',
  'notifications.category.system': 'النظام',
  'notifications.category.meetings': 'الاجتماعات',
  'notifications.category.reminders': 'التذكيرات',
  'notifications.category.important': 'مهم',
  'notifications.filterAll': 'الكل',
  'notifications.filterEmpty': 'لا توجد تنبيهات في هذه الفئة',
  'about.update.status.checking': 'جارٍ التحقق...',
  'about.update.status.available': 'v{version} متاح',
  'about.update.status.availableNoVersion': 'تحديث متاح',
  'about.update.status.downloading': 'جارٍ التنزيل...',
  'about.update.status.readyToInstall': 'v{version} جاهز للتثبيت',
  'about.update.status.readyToInstallNoVersion':
    'تم تنزيل إصدار جديد وهو جاهز. أعد التشغيل للتطبيق.',
  'about.update.status.installing': 'جارٍ التثبيت...',
  'about.update.status.restarting': 'جارٍ إعادة التشغيل...',
  'about.update.status.upToDate': 'أنت تستخدم أحدث إصدار.',
  'about.update.status.error': 'فشل التحقق من التحديثات',
  'about.update.status.default': 'التحقق من التحديثات',
  'welcome.connectionFailed': 'فشل الاتصال: {status} {statusText}',
  'welcome.connectionFailedMsg': 'فشل الاتصال: {message}',
  'welcome.continueLocally': 'المتابعة محليًا',
  'welcome.continueLocallyExperimental': 'المتابعة محليًا (تجريبي)',
  'welcome.localSessionStarting': 'بدء الجلسة المحلية...',
  'welcome.coreConfigUnreadable':
    'تعذّر على بيئة التشغيل قراءة ملف الإعدادات الخاص بها. قد يكون الملف config.toml مملوكًا لحساب مستخدم آخر، أو غير متاح لعملية التشغيل لسبب آخر. أعد تشغيل بيئة التشغيل، وإن لم يُجدِ ذلك فأصلح ملكية مجلد العمل أو أعد إنشاء وحدة التخزين الخاصة به.',
  'welcome.localSessionErrorFallback': 'تعذّر بدء جلسة محلية.',
  'welcome.localSessionDesc': 'يستخدم ملف تعريف محلي غير متصل ويتخطى TinyHumans OAuth.',
  'chat.agentChatDesc': 'فتح جلسة محادثة مباشرة مع الوكيل.',
  'chat.modelPlaceholder': 'gpt-4o',
  'channels.activeRouteValue': '{channel} عبر {authMode}',
  'privacy.dataKind.messages': 'الرسائل',
  'privacy.dataKind.agents': 'الوكلاء',
  'privacy.dataKind.skills': 'المهارات',
  'privacy.dataKind.system': 'النظام',
  'privacy.dataKind.meetings': 'الاجتماعات',
  'privacy.dataKind.reminders': 'التذكيرات',
  'privacy.dataKind.important': 'مهم',
  'onboarding.enableLocalAI': 'تفعيل الذكاء الاصطناعي المحلي',
  'onboarding.skills.status.available': 'متاح',
  'onboarding.skills.status.connected': 'متصل',
  'onboarding.skills.status.connecting': 'جارٍ الاتصال',
  'onboarding.skills.status.error': 'خطأ',
  'onboarding.skills.status.unavailable': 'غير متاح',
  'composio.statusUnavailable': 'الحالة غير متاحة',
  'composio.authExpired': 'انتهت صلاحية المصادقة',
  'composio.reconnect': 'إعادة الاتصال',
  'composio.expiredAuthorization': '{name} انتهت صلاحية الترخيص',
  'composio.expiredDescription':
    'أعد الاتصال لإعادة تمكين أدوات {name}. OpenHuman سيبقي هذا التكامل غير متاح حتى تقوم بتحديث وصول OAuth.',
  'composio.envVarOverrides': 'محدد، فإنه يتجاوز هذا الإعداد.',
  'composio.previewBadge': 'معاينة',
  'composio.previewTooltip':
    'سيتم دمج الوكيل قريبًا - يمكنك الاتصال، ولكن لا يمكن للوكيل استخدام مجموعة الأدوات هذه بعد.',
  'memory.day.sun': 'أحد',
  'memory.day.mon': 'إثن',
  'memory.day.tue': 'ثلا',
  'memory.day.wed': 'أرب',
  'memory.day.thu': 'خمي',
  'memory.day.fri': 'جمع',
  'memory.day.sat': 'سبت',
  'memory.ingesting': 'جارٍ الاستيعاب',
  'memory.ingestionQueued': 'في قائمة الانتظار',
  'memory.ingestingTitle': 'جارٍ استيعاب {title}',
  'mic.noAudioCaptured': 'لم يُلتقط أي صوت',
  'mic.noSpeechDetected': 'لم يُكتشف أي كلام',
  'mic.lowConfidenceResult': 'تعذّر فهم الصوت بوضوح: يرجى المحاولة مرة أخرى',
  'mic.failedToStopRecording': 'فشل إيقاف التسجيل: {message}',
  'mic.transcriptionFailed': 'فشل النسخ: {message}',
  'mic.voiceNotCompiled':
    'خاصية تحويل الصوت إلى نص غير متوفرة في هذا الإصدار من التطبيق. حدّث OpenHuman لتفعيلها.',
  'reflections.kind.retrospective': 'مراجعة',
  'reflections.kind.derivedFact': 'حقيقة مستنتجة',
  'reflections.kind.moodInsight': 'رؤية المزاج',
  'reflections.kind.relationshipInsight': 'رؤية العلاقة',
  'graph.tooltip.summary': 'ملخص',
  'graph.tooltip.contact': 'جهة اتصال',
  'localModel.usage.never': 'أبدًا',
  'localModel.usage.mediumLoad': 'حمل متوسط',
  'localModel.usage.lowLoad': 'حمل منخفض',
  'localModel.usage.idleMode': 'وضع الخمول',
  'localModel.rebootstrapComplete': 'اكتملت إعادة تمهيد النموذج.',
  'localModel.modelsVerified': 'تم التحقق من النماذج المحلية.',
  'accounts.addModal.allConnected': 'الكل متصل',
  'accounts.addModal.title': 'إضافة حساب',
  'accounts.respondQueue.empty': 'فارغ',
  'accounts.respondQueue.hide': 'إخفاء قائمة الردود',
  'accounts.respondQueue.loadFailed': 'فشل تحميل قائمة الردود',
  'accounts.respondQueue.loading': 'جارٍ تحميل القائمة…',
  'accounts.respondQueue.pending': 'معلّق',
  'accounts.respondQueue.show': 'إظهار قائمة الردود',
  'accounts.respondQueue.title': 'قائمة الردود',
  'accounts.webviewHost.almostReady': 'على وشك الجهوزية...',
  'accounts.webviewHost.loadTimeout': 'انتهت مهلة تحميل العرض',
  'accounts.webviewHost.loading': 'جارٍ تحميل {providerName}...',
  'accounts.webviewHost.loadingAccount': 'جارٍ تحميل الحساب',
  'accounts.webviewHost.restoringSession': 'جارٍ استعادة الجلسة...',
  'accounts.webviewHost.retryLoading': 'إعادة محاولة التحميل',
  'accounts.webviewHost.takingLonger': '{providerName} يستغرق وقتًا أطول من المتوقع.',
  'accounts.webviewHost.timeoutHint': 'تلميح انتهاء المهلة',
  'app.connectionBadge.composio': 'Composio',
  'app.connectionBadge.messaging': 'المراسلة',
  'app.connectionIndicator.connected': 'متصل بـ OpenHuman AI 🚀',
  'app.connectionIndicator.connecting': 'جارٍ الاتصال',
  'app.connectionIndicator.coreOffline': 'النواة غير متصلة',
  'app.connectionIndicator.disconnected': 'غير متصل',
  'app.connectionIndicator.offline': 'غير متصل بالإنترنت',
  'app.connectionIndicator.reconnecting': 'إعادة الاتصال…',
  'app.errorFallback.componentStack': 'مكدس المكوّنات',
  'app.errorFallback.contactSupport': 'تواصل مع الدعم',
  'app.errorFallback.copyEventId': 'نسخ',
  'app.errorFallback.eventIdCopied': 'تم النسخ',
  'app.errorFallback.eventIdLabel': 'معرّف الخطأ',
  'app.errorFallback.revealLogs': 'إظهار السجلات',
  'app.errorFallback.downloadLatest': 'تنزيل الأحدث',
  'app.errorFallback.heading': 'العنوان',
  'app.errorFallback.hint': 'تلميح',
  'app.errorFallback.reloadApp': 'إعادة تحميل التطبيق',
  'app.errorFallback.subheading': 'العنوان الفرعي',
  'app.errorFallback.tryRecover': 'محاولة الاسترداد',
  'app.localAiDownload.installing': 'جارٍ التثبيت...',
  'app.localAiDownload.preparing': 'جارٍ التحضير...',
  'app.openhumanLink.accounts.continueWith': 'متابعة باستخدام تسجيل الدخول عبر {label}',
  'app.openhumanLink.accounts.done': 'تم',
  'app.openhumanLink.accounts.intro': 'مقدمة',
  'app.openhumanLink.accounts.webviewNote': 'ملاحظة العرض',
  'app.openhumanLink.billing.openDashboard': 'فتح لوحة التحكم',
  'app.openhumanLink.billing.stayOnTrial': 'البقاء في النسخة التجريبية',
  'app.openhumanLink.billing.trialCredit': 'رصيد التسجيل',
  'app.openhumanLink.billing.trialDesc': 'قد تختلف عروض الرصيد حسب العرض الترويجي وأهلية الحساب.',
  'app.openhumanLink.defaultBody':
    'غير جاهز في النافذة المنبثقة بعد. افتح صفحة الإعدادات الكاملة عند الحاجة',
  'app.openhumanLink.discord.intro': 'مقدمة',
  'app.openhumanLink.discord.openInvite': 'فتح الدعوة',
  'app.openhumanLink.discord.perk1': 'ميزة 1',
  'app.openhumanLink.discord.perk2': 'ميزة 2',
  'app.openhumanLink.discord.perk3': 'ميزة 3',
  'app.openhumanLink.discord.perk4': 'ميزة 4',
  'app.openhumanLink.discordReport.intro':
    'نعتذر: حدث خطأ من جانبنا. نحاول تسجيل هذه الأخطاء تلقائيًا، لكن مشاركة التفاصيل على Discord تساعدنا على إصلاحها بشكل أسرع.',
  'app.openhumanLink.discordReport.openDiscord': 'فتح Discord',
  'app.openhumanLink.done': 'تم',
  'app.openhumanLink.notifications.desktopOnly':
    'الإشعارات الأصلية متاحة فقط في تطبيق سطح المكتب (شغّل `pnpm dev:app`).',
  'app.openhumanLink.notifications.permissionOff':
    'إذن الإشعارات معطّل. فعّل OpenHuman في إعدادات النظام → الإشعارات، ثم أعد المحاولة.',
  'app.openhumanLink.notifications.triggerFailed':
    'تعذّر على OpenHuman إطلاق إشعار النظام. تحقّق من إعدادات إشعارات نظام التشغيل وأعد المحاولة.',
  'app.openhumanLink.notifications.welcomeBody': 'ستصلك تنبيهات هنا عندما يتطلب أمر ما انتباهك.',
  'app.openhumanLink.notifications.welcomeTitle': 'OpenHuman جاهز للعمل',
  'app.openhumanLink.status.closed': 'مغلق',
  'app.openhumanLink.status.connected': 'متصل',
  'app.openhumanLink.status.error': 'خطأ',
  'app.openhumanLink.status.loading': 'جارٍ التحميل…',
  'app.openhumanLink.status.needsSignIn': 'يتطلب تسجيل الدخول',
  'app.openhumanLink.status.timedOut': 'انتهت المهلة',
  'app.openhumanLink.loadingChannelSetup': 'جارٍ تحميل إعداد القناة',
  'app.openhumanLink.maybeLater': 'ربما لاحقًا',
  'app.openhumanLink.notifications.asking': 'جارٍ الاستفسار من نظام التشغيل…',
  'app.openhumanLink.notifications.blocked': 'محظور',
  'app.openhumanLink.notifications.blockedStep1': 'الخطوة الأولى من الحظر',
  'app.openhumanLink.notifications.blockedStep2': 'الخطوة الثانية من الحظر',
  'app.openhumanLink.notifications.blockedStep3': 'الخطوة الثالثة من الحظر',
  'app.openhumanLink.notifications.intro': 'مقدمة',
  'app.openhumanLink.notifications.promptHint': 'تلميح الطلب',
  'app.openhumanLink.notifications.retry': 'إعادة إرسال إشعار اختبار',
  'app.openhumanLink.notifications.send': 'إرسال إشعار اختبار',
  'app.openhumanLink.notifications.sendFailed': 'تعذّر الإرسال: {error}',
  'app.openhumanLink.notifications.sent':
    'تم إرسال إشعار اختباري. إذا لم تستلمه، انتقل إلى إعدادات النظام ← الإشعارات ← OpenHuman، فعّل "السماح بالإشعارات"، واضبط نمط الشعار على "مستمر".',
  'app.openhumanLink.skipForNow': 'تخطي في الوقت الحالي',
  'app.openhumanLink.telegramUnavailable': 'Telegram غير متاح',
  'app.openhumanLink.title.accounts': 'ربط تطبيقاتك',
  'app.openhumanLink.title.billing': 'الفوترة والرصيد',
  'app.openhumanLink.title.discord': 'الانضمام إلى المجتمع',
  'app.openhumanLink.title.discordReport': 'الإبلاغ عن هذا الخطأ',
  'app.openhumanLink.title.messaging': 'ربط قناة محادثة',
  'app.openhumanLink.title.notifications': 'السماح بالإشعارات',
  'app.persistRehydration.body': 'المحتوى',
  'app.persistRehydration.heading': 'العنوان',
  'app.persistRehydration.resetCta': 'جارٍ إعادة الضبط…',
  'app.persistRehydration.resetting': 'جارٍ إعادة الضبط…',
  'app.routeLoading.initializing': 'جارٍ تهيئة OpenHuman...',
  'app.update.currentlyOn': '{version}',
  'app.update.errorFallback': 'حدث خطأ أثناء التحديث.',
  'app.update.header.default': 'تحديث',
  'app.update.header.error': 'فشل التحديث',
  'app.update.header.installing': 'جارٍ تثبيت التحديث',
  'app.update.header.readyToInstall': 'التحديث جاهز للتثبيت',
  'app.update.header.restarting': 'جارٍ إعادة التشغيل…',
  'app.update.later': 'لاحقًا',
  'app.update.newVersionReady': 'إصدار جديد جاهز للتثبيت.',
  'app.update.progress.downloaded': 'تم تنزيل {amount}',
  'app.update.progress.installing': 'جارٍ تثبيت الإصدار الجديد…',
  'app.update.progress.restarting': 'جارٍ إعادة تشغيل التطبيق…',
  'app.update.progress.working': '{percent}%',
  'app.update.restartNote': 'ملاحظة إعادة التشغيل',
  'app.update.restartNow': 'إعادة التشغيل الآن',
  'app.update.versionReady': 'الإصدار {newVersion} جاهز للتثبيت.',
  'channels.discord.accountLinked': 'تم ربط الحساب',
  'channels.discord.connect': 'توصيل',
  'channels.discord.linkTokenExpired': 'انتهت صلاحية رمز الربط. يرجى المحاولة مرة أخرى.',
  'channels.discord.linkTokenInstruction': '{token}',
  'channels.discord.linkTokenLabel': 'تسمية رمز الربط',
  'channels.discord.linkTokenOnce': 'رمز الربط لمرة واحدة',
  'channels.discord.picker.allPermissionsOk': 'البوت يمتلك جميع الأذونات المطلوبة في هذه القناة.',
  'channels.discord.picker.botNotInServers': 'البوت ليس في أي خادم',
  'channels.discord.picker.category': 'الفئة',
  'channels.discord.picker.channel': 'قناة',
  'channels.discord.picker.checkingPermissions': 'جارٍ التحقق من الأذونات',
  'channels.discord.picker.loadingChannels': 'جارٍ تحميل القنوات...',
  'channels.discord.picker.loadingServers': 'جارٍ تحميل الخوادم...',
  'channels.discord.picker.missingPermissions': 'أذونات مفقودة',
  'channels.discord.picker.noChannels': 'لا توجد قنوات نصية',
  'channels.discord.picker.noServers': 'لا توجد خوادم',
  'channels.discord.picker.selectChannel': 'اختر قناة',
  'channels.discord.picker.selectServer': 'اختر خادمًا',
  'channels.discord.picker.server': 'خادم',
  'channels.discord.picker.serverChannelSelection': 'اختيار الخادم والقناة',
  'channels.discord.savedRestartRequired': 'تم حفظ القناة. أعد تشغيل التطبيق لتفعيلها.',
  'channels.telegram.connect': 'توصيل',
  'channels.telegram.managedDmConnecting': 'جارٍ اتصال الرسائل المباشرة المُدارة',
  'channels.telegram.managedDmTimeout': 'انتهت مهلة الرسائل المباشرة المُدارة',
  'channels.telegram.reconnect': 'إعادة الاتصال',
  'channels.telegram.savedRestartRequired': 'تم حفظ القناة. أعد تشغيل التطبيق لتفعيلها.',
  'channels.web.alwaysAvailable': 'متاح دائمًا',
  'chat.approval.approve': 'الموافقة',
  'chat.approval.alwaysAllow': 'دائماً ما تسمح',
  'chat.approval.alwaysAllowHint': 'توقّف عن طلب هذه الأداة - إضافتها إلى قائمتك دائماً -',
  'chat.approval.deciding': 'العمل...',
  'chat.approval.deny': 'ديني',
  'chat.approval.error': 'لا يمكن تسجيل قرارك حاول مرة أخرى',
  'chat.approval.fallback': 'العميل يريد القيام بعمل يحتاج إلى موافقتك',
  'chat.approval.title': 'الموافقة المطلوبة',
  'chat.approval.tool': 'Tool:',
  'chat.flowApproval.title': 'يحتاج سير العمل إلى موافقة',
  'chat.flowApproval.fallback': 'يريد تشغيل سير العمل تنفيذ إجراء يحتاج إلى موافقتك.',
  'chat.flowApproval.tool': 'الأداة:',
  'chat.flowApproval.flow': 'التدفق:',
  'chat.flowApproval.approve': 'الموافقة مرة واحدة',
  'chat.flowApproval.approveAlways': 'الموافقة دائماً',
  'chat.flowApproval.approveAlwaysHint': 'تخطي نقطة التحقق هذه في التشغيلات المستقبلية لهذا التدفق',
  'chat.flowApproval.deny': 'رفض',
  'chat.flowApproval.deciding': 'جارٍ العمل…',
  'chat.flowApproval.error': 'تعذّر تسجيل قرارك. حاول مرة أخرى.',
  'chat.flowProposal.title': 'اقتراح مسار العمل',
  'chat.flowProposal.subtitle': 'راجع هذه الأتمتة قبل حفظها.',
  'chat.flowProposal.triggerLabel': 'المُشغّل',
  'chat.flowProposal.stepsLabel': 'الخطوات',
  'chat.flowProposal.noSteps': 'لا توجد خطوات إضافية.',
  'chat.flowProposal.requireApprovalHint': 'سيتطلب كل إجراء صادر موافقتك.',
  'chat.flowProposal.save': 'حفظ وتفعيل',
  'chat.flowProposal.saving': 'جارٍ الحفظ…',
  'chat.flowProposal.openInCanvas': 'فتح في اللوحة',
  'chat.flowProposal.dismiss': 'إغلاق',
  'chat.flowProposal.error': 'تعذّر حفظ سير العمل. حاول مرة أخرى.',
  'chat.flowProposal.enableError':
    'تم حفظ سير العمل، لكن تعذّر تفعيله. حاول مرة أخرى، أو فعّله من صفحة سير العمل.',
  'chat.flowProposal.savedConfirmation': 'تم الحفظ',
  'chat.flowProposal.viewWorkflow': 'عرض سير العمل',
  'chat.flowProposal.stepKind.agent': 'وكيل',
  'chat.flowProposal.stepKind.toolCall': 'إجراء',
  'chat.flowProposal.stepKind.httpRequest': 'طلب ويب',
  'chat.flowProposal.stepKind.code': 'تشغيل الكود',
  'chat.flowProposal.stepKind.condition': 'شرط',
  'chat.flowProposal.stepKind.switch': 'تبديل',
  'chat.flowProposal.stepKind.merge': 'دمج',
  'chat.flowProposal.stepKind.splitOut': 'تقسيم',
  'chat.flowProposal.stepKind.transform': 'تحويل',
  'chat.flowProposal.stepKind.outputParser': 'تحليل الإخراج',
  'chat.flowProposal.stepKind.subWorkflow': 'مسار عمل فرعي',
  'channels.authMode.managed_dm': 'قم بتسجيل الدخول باستخدام OpenHuman',
  'channels.authMode.oauth': 'OAuth تسجيل الدخول',
  'channels.authMode.bot_token': 'استخدم رمز الروبوت الخاص بك',
  'channels.authMode.api_key': 'استخدم مفتاح API الخاص بك',
  'channels.fieldRequired': '{field} مطلوب',
  'channels.mcp.title': 'MCP الخوادم',
  'channels.mcp.description':
    'تصفح وأدر خوادم Model Context Protocol التي توسّع قدرات الذكاء الاصطناعي بأدوات جديدة.',
  'channels.discord.displayName': 'Discord',
  'channels.discord.description': 'إرسال واستقبال الرسائل عبر Discord.',
  'channels.discord.authMode.bot_token.description':
    'قم بتوفير رمز الروبوت المميز Discord الخاص بك.',
  'channels.discord.authMode.oauth.description':
    'قم بتثبيت الروبوت OpenHuman على خادم Discord الخاص بك عبر OAuth.',
  'channels.discord.authMode.managed_dm.description':
    'اربط حسابك الشخصي في Discord بالروبوت OpenHuman.',
  'channels.discord.fields.bot_token.label': 'رمز الروبوت',
  'channels.discord.fields.bot_token.placeholder': 'رمز الروبوت Discord الخاص بك',
  'channels.discord.fields.guild_id.label': 'معرف الخادم (الرابطة)',
  'channels.discord.fields.guild_id.placeholder': 'اختياري: يقتصر على خادم معين',
  'channels.telegram.displayName': 'Telegram',
  'channels.telegram.description': 'إرسال واستقبال الرسائل عبر Telegram.',
  'channels.telegram.authMode.managed_dm.description':
    'أرسل رسالة إلى الروبوت OpenHuman Telegram مباشرة.',
  'channels.telegram.authMode.bot_token.description':
    'قم بتوفير رمز الروبوت Telegram الخاص بك من @BotFather.',
  'channels.telegram.fields.bot_token.label': 'رمز الروبوت',
  'channels.telegram.fields.bot_token.placeholder': '123456:ABC-DEF1234ghIkl-zyx57W2v1u123ew11',
  'channels.telegram.fields.allowed_users.label': 'المستخدمون المسموح لهم',
  'channels.telegram.fields.allowed_users.placeholder': 'أسماء المستخدمين Telegram مفصولة بفواصل',
  'channels.telegram.remoteControlTitle': 'جهاز التحكم عن بعد (Telegram)',
  'channels.telegram.remoteControlBody':
    'من دردشة Telegram المسموح بها، أرسل /الحالة، /الجلسات، /جديد، أو /مساعدة. لا يزال توجيه النموذج يستخدم /model و /models.',
  'channels.connectHelp.title': 'كيفية الاتصال',
  'channels.connectHelp.discord':
    'اختر طريقة أدناه: اربط حسابك عبر OpenHuman، أو ثبّت البوت باستخدام OAuth، أو الصق رمز البوت الخاص بك من بوابة مطوري Discord.',
  'channels.connectHelp.telegram':
    'اختر طريقة أدناه: راسل بوت OpenHuman المُدار لربطه، أو الصق رمز البوت الخاص بك من @BotFather.',
  'channels.connectHelp.slackNote':
    'تبحث عن Slack؟ يتصل Slack كتطبيق من خلال الاتصالات → OAuth، وليس كقناة مراسلة هنا.',
  'channels.web.displayName': 'الويب',
  'channels.web.description': 'الدردشة عبر واجهة مستخدم الويب المضمنة.',
  'channels.web.authMode.managed_dm.description': 'استخدم دردشة الويب المضمنة - لا يلزم الإعداد.',
  'channels.yuanbao.connect': 'Connect',
  'channels.yuanbao.connecting': 'جارٍ الاتصال…',
  'channels.yuanbao.fieldRequired': '{field} مطلوب',
  'channels.yuanbao.reconnect': 'Reconnect',
  'channels.yuanbao.savedRestartRequired': 'تم حفظ القناة. أعد تشغيل التطبيق لتفعيلها.',
  'channels.yuanbao.unexpectedStatus': 'حالة اتصال غير متوقعة: {status}',
  'chat.unsubscribeApproval.approve': 'موافقة وإلغاء الاشتراك',
  'chat.unsubscribeApproval.approved': '✓ تم إلغاء الاشتراك بنجاح.',
  'chat.unsubscribeApproval.denied': '✕ تم رفض الطلب.',
  'chat.unsubscribeApproval.deny': 'رفض',
  'chat.unsubscribeApproval.processing': 'جارٍ المعالجة...',
  'chat.unsubscribeApproval.title': 'طلب إلغاء الاشتراك',
  'commandPalette.ariaLabel': 'لوحة الأوامر',
  'commandPalette.description': 'الوصف',
  'commandPalette.label': 'الأوامر',
  'commandPalette.noResults': 'لا توجد نتائج',
  'commandPalette.placeholder': 'اكتب أمرًا أو ابحث…',
  'commandPalette.searchAria': 'البحث في الأوامر',
  'commandPalette.shortcutHint': 'اضغط ؟ لعرض جميع الاختصارات',
  'commandPalette.title': 'لوحة الأوامر',
  'kbd.ariaLabel': 'اختصار لوحة المفاتيح: {shortcut}',
  'shortcuts.title': 'اختصارات لوحة المفاتيح',
  'shortcuts.subtitle': 'سرّع سير عملك باستخدام اختصارات لوحة المفاتيح هذه.',
  'shortcuts.menuDesc': 'تصفّح جميع اختصارات لوحة المفاتيح في التطبيق.',
  'shortcuts.empty': 'لا توجد اختصارات لوحة مفاتيح متاحة حاليًا.',
  'shortcuts.openHint': 'افتح هذه القائمة في أي وقت باستخدام',
  'shortcuts.group.navigation': 'التنقل',
  'shortcuts.group.profiles': 'الملفات الشخصية',
  'shortcuts.group.chat': 'الدردشة',
  'shortcuts.group.view': 'العرض',
  'shortcuts.group.general': 'عام',
  'shortcuts.group.help': 'المساعدة',
  'shortcuts.action.home': 'الذهاب إلى الرئيسية',
  'shortcuts.action.chat': 'الذهاب إلى الدردشة',
  'shortcuts.action.knowledge': 'الذهاب إلى المعرفة والذاكرة',
  'shortcuts.action.connections': 'الذهاب إلى الاتصالات',
  'shortcuts.action.activity': 'الذهاب إلى النشاط',
  'shortcuts.action.settings': 'فتح الإعدادات',
  'shortcuts.action.newChat': 'دردشة جديدة',
  'shortcuts.action.toggleSidebar': 'تبديل الشريط الجانبي',
  'shortcuts.action.commandPalette': 'لوحة الأوامر',
  'iosMascot.connectedTo': 'متصل بـ',
  'iosMascot.defaultPairedLabel': 'سطح المكتب',
  'iosMascot.disconnect': 'قطع الاتصال',
  'iosMascot.error.generic': 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  'iosMascot.error.sendFailed': 'فشل الإرسال. تحقق من اتصالك.',
  'iosMascot.pushToTalk': 'اضغط لتتحدث',
  'iosMascot.sendMessage': 'أرسل رسالة',
  'iosMascot.thinking': 'أفكر...',
  'iosMascot.typeMessage': 'اكتب أ رسالة...',
  'iosPair.connectedLoading': 'متصل! جارٍ التحميل...',
  'iosPair.connecting': 'جارٍ الاتصال بسطح المكتب...',
  'iosPair.desktopLabel': 'سطح المكتب',
  'iosPair.error.camera': 'فشل فحص الكاميرا. تحقق من أذونات الكاميرا وحاول مرة أخرى.',
  'iosPair.error.connectionFailed': 'فشل الاتصال. تأكد من تشغيل تطبيق سطح المكتب وحاول مجدداً.',
  'iosPair.error.invalidQr': 'رمز QR غير صالح. تأكد من مسح رمز إقران OpenHuman.',
  'iosPair.error.unreachableDesktop':
    'تعذّر الوصول إلى سطح المكتب. تأكد من اتصال كلا الجهازين بالإنترنت وحاول مجدداً.',
  'iosPair.expired': 'QR code انتهت صلاحيته. اطلب من سطح المكتب إعادة إنشاء الرمز.',
  'iosPair.instructions':
    'افتح OpenHuman على سطح المكتب، اذهب إلى الإعدادات > الأجهزة، واضغط «إقران الهاتف» لعرض رمز QR.',
  'iosPair.retryScan': 'أعد محاولة المسح',
  'iosPair.scanQrCode': 'المسح الضوئي QR code',
  'iosPair.scannerOpening': 'فتح الماسح الضوئي...',
  'iosPair.step.openDesktop': 'افتح OpenHuman على سطح المكتب',
  'iosPair.step.openSettings': 'انتقل إلى الإعدادات > الأجهزة',
  'iosPair.step.showQr': 'اضغط على "إقران الهاتف" لإظهار QR',
  'iosPair.title': 'الإقران مع سطح المكتب',
  'composio.connect.additionalConfigRequired': 'يلزم إعداد إضافي',
  'composio.connect.atlassianSubdomainHint': 'acme',
  'composio.connect.atlassianSubdomainLabel': 'تسمية النطاق الفرعي لـ Atlassian',
  'composio.connect.connect': 'اتصال',
  'composio.connect.connectedAccounts': 'الحسابات المتصلة',
  'composio.connect.defaultLabel': 'افتراضي',
  'composio.connect.disconnectAccount': 'إزالة',
  'composio.connect.addAnotherAccount': 'إضافة حساب آخر',
  'composio.connect.dynamicsOrgNameHint':
    'على سبيل المثال، "myorg" لـ myorg.crm.dynamics.com. أدخل اسم المؤسسة المختصر فقط، وليس الرابط الكامل.',
  'composio.connect.dynamicsOrgNameLabel': 'اسم مؤسسة Dynamics 365',
  'composio.connect.connectionFailed': 'فشل الاتصال (الحالة: {status}).',
  'composio.connect.disconnectFailed': 'فشل قطع الاتصال: {msg}',
  'composio.connect.disconnecting': 'جارٍ قطع الاتصال…',
  'composio.connect.idleDescription': 'اربط حساب',
  'composio.connect.idleDescriptionSuffix':
    'الخاص بك. سنفتح نافذة متصفح، توافق فيها على الوصول، وسيكتشف هذا التطبيق الاتصال تلقائيًا.',
  'composio.connect.isConnected': 'متصل.',
  'composio.connect.manage': 'إدارة',
  'composio.connect.needsFieldsPrefix': 'للاتصال',
  'composio.connect.needsFieldsSuffix':
    'نحتاج إلى مزيد من المعلومات. املأ الحقول الناقصة أدناه وحاول مرة أخرى.',
  'composio.connect.needsSubdomain': 'للاتصال بـ',
  'composio.connect.needsSubdomainSuffix':
    'أدخل النطاق الفرعي لـ Atlassian (مثل acme لـ acme.atlassian.net) ثم أعد المحاولة.',
  'composio.connect.oauthComplete': 'بانتظار إكمال OAuth…',
  'composio.connect.oauthTimeout': 'انتهت مهلة OAuth',
  'composio.connect.permissions': 'الأذونات',
  'composio.connect.permissionsDefault': 'القراءة والكتابة مفعّلتان افتراضيًا',
  'composio.connect.permissionsNote': 'قد يكشف',
  'composio.connect.permissionsNoteSuffix':
    'أذونات وكيل OpenHuman الخاصة يتم التحكم بها أدناه عبر مفاتيح القراءة والكتابة والإدارة.',
  'composio.connect.reopenBrowser': 'إعادة فتح المتصفح',
  'composio.connect.requestingUrl': 'جارٍ طلب عنوان URL للاتصال…',
  'composio.connect.requiredFieldEmpty': 'هذا الحقل مطلوب.',
  'composio.connect.retryConnection': 'إعادة محاولة الاتصال',
  'composio.connect.scopeLoadError': 'تعذّر تحميل تفضيلات النطاق: {msg}',
  'composio.connect.scopeSaveError': 'تعذّر حفظ نطاق {key}: {msg}',
  'composio.connect.scope.read': 'قراءة',
  'composio.connect.scope.readHint': 'اسمح للوكيل بقراءة البيانات من هذا الاتصال.',
  'composio.connect.scope.write': 'اكتب',
  'composio.connect.scope.writeHint': 'اسمح للوكيل بإنشاء البيانات أو تعديلها من خلال هذا الاتصال.',
  'composio.connect.scope.admin': 'المسؤول',
  'composio.connect.scope.adminHint':
    'السماح للوكيل بإدارة الإعدادات أو الأذونات أو الإجراءات المدمرة.',
  'composio.connect.subdomainInvalid':
    'أدخل النطاق الفرعي القصير فقط (مثل "acme")، وليس الرابط الكامل. يجب أن يحتوي فقط على أحرف وأرقام وشُرَط.',
  'composio.connect.subdomainRequired': 'يرجى إدخال نطاقك الفرعي في Atlassian للمتابعة.',
  'composio.connect.wabaIdHint':
    'احصل عليه عبر GET /me/businesses ثم GET /{business_id}/owned_whatsapp_business_accounts باستخدام رمز وصول Meta الخاص بك.',
  'composio.connect.wabaIdLabel': 'تسمية معرف WABA',
  'composio.connect.atlassianSubdomainPlaceholder': 'your-subdomain',
  'composio.connect.dynamicsOrgNamePlaceholder': 'myorg',
  'composio.connect.wabaIdPlaceholder': 'e.g. 123456789012345',
  'composio.connect.wabaIdRequired': 'يرجى إدخال معرف حساب WhatsApp Business (WABA ID) للمتابعة.',
  'composio.connect.waitingFor': 'بانتظار',
  'composio.connect.waitingHint': 'تلميح الانتظار',
  'composio.triggers.heading': 'المشغّلات',
  'composio.triggers.listenFrom': 'الاستماع للأحداث من',
  'composio.triggers.loadError': 'تعذّر تحميل المشغّلات',
  'composio.triggers.sessionExpired':
    'انتهت صلاحية جلسة OpenHuman. سجّل الدخول مرة أخرى لتحميل المشغّلات.',
  'composio.triggers.needsConfiguration': 'يحتاج إلى إعداد',
  'composio.triggers.noneAvailable': 'لا توجد مشغّلات متاحة حاليًا لـ',
  'conversations.taskKanban.moveLeft': 'نقل لليسار',
  'conversations.taskKanban.moveRight': 'نقل لليمين',
  'conversations.taskKanban.title': 'المهام',
  'conversations.threadTodo.title': 'الخطة',
  'conversations.planReview.title': 'مراجعة الخطة',
  'conversations.planReview.subtitle':
    'وافق لتشغيلها، أو ارفضها لتجاهلها، أو أرسل ملاحظات لتعديلها.',
  'conversations.planReview.approve': 'الموافقة والتشغيل',
  'conversations.planReview.reject': 'رفض',
  'conversations.planReview.feedbackLabel': 'طلب تغييرات',
  'conversations.planReview.feedbackPlaceholder': 'صف ما الذي يجب تغييره…',
  'conversations.planReview.sendFeedback': 'إرسال الملاحظات',
  'conversations.threadGoal.label': 'الهدف',
  'conversations.threadGoal.setCta': 'تحديد هدف',
  'conversations.threadGoal.placeholder': 'ما الذي يجب أن تحققه هذه المحادثة؟',
  'conversations.threadGoal.save': 'حفظ',
  'conversations.threadGoal.cancel': 'إلغاء',
  'conversations.threadGoal.edit': 'تعديل الهدف',
  'conversations.threadGoal.clear': 'مسح الهدف',
  'conversations.threadGoal.complete': 'وضع علامة كمكتمل',
  'conversations.threadGoal.pause': 'إيقاف مؤقت',
  'conversations.threadGoal.resume': 'استئناف',
  'conversations.threadGoal.tokensSuffix': 'رمز',
  'conversations.threadGoal.status.active': 'نشط',
  'conversations.threadGoal.status.paused': 'متوقف مؤقتًا',
  'conversations.threadGoal.status.budget_limited': 'تم بلوغ الحد',
  'conversations.threadGoal.status.complete': 'مكتمل',
  'conversations.taskKanban.approval.default': 'التقصير',
  'conversations.taskKanban.approval.notRequired': 'غير مطلوب',
  'conversations.taskKanban.approval.notRequiredBadge': 'عدم الموافقة',
  'conversations.taskKanban.approval.required': 'المطلوب',
  'conversations.taskKanban.approval.requiredBadge': 'الموافقة',
  'conversations.taskKanban.approval.requiredBeforeExecution': 'مطلوب قبل الإعدام',
  'conversations.taskKanban.briefButton': 'موجز',
  'conversations.taskKanban.briefTitle': 'موجز',
  'conversations.taskKanban.closeBrief': 'موجز المهام',
  'conversations.taskKanban.field.acceptanceCriteria': 'معايير القبول',
  'conversations.taskKanban.field.allowedTools': 'الأدوات المسموح بها',
  'conversations.taskKanban.field.approval': 'الموافقة',
  'conversations.taskKanban.field.assignedAgent': 'وكيل موقع',
  'conversations.taskKanban.field.blocker': 'Blocker',
  'conversations.taskKanban.field.evidence': 'الأدلة',
  'conversations.taskKanban.field.notes': 'الحواشي',
  'conversations.taskKanban.field.objective': 'الهدف',
  'conversations.taskKanban.field.plan': 'الخطة',
  'conversations.taskKanban.field.status': 'الحالة',
  'conversations.taskKanban.field.title': 'العنوان',
  'conversations.taskKanban.saveChanges': 'التغييرات',
  'conversations.taskKanban.deleteCard': 'Delete',
  'conversations.taskKanban.workTask': 'العمل على المهمة',
  'conversations.taskKanban.viewWork': 'عرض العمل',
  'conversations.taskKanban.startingTask': 'جارٍ البدء…',
  'conversations.taskKanban.updateFailed': 'ولم يتمكن من استكمال المهمة؛ ولم يتم توفير التغييرات.',
  'conversations.taskKanban.sourcesButton': 'المصادر',
  'conversations.taskKanban.source.openExternal': 'فتح المهمة الخارجية',
  'conversations.taskKanban.source.openExternalShort': 'فتح',
  'conversations.taskKanban.source.unknownProvider': 'مصدر غير معروف',
  'conversations.taskKanban.source.urgencyValue': 'الأولوية {percent}%',
  'conversations.taskKanban.sources.desktopOnly':
    'تتوفر عناصر التحكم في مصادر المهام في تطبيق سطح المكتب.',
  'conversations.taskKanban.sources.title': 'مصادر المهام',
  'conversations.taskKanban.sources.statusEnabled': 'الجلب التلقائي مفعّل',
  'conversations.taskKanban.sources.manage': 'إدارة المصادر',
  'conversations.taskKanban.source.title': 'المصدر',
  'conversations.taskKanban.source.sourceId': 'معرّف المصدر',
  'conversations.taskKanban.source.externalId': 'المعرّف الخارجي',
  'conversations.taskKanban.source.repo': 'المستودع',
  'conversations.taskKanban.source.urgency': 'الأولوية',
  'conversations.toolTimeline.turn': 'دور',
  'conversations.toolTimeline.step': 'خطوة',
  'conversations.toolTimeline.workerThread': 'محادثة عامل',
  'conversations.subagent.viewProcessing': 'عرض المعالجة الكاملة',
  'conversations.subagent.parent': 'الأصل',
  'conversations.subagent.thinking': 'التفكير',
  'conversations.subagent.thoughts': 'الأفكار',
  'conversations.subagent.response': 'الرد',
  'conversations.subagent.toolCalls': 'استدعاءات الأدوات',
  'conversations.subagent.working': 'يعمل…',
  'conversations.subagent.noOutputYet': 'لا يوجد ناتج بعد',
  'conversations.subagent.input': 'المدخلات',
  'conversations.subagent.output': 'المخرجات',
  'conversations.subagent.noOutput': 'لم يتم إرجاع أي مخرجات',
  'conversations.subagent.close': 'إغلاق',
  'conversations.subagent.cancel': 'إلغاء المهمة',
  'conversations.subagent.cancelling': 'جارٍ الإلغاء…',
  'conversations.subagent.cancelFailed': 'تعذّر إلغاء المهمة. حاول مرة أخرى.',
  'conversations.subagent.statusRunning': 'قيد التشغيل',
  'conversations.subagent.statusCompleted': 'اكتمل',
  'conversations.subagent.statusFailed': 'فشل',
  'conversations.subagent.statusAwaitingUser': 'في انتظار المستخدم',
  'conversations.subagent.statusCancelled': 'أُلغيت',
  'conversations.agentTaskInsights.title': 'رؤى مهام الوكيل',
  'conversations.agentTaskInsights.response': 'الرد',
  'conversations.agentTaskInsights.processSourceTitle': 'مصدر عملية الوكيل',
  'conversations.agentTaskInsights.stepsHeading': 'الخطوات',
  'conversations.agentTaskInsights.sourcesHeading': 'المصادر',
  'conversations.agentTaskInsights.noSteps': 'لم يتم تسجيل أي خطوات',
  'conversations.agentTaskInsights.viewProcessSource': 'عرض مصدر عملية الوكيل الكامل',
  'conversations.agentTaskInsights.processing': 'قيد المعالجة',
  'conversations.agentTaskInsights.done': 'تم',
  'conversations.agentTaskInsights.failed': 'فشل',
  'conversations.agentTaskInsights.running': 'قيد التشغيل',
  'conversations.agentTaskInsights.cancelled': 'ملغى',
  'conversations.agentTaskInsights.awaitingUser': 'في انتظار الإدخال',
  'conversations.agentTaskInsights.viewDetails': 'عرض التفاصيل',
  'conversations.agentTaskInsights.subagentsHeading': 'الوكلاء الفرعيون',
  'daemon.serviceBlockingGate.body': 'المحتوى',
  'daemon.serviceBlockingGate.downloadHint': 'تلميح التنزيل',
  'daemon.serviceBlockingGate.downloadLatest': 'تنزيل أحدث إصدار',
  'daemon.serviceBlockingGate.retryCore': 'إعادة محاولة Core',
  'daemon.serviceBlockingGate.retryFailed':
    'فشلت إعادة المحاولة. نزّل أحدث إصدار للتطبيق وحاول مرة أخرى.',
  'daemon.serviceBlockingGate.retrying': 'جارٍ إعادة المحاولة...',
  'daemon.serviceBlockingGate.title': 'نواة OpenHuman غير متاحة',
  'home.banners.discordSubtitle': 'وصف Discord',
  'home.banners.discordTitle': 'انضم إلى Discord',
  'home.banners.earlyBirdDismiss': 'إغلاق لافتة المبكر',
  'home.banners.earlyBirdFirstSub': 'أول اشتراك.',
  'home.banners.earlyBirdOn': 'عرض المبكر نشط',
  'home.banners.earlyBirdTitle': 'أول 1,000 مستخدم يحصلون على خصم 60٪.',
  'home.banners.earlyBirdUseCode': 'استخدم كود المبكر',
  'home.banners.getSubscription': 'احصل على اشتراك',
  'home.banners.promoCreditsBody': 'لديك {amount} من رصيد العرض. يمكنك',
  'home.banners.promoCreditsUsage': 'استخدام رصيد العرض',
  'intelligence.memoryChunk.detail.chunk': 'جزء',
  'intelligence.memoryChunk.detail.copyChunkId': 'نسخ معرف الجزء',
  'intelligence.memoryChunk.detail.embeddingInfo': 'bge-m3 1024dim',
  'intelligence.memoryChunk.detail.noEmbedding': 'لا يوجد تضمين',
  'intelligence.memoryChunk.letterhead.from': 'من',
  'intelligence.memoryChunk.letterhead.to': 'إلى',
  'intelligence.memoryChunk.mentioned.chunkOne': 'جزء واحد',
  'intelligence.memoryChunk.mentioned.chunkOther': '{count} أجزاء',
  'intelligence.memoryChunk.mentioned.heading': 'م ذ ك و ر',
  'intelligence.memoryChunk.scoreBars.ariaScore': 'نتيجة {name} {pct} بالمئة',
  'intelligence.memoryChunk.scoreBars.atThreshold': 'عند {threshold}',
  'intelligence.memoryChunk.scoreBars.dropped': 'مُسقَط',
  'intelligence.memoryChunk.scoreBars.heading': 'س ب ب   ا ل ح ف ظ',
  'intelligence.memoryChunk.scoreBars.kept': 'محفوظ',
  'intelligence.diagram.title': 'مخطط البنية',
  'intelligence.diagram.description': 'أحدث مخرجات بنية محلية من نقطة نهاية المخططات المُهيأة.',
  'intelligence.diagram.refresh': 'Refresh',
  'intelligence.diagram.refreshAria': 'تحديث المخطط',
  'intelligence.diagram.emptyTitle': 'لا يوجد مخطط بعد',
  'intelligence.diagram.emptyDescription':
    'أنشئ مخطط بنية من المنسق وسيتجدد هذا اللوح تلقائياً من نقطة النهاية المحلية المُهيأة.',
  'intelligence.diagram.skillInstallCommand': 'npx skills add yizhiyanhua-ai/fireworks-tech-graph',
  'intelligence.diagram.promptExample': 'أنشئ مخطط بنية للسرب الحالي بأسلوب المحطة الداكنة',
  'intelligence.diagram.imageAlt': 'أحدث مخطط بنية OpenHuman المُولَّد',
  'intelligence.diagram.refreshesEvery': 'يتجدد كل {seconds} ثانية',
  'intelligence.memoryText.entityTypePrefix': 'نوع الكيان',
  'intelligence.tasks.activeBoardOne': 'لوحة نشطة واحدة عبر المحادثات',
  'intelligence.tasks.activeBoardOther': '{count} لوحات نشطة عبر المحادثات',
  'intelligence.tasks.empty': 'لا توجد لوحات مهام للوكيل بعد',
  'intelligence.tasks.emptyHint': 'تلميح الفراغ',
  'intelligence.tasks.failedToLoad': 'فشل التحميل',
  'intelligence.tasks.live': 'مباشر',
  'intelligence.tasks.loadingBoards': 'جارٍ تحميل لوحات المهام…',
  'intelligence.tasks.threadPrefix': 'المحادثة {thread}',
  'intelligence.tasks.subtitle': 'مهمتك ومجالس عمل العملاء عبر مكان العمل',
  'intelligence.tasks.newTask': 'المهمة الجديدة',
  'intelligence.tasks.personalBoardTitle': 'عملاء',
  'intelligence.tasks.personalEmpty': 'لا مهام شخصية حتى الآن',
  'intelligence.tasks.composer.title': 'المهمة الجديدة',
  'intelligence.tasks.composer.titleLabel': 'العنوان',
  'intelligence.tasks.composer.titlePlaceholder': 'ماذا يجب أن نفعل؟',
  'intelligence.tasks.composer.statusLabel': 'الحالة',
  'intelligence.tasks.composer.attachLabel': 'مواكبة المحادثة',
  'intelligence.tasks.composer.attachNone': 'شخصية (لا محادثة)',
  'intelligence.tasks.composer.objectiveLabel': 'الهدف',
  'intelligence.tasks.composer.objectivePlaceholder': 'اختياري - النتيجة المنشودة',
  'intelligence.tasks.composer.notesLabel': 'الحواشي',
  'intelligence.tasks.composer.notesPlaceholder': 'الملاحظات الاختيارية',
  'intelligence.tasks.composer.create': 'إنشاء مهمة',
  'intelligence.tasks.composer.creating': 'خلق...',
  'intelligence.tasks.composer.createFailed': 'لا يمكن خلق المهمة',
  'intelligence.tasks.composer.assignAgentLabel': 'دع وكيلًا يعمل على هذه المهمة تلقائيًا',
  'intelligence.tasks.composer.assignAgentHint':
    'تلتقطها لوحة المهام وتنفّذها نيابةً عنك. اتركها مغلقة للحصول على مهمة شخصية عادية.',
  'intelligence.tasks.sourceList.subtitle': 'مهام المصادر التي تنتظر التحول إلى عمل للوكيل.',
  'intelligence.tasks.sourceList.empty': 'لا توجد مهام مصادر في الانتظار.',
  'intelligence.tasks.sourceList.queued': 'في قائمة الانتظار',
  'intelligence.tasks.sourceList.workOnTask': 'العمل على المهمة',
  'intelligence.tasks.sourcePlan.title': 'تنقيح مهمة المصدر',
  'intelligence.tasks.sourcePlan.subtitle': 'راجع مسودة البحث قبل إنشاء مهمة للوكيل.',
  'intelligence.tasks.sourcePlan.researchAgent': 'مسودة وكيل البحث',
  'intelligence.tasks.sourcePlan.approve': 'الموافقة على الخطة',
  'intelligence.tasks.sourcePlan.creating': 'جارٍ إنشاء المهمة…',
  'intelligence.tasks.sourcePlan.createFailed': 'تعذر إنشاء مهمة الوكيل',
  'intelligence.tasks.workTaskFailed': 'تعذر بدء العمل على المهمة',
  'intelligence.workTask.sourceTaskHeading': 'المهمة المصدر:',
  'intelligence.workTask.repositoryLine': '- المستودع: {repo}',
  'intelligence.workTask.externalIdLine': '- المعرّف الخارجي: {externalId}',
  'intelligence.workTask.urlLine': '- الرابط: {url}',
  'intelligence.workTask.closingInstruction':
    'ابدأ بإعادة صياغة خطة التنفيذ الملموسة بإيجاز، ثم نفّذها. أبقِ التقدّم مرئيًا في هذا المحادثة وحدّث لوحة المهام عند تغيّر حالة العمل.',
  'intelligence.agentWork.subtitle': 'كل تشغيل وكيل في الخلفية، مُجمّع حسب حالة دورة الحياة.',
  'intelligence.agentWork.loading': 'جارٍ تحميل عمل الوكيل…',
  'intelligence.agentWork.failedToLoad': 'تعذّر تحميل عمل الوكيل',
  'intelligence.agentWork.empty': 'لا توجد عمليات تشغيل وكيل في الخلفية بعد.',
  'intelligence.agentWork.bucket.needsInput': 'يحتاج إلى مُدخلات',
  'intelligence.agentWork.bucket.working': 'قيد العمل',
  'intelligence.agentWork.bucket.completed': 'مكتمل',
  'intelligence.agentWork.bucket.failed': 'فشل',
  'intelligence.agentWork.bucket.stopped': 'متوقف',
  'intelligence.agentWork.column.agent': 'الوكيل',
  'intelligence.agentWork.column.status': 'الحالة',
  'intelligence.agentWork.column.elapsed': 'الوقت المنقضي',
  'intelligence.agentWork.column.cost': 'التكلفة',
  'intelligence.agentWork.column.tokens': 'الرموز',
  'intelligence.agentWork.status.pending': 'قيد الانتظار',
  'intelligence.agentWork.status.running': 'قيد العمل',
  'intelligence.agentWork.status.awaitingUser': 'يحتاج إلى مُدخلات',
  'intelligence.agentWork.status.paused': 'متوقف مؤقتًا',
  'intelligence.agentWork.status.completed': 'مكتمل',
  'intelligence.agentWork.status.failed': 'فشل',
  'intelligence.agentWork.status.cancelled': 'ملغى',
  'intelligence.agentWork.status.interrupted': 'مقاطَع',
  'intelligence.agentWork.kind.subagent': 'وكيل فرعي',
  'intelligence.agentWork.kind.workerThread': 'محادثة عامل',
  'intelligence.agentWork.kind.backgroundAgent': 'وكيل في الخلفية',
  'intelligence.agentWork.kind.teamMember': 'عضو الفريق',
  'intelligence.agentWork.kind.workflowChild': 'عنصر فرعي لسير العمل',
  'intelligence.agentWork.openThread': 'فتح المحادثة',
  'intelligence.agentWork.openWorker': 'فتح العامل',
  'worktree.label': 'شجرة العمل',
  'worktree.dirty': 'تغييرات غير مُلتزمة',
  'worktree.clean': 'نظيفة',
  'worktree.changedFile': 'ملف مُعدّل',
  'worktree.changedFiles': 'ملفات مُعدّلة',
  'worktree.removing': 'جارٍ الإزالة…',
  'worktree.removeFailed': 'فشل إزالة شجرة العمل',
  'worktree.diffFailed': 'فشل تحميل الفرق',
  'worktree.diffLoading': 'جارٍ تحميل الفرق…',
  'worktree.diffEmpty': 'لا توجد تغييرات مقارنةً بـ HEAD.',
  'worktree.dirtyConfirm':
    'تحتوي شجرة العمل هذه على تغييرات غير مُلتزمة. إزالتها تتجاهل ذلك العمل. يتم الاحتفاظ بفرع العامل.',
  'worktree.action.open': 'فتح المجلد',
  'worktree.action.diff': 'الفرق',
  'worktree.action.hideDiff': 'إخفاء الفرق',
  'worktree.action.remove': 'إزالة',
  'worktree.action.removeAnyway': 'تجاهل وإزالة',
  'worktree.action.preserve': 'الإبقاء',
  'worktree.panel.subtitle': 'أشجار عمل git معزولة أنشأها عُمّال الوكلاء المتوازون.',
  'worktree.panel.loading': 'جارٍ تحميل أشجار العمل…',
  'worktree.panel.failedToLoad': 'فشل تحميل أشجار العمل',
  'worktree.panel.empty':
    'لا توجد أشجار عمل معزولة. ستظهر هنا العُمّال المتوازون ذوو عزل شجرة العمل.',
  'worktree.panel.overlapsTitle': 'تغييرات متداخلة',
  'worktree.panel.overlapHint':
    'تم تعديل هذه الملفات بواسطة أكثر من شجرة عمل: وفّق بينها قبل الدمج.',
  'intelligence.agentWork.action.stop': 'إيقاف',
  'intelligence.agentWork.action.retry': 'إعادة المحاولة',
  'intelligence.agentWork.action.continue': 'متابعة',
  'intelligence.agentWork.action.followUp': 'متابعة لاحقة',
  'intelligence.agentWork.action.send': 'إرسال',
  'intelligence.agentWork.action.cancel': 'إلغاء',
  'intelligence.agentWork.action.continuePlaceholder': 'أرسل ردًا لإلغاء حظر هذا العامل…',
  'intelligence.agentWork.action.followUpPlaceholder': 'أرسل تعليمات متابعة…',
  'intelligence.agentWork.action.failed': 'فشل الإجراء',
  'intelligence.teams.subtitle': 'فِرَق وكلاء منسَّقة والمهام التي يتشاركونها.',
  'intelligence.teams.loading': 'جارٍ تحميل الفِرَق…',
  'intelligence.teams.failedToLoad': 'فشل تحميل الفِرَق',
  'intelligence.teams.empty': 'لا توجد فِرَق وكلاء بعد',
  'intelligence.teams.emptyHint':
    'تظهر الفِرَق هنا عندما يُنشئ وكيل وكلاء فرعيين منسَّقين لمشاركة هدف مشترك.',
  'intelligence.teams.refresh': 'تحديث',
  'intelligence.teams.backToList': 'كل الفِرَق',
  'intelligence.teams.status.active': 'نشط',
  'intelligence.teams.status.closed': 'مغلق',
  'intelligence.teams.header.lead': 'قائد',
  'intelligence.teams.header.taskCount': '{count} مهمة',
  'intelligence.teams.header.memberCount': '{count} عضو',
  'intelligence.teams.member.active': 'نشط',
  'intelligence.teams.member.pending': 'قيد الانتظار',
  'intelligence.teams.member.idle': 'خامل',
  'intelligence.teams.member.stopped': 'متوقف',
  'intelligence.teams.column.todo': 'للتنفيذ',
  'intelligence.teams.column.ready': 'جاهز',
  'intelligence.teams.column.inProgress': 'قيد التنفيذ',
  'intelligence.teams.column.blocked': 'محظور',
  'intelligence.teams.column.done': 'مكتمل',
  'intelligence.teams.emptyColumn': 'فارغ',
  'intelligence.teams.unclaimed': 'غير مُسنَد',
  'intelligence.teams.pickedUpBy': 'تولّاه {name}',
  'intelligence.teams.depLockTitle': '{count} تبعيات غير مُستوفاة',
  'intelligence.teams.gate.pending': 'البوابة قيد الانتظار',
  'intelligence.teams.gate.passed': 'اجتاز البوابة',
  'intelligence.teams.gate.failed': 'فشل في البوابة',
  'intelligence.teams.gate.label': 'البوابة: {status}',
  'intelligence.teams.activity.title': 'نشاط الفريق',
  'intelligence.teams.activity.empty': 'لا توجد رسائل بعد',
  'intelligence.teams.activity.toTeam': 'الفريق',
  'intelligence.teams.member.start': 'ابدأ',
  'intelligence.teams.composer.placeholder': 'رسالة إلى زميل…',
  'intelligence.teams.composer.send': 'إرسال',
  'intelligence.teams.composer.recipient': 'المستلم',
  'intelligence.teams.composer.toTeam': 'الفريق بأكمله',
  'intelligence.teams.action.blocked': 'في انتظار التبعيات',
  'intelligence.teams.action.alreadyClaimed': 'تم أخذها من قبل زميل آخر',
  'intelligence.teams.action.alreadyActive': 'الزميل قيد التشغيل بالفعل',
  'intelligence.teams.action.noClaimableTask': 'لا توجد مهمة جاهزة لهذا الزميل',
  'intelligence.teams.action.unknownTask': 'المهمة غير موجودة',
  'intelligence.refine.objectiveDefault': 'حوّل المهمة المصدر إلى مهمة وكيل جاهزة للتنفيذ: {title}',
  'intelligence.refine.sourceLine': 'المصدر: {url}',
  'intelligence.refine.sourceIntake': 'المصدر: استقبال مصدر المهام',
  'intelligence.refine.repositoryLine': 'المستودع: {repo}',
  'intelligence.refine.externalTaskLine': 'المهمة الخارجية: {externalId}',
  'intelligence.refine.planStep1': 'اقرأ المهمة المصدر المرتبطة وتأكّد من السلوك المطلوب بالضبط.',
  'intelligence.refine.planStep2': 'افحص مسارات الكود ذات الصلة وحدّد أصغر حدود للتنفيذ.',
  'intelligence.refine.planStep3': 'نفّذ التغيير مع اختبارات مركّزة حول السلوك المرئي للمستخدم.',
  'intelligence.refine.planStep4': 'شغّل التحقق المستهدف وسجّل أي مخاطر متبقية أو أعمال متابعة.',
  'intelligence.refine.acceptance1': 'متطلبات المهمة المصدر ممثَّلة في التنفيذ النهائي.',
  'intelligence.refine.acceptance2': 'اختبارات الوحدة أو التكامل ذات الصلة تغطّي السلوك المتغيّر.',
  'intelligence.refine.acceptance3': 'نتائج التحقق وأي مخاطر غير محلولة مسجَّلة عند الإكمال.',
  'notifications.card.dismiss': 'إغلاق الإشعار',
  'notifications.card.importanceTitle': 'الأهمية: {pct}%',
  'notifications.center.empty': 'لا توجد إشعارات بعد',
  'notifications.center.emptyHint': 'تلميح الفراغ',
  'notifications.center.filterAll': 'تصفية الكل',
  'notifications.center.markAllRead': 'تحديد الكل كمقروء',
  'notifications.center.title': 'الإشعارات',
  'notifications.meeting.joinListen': 'الانضمام (استماع فقط)',
  'notifications.meeting.joinActive': 'الانضمام والرد',
  'notifications.meeting.skip': 'ليس هذا',
  'notifications.meeting.alwaysJoin': 'الانضمام دائماً',
  'notifications.meeting.actionError': 'تعذّر إكمال هذا الإجراء. يرجى المحاولة مرة أخرى.',
  'notifications.flow.approveTitle': 'يحتاج سير العمل إلى موافقة',
  'notifications.flow.approve': 'موافقة',
  'notifications.flow.approving': 'جارٍ الموافقة…',
  'notifications.flow.dismiss': 'إغلاق',
  'notifications.flow.error': 'تعذّر استئناف سير العمل. يرجى المحاولة مرة أخرى.',
  'notifications.flow.gateCount': 'في انتظار {count} من بوابات الموافقة',
  'notifications.flow.approveHint': 'استئناف سير العمل بعد نقطة التحقق هذه',
  'notifications.flow.dismissHint': 'إخفاء هذا التنبيه دون استئناف سير العمل',
  'notifications.flow.viewRun': 'عرض التشغيل',
  'notifications.flowGate.title': 'يحتاج سير العمل إلى موافقة',
  'notifications.flowGate.tool': 'الأداة:',
  'notifications.flowGate.approve': 'الموافقة مرة واحدة',
  'notifications.flowGate.approveAlways': 'الموافقة دائماً',
  'notifications.flowGate.approveAlwaysHint':
    'تخطي نقطة التحقق هذه في التشغيلات المستقبلية لهذا التدفق',
  'notifications.flowGate.deny': 'رفض',
  'notifications.flowGate.deciding': 'جارٍ العمل…',
  'notifications.flowGate.error': 'تعذّر تسجيل قرارك. حاول مرة أخرى.',
  'flowRuns.inspector.title': 'تفاصيل التشغيل',
  'flowRuns.inspector.startedAt': 'بدأ',
  'flowRuns.inspector.finishedAt': 'انتهى',
  'flowRuns.inspector.running': 'قيد التشغيل…',
  'flowRuns.inspector.error': 'خطأ',
  'flowRuns.inspector.pendingApprovals': 'الموافقات المعلقة',
  'flowRuns.inspector.pendingApprovalsCount': '{count} عقدة (عقد) في انتظار الموافقة',
  'flowRuns.inspector.approval.tool': 'الأداة:',
  'flowRuns.inspector.approval.approve': 'الموافقة مرة واحدة',
  'flowRuns.inspector.approval.approveAlways': 'الموافقة دائماً',
  'flowRuns.inspector.approval.approveAlwaysHint':
    'تخطي نقطة التحقق هذه في التشغيلات المستقبلية لهذا التدفق',
  'flowRuns.inspector.approval.deny': 'رفض',
  'flowRuns.inspector.approval.deciding': 'جارٍ العمل…',
  'flowRuns.inspector.approval.loadError': 'تعذّر تحميل الموافقات المعلقة لهذا التشغيل.',
  'flowRuns.inspector.steps': 'الخطوات',
  'flowRuns.inspector.noSteps': 'لم يتم تسجيل أي خطوات بعد.',
  'flowRuns.inspector.output': 'إظهار المخرجات الخام',
  'flowRuns.inspector.summary.failedPrefix': 'تعذر الإكمال:',
  'flowRuns.inspector.summary.unknownError': 'حدث خطأ ما',
  'flowRuns.inspector.summary.itemsFetched': 'تم جلب {count} عنصر (عناصر)',
  'flowRuns.inspector.summary.completed': 'اكتملت الخطوة',
  'flowRuns.inspector.summary.noOutput': 'لم يتم إنتاج أي مخرجات',
  'flowRuns.inspector.port': 'المنفذ',
  'flowRuns.inspector.loading': 'جارٍ تحميل التشغيل…',
  'flowRuns.inspector.loadError': 'تعذّر تحميل هذا التشغيل',
  'flowRuns.inspector.fixWithAgent': 'إصلاح بمساعدة الوكيل',
  'flowRuns.inspector.dataTable': 'جدول',
  'flowRuns.inspector.dataJson': 'JSON',
  'flowRuns.inspector.dataViewLabel': 'عرض المخرجات',
  'flowRuns.inspector.itemCount': '{count} عنصر',
  'flowRuns.inspector.noItems': 'لا توجد عناصر مخرجات',
  'flowRuns.inspector.emptyValue': '(فارغ)',
  'flowRuns.inspector.binaryLabel': 'ثنائي',
  'flowRuns.inspector.showSource': 'المصدر',
  'flowRuns.inspector.hideSource': 'إخفاء المصدر',
  'flowRuns.inspector.sourceInputTitle': 'عنصر الإدخال المصدر',
  'flowRuns.status.running': 'قيد التشغيل',
  'flowRuns.status.completed': 'مكتمل',
  'flowRuns.status.completed_with_warnings': 'مكتمل مع تحذيرات',
  'flowRuns.status.pending_approval': 'بانتظار الموافقة',
  'flowRuns.status.failed': 'فشل',
  'flowRuns.status.cancelled': 'ملغى',
  'flowRuns.status.interrupted': 'تمت المقاطعة',

  'flows.page.title': 'سير العمل',
  'flows.page.description': 'أتمتة محفوظة يمكنك تفعيلها وتشغيلها ومتابعتها.',
  'flows.page.emptyTitle': 'لا توجد عمليات سير عمل بعد',
  'flows.page.emptyDescription':
    'ستظهر عمليات سير العمل المحفوظة هنا بمجرد إنشاء واحدة من لوحة الرسم.',
  'flows.page.loading': 'جارٍ تحميل عمليات سير العمل…',
  'flows.page.loadError': 'تعذر تحميل عمليات سير العمل. يرجى المحاولة مرة أخرى.',
  'flows.page.newWorkflow': 'سير عمل جديد',
  'flows.list.lastRun': 'آخر تشغيل',
  'flows.list.neverRun': 'لم يتم التشغيل بعد',
  'flows.list.justNow': 'الآن',
  'flows.discoveries.title': 'اكتشافات سير العمل',
  'flows.discoveries.description': 'أتمتة يقترحها Flow Scout بناءً على طريقة عملك.',
  'flows.allRuns.title': 'تشغيلات سير العمل',
  'flows.allRuns.description': 'كل تشغيلات سير العمل في مساحة عملك، الأحدث أولاً.',
  'flows.allRuns.loading': 'جارٍ تحميل التشغيلات…',
  'flows.allRuns.empty': 'لا توجد تشغيلات سير عمل بعد.',
  'flows.allRuns.unknownWorkflow': 'سير عمل غير معروف',
  'flows.allRuns.status.running': 'قيد التشغيل',
  'flows.allRuns.status.completed': 'مكتمل',
  'flows.allRuns.status.completed_with_warnings': 'مكتمل مع تحذيرات',
  'flows.allRuns.status.pending_approval': 'بانتظار الموافقة',
  'flows.allRuns.status.failed': 'فشل',
  'flows.allRuns.status.cancelled': 'أُلغي',
  'flows.allRuns.status.interrupted': 'تمت المقاطعة',
  'flows.list.minutesAgo': 'منذ {count} دقيقة',
  'flows.list.hoursAgo': 'منذ {count} ساعة',
  'flows.list.daysAgo': 'منذ {count} يوم',
  'flows.list.runNow': 'تشغيل',
  'flows.list.running': 'جارٍ التشغيل…',
  'flows.list.viewRuns': 'عرض التشغيلات',
  'flows.list.toggleEnabled': 'تفعيل سير العمل',
  'flows.list.enabled': 'مفعّل',
  'flows.list.paused': 'متوقف مؤقتًا',
  'flows.list.runStarted': 'بدأ تشغيل سير العمل',
  'flows.runs.title': 'عمليات التشغيل لـ {name}',
  'flows.runs.titleFallback': 'عمليات تشغيل سير العمل',
  'flows.runs.loading': 'جارٍ تحميل عمليات التشغيل…',
  'flows.runs.loadError': 'تعذّر تحميل عمليات التشغيل',
  'flows.runs.empty': 'لا توجد عمليات تشغيل بعد',
  'flows.promptBar.label': 'صف سير عمل',
  'flows.promptBar.placeholder': 'صف سير عملك',
  'flows.promptBar.copilotTitle': 'كوبايلوت',
  'flows.promptBar.submit': 'إنشاء',
  'flows.promptBar.startBuilding': 'ابدأ الإنشاء',
  'flows.promptBar.disclaimer': 'الكوبايلوت ذكاء اصطناعي وقد يخطئ. يُرجى التحقق من الردود.',
  'flows.promptBar.thinking': 'جارٍ الإنشاء…',
  'flows.promptBar.heroTitle': 'صف سير عمل',
  'flows.promptBar.heroSubtitle': 'أخبر المُنشئ بما يجب أتمتته وراجع اقتراحه.',
  'flows.promptBar.error': 'تعذّر الوصول إلى مُنشئ سير العمل. يرجى المحاولة مرة أخرى.',
  'flows.promptBar.offline': 'أنت غير متصل. أعد الاتصال لإنشاء سير عمل.',
  'flows.suggest.title': 'مقترحة لك',
  'flows.suggest.subtitle': 'أتمتة يرى Flow Scout أنها ستساعدك، بناءً على طريقة عملك.',
  'flows.suggest.discover': 'اكتشاف',
  'flows.suggest.rediscover': 'تحديث',
  'flows.suggest.discovering': 'جارٍ البحث عن أتمتة…',
  'flows.suggest.empty':
    'لا توجد اقتراحات بعد. شغّل الاكتشاف وسيبحث Flow Scout في عملك عن أتمتة تستحق الإعداد.',
  'flows.suggest.error': 'تعذّر تشغيل الاكتشاف. يرجى المحاولة مرة أخرى.',
  'flows.suggest.why': 'لماذا',
  'flows.suggest.build': 'أنشئ هذا',
  'flows.suggest.opening': 'جارٍ الفتح…',
  'flows.suggest.dismiss': 'تجاهل',
  'flows.suggest.uses': 'يستخدم',
  'flows.suggest.trigger.schedule': 'مجدول',
  'flows.suggest.trigger.app_event': 'عند وقوع حدث',
  'flows.suggest.trigger.manual': 'عند الطلب',
  'flows.copilot.open': 'المساعد',
  'flows.copilot.title': 'مساعد سير العمل',
  'flows.copilot.subtitle': 'اطلب تغييرات وراجع كل اقتراح قبل تطبيقه.',
  'flows.copilot.close': 'إغلاق المساعد',
  'flows.copilot.placeholder': 'اطلب تغييرًا…',
  'flows.copilot.send': 'إرسال',
  'flows.copilot.thinking': 'يفكر…',
  'flows.copilot.error': 'تعذّر الوصول إلى مُنشئ سير العمل. يرجى المحاولة مرة أخرى.',
  'flows.copilot.offline': 'أنت غير متصل. أعد الاتصال لاستخدام المساعد.',
  'flows.copilot.emptyState': 'صف تغييرًا على سير العمل هذا وسيقترح المُنشئ تحديثًا.',
  'flows.copilot.proposalTitle': 'التغييرات المقترحة',
  'flows.copilot.added': 'أُضيف {count}',
  'flows.copilot.removed': 'أُزيل {count}',
  'flows.copilot.noChanges': 'هذا الاقتراح لا يغيّر أي عقدة.',
  'flows.copilot.accept': 'تطبيق على المسودة',
  'flows.copilot.acceptAndSave': 'قبول وحفظ',
  'flows.copilot.saveAndEnable': 'حفظ وتفعيل',
  'flows.copilot.saving': 'جارٍ الحفظ…',
  'flows.copilot.enabling': 'جارٍ التفعيل…',
  'flows.copilot.enableError': 'تم الحفظ، لكن تعذّر تفعيل سير العمل. حاول تفعيله من القائمة.',
  'flows.copilot.reject': 'تجاهل',
  'flows.copilot.previewHint': 'جارٍ مراجعة مسودة مقترحة: لم يُحفظ شيء بعد.',
  'flows.copilot.repairDisplay': 'فشل تشغيل؛ راجعه واقترح إصلاحًا.',
  'flows.copilot.tool.proposing': 'اقتراح سير العمل…',
  'flows.copilot.tool.dryRunning': 'تجربة تشغيل سير العمل…',
  'flows.copilot.tool.saving': 'حفظ سير العمل…',
  'flows.copilot.tool.usingTools': 'استخدام الأدوات…',
  'flows.copilot.cappedNotice':
    'بلغ المُنشئ الحد الأقصى لعدد التكرارات قبل الانتهاء من سير العمل هذا. عند المتابعة، سيستمر البناء انطلاقًا من المسودة الحالية.',
  'flows.copilot.continueBuilding': 'متابعة الإنشاء',
  'flows.list.view': 'عرض سير العمل',
  'flows.list.export': 'تصدير',
  'flows.list.exported': 'تم تصدير سير العمل',
  'flows.page.import': 'استيراد',
  'flows.import.invalidFile': 'هذا الملف ليس ملف JSON صالحًا لسير العمل.',
  'flows.import.error': 'تعذّر استيراد سير العمل هذا. تحقق من الملف وحاول مرة أخرى.',
  'flows.import.warningTitle': 'تحذير الاستيراد',
  'flows.canvas.title': 'سير العمل',
  'flows.canvas.loading': 'جارٍ تحميل سير العمل…',
  'flows.canvas.loadError': 'تعذّر تحميل سير العمل هذا. يرجى المحاولة مرة أخرى.',
  'flows.canvas.notFound': 'تعذّر العثور على سير العمل هذا.',
  'flows.canvas.draftMissing': 'لا توجد مسودة سير عمل لفتحها. اقترح واحدة من الدردشة أولاً.',
  'flows.canvas.backToList': 'العودة إلى قائمة سير العمل',
  'flows.nodeKind.trigger': 'المُشغِّل',
  'flows.nodeKind.agent': 'الوكيل',
  'flows.nodeKind.tool_call': 'استدعاء أداة',
  'flows.nodeKind.http_request': 'طلب HTTP',
  'flows.nodeKind.code': 'الكود',
  'flows.nodeKind.condition': 'الشرط',
  'flows.nodeKind.switch': 'المحول',
  'flows.nodeKind.merge': 'الدمج',
  'flows.nodeKind.split_out': 'تقسيم المخرجات',
  'flows.nodeKind.transform': 'التحويل',
  'flows.nodeKind.output_parser': 'محلل المخرجات',
  'flows.nodeKind.sub_workflow': 'سير عمل فرعي',
  'flows.nodeKind.memory': 'الذاكرة',
  'flows.nodeKind.dedup': 'إزالة التكرار',
  'flows.nodeKind.loop': 'حلقة',
  'flows.nodeSummary.trigger.manual': 'يعمل عند الطلب',
  'flows.nodeSummary.trigger.webhook': 'يعمل عند استقبال ويب هوك',
  'flows.nodeSummary.trigger.appEventOn': 'عند {parts}',
  'flows.nodeSummary.trigger.appEvent': 'يعمل عند حدث في التطبيق',
  'flows.nodeSummary.trigger.unknownKind': 'المُشغِّل: {kind}',
  'flows.nodeSummary.agent.defaultModel': 'النموذج الافتراضي',
  'flows.nodeSummary.agent.withPrompt': '“{prompt}” · {model}',
  'flows.nodeSummary.agent.default': 'يسأل {model}',
  'flows.nodeSummary.toolCall.runsNative': 'يُشغّل {name}',
  'flows.nodeSummary.toolCall.pickNative': 'يُشغّل أداة من OpenHuman (اختر واحدة)',
  'flows.nodeSummary.toolCall.runs': 'يُشغّل {slug}',
  'flows.nodeSummary.toolCall.pick': 'يُشغّل إجراء تطبيق (اختر واحدًا)',
  'flows.nodeSummary.http.withUrl': '{method} {url}',
  'flows.nodeSummary.http.noUrl': 'طلب {method} (حدد عنوان URL)',
  'flows.nodeSummary.code.runs': 'يُشغّل كود {lang}',
  'flows.nodeSummary.condition.withField': 'إذا {field} ← صحيح / خطأ',
  'flows.nodeSummary.condition.default': 'يتفرّع إلى صحيح / خطأ',
  'flows.nodeSummary.switch.byExpr': 'يوجّه حسب {expr}',
  'flows.nodeSummary.switch.byExprWithRoutes': 'يوجّه حسب {expr} ({count} مسارات)',
  'flows.nodeSummary.switch.byValue': 'يوجّه حسب قيمة',
  'flows.nodeSummary.switch.byValueWithRoutes': 'يوجّه حسب قيمة ({count} مسارات)',
  'flows.nodeSummary.merge': 'يدمج الفروع المتوازية',
  'flows.nodeSummary.splitOut.withPath': 'يقسّم كل {path}',
  'flows.nodeSummary.splitOut.default': 'يقسّم قائمة إلى عناصر',
  'flows.nodeSummary.transform.default': 'يعيد تشكيل كل عنصر',
  'flows.nodeSummary.transform.setFieldsSingular': 'يضبط {n} حقل في كل عنصر',
  'flows.nodeSummary.transform.setFieldsPlural': 'يضبط {n} حقول في كل عنصر',
  'flows.nodeSummary.outputParser': 'يحلّل المخرجات السابقة',
  'flows.nodeSummary.subWorkflow': 'يُشغّل سير عمل متداخل',
  'flows.nodeSummary.memory.flavourWith': 'يقرأ نمط "{flavour}"',
  'flows.nodeSummary.memory.flavour': 'يقرأ نمطًا من الذاكرة',
  'flows.nodeSummary.memory.people': 'يبحث في ذاكرة الأشخاص',
  'flows.nodeSummary.memory.remember': 'يحفظ قيمة في سير العمل هذا',
  'flows.nodeSummary.memory.forget': 'ينسى قيمة من سير العمل هذا',
  'flows.nodeSummary.memory.searchScoped': 'يبحث في الذاكرة ({scope})',
  'flows.nodeSummary.memory.search': 'يبحث في الذاكرة',
  'flows.nodeSummary.memory.recallScoped': 'يسترجع من الذاكرة ({scope})',
  'flows.nodeSummary.memory.recall': 'يسترجع من الذاكرة',
  'flows.nodeSummary.dedup.withKey': 'يتخطى العناصر التي سبق رؤيتها حسب {key}',
  'flows.nodeSummary.dedup.default': 'يتخطى العناصر التي سبقت معالجتها',
  'flows.nodeSummary.loop.upTo': 'يتكرر حتى {max} مرة',
  'flows.nodeSummary.loop.whileCondition': 'يتكرر حتى {max} مرة طالما {condition}',
  'flows.palette.title': 'العقد',
  'flows.palette.addNode': 'إضافة عقدة {kind}',
  'flows.editor.save': 'حفظ',
  'flows.editor.deleteSelected': 'حذف المحدد',
  // ── Validation UX + draft/dirty state (issue B5b / Phase 3c–3d)
  'flows.editor.saving': 'جارٍ الحفظ…',
  'flows.editor.run': 'تشغيل',
  'flows.editor.running': 'جارٍ التشغيل…',
  'flows.editor.runFailed': 'تعذّر بدء التشغيل',
  'flows.editor.validate': 'تحقّق',
  'flows.editor.validating': 'جارٍ التحقّق…',
  'flows.editor.discard': 'تجاهل التغييرات',
  'flows.editor.confirm.runTitle': 'تشغيل سير العمل؟',
  'flows.editor.confirm.runBody': 'سيؤدي هذا إلى تنفيذ سير العمل الآن.',
  'flows.editor.confirm.saveTitle': 'حفظ التغييرات؟',
  'flows.editor.confirm.saveBody': 'سيؤدي هذا إلى حفظ تغييراتك في سير العمل.',
  'flows.editor.confirm.discardTitle': 'تجاهل التغييرات؟',
  'flows.editor.confirm.discardBody':
    'يؤدي هذا إلى التراجع عن جميع التعديلات غير المحفوظة ولا يمكن التراجع عنه.',
  'flows.editor.confirm.confirm': 'تأكيد',
  'flows.editor.confirm.cancel': 'إلغاء',
  'flows.editor.unsaved': 'تغييرات غير محفوظة',
  'flows.editor.saveBlocked': 'أصلِح الأخطاء أدناه قبل الحفظ.',
  'flows.editor.errorsTitle': 'أخطاء',
  'flows.editor.warningsTitle': 'تحذيرات',
  'flows.editor.saveFailedTitle': 'تعذّر الحفظ',
  'flows.editor.leaveTitle': 'المغادرة دون حفظ؟',
  'flows.editor.leaveBody': 'لديك تغييرات غير محفوظة على سير العمل هذا. إذا غادرت الآن، فستُفقد.',
  'flows.editor.leaveStay': 'ابقَ',
  'flows.editor.leaveDiscard': 'غادر',
  // ── Node config drawer (issue B5b / Phase 3b): per-kind config forms
  'flowRuns.inspector.diagnosticsTitle': 'تحذيرات التعبير',
  'flowRuns.inspector.diagnosticResolvedNull': 'تم حله إلى null',
  'flows.runs.sidebarTitle': 'التشغيلات',
  'flows.runs.refresh': 'تحديث التشغيلات',
  'flows.palette.appAction': 'إجراء تطبيق',
  'flows.palette.ohTool': 'أداة',
  'flows.editor.deleteNode': 'حذف',
  'flows.nodeConfig.connections.title': 'الاتصالات',
  'flows.nodeConfig.connections.inputs': 'المدخلات',
  'flows.nodeConfig.connections.outputs': 'المخرجات',
  'flows.nodeConfig.connections.none': 'غير متصل بأي عقدة أخرى بعد.',
  'flows.nodeConfig.connections.remove': 'إزالة الاتصال',
  'flows.nodeConfig.trigger.scheduleCronLabel': 'تعبير cron',
  'flows.nodeConfig.trigger.scheduleFreqLabel': 'التكرار',
  'flows.nodeConfig.trigger.scheduleFreq_minutes': 'كل N دقيقة',
  'flows.nodeConfig.trigger.scheduleFreq_hours': 'كل N ساعة',
  'flows.nodeConfig.trigger.scheduleFreq_daily': 'في وقت محدد كل يوم',
  'flows.nodeConfig.trigger.scheduleEvery': 'كل',
  'flows.nodeConfig.trigger.scheduleInterval': 'الفاصل',
  'flows.nodeConfig.trigger.scheduleUnit_minutes': 'دقيقة',
  'flows.nodeConfig.trigger.scheduleUnit_hours': 'ساعة',
  'flows.nodeConfig.trigger.scheduleAt': 'عند',
  'flows.nodeConfig.trigger.scheduleTime': 'وقت اليوم',
  'flows.nodeConfig.trigger.scheduleDays': 'في الأيام (اختياري: اتركه فارغًا لكل يوم)',
  'flows.nodeConfig.trigger.scheduleAdvanced': 'متقدم (تحرير cron)',
  'flows.nodeConfig.trigger.scheduleSimple': 'العودة إلى الجدولة البسيطة',
  'flows.cron.customSchedule': 'جدولة مخصصة ({expr})',
  'flows.cron.noScheduleSet': 'لم يتم ضبط جدولة',
  'flows.cron.weekdays': 'أيام الأسبوع',
  'flows.cron.weekends': 'عطلة نهاية الأسبوع',
  'flows.cron.everyMinute': 'كل دقيقة',
  'flows.cron.everyMinuteOnDays': 'كل دقيقة في {days}',
  'flows.cron.everyNMinutes': 'كل {n} دقيقة',
  'flows.cron.everyNMinutesOnDays': 'كل {n} دقيقة في {days}',
  'flows.cron.everyHour': 'كل ساعة',
  'flows.cron.everyHourOnDays': 'كل ساعة في {days}',
  'flows.cron.everyNHours': 'كل {n} ساعة',
  'flows.cron.everyNHoursOnDays': 'كل {n} ساعة في {days}',
  'flows.cron.everyDayAtTime': 'كل يوم في {time}',
  'flows.cron.atTimeOnDays': 'في {time} في {days}',
  'flows.cron.invalidInterval': 'فاصل زمني غير صالح',
  'flows.cron.dailyEvery24h': 'يوميًا (كل 24 ساعة)',
  'flows.cron.everyNDays': 'كل {n} يوم',
  'flows.cron.everyNHoursShort': 'كل {n} س',
  'flows.cron.everyNMinutesShort': 'كل {n} د',
  'flows.cron.everySecond': 'كل ثانية',
  'flows.cron.everyNSeconds': 'كل {n} ث',
  'flows.cron.onceAtRaw': 'مرة واحدة في {at}',
  'flows.cron.onceAt': 'مرة واحدة في {at}',
  'flows.nodeConfig.trigger.pickApp': 'اختر تطبيقًا متصلًا أولًا.',
  'flows.nodeConfig.tool.pickConnection': 'اختر اتصالًا أولًا.',
  'flows.nodeConfig.composio.noConnections':
    'لا توجد تطبيقات متصلة بعد. صِل تطبيقًا من الإعدادات → التطبيقات، ثم اختره هنا.',
  'flows.nodeConfig.composio.selectApp': 'اختر تطبيقًا…',
  'flows.nodeConfig.composio.select': 'اختر…',
  'flows.nodeConfig.composio.loading': 'جارٍ التحميل…',
  'flows.nodeConfig.composio.custom': 'إدخال يدوي…',
  'flows.nodeConfig.composio.customPlaceholder': 'SLUG_NAME',
  'flows.nodeConfig.agent.modelHint': 'اختر مستوى القدرة: سيحدد مساحة العمل النموذج.',
  'flows.nodeConfig.agent.modelInherit': 'الافتراضي (موروث)',
  'flows.nodeConfig.agent.agentRefLabel': 'الوكيل',
  'flows.nodeConfig.agent.agentRefHint': 'شغّل هذه العقدة كوكيل مُسجَّل: تُطبَّق أدواته وضوابطه.',
  'flows.nodeConfig.agent.agentRefInherit': 'افتراضي (مُنشئ سير العمل)',
  'flows.nodeConfig.agent.modelManagedTiers': 'المستويات المُدارة',
  'flows.nodeConfig.agent.modelHints': 'تلميحات النموذج',
  'flows.nodeConfig.agent.modelCustom': 'نموذج مخصص…',
  'flows.nodeConfig.agent.modelCustomPlaceholder': 'مثل gpt-4o-mini',
  'flows.nodeConfig.tool.requiredMark': 'مطلوب',
  'flows.nodeConfig.tool.requiredMissing': 'مطلوب: غير موصول',
  'flows.nodeConfig.tool.argsAdvancedLabel': 'كل الوسيطات (متقدم)',
  'flows.nodeConfig.upstream.insert': 'إدراج…',
  'flows.nodeConfig.upstream.insertLabel': 'إدراج قيمة من خطوة سابقة',
  'flows.nodeConfig.native.toolLabel': 'أداة',
  'flows.nodeConfig.native.toolHint': 'إحدى أدوات المساعد المدمجة (البحث، الوسائط، الملفات، …).',
  'flows.nodeConfig.native.select': 'اختر أداة…',
  'flows.nodeConfig.native.loading': 'جارٍ تحميل الأدوات…',
  'flows.nodeConfig.close': 'إغلاق الإعدادات',
  'flows.nodeConfig.nameLabel': 'الاسم',
  'flows.nodeConfig.namePlaceholder': 'اسم العقدة',
  'flows.nodeConfig.editForm': 'تحرير كنموذج',
  'flows.nodeConfig.editJson': 'تحرير كـ JSON',
  'flows.nodeConfig.rawJsonLabel': 'الإعدادات (JSON)',
  'flows.nodeConfig.rawJsonHint': 'إعدادات حرة لهذه العقدة.',
  'flows.nodeConfig.rawJsonInvalid': 'JSON غير صالح: لا تُطبَّق التغييرات حتى يتم تحليله بنجاح.',
  'flows.nodeConfig.expressionHint': 'ابدأ بـ = لحساب القيمة من مدخل العقدة، مثل =item.url',
  'flows.nodeConfig.expressionBadge': 'تعبير',
  'flows.nodeConfig.keymapKeyPlaceholder': 'المفتاح',
  'flows.nodeConfig.keymapValuePlaceholder': 'القيمة',
  'flows.nodeConfig.keymapRemove': 'إزالة الصف',
  'flows.nodeConfig.keymapAdd': 'إضافة صف',
  'flows.nodeConfig.credentialLabel': 'بيانات الاعتماد',
  'flows.nodeConfig.credentialHint': 'اختر حسابًا متصلاً أو بيانات اعتماد لهذه العقدة.',
  'flows.nodeConfig.credentialEmpty': 'لا توجد بيانات اعتماد متصلة متاحة.',
  'flows.nodeConfig.credentialNone': 'لا شيء',
  'flows.nodeConfig.trigger.kindLabel': 'نوع المشغِّل',
  'flows.nodeConfig.trigger.kind_manual': 'يدوي',
  'flows.nodeConfig.trigger.kind_schedule': 'جدولة',
  'flows.nodeConfig.trigger.kind_webhook': 'ويب هوك',
  'flows.nodeConfig.trigger.kind_app_event': 'حدث التطبيق',
  'flows.nodeConfig.trigger.scheduleLabel': 'جدولة cron',
  'flows.nodeConfig.trigger.scheduleHint': 'تعبير cron: الدقيقة الساعة اليوم الشهر يوم الأسبوع.',
  'flows.nodeConfig.trigger.toolkitLabel': 'مجموعة الأدوات',
  'flows.nodeConfig.trigger.triggerSlugLabel': 'معرّف المشغِّل',
  'flows.nodeConfig.trigger.webhookHint': 'تُحفَظ مشغِّلات الويب هوك لكنها لا تعمل تلقائيًا بعد.',
  'flows.nodeConfig.http.methodLabel': 'الطريقة',
  'flows.nodeConfig.http.urlLabel': 'URL',
  'flows.nodeConfig.http.headersLabel': 'الترويسات',
  'flows.nodeConfig.http.bodyLabel': 'المحتوى (JSON)',
  'flows.nodeConfig.agent.promptLabel': 'المُوجِّه',
  'flows.nodeConfig.agent.promptPlaceholder': 'تعليمات للوكيل…',
  'flows.nodeConfig.agent.modelLabel': 'النموذج',
  'flows.nodeConfig.tool.slugLabel': 'معرّف الأداة',
  'flows.nodeConfig.tool.argsLabel': 'الوسائط (JSON)',
  'flows.nodeConfig.condition.fieldLabel': 'الحقل',
  'flows.nodeConfig.condition.fieldHint':
    'مفتاح عنصر المدخل لاختبار صحته. يوجِّه إلى true أو false.',
  'flows.nodeConfig.switch.expressionLabel': 'تعبير',
  'flows.nodeConfig.switch.hint':
    'تختار القيمة الناتجة منفذ الإخراج المطابق؛ يذهب null إلى default.',
  'flows.nodeConfig.switch.fieldLabel': 'الحقل (احتياطي)',
  'flows.nodeConfig.transform.setLabel': 'تعيين الحقول',
  'flows.nodeConfig.transform.setHint': 'كل قيمة تعبير يُقيَّم لكل عنصر، مثل =item.name',
  'flows.nodeConfig.code.languageLabel': 'اللغة',
  'flows.nodeConfig.code.language_javascript': 'JavaScript',
  'flows.nodeConfig.code.language_python': 'Python',
  'flows.nodeConfig.code.sourceLabel': 'الكود المصدري',
  'flows.nodeConfig.memory.operationLabel': 'العملية',
  'flows.nodeConfig.memory.operation_recall': 'استرجاع',
  'flows.nodeConfig.memory.operation_search': 'بحث',
  'flows.nodeConfig.memory.operation_flavour': 'النمط',
  'flows.nodeConfig.memory.operation_people': 'الأشخاص',
  'flows.nodeConfig.memory.operation_remember': 'تذكر',
  'flows.nodeConfig.memory.operation_forget': 'نسيان',
  'flows.nodeConfig.memory.scopeLabel': 'النطاق',
  'flows.nodeConfig.memory.scopeHint': 'مكان البحث عن هذه الذاكرة.',
  'flows.nodeConfig.memory.scopeWriteHint':
    'يُسمح بالكتابة داخل سير العمل هذا فقط، وليس أبدًا في ذاكرتك الشخصية.',
  'flows.nodeConfig.memory.scope_user': 'أنت (للقراءة فقط)',
  'flows.nodeConfig.memory.scope_flow': 'سير العمل هذا',
  'flows.nodeConfig.memory.scope_flows': 'كل سير العمل (للقراءة فقط)',
  'flows.nodeConfig.memory.queryLabel': 'الاستعلام',
  'flows.nodeConfig.memory.queryOptionalHint': 'اختياري: يضيّق نطاق البحث عن الأشخاص.',
  'flows.nodeConfig.memory.flavourLabel': 'النمط',
  'flows.nodeConfig.memory.flavourHint': 'أي جانب من ملف الشخصية يجب قراءته، مثل communication.',
  'flows.nodeConfig.memory.flavour_communication': 'التواصل',
  'flows.nodeConfig.memory.flavour_coding_style': 'أسلوب البرمجة',
  'flows.nodeConfig.memory.flavour_stack': 'التقنيات المستخدمة',
  'flows.nodeConfig.memory.flavour_workflow': 'سير العمل',
  'flows.nodeConfig.memory.flavour_environment': 'البيئة',
  'flows.nodeConfig.memory.flavour_directives': 'التوجيهات',
  'flows.nodeConfig.memory.flavour_anti_preferences': 'التفضيلات السلبية',
  'flows.nodeConfig.memory.keyLabel': 'المفتاح',
  'flows.nodeConfig.memory.valueLabel': 'القيمة',
  'flows.nodeConfig.memory.limitLabel': 'الحد الأقصى',
  'flows.nodeConfig.memory.limitHint': 'أقصى عدد من النتائج.',
  'flows.nodeConfig.memory.minScoreLabel': 'الحد الأدنى للنتيجة',
  'flows.nodeConfig.memory.minScoreHint': 'عتبة الصلة من 0 إلى 1.',
  'flows.nodeConfig.dedup.keyLabel': 'المفتاح',
  'flows.nodeConfig.dedup.keyHint':
    'تعبير معرف ثابت لكل عنصر، مثل =item.id. يتم تخطي العناصر التي شوهد مفتاحها من قبل.',

  // `loop` node: a bounded loop head. Emits on `body` until its cap or
  // condition says stop, then on `done`.
  'flows.nodeConfig.loop.maxIterationsLabel': 'الحد الأقصى للتكرارات',
  'flows.nodeConfig.loop.maxIterationsHint':
    'عدد المرات التي يمكن أن يعمل فيها المتن قبل توقف الحلقة. محدود دائمًا.',
  'flows.nodeConfig.loop.onExceededLabel': 'عند بلوغ الحد',
  'flows.nodeConfig.loop.onExceededHint':
    'أفشل التشغيل، أو أوقف التكرار وتابع عبر المنفذ done بعناصر الجولة الأخيرة.',
  'flows.nodeConfig.loop.onExceeded_error': 'أفشل التشغيل',
  'flows.nodeConfig.loop.onExceeded_continue': 'تابع بنتائج جزئية',
  'flows.nodeConfig.loop.conditionLabel': 'تابع طالما',
  'flows.nodeConfig.loop.conditionHint':
    'اختياري. طالما كانت النتيجة صحيحة تستمر الحلقة؛ وأول نتيجة خاطئة تخرج عبر المنفذ done.',

  'flows.enableApproval.title': 'هل تسمح لسير العمل هذا بالتنفيذ؟',
  'flows.enableApproval.intro':
    'يحتاج سير العمل هذا إلى إذنك للإجراءات أدناه. تنطبق الموافقة على سير العمل هذا فقط.',
  'flows.enableApproval.approveAll': 'الموافقة على الكل',
  'flows.enableApproval.deny': 'رفض',
  'flows.enableApproval.enableAnyway': 'التفعيل على أي حال',
  'flows.enableApproval.granting': 'جارٍ الموافقة…',
  'flows.enableApproval.error': 'تعذر حفظ الموافقات. يرجى المحاولة مرة أخرى.',
  'flows.enableApproval.blockedHint': 'محظور بموجب إعدادات وصول الوكيل لديك.',
  'flows.enableApproval.dynamicHint': 'يُحدد أثناء تشغيل سير العمل، وسيطلب إذنك عند الحاجة.',
  'flows.enableApproval.agentHint': 'قد تطلب خطوة الذكاء الاصطناعي هذه إذنًا منفصلًا لإجراءاتها.',
  'flows.enableApproval.deniedDisabled': 'تم الحفظ، لكن سير العمل بقي متوقفًا.',
  'flows.chooser.title': 'إنشاء سير عمل',
  'flows.chooser.subtitle': 'اختر كيف تريد أن تبدأ.',
  'flows.chooser.scratchTitle': 'ابدأ من الصفر',
  'flows.chooser.scratchDescription': 'ابدأ بلوحة فارغة ومشغّل يدوي واحد.',
  'flows.chooser.templateTitle': 'من قالب',
  'flows.chooser.templateDescription': 'ابدأ من مثال جاهز وخصّصه.',
  'flows.chooser.describeTitle': 'صِفه',
  'flows.chooser.describeDescription': 'أخبر المساعد بما تريد ودعه يصيغ سير العمل.',
  'flows.chooser.creating': 'جارٍ إنشاء سير العمل…',
  'flows.chooser.createError': 'تعذّر إنشاء سير العمل. يرجى المحاولة مرة أخرى.',
  'flows.templates.title': 'ابدأ من قالب',
  'flows.templates.subtitle': 'اختر نقطة بداية وخصّصها في المحرّر.',
  'flows.templates.use': 'استخدام القالب',
  'flows.templates.back': 'رجوع',
  'flows.templates.empty': 'لا توجد قوالب متاحة.',
  'flows.templates.category.scheduled': 'مجدول',
  'flows.templates.category.triggered': 'مُشغَّل',
  'flows.templates.category.onDemand': 'عند الطلب',
  'flows.templates.daily-digest.name': 'ملخص يومي إلى قناة',
  'flows.templates.daily-digest.description':
    'وفق جدول زمني، يكتب وكيل ملخصًا قصيرًا وينشره في قناة.',
  'flows.templates.scheduled-scrape.name': 'استخراج مجدول إلى الذاكرة',
  'flows.templates.scheduled-scrape.description':
    'اجلب مصدرًا وفق جدول زمني، وأعد تشكيل النتائج، واحفظها في الذاكرة.',
  'flows.templates.webhook-triage.name': 'فرز الويب هوك والإشعار',
  'flows.templates.webhook-triage.description':
    'يُفرز الويب هوك الوارد بواسطة وكيل، ثم يصلك إشعار.',
  'flows.templates.app-event-route.name': 'حدث تطبيق إلى إجراء شرطي',
  'flows.templates.app-event-route.description':
    'يشغّل حدث من تطبيق متصل فحصًا، ثم ينفّذ إجراءً عند التطابق.',
  'flows.templates.http-fetch-parse.name': 'جلب واجهة API وتحليلها',
  'flows.templates.http-fetch-parse.description':
    'استدعِ نقطة نهاية HTTP عند الطلب وحلّل الاستجابة إلى شكل قابل للاستخدام.',
  'flows.templates.ask-agent.name': 'اسأل الوكيل',
  'flows.templates.ask-agent.description': 'مشغّل يدوي بسيط يسلّم مهمة إلى وكيل.',
  'flows.templates.opus-sonnet-brief.name': 'موجز بحثي (Opus يخطّط، Sonnet يصيغ)',
  'flows.templates.opus-sonnet-brief.description':
    'وكيل من فئة الاستدلال يخطّط الموجز، ووكيل من فئة الدردشة يصيغه، ثم تُشكَّل النتيجة من أجلك.',

  'oauth.button.connecting': 'جارٍ الاتصال...',
  'oauth.button.loopbackTimeout':
    'انتهت مهلة تسجيل الدخول: لم يكتمل المتصفح إعادة توجيه OAuth. يرجى المحاولة مرة أخرى.',
  'oauth.login.continueWith': 'المتابعة مع',
  'onboarding.contextGathering.buildingDesc': 'وصف البناء',
  'onboarding.contextGathering.buildingProfile': 'جارٍ بناء ملفك الشخصي...',
  'onboarding.contextGathering.continueToChat': 'المتابعة إلى المحادثة',
  'onboarding.contextGathering.coreAlive': 'النواة متاحة: قد يستغرق التشغيل الأول دقيقة.',
  'onboarding.contextGathering.coreAliveProbing': 'يجري التحقق من اتصال النواة…',
  'onboarding.contextGathering.coreUnreachable':
    'النواة لا تستجيب. يمكنك المتابعة والمحاولة لاحقًا.',
  'onboarding.contextGathering.errorDesc':
    'تعذّر إنشاء ملفك الكامل الآن، لكن لا بأس: يمكنك المتابعة وسيُبنى ملفك مع الوقت.',
  'onboarding.contextGathering.stillWorkingDesc':
    'قد يستغرق التشغيل الأول 30–60 ثانية أثناء تهيئة نموذجك المحلي والأدوات. يمكنك المتابعة إلى المحادثة في أي وقت: يستمر بناء الملف الشخصي في الخلفية.',
  'onboarding.contextGathering.stillWorkingTitle': 'لا يزال العمل جاريًا على ملفك الشخصي…',
  'onboarding.contextGathering.title': 'جمع السياق',
  'openhuman.team_list_teams': 'قائمة الفرق',
  'overlay.ariaAttention': 'رسالة انتباه',
  'overlay.ariaCompanion': 'الرفيق نشط',
  'overlay.ariaOrb': 'تراكب OpenHuman',
  'overlay.ariaVoiceActive': 'إدخال الصوت نشط',
  'overlay.companion.error': 'خطأ',
  'overlay.companion.listening': 'يستمع…',
  'overlay.companion.speaking': 'يتحدث…',
  'overlay.companion.thinking': 'يفكر…',
  'overlay.orbTitle': 'اسحب للتحريك · انقر مرتين لإعادة الضبط',
  'pages.settings.account.connections': 'الاتصالات',
  'pages.settings.account.connectionsDesc': 'وصف الاتصالات',
  'pages.settings.account.migration': 'استيراد من مساعد آخر',
  'pages.settings.account.migrationDesc':
    'انقل الذاكرة والملاحظات من OpenClaw (وقريبًا Hermes) إلى مساحة العمل هذه.',
  'pages.settings.account.privacy': 'الخصوصية',
  'pages.settings.account.privacyDesc': 'وصف الخصوصية',
  'pages.settings.account.recoveryPhrase': 'عبارة الاسترداد',
  'pages.settings.account.recoveryPhraseDesc': 'وصف عبارة الاسترداد',
  'pages.settings.account.team': 'الفريق',
  'pages.settings.account.teamDesc': 'وصف الفريق',
  'pages.settings.accountSection.description':
    'عبارة الاسترداد والفريق والاتصالات وإعدادات الخصوصية.',
  'pages.settings.accountSection.title': 'الحساب',
  'pages.settings.ai.llm': 'LLM',
  'pages.settings.ai.llmDesc': 'وصف LLM',
  'pages.settings.ai.voice': 'الصوت',
  'pages.settings.ai.voiceDesc': 'وصف الصوت',
  'pages.settings.aiSection.description': 'مزودو نماذج اللغة وOllama المحلي والصوت (STT / TTS).',
  'pages.settings.aiSection.title': 'الذكاء الاصطناعي',
  'settings.developerMenu.composio.title': 'Composio',
  'settings.developerMenu.composio.desc': 'وضع التوجيه ومشغلات التكامل وأرشيف محفوظات التشغيل.',
  'pages.settings.features.messagingChannels': 'قنوات المراسلة',
  'pages.settings.features.messagingChannelsDesc': 'وصف قنوات المراسلة',
  'pages.settings.features.notifications': 'الإشعارات',
  'pages.settings.features.notificationsDesc': 'وصف الإشعارات',
  'pages.settings.features.tools': 'الأدوات',
  'pages.settings.features.toolsDesc': 'وصف الأدوات',
  'pages.settings.featuresSection.title': 'الميزات',
  'privacy.dataKind.credentials': 'بيانات الاعتماد',
  'privacy.dataKind.derived': 'مشتقة',
  'privacy.dataKind.diagnostics': 'التشخيص',
  'privacy.dataKind.metadata': 'البيانات الوصفية',
  'privacy.dataKind.raw': 'خام',
  'privacy.whatLeaves.link.label': 'ما الذي يغادر جهازي؟',
  'rewards.community.achievementsUnlocked': 'تم فتح {unlocked} من {total} إنجازات',
  'rewards.community.activityStreakHint': 'أيام متتالية كنت نشطًا فيها على OpenHuman.',
  'rewards.community.activityTitle': 'نشاطك',
  'rewards.community.claimCredited': 'تمت إضافة {amount} إلى رصيدك',
  'rewards.community.claimError': 'تعذّرت المطالبة. يرجى المحاولة مرة أخرى.',
  'rewards.community.claimTokens': 'المطالبة بـ {tokens} رمز',
  'rewards.community.claimed': 'تمت المطالبة',
  'rewards.community.claiming': 'جارٍ المطالبة…',
  'rewards.community.connectDiscord': 'ربط Discord',
  'rewards.community.connectDiscordError': 'تعذّر بدء الاتصال بـ Discord. يرجى المحاولة مرة أخرى.',
  'rewards.community.connectingDiscord': 'جارٍ الاتصال…',
  'rewards.community.cumulativeTokens': 'الرموز التراكمية',
  'rewards.community.currentStreak': 'سلسلة النشاط',
  'rewards.community.disconnectDiscord': 'قطع الاتصال',
  'rewards.community.disconnectDiscordError': 'تعذّر قطع اتصال Discord. يُرجى المحاولة مرة أخرى.',
  'rewards.community.disconnectingDiscord': 'جارٍ قطع الاتصال…',
  'rewards.community.discordAccount': 'حساب Discord',
  'rewards.community.discordConnected': 'تم الاتصال بـ Discord',
  'rewards.community.discordConnectedAs': 'متصل باسم {username}',
  'rewards.community.discordDetails': 'Discord',
  'rewards.community.discordLinkedNotInGuild': 'Discord مرتبط لكن ليس في السيرفر',
  'rewards.community.discordMember': 'انضممت إلى الخادم',
  'rewards.community.discordNotLinked': 'Discord غير مرتبط',
  'rewards.community.discordServer': 'سيرفر Discord',
  'rewards.community.discordStatusUnavailable': 'حالة Discord غير متاحة',
  'rewards.community.discordWaiting': 'في انتظار Discord',
  'rewards.community.heroSubtitle': 'عنوان فرعي للبطل',
  'rewards.community.heroTitle': 'عنوان البطل',
  'rewards.community.joinDiscord': 'انضم إلى Discord',
  'rewards.community.loadingRewards': 'جارٍ تحميل المكافآت…',
  'rewards.community.locked': 'مفتوح',
  'rewards.community.longestStreak': 'أطول سلسلة',
  'rewards.community.retrying': 'جارٍ إعادة المحاولة…',
  'rewards.community.rewardTokens': '+{tokens} توكن',
  'rewards.community.rewardTokensMonthly': '+{tokens} توكن/شهر',
  'rewards.community.roleAssigned': 'تم تعيين الرتبة',
  'rewards.community.roleAssignmentCount': 'تم تعيين {assigned} من {unlocked} رتبة',
  'rewards.community.roleClaimDesc':
    'لقد فتحت رتب Discord لكنك لم تنضم بعد إلى خادم OpenHuman. انضم ليتم تعيينها تلقائيًا.',
  'rewards.community.roleClaimTitle': 'احصل على رتب Discord الخاصة بك',
  'rewards.community.roleJoinToClaim': 'انضم إلى الخادم للحصول عليها',
  'rewards.community.rolePending': 'جارٍ مزامنة الرتبة…',
  'rewards.community.rolesAndRewards': 'الأدوار والمكافآت',
  'rewards.community.streakDays': '{n} يوم',
  'rewards.community.syncPending': 'مزامنة المكافآت معلقة',
  'rewards.community.syncPendingDesc': 'وصف انتظار المزامنة',
  'rewards.community.syncUnavailable': 'المزامنة غير متاحة',
  'rewards.community.tryAgain': 'جارٍ إعادة المحاولة…',
  'rewards.community.unknown': 'غير معروف',
  'rewards.community.unlocked': 'مفتوح',
  'rewards.community.yourProgress': 'تقدمك',
  'rewards.coupon.colCode': 'الرمز',
  'rewards.coupon.colRedeemed': 'مُستردّ',
  'rewards.coupon.colReward': 'المكافأة',
  'rewards.coupon.colStatus': 'الحالة',
  'rewards.coupon.loadingHistory': 'جارٍ تحميل سجل المكافآت…',
  'rewards.coupon.noCodes': 'لم يتم استبدال أي رموز مكافآت بعد.',
  'rewards.coupon.pending': 'معلّق',
  'rewards.coupon.placeholder': 'رمز القسيمة',
  'rewards.coupon.promoCredits': 'رصيد عرض ترويجي',
  'rewards.coupon.recentRedemptions': 'عمليات الاسترداد الأخيرة',
  'rewards.coupon.redeemAccepted': 'تم قبول {code}. سيتم فتح {amount} بعد إكمال الإجراء المطلوب.',
  'rewards.coupon.redeemButton': 'استبدال الرمز',
  'rewards.coupon.redeemSuccess': 'تم استبدال {code}. تمت إضافة {amount} إلى رصيدك.',
  'rewards.coupon.redeemedCodes': 'الرموز المستردة',
  'rewards.coupon.redeeming': 'جارٍ الاسترداد...',
  'rewards.coupon.statusApplied': 'مُطبَّق',
  'rewards.coupon.statusPendingAction': 'بانتظار إجراء',
  'rewards.coupon.statusRedeemed': 'تم الاستبدال',
  'rewards.coupon.subtitle': 'العنوان الفرعي',
  'rewards.coupon.title': 'استرداد رمز قسيمة',
  'rewards.referralSection.activity': 'نشاط الإحالة',
  'rewards.referralSection.apply': 'جارٍ التطبيق…',
  'rewards.referralSection.applying': 'جارٍ التطبيق…',
  'rewards.referralSection.colReferredUser': 'المستخدم المُحال',
  'rewards.referralSection.colReward': 'المكافأة',
  'rewards.referralSection.colStatus': 'الحالة',
  'rewards.referralSection.colUpdated': 'المحدَّث',
  'rewards.referralSection.completed': 'مكتمل',
  'rewards.referralSection.copyCode': 'نسخ الرمز',
  'rewards.referralSection.copyFailed': 'فشل النسخ',
  'rewards.referralSection.haveCode': 'هل لديك رمز إحالة؟',
  'rewards.referralSection.haveCodeDesc': 'وصف امتلاك الرمز',
  'rewards.referralSection.linked': 'مرتبط',
  'rewards.referralSection.linkedCode': '(الرمز {code})',
  'rewards.referralSection.loading': 'جارٍ تحميل برنامج الإحالة…',
  'rewards.referralSection.retry': 'أعد المحاولة',
  'rewards.referralSection.noReferrals': 'لا توجد إحالات',
  'rewards.referralSection.pendingReferrals': 'الإحالات المعلقة',
  'rewards.referralSection.placeholder': 'رمز الإحالة',
  'rewards.referralSection.share': 'مشاركة',
  'rewards.referralSection.statusCompleted': 'الحالة: مكتمل',
  'rewards.referralSection.statusExpired': 'الحالة: منتهي الصلاحية',
  'rewards.referralSection.statusJoined': 'الحالة: انضم',
  'rewards.referralSection.subtitle': 'العنوان الفرعي',
  'rewards.referralSection.title': 'ادعُ أصدقاء واكسب رصيدًا',
  'rewards.referralSection.totalEarned': 'إجمالي المكتسب',
  'rewards.referralSection.yourCode': 'رمزك',
  'settings.ai.addCloudProvider': 'إضافة مزود سحابي',
  'settings.ai.addProvider': 'جارٍ الحفظ…',
  'settings.ai.apiKeyFieldLabel': 'تسمية حقل مفتاح API',
  'settings.ai.apiKeyRequired': 'يرجى لصق مفتاح API للمتابعة.',
  'settings.ai.apiKeyStoredEncrypted': 'مفتاح API محفوظ مشفّرًا',
  'settings.ai.apiKeysEncrypted': 'Xqx0xx',
  'settings.ai.clearStoredKey': 'مسح المفتاح المحفوظ',
  'settings.ai.connectProvider': 'ربط مزود',
  'settings.ai.customRouting': 'توجيه مخصص',
  'settings.ai.defaultResolvesTo': 'الافتراضي يُحل إلى',
  'settings.ai.discard': 'تجاهل',
  'settings.ai.editProvider': 'تعديل المزود',
  'settings.ai.llmProviders': 'مزودو LLM',
  'settings.ai.llmProvidersDesc': 'وصف مزودي LLM',
  'settings.ai.localOllama': 'محلي (Ollama)',
  'settings.ai.modelLabel': 'النموذج',
  'settings.ai.noCustomProviders': 'لا يوجد مزودون مخصصون',
  'settings.ai.openAiCompat.authHeaderExample': 'التفويض: الحامل <مفتاحك>',
  'settings.ai.openAiCompat.authHeaderLabel': 'رأس المصادقة',
  'settings.ai.openAiCompat.baseUrlLabel': 'القاعدة URL',
  'settings.ai.openAiCompat.baseUrlUnavailable': 'غير متاح',
  'settings.ai.openAiCompat.clearKey': 'مسح المفتاح',
  'settings.ai.openAiCompat.description':
    'توجيه العبوات المحلية في هذا الخادم / v1 إلى الطريق عبر مقدمي الخدمات المشكلين أدناه. التوثيق يستخدم مفتاحاً مستقراً وضعته هنا، وليس حامل اللب الداخلي للطلب.',
  'settings.ai.openAiCompat.keyConfigured': 'تم تكوين المفتاح',
  'settings.ai.openAiCompat.keyRequired': 'المفتاح مطلوب',
  'settings.ai.openAiCompat.rotateKey': 'مفتاح التدوير',
  'settings.ai.openAiCompat.setKey': 'مفتاح التعيين',
  'settings.ai.openAiCompat.title': 'OpenAI نقطة النهاية المتوافقة',
  'settings.ai.providerLabel': 'المزود',
  'skills.mcpComingSoon.title': 'MCP الخوادم',
  'skills.mcpComingSoon.description':
    'إدارة خادم MCP قادمة قريباً. ستكون هذه التبويبة المكان المخصص لاكتشاف خوادم MCP وتوصيلها ومراقبتها.',
  'settings.ai.routing': 'التوجيه',
  'settings.ai.claudeCode.button': 'Claude Code',
  'settings.ai.claudeCode.inlineNotConnected':
    'غير متصل: يوجّه المحادثة عبر واجهة Claude Code CLI المحلية لديك.',
  'settings.ai.claudeCode.checkingSignIn': 'جارٍ التحقق من تسجيل الدخول…',
  'settings.ai.claudeCode.inlineConnected': 'متصل.',
  'settings.ai.claudeCode.signedInAs': 'مسجّل الدخول باسم',
  'settings.ai.claudeCode.subscriptionFallback': 'اشتراك Claude',
  'settings.ai.claudeCode.usingApiKeyEnv': 'يستخدم ANTHROPIC_API_KEY',
  'settings.ai.claudeCode.cliNotInstalled': 'واجهة CLI غير مثبَّتة',
  'settings.ai.claudeCode.signInUnknown': 'حالة تسجيل الدخول غير معروفة',
  'settings.ai.claudeCode.connectedNotSignedIn': 'متصل · لم يتم تسجيل الدخول',
  'settings.ai.claudeCode.modalTitle': 'Claude Code CLI',
  'settings.ai.claudeCode.modelHelp':
    'معرّف نموذج تقبله أداة claude: اسم مختصر (sonnet أو opus) أو اسم كامل (claude-sonnet-4-5). يُمرَّر كما هو إلى claude --model، لذا تُرفض الصيغ التسويقية مثل sonnet-4-5.',
  'settings.ai.claudeCode.modalDescription':
    'يوجّه أعباء المحادثة والمهام الوكيلة والاستدلال عبر واجهة Claude Code CLI المثبَّتة محليًا. لا حاجة لمفتاح API: فهي تستخدم تسجيل الدخول الخاص بها.',
  'settings.ai.claudeCode.close': 'إغلاق',
  'settings.ai.claudeCode.connection': 'الاتصال',
  'settings.ai.claudeCode.enabled': 'مُفعَّل',
  'settings.ai.claudeCode.notEnabled': 'غير مُفعَّل',
  'settings.ai.claudeCode.disconnect': 'قطع الاتصال',
  'settings.ai.claudeCode.disconnecting': 'جارٍ قطع الاتصال…',
  'settings.ai.claudeCode.enable': 'تفعيل Claude Code',
  'settings.ai.claudeCode.enabling': 'جارٍ التفعيل…',
  'settings.ai.claudeCode.authentication': 'المصادقة',
  'settings.ai.claudeCode.recheck': 'إعادة الفحص',
  'settings.ai.claudeCode.checking': 'جارٍ الفحص…',
  'settings.ai.claudeCode.openingTerminal': 'جارٍ فتح الطرفية…',
  'settings.ai.claudeCode.signIn': 'تسجيل الدخول عبر Claude',
  'settings.ai.claudeCode.reconnect': 'إعادة الاتصال',
  'settings.ai.claudeCode.loginHint':
    'يفتح طرفية تُشغّل claude login. بعد اكتمالها، انقر على إعادة الفحص.',
  'settings.ai.claudeCode.loginError': 'تعذّر فتح طرفية تسجيل الدخول. يُرجى المحاولة مرة أخرى.',
  'settings.ai.claudeCode.fullAccess': 'وصول كامل',
  'settings.ai.claudeCode.fullAccessOn':
    'يمكن لـ Claude Code تشغيل الأوامر واستخدام الشبكة وإنشاء وكلاء فرعيين.',
  'settings.ai.claudeCode.fullAccessOff':
    'قبول التعديلات فقط: يطبّق تعديلات الملفات تلقائيًا ويقيّد الأوامر والشبكة.',
  'settings.ai.claudeCode.sandboxNoteMac':
    'على نظام macOS، يظل ~/.openhuman محميًا بواسطة البيئة المعزولة في كلا الوضعين.',
  'settings.ai.claudeCode.sandboxNoteOther':
    'الوصول الكامل غير مقيّد على هذه المنصة: فعّله فقط إذا كنت تثق بمساحة العمل.',
  'settings.ai.claudeCode.enableToCheck': 'فعّل Claude Code للتحقق من تسجيل الدخول.',
  'settings.ai.claudeCode.usingApiKeyEnvDetail': 'يستخدم ANTHROPIC_API_KEY من البيئة.',
  'settings.ai.claudeCode.notFoundInstall':
    'لم يتم العثور على Claude Code CLI: ثبّته عبر: npm install -g @anthropic-ai/claude-code',
  'settings.ai.claudeCode.unknownDetail':
    'تعذّر تحديد حالة تسجيل الدخول. قد تكون نسخة claude CLI لديك أقدم من دعم حالة المصادقة: جرّب إعادة الاتصال ثم إعادة الفحص.',
  'settings.ai.claudeCode.notSignedIn': 'لم يتم تسجيل الدخول.',
  'settings.ai.routingCustom': 'توجيه مخصص',
  'settings.ai.routingDefault': 'افتراضي',
  'settings.ai.routingDesc': 'وصف التوجيه',
  'settings.ai.saveChanges': 'جارٍ الحفظ…',
  'settings.ai.saving': 'جارٍ الحفظ…',
  'settings.ai.unsavedChange': 'تغيير غير محفوظ',
  'settings.ai.unsavedChanges': 'تغييرات غير محفوظة',
  'settings.ai.workloadGroupBackground': 'مجموعة عبء العمل الخلفي',
  'settings.ai.workloadGroupChat': 'مجموعة عبء عمل المحادثة',
  'settings.ai.disconnectProvider': 'قطع الاتصال {label}',
  'settings.ai.connectProviderLabel': 'الاتصال {label}',
  'settings.ai.editProviderEndpoint': 'تعديل نقطة النهاية {label}',
  'settings.ai.defaultLocalEndpoint': 'http://localhost:11434/v1',
  'settings.ai.editEndpoint': 'تعديل نقطة الاتصال',
  'settings.ai.endpointUrlLabel': 'نقطة النهاية URL',
  'settings.ai.localRuntimeHelper':
    'حيث يمكن الوصول إلى {label}. الإعداد الافتراضي هو المضيف المحلي؛ وجّه هذا إلى مضيف بعيد (مثلًا http://10.0.0.4:11434/v1) لاستخدام نسخة مشتركة.',
  'settings.ai.endpointUrlRequired': 'نقطة النهاية URL مطلوبة.',
  'settings.ai.endpointProtocolRequired': 'يجب أن تبدأ نقطة النهاية بـ http:// أو https://.',
  'settings.ai.connectProviderDialog': 'الاتصال {label}',
  'settings.ai.getProviderApiKey': 'احصل على مفتاح API',
  'settings.ai.or': 'أو',
  'settings.ai.codexOauthMissingAuthUrl':
    'لم يُرجع Codex OAuth عنوان URL للتفويض. حاول تسجيل الدخول مرة أخرى.',
  'settings.ai.codexOauthMissingCallbackUrl':
    'الصق عنوان URL لإعادة التوجيه من متصفحك بعد تسجيل الدخول.',
  'settings.ai.openRouterOauthDescription':
    'وقع مع OpenRouter وإستيراد مفتاح ×xxxxx متحكم به مستخدماً',
  'settings.ai.connecting': 'جارٍ الاتصال...',
  'settings.ai.codexAuthButton': 'ربط Codex',
  'settings.ai.codexAuthHelper': 'يستخدم تسجيل دخول Codex CLI الحالي من ~/.codex/auth.json.',
  'settings.ai.backgroundLoops': 'حلقات الخلفية',
  'settings.ai.backgroundLoopsDesc':
    'شاهدْ ما يَعْملُ بدون رسالةِ دردشةِ، يَتوقّفُ عملَ نبضات القلب، ويَتفحصُ مؤخراً دفترِ دفاترِ الإئتمانِ.',
  'settings.ai.heartbeatControls': 'التحكم في نبضات القلب',
  'settings.ai.heartbeatControlsDesc':
    'تعطل ويؤدي التمكين إلى بدء الحلقة؛ ويؤدي إلى إجهاض المهمة الجارية.',
  'settings.ai.heartbeatLoop': 'حلقة نبضات القلب',
  'settings.ai.heartbeatLoopDesc': 'الجدول الزمني الرئيسي للمخطط + الإستنتاجات الخفية الاختيارية',
  'settings.ai.subconsciousInference': 'الاستدلال اللاواعي',
  'settings.ai.subconsciousInferenceDesc': 'يُجري تقييماً مُدعماً بنموذج (Xqx0x) على دقات القلب',
  'settings.ai.calendarMeetingChecks': 'يتحقق اجتماع التقويم',
  'settings.ai.calendarMeetingChecksDesc':
    '(د) قائمة بالأحداث التقويمية للوصلات الناشطة من طراز Xqx0xx Calendar.',
  'settings.ai.calendarCap': 'غطاء التقويم',
  'settings.ai.connectionsPerTick': 'xxxxxxxxxxxxx',
  'settings.ai.meetingLookahead': 'نظرة أمامية للاجتماع',
  'settings.ai.minutesShort': '{count} دقيقة',
  'settings.ai.reminderLookahead': 'نظرة أمامية للتذكير',
  'settings.ai.cronReminderChecks': 'التحقق من تذكير Cron',
  'settings.ai.cronReminderChecksDesc':
    'وقد مكّنت الفحوصات من توفير فرص عمل للتذكير بالبنود المقبلة.',
  'settings.ai.relevantNotificationChecks': 'عمليات التحقق من الإشعارات ذات الصلة',
  'settings.ai.relevantNotificationChecksDesc':
    ':: تشجيع الإخطارات المحلية العاجلة إلى تنبيهات استباقية.',
  'settings.ai.externalDelivery': 'التسليم الخارجي',
  'settings.ai.externalDeliveryDesc': 'دعونا نرسل رسائل استباقية إلى القنوات الخارجية.',
  'settings.ai.interval': 'الفاصل الزمني',
  'settings.ai.running': 'قيد التشغيل...',
  'settings.ai.plannerTickNow': 'علامة المخطط الآن',
  'settings.ai.loadingHeartbeatControls': 'جارٍ تحميل عناصر التحكم في نبضات القلب...',
  'settings.ai.heartbeatControlsUnavailable': 'عناصر التحكم في نبضات القلب غير متاحة.',
  'settings.ai.loopMap': 'خريطة حلقة',
  'settings.ai.plannerSummary':
    'المخطط: {sourceEvents} أحداث المصدر، {sent} تم إرسالها، {deduped} تم حذفها.',
  'settings.ai.routeLabel': 'المسار: {route}',
  'settings.ai.on': 'على',
  'settings.ai.off': 'إيقاف',
  'settings.ai.recentUsageLedger': 'دفتر أستاذ الاستخدام الأخير',
  'settings.ai.recentUsageLedgerDesc':
    'وتكشف الصفوف الخلفية ×xxxxxxxxxxx اليوم؛ وتحتاج بطاقات المصدر إلى دعم احتياطي.',
  'settings.ai.latestSpend': 'آخر إنفاق: {amount} في {time} ({action})',
  'settings.ai.topActions': 'أهم الإجراءات',
  'settings.ai.noSpendRows': 'لم يتم تحميل صفوف إنفاق.',
  'settings.ai.topHours': 'أعلى الساعات',
  'settings.ai.noHourlySpend': 'لا يوجد إنفاق بالساعة حتى الآن.',
  'settings.ai.openhumanDefault': 'OpenHuman (افتراضي)',
  'settings.ai.localModelResolved': 'Xqx1xxxxxx',
  'settings.ai.customRoutingForWorkload': 'التوجيه المخصص لـ {label}',
  'settings.ai.loadingModels': 'جارٍ تحميل النماذج...',
  'settings.ai.enterModelIdManually': 'أو أدخل معرف النموذج يدويًا:',
  'settings.ai.modelIdPlaceholderForProvider': '{slug} معرف النموذج',
  'settings.ai.modelIdPlaceholder': 'model-id',
  'settings.ai.selectModel': 'حدد نموذجًا...',
  'settings.ai.deploymentNameLabel': 'اسم النشر',
  'settings.ai.deploymentNamePlaceholder': 'my-gpt-deployment',
  'settings.ai.deploymentNameHelp':
    'أدخل اسم النشر الذي حددته في Azure AI Foundry. هذا ليس معرف النموذج.',
  'settings.ai.deploymentNameLegacyHint':
    'تطابق هذه القيمة معرف نموذج أساسي من كتالوج المزود. يوجه Azure الطلبات حسب اسم النشر، لذا تأكد من أن هذا هو الاسم الذي منحته لعملية النشر.',
  'settings.ai.deploymentNameProviderHint':
    'تم اكتشاف نقطة نهاية Azure. حدد اسم النشر في حقل النموذج بعد اختيار هذا المزود.',
  'settings.ai.chooseModelFromList': 'اختر من القائمة',
  'settings.ai.enterModelIdManuallyAction': 'أدخل معرف النموذج يدويًا',
  'settings.ai.enterDeploymentNameManuallyAction': 'أدخل اسم النشر يدويًا',
  'settings.ai.probeFailedHint':
    'تعذّر علينا قراءة قائمة النماذج لدى هذا المزوّد. تلك القائمة تملأ القائمة المنسدلة فقط، لذا لا يزال بإمكانك إضافة المزوّد وكتابة اسم النموذج أو النشر بنفسك.',
  'settings.ai.probeFailedAddAnyway': 'أضِف دون التحقق',
  'settings.ai.azureV1EndpointHint':
    'مع Azure استخدم عنوان الإصدار v1‏: https://YOUR-RESOURCE.openai.azure.com/openai/v1. لا يوفّر عنوان المورد الأقدم قائمة نماذج ويتوقّع ترويسة مصادقة مختلفة.',
  'settings.ai.temperatureOverride': 'تجاوز درجة الحرارة',
  'settings.ai.temperatureOverrideSlider': 'تجاوز درجة الحرارة (شريط التمرير)',
  'settings.ai.temperatureOverrideValue': 'تجاوز درجة الحرارة (القيمة)',
  'settings.ai.temperatureOverrideDesc':
    'أقل = أكثر تحديدا. إتركْ غير مُمْكَنَّلَ لإسْتِعْمال قَبْل المُقدّمِ.',
  'settings.ai.modelVision': 'يدعم الرؤية (إدخال الصور)',
  'settings.ai.modelVisionDesc':
    'فعّل هذا إذا كان النموذج يقبل الصور. يتيح لمربع الدردشة إرفاق الصور عند اختيار هذا النموذج.',
  'settings.ai.testFailed': 'فشل الاختبار',
  'settings.ai.providerTest.authRejected':
    "تم حفظ المفتاح، لكن '{slug}' رفضه. تأكد من لصق المفتاح كاملاً ومن أنه ما زال نشطاً في لوحة تحكم المزوّد.",
  'settings.ai.providerTest.modelNotRecognized':
    "تم حفظ المفتاح وقبوله، لكن '{slug}' لا يتعرف على النموذج المحدد. اختر معرّف نموذج يقدمه هذا المزوّد فعلياً (يُضبط نموذجه الافتراضي في إدخال المزوّد).",
  'settings.ai.providerTest.quotaOrBilling':
    "تم حفظ المفتاح وقبوله، لكن '{slug}' رفض الطلب لأسباب تتعلق بالحصة أو الفوترة. تحقق من رصيد حسابك وحدود الاستخدام لدى المزوّد.",
  'settings.ai.providerTest.endpointNotFound':
    "تم حفظ المفتاح، لكن نقطة النهاية المهيأة لـ '{slug}' أعادت 404. تحقق من عنوان URL الأساسي: عادةً ما يحتاج المزوّد المتوافق مع OpenAI إلى اللاحقة '/v1' (مثل https://api.openai.com/v1).",
  'settings.ai.providerTest.timeout':
    "تم حفظ المفتاح، لكن '{slug}' لم يستجب في الوقت المحدد. تحقق من عنوان نقطة النهاية ومن شبكتك ثم أعد الاختبار.",
  'settings.ai.providerTest.emptyReply':
    "تم حفظ المفتاح، لكن '{slug}' أعاد رداً فارغاً على رسالة اختبار. تحقق من معرّف النموذج المهيأ لهذا المزوّد.",
  'settings.ai.providerTest.unknown':
    "تم حفظ المفتاح، لكن فشل استدعاء اختباري إلى '{slug}'. تحقق من صفحة حالة المزوّد ومن عنوان نقطة النهاية ثم أعد الاختبار.",
  'settings.ai.testingModel': 'نموذج الاختبار...',
  'settings.ai.modelResponse': 'استجابة النموذج',
  'settings.ai.providerWithValue': 'الموفر: {value}',
  'settings.ai.noneDash': 'لا شيء',
  'settings.ai.promptHelloWorld': 'موجه: مرحبًا بالعالم',
  'settings.ai.startedAt': 'البداية: {value}',
  'settings.ai.waitingForModelResponse': 'في انتظار الاستجابة من النموذج المحدد...',
  'settings.ai.response': 'الاستجابة',
  'settings.ai.testing': 'جارٍ الاختبار...',
  'settings.ai.test': 'اختبار',
  'settings.ai.slugMissingError': 'أدخل اسم الموفر لإنشاء سبيكة ثابتة.',
  'settings.ai.slugInUseError': 'اسم الموفر هذا قيد الاستخدام بالفعل.',
  'settings.ai.slugReservedError': 'اختر اسم موفر مختلف.',
  'settings.ai.providerNamePlaceholder': 'موفر الخدمة الخاص بي',
  'settings.ai.slugLabel': 'الارتباط الثابت:',
  'settings.ai.openAiUrlLabel': 'Xqx1xxxxxxxxxxx',
  'settings.ai.openAiUrlPlaceholder': 'https://api.openai.com/v1',
  'settings.ai.keepExistingKeyPlaceholder': 'اتركه فارغًا للاحتفاظ بالمفتاح الموجود',
  'settings.ai.reindexingMemory': 'إعادة فهرسة الذاكرة',
  'settings.ai.reindexingMemoryMessage':
    'يتم إعادة تجهيز الامتصاصات ويعاد إدراج مادة (أدوات) ذاكرة &quot; Xqx0xxx &quot; في إطار النموذج الحالي - يخفض التذكر العلماني إلى حين الانتهاء من ذلك. البحث عن الكلمات الرئيسية يستمر في العمل، ويستمر إعادة التفكير في الخلفية إذا أغلقت هذا.',
  'settings.ai.signInWithOpenRouter': 'قم بتسجيل الدخول باستخدام OpenRouter',
  'settings.ai.weekBudget': 'ميزانية الأسبوع',
  'settings.ai.cycleRemaining': 'الدورة المتبقية',
  'settings.ai.cycleTotalSpend': 'إجمالي إنفاق الدورة',
  'settings.ai.avgSpendRow': 'متوسط صف الإنفاق',
  'settings.ai.backgroundApiReads': 'Bg API يقرأ',
  'settings.ai.backgroundWakeups': 'تنبيهات Bg',
  'settings.ai.budgetMath': 'حسابات الميزانية',
  'settings.ai.rowsLeft': 'الصفوف المتبقية',
  'settings.ai.rowsPerFullWeekBudget': 'الصفوف لكل ميزانية أسبوع كامل',
  'settings.ai.sampleBurnRate': 'معدل حرق العينة',
  'settings.ai.projectedEmpty': 'فارغ متوقع',
  'settings.ai.apiReadsPerDollarRemaining': 'API عدد القراءات لكل دولار متبقي',
  'settings.ai.loopCallBudget': 'ميزانية المكالمة المتكررة',
  'settings.ai.heartbeatTicks': 'علامات نبضات القلب',
  'settings.ai.calendarPlannerCalls': 'يستدعي مخطط التقويم',
  'settings.ai.calendarFanoutCap': 'غطاء التوزيع الموسع للتقويم',
  'settings.ai.subconsciousModelCalls': 'يستدعي نموذج اللاوعي',
  'settings.ai.composioSyncScans': 'Composio عمليات مسح المزامنة',
  'settings.ai.totalBackgroundApiReadBudget': 'إجمالي bg API ميزانية القراءة',
  'settings.ai.memoryWorkerPolls': 'استطلاعات عاملي الذاكرة',
  'settings.ai.defaultProviderName': 'OpenHuman',
  'settings.ai.routing.managed': 'المُدارة',
  'settings.ai.routing.managedAlwaysOn': 'دائما على',
  'settings.ai.routing.managedHint':
    'المُدارة متاحة دائمًا كبديل. لاستخدام النموذج الخاص بك، اختر وضع التوجيه أدناه.',
  'settings.ai.routing.managedDesc':
    '(Xqx0xx) سيحقق كل شيء في السحابة، ويختار أفضل نموذج للمهمة، ويرفع التكاليف إلى أقصى حد، ويحتفظ بأمن التخلف عن الدفع.',
  'settings.ai.routing.managedMsg':
    'وسيتولى Xqx0xx معالجة جميع الإفادات المتعلقة بكل عبء عمل، ويختار تلقائيا أفضل طريق للتكاليف والجودة والأمن.',
  'settings.ai.routing.useYourOwn': 'استخدم النماذج الخاصة بك',
  'settings.ai.routing.useYourOwnDesc':
    'اختيار مقدم واحد + نموذج ودفع كل عبء عمل من خلاله. وهذا أمر بسيط، ولكن يمكن أن يكون غير فعال لأن الوزن الخفيف والوزن الثقيل يتقاسمان نفس الطريق.',
  'settings.ai.routing.advanced': 'متقدم',
  'settings.ai.routing.advancedDesc':
    'اختر نماذج مختلفة لمهام مختلفة وهذا هو أفضل خيار لتحقيق أقصى قدر من التكاليف والتحكم فيها.',
  'settings.ai.routing.customDesc':
    'التمرين الجيد يعطيك أفضل تكلفة و التحكم استخدم الصفوف الواردة أدناه لتحديد حجم العمل الذي يبقى جاهزاً والذي يستخدم عجزك المشترك والذي يلصق بنموذج محدد',
  'settings.ai.routing.chatAndConversations': 'الدردشة والمحادثات',
  'settings.ai.routing.chatDesc':
    'النماذج المستخدمة أثناء التفاعل المباشر للمستعملين، والردود، والتفسير، وحلقات العملاء، والمساعدة في التدوين.',
  'settings.ai.routing.backgroundTasks': 'مهام الخلفية',
  'settings.ai.routing.bgTasksDesc':
    'النماذج المستخدمة خارج التدفق الرئيسي للمحادثات للتلخيص والقلب والتعلم والتقييم اللاوعي.',
  'settings.ai.routing.workload.chat.label': 'Chat',
  'settings.ai.routing.workload.chat.description':
    'المحادثة المباشرة ذهابًا وإيابًا: الوضع "السريع" في المحادثات',
  'settings.ai.routing.workload.chat.hint':
    'موصى به: نموذج دردشة سريع رخيص أو متوسط ​​التكلفة مع رموز مميزة عالية/ثانية وزمن وصول منخفض. يمكن للنماذج المحلية مفتوحة المصدر أن تعمل بشكل جيد هنا إذا شعرت بالاستجابة.',
  'settings.ai.routing.workload.reasoning.label': 'Reasoning',
  'settings.ai.routing.workload.reasoning.description':
    'وكيل الدردشة الرئيسي، ملخص الاجتماع: وضع "الاستدلال" في المحادثات',
  'settings.ai.routing.workload.reasoning.hint':
    'موصى به: حدود أكثر تكلفة أو نموذج تفكير قوي للتفكير العميق. يتم استخدام هذا لوكيل الدردشة الرئيسي وملخصات الاجتماعات وتوليف الإجابات الأثقل.',
  'settings.ai.routing.workload.agentic.label': 'Agentic',
  'settings.ai.routing.workload.agentic.description':
    'مشغلو الوكيل الفرعي، وحلقات الأدوات، وقرارات GIF',
  'settings.ai.routing.workload.agentic.hint':
    'موصى به: نموذج موثوق لمتابعة التعليمات مع استخدام قوي للأداة. عادةً ما تكون النماذج الحدودية متوسطة التكلفة هي الأكثر أمانًا؛ يمكن أن تعمل النماذج مفتوحة المصدر القادرة على العمل إذا كان استدعاء الأداة مستقرًا.',
  'settings.ai.routing.workload.coding.label': 'Coding',
  'settings.ai.routing.workload.coding.description': 'يمر إنشاء التعليمات البرمجية وإعادة البناء',
  'settings.ai.routing.workload.coding.hint':
    'موصى به: نموذج تم ضبطه بالبرمجة مع اتباع تعليمات قوية، وجودة التحرير، وأداء السياق الطويل. وهذا عادة ما يستحق إنفاق المزيد عليه.',
  'settings.ai.routing.workload.vision.label': 'Vision',
  'settings.ai.routing.workload.vision.description':
    'فهم الصورة للوكيل الفرعي للرؤية: متعدد الوسائط دائمًا',
  'settings.ai.routing.workload.vision.hint':
    'موصى به: نموذج متعدد الوسائط يقبل إدخال الصور. الإعداد الافتراضي المُدار (vision-v1) قادر على التقاط الصور؛ يتم التعامل دائمًا مع أي مزود تقوم بتوجيهه إلى هنا على أنه ذو قدرة على الرؤية.',
  'settings.ai.routing.workload.memory.label': 'تلخيص الذاكرة',
  'settings.ai.routing.workload.memory.description': 'مقتطفات شجرة والتوحيد',
  'settings.ai.routing.workload.memory.hint':
    'موصى به: نموذج تلخيص أرخص. وينبغي أن تكون متسقة ومتماسكة، ولكنها لا تحتاج إلى تفكير عالي المستوى.',
  'settings.ai.routing.workload.heartbeat.label': 'Heartbeat',
  'settings.ai.routing.workload.heartbeat.description': 'التفكير في الخلفية بين أدوار المستخدم',
  'settings.ai.routing.workload.heartbeat.hint':
    'موصى به: نموذج خلفية رخيص وفعال. يحدث هذا غالبًا بين المنعطفات، لذا فإن التكلفة المنخفضة أكثر أهمية من الحد الأقصى من الذكاء.',
  'settings.ai.routing.workload.learning.label': 'التعلم · تأملات',
  'settings.ai.routing.workload.learning.description': 'التفكير الدوري في التاريخ الحديث',
  'settings.ai.routing.workload.learning.hint':
    'الموصى بها: نموذج عاكس أقوى. يمكن أن يكون هذا متوسط ​​التكلفة أو ممتازًا لأنه يستفيد من التوليف الأفضل على مدار التاريخ الحديث.',
  'settings.ai.routing.workload.subconscious.label': 'Subconscious',
  'settings.ai.routing.workload.subconscious.description': 'سجل الأحداث + الشيكات الانجراف',
  'settings.ai.routing.workload.subconscious.hint':
    'موصى به: نموذج مراقبة رخيص للغاية، ومن الأفضل أن يكون خفيف الوزن ويمكن التنبؤ به. هذا مخصص لتسجيل الأحداث وفحوصات الانجراف وتقييم الخلفية الهادئة.',
  'settings.ai.routing.addCustomProvider': 'إضافة موفر مخصص',
  'settings.ai.globalModel.title': 'اختر نموذجًا واحدًا لكل شيء',
  'settings.ai.globalModel.desc':
    'هذا يَسْحبُ كُلّ الإطلاع خلال نموذجِ واحد. وهي أبسط، ولكنها يمكن أن تكون غير فعالة من حيث التكلفة والجودة لأن الوزن الخفيف والمهام الثقيلة ستستخدم جميعها نفس الطريق.',
  'settings.ai.globalModel.noProviders':
    'أضف أو أربط المزود أولاً ثم يمكنك توجيه كل عبء عمل من خلال نموذج واحد هنا.',
  'settings.ai.globalModel.provider': 'الموفر',
  'settings.ai.globalModel.model': 'الموديل',
  'settings.ai.globalModel.loadingModels': 'جارٍ تحميل النماذج...',
  'settings.ai.globalModel.enterModelId': 'أدخل معرف النموذج',
  'settings.ai.globalModel.appliesToAll':
    'ينطبق على نفس المزود + النموذج للدردشة والتفكير والترميز والذاكرة و نبضات القلب والتعلم و اللاوعي تم تشكيل الخلايا بشكل منفصل التغييرات تنقذ عندما تنقر',
  'settings.ai.globalModel.saving': 'جاري الحفظ...',
  'settings.ai.globalModel.saved': 'تم الحفظ',
  'settings.ai.workload.noModel': 'لم يتم تحديد نموذج',
  'settings.ai.workload.changeModel': 'تغيير النموذج',
  'settings.ai.workload.chooseModel': 'اختر النموذج',
  'settings.ai.provider.ollama': 'Ollama',
  'settings.billing.autoRecharge.addAmount': 'أضف هذا المبلغ',
  'settings.billing.autoRecharge.addCard': 'إضافة بطاقة',
  'settings.billing.autoRecharge.amountHint': 'تلميح المبلغ',
  'settings.billing.autoRecharge.defaultCard': 'البطاقة الافتراضية',
  'settings.billing.autoRecharge.lastRechargeFailed': 'فشلت آخر عملية شحن',
  'settings.billing.autoRecharge.lastRecharged': 'آخر شحن',
  'settings.billing.autoRecharge.expires': 'تنتهي صلاحيته {date}',
  'settings.billing.autoRecharge.noCards': 'لا توجد بطاقات',
  'settings.billing.autoRecharge.paymentMethods': 'طرق الدفع',
  'settings.billing.autoRecharge.rechargeInProgress': 'الشحن جارٍ',
  'settings.billing.autoRecharge.spentThisWeek': '${spent} من ${limit} المستخدم هذا الأسبوع',
  'settings.billing.autoRecharge.rechargeWhen': 'شحن عندما ينخفض الرصيد عن',
  'settings.billing.autoRecharge.saveSettings': 'جارٍ الحفظ…',
  'settings.billing.autoRecharge.saving': 'جارٍ الحفظ…',
  'settings.billing.autoRecharge.setDefault': ':',
  'settings.billing.autoRecharge.subtitle': 'العنوان الفرعي',
  'settings.billing.autoRecharge.title': 'تفعيل الشحن التلقائي',
  'settings.billing.autoRecharge.toggleAriaLabel': 'تبديل الشحن التلقائي',
  'settings.billing.autoRecharge.weeklyLimit': 'حد الإنفاق الأسبوعي',
  'settings.billing.history.desc': 'الوصف',
  'settings.billing.history.empty': 'فارغ',
  'settings.billing.history.openPortal': 'فتح البوابة',
  'settings.billing.history.posted': 'مُرسَل',
  'settings.billing.history.title': 'العنوان',
  'settings.billing.inferenceBudget.cycleEnds': 'نهاية الدورة',
  'settings.billing.inferenceBudget.exhausted': 'منتهٍ',
  'settings.billing.inferenceBudget.loadError': 'خطأ في التحميل',
  'settings.billing.inferenceBudget.noBudgetDesc': 'وصف عدم وجود ميزانية',
  'settings.billing.inferenceBudget.noRecurringBudget': 'لا توجد ميزانية متكررة',
  'settings.billing.inferenceBudget.noRecurringPlanBudget': 'لا توجد ميزانية خطة متكررة',
  'settings.billing.inferenceBudget.noRecurringWeeklyDesc':
    'خطتك الحالية لا تتضمن ميزانية إسبوالية متكررة وبدلاً من ذلك، يدفع الاستخدام من الائتمانات المتاحة.',
  'settings.billing.inferenceBudget.remaining': 'المتبقي',
  'settings.billing.inferenceBudget.remainingSummary': '{remaining} / {budget} المتبقي',
  'settings.billing.inferenceBudget.spentThisCycle': 'تم إنفاق {amount} هذه الدورة',
  'settings.billing.inferenceBudget.cycleEndsOn': 'تنتهي الدورة {date}',
  'settings.billing.inferenceBudget.exhaustedDesc':
    'واستُنفد استخدام الاشتراك المشمول. تقدم الائتمانات لتستمر في استخدام "آي آي" بدون انتظار الدورة القادمة',
  'settings.billing.inferenceBudget.discountVsPayg': '{pct}% أرخص لكل مكالمة من الدفع أولاً بأول.',
  'settings.billing.inferenceBudget.cycleSpend': 'الإنفاق الدوري',
  'settings.billing.inferenceBudget.totalAmount': '{amount} الإجمالي',
  'settings.billing.inferenceBudget.inference': 'الاستدلال',
  'settings.billing.inferenceBudget.integrations': 'عمليات التكامل',
  'settings.billing.inferenceBudget.calls': '{count} المكالمات',
  'settings.billing.inferenceBudget.dailySpend': 'الإنفاق اليومي',
  'settings.billing.inferenceBudget.dailySpendPoint': '{date}: {amount}',
  'settings.billing.inferenceBudget.topModels': 'أفضل الموديلات',
  'settings.billing.inferenceBudget.noInferenceUsage': 'لا يوجد استخدام للاستدلال في هذه الدورة.',
  'settings.billing.inferenceBudget.topIntegrations': 'أهم عمليات التكامل',
  'settings.billing.inferenceBudget.noIntegrationUsage': 'لا يوجد استخدام للتكامل في هذه الدورة.',
  'settings.billing.inferenceBudget.tenHourCap': 'حد عشر ساعات',
  'settings.billing.inferenceBudget.title': 'العنوان',
  'settings.billing.inferenceBudget.unableToLoad': 'غير قادر على تحميل بيانات الاستخدام',
  'settings.billing.inferenceBudget.notAvailable': 'غير متوفر',
  'settings.billing.payAsYouGo.available': 'متاح',
  'settings.billing.payAsYouGo.chargeCustomAmount': 'جارٍ الفتح…',
  'settings.billing.payAsYouGo.chooseTopUpDesc': 'وصف اختيار الشحن',
  'settings.billing.payAsYouGo.chooseTopUpTitle': 'عنوان اختيار الشحن',
  'settings.billing.payAsYouGo.creditBalanceDesc': 'وصف رصيد الائتمان',
  'settings.billing.payAsYouGo.creditBalanceTitle': 'عنوان رصيد الائتمان',
  'settings.billing.payAsYouGo.customAmount': 'مبلغ مخصص',
  'settings.billing.payAsYouGo.enterAmount': 'أدخل المبلغ',
  'settings.billing.payAsYouGo.opening': 'جارٍ الفتح',
  'settings.billing.payAsYouGo.promotionalCredits': 'رصيد ترويجي',
  'settings.billing.payAsYouGo.topUpBalance': 'شحن الرصيد',
  'settings.billing.payAsYouGo.topUpCredits': 'شحن الرصيد',
  'settings.billing.payAsYouGo.unableToLoad': 'تعذّر تحميل الرصيد.',
  'settings.billing.subscription.annual': 'سنوي',
  'settings.billing.subscription.billedAnnually': 'يُفوتر سنويًا',
  'settings.billing.subscription.chooseSubtitle': 'عنوان فرعي للاختيار',
  'settings.billing.subscription.chooseTitle': 'عنوان الاختيار',
  'settings.billing.subscription.cryptoDesc': 'وصف العملة المشفرة',
  'settings.billing.subscription.cryptoQuestion': 'سؤال العملة المشفرة',
  'settings.billing.subscription.current': 'الحالي',
  'settings.billing.subscription.currentPlan': 'الخطة الحالية',
  'settings.billing.subscription.monthly': 'شهري',
  'settings.billing.subscription.paymentConfirmed': 'تم تأكيد الدفع',
  'settings.billing.subscription.perMonth': 'في الشهر',
  'settings.billing.subscription.popular': 'شائع',
  'settings.billing.subscription.save': '{pct}',
  'settings.billing.subscription.upgrade': 'ترقية',
  'settings.billing.subscription.waiting': 'انتظار',
  'settings.billing.subscription.waitingPayment': 'في انتظار الدفع',
  'settings.composio.apiKeyDesc': 'يتم حاليًا تخزين مفتاح Composio API على هذا الجهاز.',
  'settings.composio.apiKeyExamplePlaceholder': 'ck_live_xxxxxxxxxxxxxxxxxx',
  'settings.composio.apiKeyLabel': 'مفتاح Composio API',
  'settings.composio.apiKeyStored': 'تم تخزين مفتاح API',
  'settings.composio.apiKeyStoredPlaceholder':
    '• ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ● ●',
  'settings.composio.clearedToBackend': 'تم التبديل إلى وضع الخلفية',
  'settings.composio.confirmItem1': 'حساب على app.composio.dev مع مفتاح API',
  'settings.composio.confirmItem2': 'لإعادة ربط كل تكامل عبر حساب Composio الشخصي الخاص بك',
  'settings.composio.confirmItem3':
    'ملاحظة: مشغّلات Composio (الـ webhooks الفورية) لا تعمل في الوضع المباشر بعد: فقط استدعاءات الأدوات المتزامنة',
  'settings.composio.confirmNeedItems': 'ستحتاج إلى:',
  'settings.composio.confirmSwitch': 'أفهم، التبديل إلى المباشر',
  'settings.composio.confirmTitle': '⚠️ التبديل إلى الوضع المباشر',
  'settings.composio.confirmWarning':
    'تكاملاتك الحالية (Gmail، Slack، GitHub، إلخ المرتبطة عبر OpenHuman) لن تكون مرئية: فهي موجودة في مستأجر Composio المُدار من OpenHuman.',
  'settings.composio.intro':
    'يُدمج Composio أكثر من 250 تطبيقًا خارجيًا كأدوات يمكن للوكيل استدعاؤها. اختر كيفية توجيه هذه الاستدعاءات.',
  'settings.composio.title': 'Composio',
  'settings.composio.modeDirect': 'مباشر (استخدم مفتاح API الخاص بك)',
  'settings.composio.modeDirectDesc':
    'تذهب الاستدعاءات إلى backend.composio.dev مباشرةً. سيادي / مناسب للعمل دون اتصال. تنفيذ الأدوات يعمل بشكل متزامن؛ مشغّلات الـ webhooks الفورية لم تُوجَّه بعد في الوضع المباشر (مشكلة متابعة).',
  'settings.composio.modeManaged': 'مُدار (OpenHuman يتولى الأمر نيابةً عنك)',
  'settings.composio.modeManagedDesc':
    'يقوم OpenHuman بتمرير استدعاءات الأدوات عبر خادمنا الخلفي (موصى به). تتم وساطة المصادقة؛ لن تلصق مفتاح Composio API. الـ webhooks مُوجَّهة بالكامل.',
  'settings.composio.routingMode': 'وضع التوجيه',
  'settings.composio.saveErrorNoKey': 'فشل الحفظ. الوضع المباشر يتطلب مفتاح API غير فارغ.',
  'settings.composio.saving': 'جارٍ الحفظ…',
  'settings.composio.switching': 'جارٍ التبديل…',
  'settings.cron.jobs.commandRequired': 'الأمر مطلوب لمهام shell',
  'settings.cron.jobs.createJob': 'مهمة مجدولة جديدة',
  'settings.cron.jobs.created': 'تم إنشاء المهمة',
  'settings.cron.jobs.custom': 'مخصص',
  'settings.cron.jobs.desc': 'الوصف',
  'settings.cron.jobs.edit': 'تعديل',
  'settings.cron.jobs.editJob': 'تعديل المهمة المجدولة',
  'settings.cron.jobs.empty': 'لا توجد مهام cron أساسية.',
  'settings.cron.jobs.errorCreate': 'فشل إنشاء مهمة cron: {message}',
  'settings.cron.jobs.errorLoadList': 'فشل تحميل مهام cron الأساسية: {message}',
  'settings.cron.jobs.errorLoadRuns': 'فشل تحميل سجل التشغيل: {message}',
  'settings.cron.jobs.errorRemove': 'فشل إزالة مهمة cron الأساسية: {message}',
  'settings.cron.jobs.errorRun': 'فشل تشغيل مهمة cron الأساسية: {message}',
  'settings.cron.jobs.errorToggle': 'فشل تحديث مهمة cron الأساسية: {message}',
  'settings.cron.jobs.errorUpdate': 'فشل تحديث مهمة cron: {message}',
  'settings.cron.jobs.formAtLabel': 'التشغيل في',
  'settings.cron.jobs.formCancel': 'إلغاء',
  'settings.cron.jobs.formCommand': 'أمر shell',
  'settings.cron.jobs.formCommandPlaceholder': 'مثال: curl https://example.com/health',
  'settings.cron.jobs.formCreate': 'إنشاء',
  'settings.cron.jobs.formCronCustom': 'تعبير مخصص',
  'settings.cron.jobs.formCronCustomPlaceholder': 'مثال: */30 * * * *',
  'settings.cron.jobs.formCronPreset': 'إعداد مسبق',
  'settings.cron.jobs.formCronPreview': 'يعمل: {preview}',
  'settings.cron.jobs.formDeleteAfterRun': 'حذف بعد أول تشغيل',
  'settings.cron.jobs.formDelivery': 'وضع التسليم',
  'settings.cron.jobs.formDeliveryNone': 'بلا (الإخراج فقط)',
  'settings.cron.jobs.formDeliveryProactive': 'استباقي (إشعار فوري)',
  'settings.cron.jobs.formError': 'فشل حفظ المهمة',
  'settings.cron.jobs.formEveryLabel': 'الفاصل الزمني (ميلي ثانية)',
  'settings.cron.jobs.formEveryPlaceholder': 'مثال: 3600000',
  'settings.cron.jobs.formJobType': 'نوع المهمة',
  'settings.cron.jobs.formJobTypeAgent': 'Agent (موجّه AI)',
  'settings.cron.jobs.formJobTypeShell': 'أمر shell',
  'settings.cron.jobs.formName': 'اسم المهمة',
  'settings.cron.jobs.formNamePlaceholder': 'مثال: daily-report, cleanup-task',
  'settings.cron.jobs.formPrompt': 'موجّه Agent',
  'settings.cron.jobs.formPromptPlaceholder': 'ماذا يجب أن يفعل الوكيل في كل تشغيل؟',
  'settings.cron.jobs.formPromptRequired': 'الموجّه مطلوب لمهام Agent',
  'settings.cron.jobs.formSave': 'حفظ',
  'settings.cron.jobs.formSaving': 'جارٍ الحفظ…',
  'settings.cron.jobs.formScheduleAt': 'مرة واحدة (التشغيل في)',
  'settings.cron.jobs.formScheduleCron': 'متكرر (cron)',
  'settings.cron.jobs.formScheduleEvery': 'الفاصل الزمني (كل N مللي ثانية)',
  'settings.cron.jobs.formScheduleRequired': 'الجدول مطلوب',
  'settings.cron.jobs.formScheduleType': 'نوع الجدول',
  'settings.cron.jobs.formSessionIsolated': 'معزول (موصى به)',
  'settings.cron.jobs.formSessionMain': 'الجلسة الرئيسية',
  'settings.cron.jobs.formSessionTarget': 'هدف الجلسة',
  'settings.cron.jobs.formProfile': 'ملف الوكيل',
  'settings.cron.jobs.formProfileNone': 'بدون ملف',
  'settings.cron.jobs.formProfileHint':
    'شغّل هذه المهمة بالملف المحدد، مستخدمًا روحه وذاكرته ومساحة عمله.',
  'settings.cron.jobs.profile': 'الملف',
  'settings.cron.jobs.lastStatus': 'آخر حالة',
  'settings.cron.jobs.loading': 'جارٍ تحميل مهام cron...',
  'settings.cron.jobs.loadingRuns': 'جارٍ تحميل عمليات التشغيل',
  'settings.cron.jobs.nextRun': 'التشغيل التالي',
  'settings.cron.jobs.pause': 'إيقاف مؤقت',
  'settings.cron.jobs.paused': 'متوقف مؤقتاً',
  'settings.cron.jobs.recentRuns': 'التشغيلات الأخيرة',
  'settings.cron.jobs.removing': 'جارٍ الإزالة',
  'settings.cron.jobs.resume': 'استئناف',
  'settings.cron.jobs.runningNow': 'يعمل الآن',
  'settings.cron.jobs.saving': 'جارٍ الحفظ…',
  'settings.cron.jobs.schedule': 'الجدول',
  'settings.cron.jobs.title': 'مهام Cron الأساسية',
  'settings.cron.jobs.updated': 'تم تحديث المهمة',
  'settings.cron.jobs.viewRuns': 'عرض عمليات التشغيل',
  'settings.cron.schedule.every2hours': 'كل ساعتين',
  'settings.cron.schedule.every30min': 'كل 30 دقيقة',
  'settings.cron.schedule.every6hours': 'كل 6 ساعات',
  'settings.cron.schedule.everyHour': 'كل ساعة',
  'settings.cron.schedule.onceDaily': 'مرة يوميًا (9 صباحًا)',
  'settings.localModel.deviceCapability.active': 'نشط',
  'settings.localModel.deviceCapability.appliedTier': 'المستوى المطبّق',
  'settings.localModel.deviceCapability.applying': 'جارٍ التطبيق',
  'settings.localModel.deviceCapability.cores': '{count}',
  'settings.localModel.deviceCapability.couldNotLoadPresets': 'تعذّر تحميل الإعدادات المسبقة',
  'settings.localModel.deviceCapability.cpu': 'CPU',
  'settings.localModel.deviceCapability.customModelIds': 'معرفات نماذج مخصصة',
  'settings.localModel.deviceCapability.detected': 'تم الكشف',
  'settings.localModel.deviceCapability.disabled': 'معطّل',
  'settings.localModel.deviceCapability.disabledDesc': 'وصف التعطيل',
  'settings.localModel.deviceCapability.downloadingModels': '(جارٍ تنزيل النماذج)',
  'settings.localModel.deviceCapability.downloadingSetupDesc':
    'جارٍ تنزيل مثبّت OllamaSetup (~2 GB) وفكّه. قد يستغرق هذا دقيقة عند التثبيت الأول.',
  'settings.localModel.deviceCapability.failedToApplyPreset': 'فشل تطبيق الإعداد المسبق',
  'settings.localModel.deviceCapability.gpu': 'GPU',
  'settings.localModel.deviceCapability.installFailed': 'فشل تثبيت Ollama',
  'settings.localModel.deviceCapability.installFailedDesc':
    'خرج المثبّت قبل أن يصبح Ollama قابلاً للاستخدام. انقر إعادة المحاولة، أو ثبّته يدويًا من ollama.com.',
  'settings.localModel.deviceCapability.installFirst': 'شغّل Ollama أولاً.',
  'settings.localModel.deviceCapability.installFirstDesc':
    'تعتمد المستويات المحلية على نقطة نهاية Ollama مُدارة خارجيًا. شغّلها بنفسك، وحمّل النماذج التي تريدها، واستمر في استخدام "معطّل (التراجع السحابي)" حتى يصبح وقت التشغيل قابلاً للوصول.',
  'settings.localModel.deviceCapability.installOllamaFirst':
    'شغّل Ollama أولاً لاستخدام هذا المستوى',
  'settings.localModel.deviceCapability.installingOllama': 'جارٍ تثبيت Ollama',
  'settings.localModel.deviceCapability.loadingDeviceInfo': 'جارٍ تحميل معلومات الجهاز',
  'settings.localModel.deviceCapability.localAiDisabled':
    'الذكاء الاصطناعي المحلي معطّل: يُستخدم الاحتياط السحابي.',
  'settings.localModel.deviceCapability.modelTier': 'مستوى النموذج',
  'settings.localModel.deviceCapability.needsOllama': 'يحتاج إلى Ollama',
  'settings.localModel.deviceCapability.notDetected': 'لم يُكتشف',
  'settings.localModel.deviceCapability.disabledLowercase': 'معطل',
  'settings.localModel.deviceCapability.presetDetails':
    'الدردشة: {chatModel} · الرؤية: {visionModel} · ذاكرة الوصول العشوائي المستهدفة: {targetRamGb} جيجابايت',
  'settings.localModel.deviceCapability.ram': 'RAM',
  'settings.localModel.deviceCapability.recommended': 'موصى به',
  'settings.localModel.deviceCapability.retryInstall': 'جارٍ إعادة المحاولة…',
  'settings.localModel.deviceCapability.retrying': 'جارٍ إعادة المحاولة…',
  'settings.localModel.deviceCapability.starting': 'جارٍ البدء…',
  'settings.localModel.download.audioPathPlaceholder': 'المسار المطلق لملف الصوت',
  'settings.localModel.download.capabilityChat': 'الدردشة',
  'settings.localModel.download.capabilityEmbedding': 'التضمين',
  'settings.localModel.download.capabilityAssets': 'أصول الإمكانات',
  'settings.localModel.download.capabilityStt': 'STT',
  'settings.localModel.download.capabilityTts': 'TTS',
  'settings.localModel.download.capabilityVision': 'الرؤية',
  'settings.localModel.download.downloading': 'جارٍ التنزيل...',
  'settings.localModel.download.embeddingDimensions': 'الأبعاد: {dimensions}',
  'settings.localModel.download.embeddingModel': 'الموديل: {modelId}',
  'settings.localModel.download.embeddingPlaceholder': 'سلسلة إدخال واحدة في كل سطر...',
  'settings.localModel.download.embeddingVectors': 'المتجهات: {count}',
  'settings.localModel.download.noThinkMode': 'بدون وضع التفكير',
  'settings.localModel.download.notAvailable': 'غير متوفر',
  'settings.localModel.download.promptPlaceholder': 'اكتب أي طلب وشغّله على النموذج المحلي...',
  'settings.localModel.download.quantizationPref': 'تفضيل التكميم',
  'settings.localModel.download.runEmbeddingTest': 'جارٍ التشغيل...',
  'settings.localModel.download.runPromptTest': 'تشغيل اختبار المُوجِّه',
  'settings.localModel.download.runSummaryTest': 'تشغيل اختبار الملخص',
  'settings.localModel.download.runTranscriptionTest': 'جارٍ التشغيل...',
  'settings.localModel.download.runTtsTest': 'جارٍ التشغيل...',
  'settings.localModel.download.runVisionTest': 'جارٍ التشغيل...',
  'settings.localModel.download.running': 'جارٍ التشغيل...',
  'settings.localModel.download.runningPrompt': 'جارٍ تشغيل الطلب',
  'settings.localModel.download.summaryHelper':
    'يستدعي `openhuman.inference_summarize` عبر Rust core',
  'settings.localModel.download.summarizePlaceholder': 'الصق النص لتلخيصه بالنموذج المحلي...',
  'settings.localModel.download.testCustomPrompt': 'اختبار طلب مخصص',
  'settings.localModel.download.testEmbeddings': 'اختبار التضمينات',
  'settings.localModel.download.testSummarization': 'اختبار التلخيص',
  'settings.localModel.download.testVisionPrompt': 'اختبار طلب الرؤية',
  'settings.localModel.download.testVoiceInput': 'اختبار إدخال الصوت (STT)',
  'settings.localModel.download.testVoiceOutput': 'اختبار إخراج الصوت (TTS)',
  'settings.localModel.download.transcript': 'النص:',
  'settings.localModel.download.ttsOutput': 'الإخراج: {outputPath}',
  'settings.localModel.download.ttsOutputPlaceholder': 'مسار WAV للإخراج (اختياري)',
  'settings.localModel.download.ttsPlaceholder': 'أدخل النص للتحويل إلى كلام...',
  'settings.localModel.download.ttsVoice': 'الصوت: {voiceId}',
  'settings.localModel.download.visionImagePlaceholder':
    'مرجع صورة واحد في كل سطر (URI للبيانات أو URL أو مسار محلي)',
  'settings.localModel.download.visionPromptPlaceholder': 'أدخل طلبًا لنموذج الرؤية...',
  'settings.localModel.status.allChecksPassed': 'اجتازت جميع الفحوصات',
  'settings.localModel.status.artifact': 'المنتج',
  'settings.localModel.status.backend': 'الخلفية',
  'settings.localModel.status.binary': 'الملف الثنائي',
  'settings.localModel.status.bootstrapResume': 'تمهيد / استئناف',
  'settings.localModel.status.checking': 'جارٍ التحقق...',
  'settings.localModel.status.checkingOllama': 'جارٍ التحقق من Ollama',
  'settings.localModel.status.contextBelowMinimumBadge':
    '{contextLength} ctx - أقل من {required} دقيقة',
  'settings.localModel.status.contextBelowMinimumTitle':
    'مرفوض: الرموز المميزة لنافذة السياق {contextLength} أقل من الحد الأدنى للرمز المميز {required} الذي تتطلبه طبقة الذاكرة. سيتم إتلاف الاستدعاء عن طريق الاقتطاع الصامت.',
  'settings.localModel.status.contextOkBadge': '{contextLength} ctx ✓',
  'settings.localModel.status.contextOkTitle':
    'تتوافق الرموز المميزة لنافذة السياق {contextLength} مع الحد الأدنى لطبقة الذاكرة وهو {required} من الرموز المميزة.',
  'settings.localModel.status.contextUnknownBadge': 'ctx غير معروف',
  'settings.localModel.status.contextUnknownTitle':
    'نافذة السياق غير معروفة؛ لا يمكن التأكد من أنه يلبي الحد الأدنى لطبقة الذاكرة {required}-token.',
  'settings.localModel.status.customLocation': 'موقع مخصص',
  'settings.localModel.status.customLocationDesc': 'وصف الموقع المخصص',
  'settings.localModel.status.diagnosticsHint':
    'انقر "تشغيل التشخيصات" للتحقق من أن Ollama يعمل وأن النماذج مثبتة.',
  'settings.localModel.status.downloadingUnknown': 'جارٍ التنزيل (الحجم غير معروف)',
  'settings.localModel.status.eta': 'الوقت المتوقع',
  'settings.localModel.status.expectedModels': 'النماذج المتوقعة',
  'settings.localModel.status.expectedChat': 'الدردشة: {model}',
  'settings.localModel.status.expectedEmbedding': 'التضمين: {model}',
  'settings.localModel.status.expectedVision': 'الرؤية: {model}',
  'settings.localModel.status.externalProcess': 'العملية الخارجية',
  'settings.localModel.status.forceRebootstrap': 'فرض إعادة التهيئة',
  'settings.localModel.status.generationTps': 'سرعة التوليد TPS',
  'settings.localModel.status.hideErrorDetails': 'إخفاء تفاصيل الخطأ',
  'settings.localModel.status.installManually': 'تثبيت يدوي',
  'settings.localModel.status.installManuallyFrom': 'تثبيت يدوي من',
  'settings.localModel.status.installOllama': 'جارٍ البدء…',
  'settings.localModel.status.installedModels': 'النماذج المثبّتة',
  'settings.localModel.status.installing': 'جارٍ التثبيت...',
  'settings.localModel.status.installingOllama': 'جارٍ تثبيت بيئة Ollama...',
  'settings.localModel.status.issues': 'المشكلات',
  'settings.localModel.status.issuesFound': 'تم العثور على {count} مشكلة',
  'settings.localModel.status.lastLatency': 'آخر زمن استجابة',
  'settings.localModel.status.model': 'النموذج',
  'settings.localModel.status.notAvailable': 'غير متوفر',
  'settings.localModel.status.notFound': 'غير موجود',
  'settings.localModel.status.notRunning': 'غير قيد التشغيل',
  'settings.localModel.status.ollamaBinaryPath': 'مسار ملف Ollama الثنائي',
  'localModel.ollamaServer.helperText': 'مثال: http://192.168.1.5:11434',
  'localModel.ollamaServer.label': 'عنوان URL لخادم Ollama',
  'localModel.ollamaServer.modelCount': 'نماذج',
  'localModel.ollamaServer.placeholder': 'http://localhost:11434',
  'localModel.ollamaServer.reachable': 'قابل للوصول',
  'localModel.ollamaServer.resetButton': 'إعادة التعيين إلى الافتراضي',
  'localModel.ollamaServer.saveButton': 'حفظ',
  'localModel.ollamaServer.testButton': 'اختبار الاتصال',
  'localModel.ollamaServer.unreachable': 'غير قابل للوصول',
  'localModel.ollamaServer.validationError':
    'يجب أن يكون عنوان URL صالحاً يبدأ بـ http:// أو https://',
  'settings.localModel.status.ollamaDiagnostics': 'تشخيص Ollama',
  'settings.localModel.status.ollamaNotInstalled': 'وقت تشغيل Ollama غير متاح',
  'settings.localModel.status.ollamaNotInstalledDesc':
    'يعامل OpenHuman الآن Ollama كوقت تشغيل استدلال خارجي. شغّل خادم Ollama الخاص بك، وحمّل النماذج التي تريدها، ووجّه توجيه الأحمال إليه.',
  'settings.localModel.status.progress': 'التقدم',
  'settings.localModel.status.provider': 'المزود',
  'settings.localModel.status.retryBootstrap': 'إعادة محاولة التمهيد',
  'settings.localModel.status.runDiagnostics': 'جارٍ التحقق...',
  'settings.localModel.status.running': 'يعمل',
  'settings.localModel.status.runningExternalProcess': 'يعمل عبر عملية خارجية',
  'settings.localModel.status.runtimeStatus': 'حالة بيئة التشغيل',
  'settings.localModel.status.server': 'الخادم',
  'settings.localModel.status.setPath': 'جارٍ الضبط...',
  'settings.localModel.status.setting': 'جارٍ الضبط...',
  'settings.localModel.status.showErrorDetails': 'إخفاء تفاصيل الخطأ',
  'settings.localModel.status.showInstallErrorDetails': 'إخفاء تفاصيل الخطأ',
  'settings.localModel.status.suggestedFixes': 'الإصلاحات المقترحة',
  'settings.localModel.status.thenSetPath': 'ثم اضبط المسار',
  'settings.localModel.status.triggering': 'جارٍ التشغيل...',
  'settings.localModel.status.unavailable': 'غير متاح',
  'settings.localModel.status.working': 'جارٍ العمل...',
  'settings.developerMenu.ai.title': 'إعدادات الذكاء الاصطناعي',
  'settings.developerMenu.ai.desc': 'مزودو السحابة، ونماذج Ollama المحلية، والتوجيه لكل عبء عمل',
  'settings.developerMenu.messagingChannels.title': 'قنوات المراسلة',
  'settings.developerMenu.messagingChannels.desc':
    'تكوين أوضاع مصادقة Telegram/Discord وتوجيه القناة الافتراضي',
  'settings.developerMenu.tools.title': 'الأدوات',
  'settings.developerMenu.tools.desc':
    'تفعيل أو تعطيل الإمكانات التي يمكن لـ OpenHuman استخدامها نيابةً عنك',
  'settings.developerMenu.agentChat.title': 'دردشة الوكيل',
  'settings.developerMenu.agentChat.desc': 'اختبار محادثة الوكيل مع تجاوزات النموذج ودرجة الحرارة',
  'settings.developerMenu.devWorkflow.title': 'سير عمل المطور',
  'settings.developerMenu.devWorkflow.desc':
    'عميلة ذاتية تلتقط مشاكلك في الاكسكسكساكس وتثير العلاقات العامة في الجدول الزمني',
  'settings.developerMenu.devWorkflow.panelDesc':
    'نؤمن بعميل مطور مستقل يلتقط القضايا التي تخصك و يجلب طلبات سحب تلقائياً على جدول زمني',
  'settings.developerMenu.skillsRunner.title': 'سكايل رانر',
  'settings.developerMenu.skillsRunner.desc':
    'تشغيل أي مهارة معبأة - ملء مدخلاته وإطلاق النار على خلفية مستقلة',
  'settings.developerMenu.skillsRunner.panelDesc':
    'اختر مهارة معبأة، واملأ مدخلاتها المعلنة، وأطلق النار ونبات الخلفية. استخدم (ديف) بدلاً من ذلك إذا أردت وظيفة متكررة',
  'settings.skillsRunner.skill': 'Skill',
  'settings.skillsRunner.selectSkill': 'اختيار مهارة...',
  'settings.skillsRunner.loadingSkills': 'مهارات التعبئة',
  'settings.skillsRunner.loadingDescription': 'مُدخلات مهارة التعبئة...',
  'settings.skillsRunner.noInputs': 'هذه المهارة لا تعلن أي مدخلات',
  'settings.skillsRunner.placeholder.required': 'required',
  'settings.skillsRunner.runNow': 'اركض الآن',
  'settings.skillsRunner.starting': 'بدء...',
  'settings.skillsRunner.started': 'بدأت...',
  'settings.skillsRunner.logPath': 'لوغ:',
  'settings.skillsRunner.error.listSkills': 'فشل في تحميل المهارات:',
  'settings.skillsRunner.error.describe': 'عدم تحميل المدخلات:',
  'settings.skillsRunner.error.missingRequired': 'المفقود يتطلب مدخلات (مساهمات):',
  'settings.skillsRunner.error.run': 'لم يبدأ التشغيل:',
  'settings.skillsRunner.error.preflightGate': 'البوابة الأمامية فشلت',
  'settings.skillsRunner.error.runtimeUnavailable': 'وقت التشغيل غير متاح',
  'settings.skillsRunner.error.runtimeUnavailableDefault': 'غير متاح',
  'settings.skillsRunner.schedule.heading': 'الجدول (المتكرر)',
  'settings.skillsRunner.schedule.help':
    'وفر هذه المهارة + المدخلات كعمل كرتوني متكرر. العميل سيتصل بـ "هريب" في كل مرة',
  'settings.skillsRunner.schedule.frequency': 'التردد',
  'settings.skillsRunner.schedule.every30min': 'كل 30 دقيقة',
  'settings.skillsRunner.schedule.everyHour': 'كل ساعة',
  'settings.skillsRunner.schedule.every2hours': 'كل ساعتين',
  'settings.skillsRunner.schedule.every6hours': 'كل 6 ساعات',
  'settings.skillsRunner.schedule.onceDaily': 'يوم واحد (9:00)',
  'settings.skillsRunner.schedule.save': 'الجدول الزمني',
  'settings.skillsRunner.schedule.saving': 'إنقاذ...',
  'settings.skillsRunner.schedule.saved': 'تم حفظ الجدول.',
  'settings.skillsRunner.schedule.error': 'فشل الجدول الزمني:',
  'settings.skillsRunner.schedule.loadingJobs': 'وضع الجداول الحالية...',
  'settings.skillsRunner.schedule.noJobs': 'لم يتم توفير جداول لهذه المهارة بعد',
  'settings.skillsRunner.schedule.existing': 'الوظائف المقررة لهذه المهارة:',
  'settings.skillsRunner.schedule.inputsLabel': 'المدخلات',
  'settings.skillsRunner.schedule.inputsNone': 'لا مدخلات',
  'settings.skillsRunner.schedule.runNow': 'اركض',
  'settings.skillsRunner.schedule.remove': 'إزالة الألغام',
  'settings.skillsRunner.scheduleEnabled': 'Enabled',
  'settings.skillsRunner.scheduleDisabled': 'مدفوع',
  'settings.skillsRunner.scheduleToggleAria': 'الجدول الزمني الميسر',
  'settings.skillsRunner.schedule.history': 'التاريخ',
  'settings.skillsRunner.schedule.historyLoading': 'تاريخ الحب...',
  'settings.skillsRunner.schedule.historyEmpty': 'لا ركض حتى الآن لهذا الجدول الزمني',
  'settings.skillsRunner.schedule.historyNoOutput': 'لم يسجل أي ناتج',
  'settings.skillsRunner.schedule.active': 'النشاط',
  'settings.skillsRunner.schedule.lastRunLabel': 'الأخير:',
  'settings.skillsRunner.recentRuns.headingForSkill': 'عمليات حديثة لهذه المهارة',
  'settings.skillsRunner.recentRuns.headingAll': 'المهارة الأخيرة (جميعها)',
  'settings.skillsRunner.recentRuns.refresh': 'التجديد',
  'settings.skillsRunner.recentRuns.loading': '....',
  'settings.skillsRunner.recentRuns.empty': 'لا عمليات حديثة',
  'settings.skillsRunner.viewer.loading': 'سجل الشحن...',
  'settings.skillsRunner.viewer.tailing': 'يحيا الذيل',
  'settings.skillsRunner.viewer.fetching': 'جلب',
  'settings.skillsRunner.viewer.error': 'يُستعاض عن العنوان بالفشل:',
  'settings.skillsRunner.repoPicker.loading': 'مستودعات التعبئة...',
  'settings.skillsRunner.repoPicker.select': 'اختيار مستودع...',
  'settings.skillsRunner.repoPicker.empty':
    'لم تُعاد أي مستودعات Connect GitHub via xqx1x to populate this list.',
  'settings.skillsRunner.repoPicker.notConnected':
    'GitHub غير متصل عبر Composio. قم بتوصيله من خلال المهارات ← Composio أولًا.',
  'settings.skillsRunner.repoPicker.privateTag': '(خاص)',
  'settings.skillsRunner.branchPicker.needRepo': 'اختر مذكرة أولاً',
  'settings.skillsRunner.branchPicker.loading': 'فروع التعبئة...',
  'settings.skillsRunner.branchPicker.select': 'اختيار فرع...',
  'settings.devWorkflow.githubRepository': 'مخزن Xqx0xx',
  'settings.devWorkflow.loadingRepositories': 'مستودعات التعبئة...',
  'settings.devWorkflow.selectRepository': 'اختيار مستودع',
  'settings.devWorkflow.privateTag': '(خاص)',
  'settings.devWorkflow.detectingForkInfo': 'كشف المعلومات الشوكية',
  'settings.devWorkflow.forkDetected': 'الشوكة المكتشفة',
  'settings.devWorkflow.upstream': 'أعلى النهر:',
  'settings.devWorkflow.forkPrNote': 'وستُرفع معدلات الحد من الفقر ضد مستودع ما بعد الإنتاج.',
  'settings.devWorkflow.notForkNote': 'ليس شوكة وستُثار أسعار الصرف ضد هذا المستودع مباشرة.',
  'settings.devWorkflow.targetBranch': 'الفرع المستهدف',
  'settings.devWorkflow.targetBranchNote': 'ستُرفع أسعار الصرف ضد هذا الفرع',
  'settings.devWorkflow.loadingBranches': 'فروع التعبئة...',
  'settings.devWorkflow.runFrequency': 'تشغيل التردد',
  'settings.devWorkflow.runFrequencyNote':
    'كم من الأحيان يجب على الوكيل أن يفحص القضايا ويرفع الحد من الفقر',
  'settings.devWorkflow.updateConfiguration': 'تحديث النظام',
  'settings.devWorkflow.saveConfiguration': 'إنقاذ المفاوضة',
  'settings.devWorkflow.remove': 'إزالة الألغام',
  'settings.devWorkflow.saved': 'منقذة',
  'settings.devWorkflow.activeConfiguration': 'الاتحاد النشط',
  'settings.devWorkflow.activeConfigRepository': 'مستودع:',
  'settings.devWorkflow.activeConfigUpstream': 'أعلى النهر:',
  'settings.devWorkflow.activeConfigTargetBranch': 'الفرع المستهدف:',
  'settings.devWorkflow.activeConfigSchedule': 'الجدول الزمني:',
  'settings.devWorkflow.enabled': 'Enabled',
  'settings.devWorkflow.paused': 'مدفوع',
  'settings.devWorkflow.nextRun': 'الجولة التالية',
  'settings.devWorkflow.lastRun': 'آخر مرة',
  'settings.devWorkflow.runNow': 'اركض الآن',
  'settings.devWorkflow.running': 'تشغيل...',
  'settings.devWorkflow.recentRuns': 'عمليات حديثة',
  'settings.devWorkflow.cronSaveError': 'فشل في توفير التشكيلة',
  'settings.devWorkflow.lastOutput': 'الناتج الأخير',
  'settings.devWorkflow.noOutput': 'لم يسجل أي ناتج',
  'settings.devWorkflow.runningStatus': 'الوكيل يَرْكضُ - يَلتقطُ a مشكلة ويَعْملُ على a إصلاح...',
  'settings.devWorkflow.errorNotConnected':
    'اكساكسوكس ليس متصلاً يرجى ربط Xqx1xx عبر ستينغز تقدمت أولاً',
  'settings.devWorkflow.errorToolNotEnabled':
    'أداة (إكسكساكس) غير مُمكّنة من هذه المساندة. أرجو أن تطلبوا من أمينكم أن يسمح بذلك في دمج الـ (إكسكس 1 xx) (النسخة رقم 842).',
  'settings.devWorkflow.errorNotAuthenticated': 'غير موثق يرجى التوقيع في البداية.',
  'settings.devWorkflow.errorNoRepositories': 'لا توجد مستودعات لهذا الحساب',
  'settings.devWorkflow.schedule.every30min': 'كل 30 دقيقة',
  'settings.devWorkflow.schedule.everyHour': 'كل ساعة',
  'settings.devWorkflow.schedule.every2hours': 'كل ساعتين',
  'settings.devWorkflow.schedule.every6hours': 'كل 6 ساعات',
  'settings.devWorkflow.schedule.onceDaily': 'يوم واحد (9 صباحا)',
  'settings.developerMenu.tasks.title': 'المهام',
  'settings.developerMenu.tasks.desc':
    'تصفّح لوحات المهام وإدارتها: مهامك الخاصة إضافةً إلى اللوحات التي تنشئها الوكلاء عبر المحادثات.',
  'settings.developerMenu.cronJobs.title': 'مهام Cron',
  'settings.developerMenu.cronJobs.desc': 'عرض وتكوين المهام المجدولة لمهارات وقت التشغيل',
  'settings.developerMenu.localModelDebug.title': 'تصحيح النموذج المحلي',
  'settings.developerMenu.localModelDebug.desc':
    'إعدادات Ollama، وتنزيلات الأصول، واختبارات النموذج، والتشخيصات',
  'settings.developerMenu.webhooks.title': 'خطافات الويب',
  'settings.developerMenu.webhooks.desc':
    'فحص تسجيلات خطافات الويب وقت التشغيل وسجلات الطلبات الملتقطة',
  'settings.developerMenu.eventLog.title': 'الحدث',
  'settings.developerMenu.eventLog.desc':
    'تيار ملون مباشر لجميع العناصر والأدوات والأحداث النظامية',
  'settings.developerMenu.eventLog.allTypes': 'جميع الأنواع',
  'settings.developerMenu.eventLog.filterAgent': '(فيلتر)',
  'settings.developerMenu.eventLog.download': 'تحميل',
  'settings.developerMenu.eventLog.events': 'أحداث',
  'settings.developerMenu.eventLog.live': 'الحياة',
  'settings.developerMenu.eventLog.disconnected': 'مفصولة',
  'settings.developerMenu.eventLog.waiting': 'ننتظر الأحداث...',
  'settings.developerMenu.eventLog.notConnected': 'غير متصل بالنواة',
  'settings.developerMenu.eventLog.jumpToLatest': 'اقفز على آخر',
  'settings.developerMenu.eventLog.badge.tool': 'TOOL',
  'settings.developerMenu.eventLog.badge.agent': 'AGENT',
  'settings.developerMenu.eventLog.badge.info': 'INFO',
  'settings.developerMenu.eventLog.badge.mem': 'MEM',
  'settings.developerMenu.eventLog.badge.chan': 'CHAN',
  'settings.developerMenu.eventLog.badge.cron': 'CRON',
  'settings.developerMenu.eventLog.badge.hook': 'HOOK',
  'settings.developerMenu.eventLog.badge.warn': 'WARN',
  'settings.developerMenu.eventLog.badge.skill': 'SKILL',
  'settings.developerMenu.eventLog.badge.comp': 'COMP',
  'settings.developerMenu.eventLog.badge.mcp': 'MCP',
  'settings.developerMenu.intelligence.title': 'الذكاء',
  'settings.developerMenu.intelligence.desc':
    'مساحة عمل الذاكرة، ومحرك اللاوعي، والأحلام، والإعدادات',
  'settings.developerMenu.notificationRouting.title': 'توجيه الإشعارات',
  'settings.developerMenu.notificationRouting.desc':
    'تقييم الأهمية بالذكاء الاصطناعي وتصعيد المنسق لتنبيهات التكامل',
  'settings.developerMenu.composeioTriggers.title': 'مشغلات ComposeIO',
  'settings.developerMenu.composeioTriggers.desc': 'عرض سجل مشغلات ComposeIO والأرشيف',
  'settings.developerMenu.composioRouting.title': 'توجيه Composio (الوضع المباشر)',
  'settings.developerMenu.composioRouting.desc':
    'استخدم مفتاح Composio API الخاص بك ووجّه الاستدعاءات مباشرةً إلى backend.composio.dev',
  'settings.developerMenu.integrationTriggers.title': 'مشغلات التكامل',
  'settings.developerMenu.integrationTriggers.desc':
    'تكوين إعدادات فرز الذكاء الاصطناعي لمشغلات تكامل Composio',
  'settings.developerMenu.mcpServer.title': 'MCP الخادم',
  'settings.developerMenu.mcpServer.desc': 'تكوين عملاء MCP الخارجيين للاتصال بـ OpenHuman',
  'settings.developerMenu.autonomy.title': 'استقلالية الوكيل',
  'settings.developerMenu.autonomy.desc': 'حدود معدل إجراءات الأدوات وعتبات الأمان',
  'settings.developerMenu.voiceDebug.title': 'الصوت (تصحيح)',
  'settings.developerMenu.voiceDebug.desc': 'حالة وقت التشغيل لإملاء الصوت وإعدادات التصحيح',
  'settings.mcpServer.title': 'Xqx0x',
  'settings.mcpServer.toolsSectionTitle': 'الأدوات المتاحة',
  'settings.mcpServer.toolsSectionDesc':
    'الأدوات التي يتم كشفها عبر خادم MCP stdio عند تشغيل mcp openhuman-core',
  'settings.mcpServer.configSectionTitle': 'تكوين العميل',
  'settings.mcpServer.configSectionDesc': 'حدد عميل MCP الخاص بك لإنشاء مقتطف التكوين الصحيح',
  'settings.mcpServer.copySnippet': 'انسخ إلى الحافظة',
  'settings.mcpServer.copied': 'تم النسخ!',
  'settings.mcpServer.openConfigFile': 'فتح ملف التكوين',
  'settings.mcpServer.binaryPathNotFound':
    'OpenHuman لم يتم العثور على الثنائي. في حالة التشغيل من المصدر، قم بالإنشاء باستخدام: cargo build --bin openhuman-core',
  'settings.mcpServer.openConfigError': 'فشل في فتح ملف التكوين',
  'settings.mcpServer.clientClaudeDesktop': 'Claude Desktop',
  'settings.mcpServer.clientCursor': 'المؤشر',
  'settings.mcpServer.clientCodex': 'Codex',
  'settings.mcpServer.clientZed': 'Zed',
  'settings.mcpServer.configFilePath': 'ملف التكوين',
  'settings.mcpServer.clientSelectorAriaLabel': 'MCP محدد العميل',
  'settings.appearance.menuDesc': 'اختر الفاتح أو الداكن أو مطابقة سمة النظام',
  'settings.agentAccess.title': 'الوكيل OS وصول',
  'settings.agentAccess.menuDesc': 'التحكم في المكان الذي يمكن فيه للوكيل أن يستخدم القذيفة',
  'settings.agentAccess.loadError': 'فشل في تحديد مواقع الدخول',
  'settings.agentAccess.saveError': 'عدم توفير أماكن الوصول',
  'settings.agentAccess.saved': 'منقذ - ينطبق على رسالتك القادمة.',
  'settings.agentAccess.desktopOnly': 'ولا توجد أماكن الوصول إلا في التطبيق المكتبي.',
  'settings.agentAccess.loading': 'التعبئة...',
  'settings.agentAccess.accessMode': 'طريقة الوصول',
  'settings.agentAccess.tier.readonly.title': 'القراءة فقط',
  'settings.agentAccess.tier.readonly.desc':
    'ويقرأ الملفات ويدير الأوامر فقط للاستكشاف - ولكن لا يكتب أبدا، أو يحرر، أو يدير أي شيء يغير الدولة.',
  'settings.agentAccess.tier.supervised.title': 'اسأل قبل التحرير',
  'settings.agentAccess.tier.supervised.desc':
    'يخلق ملفات جديدة بحرية، ولكن يطلب موافقتك قبل تحرير ملف قائم، إدارة القيادة، الوصول إلى الشبكة، أو تركيب أي شيء.',
  'settings.agentAccess.tier.full.title': 'الوصول الكامل',
  'settings.agentAccess.tier.full.desc':
    'ويدير أوامره بوصول حسابك الكامل للمستعملين - ويمكنه أن يكون مكعبا في أي مكان مسموح به، باستثناء مخازن الإبداع والنظام. الأوامر المدمرة، الوصول إلى الشبكة، والتركات لا تزال تطلب الموافقة.',
  'settings.agentAccess.defaultTag': '(عجز)',
  'settings.agentAccess.fullWarning':
    'الدخول الكامل يُديرُ الأوامرَ بوصولِ حسابِكَ الكاملِ وهو لَيسَ مُربّطَ رملَ. فقط قم بتمكينها عندما تضغطين على العميل بهذه الآلة ولا تزال الأدلة الإبداعية والنظامية مجمدة، وما زالت أعمال التدمير والشبكات والتركيب تتطلب الموافقة.',
  'settings.agentAccess.confine.label': 'مقصورة على مكان العمل',
  'settings.agentAccess.confine.desc':
    'قيّد الوكيل بدليل مساحة العمل (بالإضافة إلى أي مجلدات ممنوحة)، بصرف النظر عن وضع الوصول المحدد. عند إيقاف التشغيل، يمكنه الوصول إلى أي مكان يمكن لمستخدمك الوصول إليه، باستثناء أدلة بيانات الاعتماد والنظام المحظورة دائمًا.',
  'settings.agentAccess.requireTaskPlanApproval.label': 'الموافقة على خطة العمل المطلوبة',
  'settings.agentAccess.requireTaskPlanApproval.desc':
    'وقف أمام عميل معين يقوم بتنفيذ موجز عمل مشرف على عميل',
  'settings.agentAccess.autoApproveAll.label': 'الموافقة التلقائية على جميع الإجراءات',
  'settings.agentAccess.autoApproveAll.desc':
    'عند التفعيل، سينفذ الوكيل جميع الإجراءات المؤهلة دون طلب موافقتك أولاً. يشمل ذلك كتابة الملفات وتنفيذ أوامر الطرفية وطلبات الشبكة وأي تأثيرات جانبية أخرى. تظل الحواجز الأمنية الصارمة، مثل أدلة بيانات الاعتماد والأدلة النظامية، سارية المفعول، ولا تتم الموافقة التلقائية أبداً على الإجراءات ذات المصدر غير الموثوق أو غير المعروف.',
  'settings.agentAccess.tinyplaceAutopilot.title': 'وكيل tiny.place المستقل',
  'settings.agentAccess.tinyplaceAutopilot.desc':
    'دع OpenHuman يتصرف على tiny.place بمفرده. وفق جدول زمني، يبحث عن عمل مجدٍ (المكافآت المفتوحة أولًا)، وينجز ما يناسب مهاراته ويتصرف من هويتك. يعمل دون إشراف ويمكنه الإنفاق، لذا أبقِه على devnet أثناء الاختبار. معطّل افتراضيًا.',
  'settings.agentAccess.tinyplaceAutopilot.label': 'التشغيل تلقائيًا',
  'settings.agentAccess.timeout.label': 'مهلة الإجراء',
  'settings.agentAccess.timeout.desc':
    'المدة التي يُسمح خلالها بتشغيل أداة أو إجراء واحد قبل إلغائه. زِد هذه القيمة إذا كان نموذج محلي كبير يُقاطَع قبل أن ينهي رده.',
  'settings.agentAccess.timeout.unit': 'ثوانٍ',
  'settings.agentAccess.timeout.invalid': 'أدخل عدداً صحيحاً من الثواني ضمن النطاق المسموح به',
  'settings.agentAccess.timeout.envOverride':
    'متغير البيئة OPENHUMAN_TOOL_TIMEOUT_SECS يتجاوز هذا الإعداد، لذا لن يكون للتغييرات هنا أي تأثير حتى يتم إلغاء ضبطه.',
  'settings.agentAccess.grantedFolders': 'الملفات الممنوحة',
  'settings.agentAccess.alwaysAllow': 'الأدوات المتدنية دائما',
  'settings.agentAccess.alwaysAllowDesc':
    'الأدوات التي وضعت علامة "الطرق تسمح" في الدردشة دون أن تسأل. أزيلي واحدة ليتم دفعها مجدداً',
  'settings.agentAccess.alwaysAllowNone': 'لا أدوات متدنية دائماً حتى الآن',
  'settings.agentAccess.grantedDesc':
    'يُرجى من العميل القراءة والكتابة، بالإضافة إلى مكان العمل. وتُحجب دائماً المخازن الإبداعية (Assh و///.gnupg و/.aws, keychains) ودليل النظام (/etc, /System, C:/ xqx0xx,...) حتى داخل ملف مُنح.',
  'settings.agentAccess.noneGranted': 'لم تُمنح الملفات',
  'settings.agentAccess.readWrite': 'يصبح نصها كما يلي:',
  'settings.agentAccess.readOnly': 'القراءة فقط',
  'settings.agentAccess.remove': 'إزالة الألغام',
  'settings.agentAccess.pathPlaceholder': 'المسار المطلق للمجلد',
  'settings.agentAccess.accessLevelLabel': 'مستوى الوصول',
  'settings.agentAccess.add': 'مضاف',
  'settings.agentAccess.saving': 'إنقاذ...',
  'settings.agentAccess.changesApply': 'التغييرات تنطبق على رسالتك القادمة',
  'settings.agentAccess.directories': 'الأدلّة',
  'settings.agentAccess.actionSandbox': 'صندوق الإجراءات',
  'settings.agentAccess.readWriteAccess': 'قراءة + كتابة',
  'settings.agentAccess.actionSandboxDesc': 'دليل العمل الافتراضي لأدوات الطرفية والملفات وgit.',
  'settings.agentAccess.actionDir.edit': 'تعديل',
  'settings.agentAccess.actionDir.save': 'حفظ',
  'settings.agentAccess.actionDir.cancel': 'إلغاء',
  'settings.agentAccess.actionDir.placeholder': 'مسار مطلق، مثل /Users/you/Projects',
  'settings.agentAccess.actionDir.envLocked':
    'محدد بواسطة OPENHUMAN_ACTION_DIR. غيّر متغير البيئة للتجاوز.',
  'settings.agentAccess.actionDir.saved': 'تم تحديث دليل الإجراءات.',
  'settings.agentAccess.internalState': 'الحالة الداخلية',
  'settings.agentAccess.agentBlocked': 'محظور على الوكيل',
  'settings.agentAccess.internalStateDesc':
    'قواعد بيانات الذاكرة والجلسات والرموز وغيرها من البيانات الأساسية. غير متاحة لأدوات الوكيل.',
  'settings.agentAccess.actionDirInputLabel': 'مسار صندوق إجراءات الوكيل',
  'settings.agentAccess.actionDirSave': 'حفظ',
  'settings.agentAccess.actionDirSaving': 'جارٍ الحفظ…',
  'settings.agentAccess.actionDirSaved': 'تم تحديث صندوق الإجراءات.',
  'settings.agentAccess.actionDirEmptyError': 'لا يمكن أن يكون المسار فارغًا.',
  'settings.agentAccess.actionDirSaveError': 'تعذّر تحديث صندوق الإجراءات.',
  'settings.agentAccess.actionDirEnvOverrideError':
    'تم ضبط OPENHUMAN_ACTION_DIR: قم بإلغاء متغير البيئة لتعديل هذا من الإعدادات.',
  'settings.agentAccess.actionDirEnvOverrideNote':
    'تم تجاوزه بواسطة OPENHUMAN_ACTION_DIR: قم بإلغاء متغير البيئة لإدارته من الإعدادات.',
  'settings.agentAccess.approvalHistory': 'سجل الموافقات',
  'settings.agentAccess.approvalHistoryDesc':
    'مراجعة قرارات الموافقة / الرفض السابقة التي طلبها الوكيل.',
  'settings.agentAccess.viewApprovalHistory': 'عرض سجل الموافقات',

  // ── لوحة الأذونات ────────────────────────────────────────────────
  'settings.permissions.title': 'الأذونات',
  'settings.permissions.menuDesc': 'اختر ما يمكن للمساعد فعله والمكان الذي يمكنه العمل فيه.',
  'settings.permissions.accessMode': 'ماذا يمكن للمساعد أن يفعل؟',
  'settings.permissions.accessModeDesc':
    'اختر مقدار الحرية التي يتمتع بها المساعد عند اتخاذ الإجراءات على جهاز الكمبيوتر الخاص بك.',
  'settings.permissions.preset.readonly.title': 'انظر ولا تلمس',
  'settings.permissions.preset.readonly.desc':
    'يمكن للمساعد قراءة الملفات والاستكشاف، لكنه لن يكتب أو يعدّل أو يُشغّل أي شيء يغير الحالة.',
  'settings.permissions.preset.supervised.title': 'اسألني أولاً',
  'settings.permissions.preset.supervised.desc':
    'يمكنه إنشاء ملفات جديدة بحرية، لكنه يطلب موافقتك دائمًا قبل التعديل أو تشغيل الأوامر أو الوصول إلى الشبكة.',
  'settings.permissions.preset.full.title': 'تحكم كامل',
  'settings.permissions.preset.full.desc':
    'يعمل بصلاحيات حسابك الكاملة. الأوامر المدمرة والوصول إلى الشبكة والتثبيت لا تزال تطلب الموافقة.',
  'settings.permissions.folders': 'أين يمكنه العمل؟',
  'settings.permissions.foldersDesc':
    'المجلد الافتراضي الذي يقرأ ويكتب فيه المساعد. يمكنك إضافة مجلدات أخرى في الإعدادات المتقدمة.',

  'settings.meetings.title': 'الاجتماعات',
  'settings.meetings.menuDesc': 'انضمام تلقائي وملخصات ونصوص لمساعد الاجتماعات',
  'settings.meetings.desktopOnly': 'إعدادات الاجتماعات متاحة على سطح المكتب فقط.',
  'settings.meetings.loading': 'جارٍ التحميل…',
  'settings.meetings.loadError': 'فشل تحميل إعدادات الاجتماعات.',
  'settings.meetings.saveError': 'فشل حفظ إعدادات الاجتماعات.',
  'settings.meetings.saved': 'تم الحفظ',
  'settings.meetings.saving': 'جارٍ الحفظ…',
  'settings.meetings.autoJoin.title': 'سياسة الانضمام التلقائي',
  'settings.meetings.autoJoin.desc': 'عند وجود رابط Google Meet في حدث التقويم',
  'settings.meetings.autoJoin.askEachTime': 'اسأل كل مرة',
  'settings.meetings.autoJoin.always': 'الانضمام دائماً',
  'settings.meetings.autoJoin.never': 'عدم الانضمام أبداً',
  'settings.meetings.autoSummarize.title': 'ملخص بعد المكالمة',
  'settings.meetings.autoSummarize.desc': 'إنشاء ملخص بعد انتهاء المكالمة',
  'settings.meetings.autoSummarize.ask': 'اسأل بعد المكالمة',
  'settings.meetings.autoSummarize.always': 'تلخيص دائماً',
  'settings.meetings.autoSummarize.never': 'عدم التلخيص أبداً',
  'settings.meetings.listenOnly': 'وضع الاستماع فقط',
  'settings.meetings.listenOnlyDesc': 'الانضمام مع كتم الميكروفون',
  'settings.meetings.ingestTranscripts': 'استيعاب نصوص الخلفية',
  'settings.meetings.ingestTranscriptsDesc': 'تخزين نصوص الاجتماعات في الذاكرة',
  'settings.sandbox.title': 'تنفيذ Sandbox',
  'settings.sandbox.menuDesc': 'تكوين خلفيات Sandbox لعزل أدوات الوكيل.',
  'settings.sandbox.loading': 'جارٍ التحميل…',
  'settings.sandbox.desktopOnly': 'إعدادات Sandbox متاحة فقط في تطبيق سطح المكتب.',
  'settings.sandbox.loadError': 'فشل تحميل إعدادات Sandbox.',
  'settings.sandbox.saveError': 'فشل حفظ إعدادات Sandbox.',
  'settings.sandbox.saved': 'تم الحفظ: يُطبَّق على جلسات الوكيل الجديدة.',
  'settings.sandbox.saving': 'جارٍ الحفظ…',
  'settings.sandbox.status': 'الحالة',
  'settings.sandbox.dockerStatus': 'Docker',
  'settings.sandbox.available': 'متاح',
  'settings.sandbox.unavailable': 'غير متاح',
  'settings.sandbox.detectedBackend': 'الخلفية التشغيلية',
  'settings.sandbox.enableLabel': 'تفعيل تنفيذ Sandbox',
  'settings.sandbox.enableDesc': 'تشغيل أدوات الوكيل داخل بيئة Sandbox معزولة.',
  'settings.sandbox.backendLabel': 'الخلفية',
  'settings.sandbox.backendDesc': 'اختر خلفية العزل المستخدمة للتنفيذ داخل Sandbox.',
  'settings.sandbox.backend.auto': 'تلقائي (اكتشاف الأفضل المتاح)',
  'settings.sandbox.backend.docker': 'Docker',
  'settings.sandbox.backend.landlock': 'Landlock (Linux)',
  'settings.sandbox.backend.firejail': 'Firejail (Linux)',
  'settings.sandbox.backend.bubblewrap': 'Bubblewrap (Linux)',
  'settings.sandbox.backend.none': 'بدون (لا يوجد Sandbox)',
  'settings.sandbox.dockerSettings': 'إعدادات Docker',
  'settings.sandbox.dockerImage': 'الصورة',
  'settings.sandbox.dockerImagePlaceholder': 'alpine:3.20',
  'settings.sandbox.memoryLimit': 'حد الذاكرة',
  'settings.sandbox.memoryUnit': 'MB',
  'settings.sandbox.cpuLimit': 'حد المعالج',
  'settings.sandbox.cpuUnit': 'نوى',
  'settings.sandbox.envPassthrough': 'تمرير متغيرات البيئة',
  'settings.sandbox.envPassthroughDesc': 'متغيرات البيئة المُمرَّرة إلى داخل Sandbox.',
  'settings.sandbox.noEnvVars': 'لم يتم تكوين أي متغيرات بيئة.',
  'settings.approvalHistory.title': 'سجل الموافقات',
  'settings.approvalHistory.subtitle': 'قرارات الموافقة على الأدوات الأخيرة، الأحدث أولاً.',
  'settings.approvalHistory.refresh': 'تحديث',
  'settings.approvalHistory.loading': 'جارٍ تحميل سجل الموافقات…',
  'settings.approvalHistory.retry': 'إعادة المحاولة',
  'settings.approvalHistory.emptyState': 'لا توجد قرارات موافقة مسجّلة بعد.',
  'settings.approvalHistory.errorGeneric': 'تعذّر تحميل سجل الموافقات. حاول مرة أخرى.',
  'settings.approvalHistory.decidedAt': 'تم القرار في {date}',
  'settings.approvalHistory.decision.approveOnce': 'تمت الموافقة مرة واحدة',
  'settings.approvalHistory.decision.approveAlways': 'مسموح دائمًا',
  'settings.approvalHistory.decision.approveAlwaysFlow': 'مسموح دائمًا (التدفق)',
  'settings.approvalHistory.decision.deny': 'مرفوض',
  'settings.theme.variantLight': 'فاتح',
  'settings.theme.variantDark': 'داكن',
  'settings.theme.variantAuto': 'تلقائي',
  'settings.theme.variantAria': 'نمط السمة',
  'settings.theme.backdropHeading': 'الخلفية',
  'settings.theme.backdrop.mesh': 'شبكة',
  'settings.theme.backdrop.solid': 'لون موحّد',
  'settings.theme.backdrop.image': 'صورة',
  'settings.theme.backdropImageUrl': 'رابط صورة الخلفية',
  'settings.theme.backdropDots': 'إظهار نقاط الخلفية',
  'settings.theme.backdropHint':
    'تعرض الشبكة التدرّج المتحرك؛ ويستخدم اللون الموحّد خلفية ثابتة؛ وترسم الصورة خلفيتك الخاصة.',
  'settings.theme.autoForkHint': 'تعديل سمة جاهزة يحفظ تغييراتك تلقائيًا كسمة مخصّصة جديدة.',
  'settings.theme.title': 'استوديو السمات',
  'settings.theme.menuDesc': 'خصّص الألوان والخطوط بالكامل، أو اختر سمة جاهزة.',
  'settings.theme.presetsHeading': 'السمات',
  'settings.theme.builtInBadge': 'جاهزة',
  'settings.theme.customBadge': 'مخصّصة',
  'settings.theme.customizeHint':
    'السمات الجاهزة للقراءة فقط. انسخ هذه السمة لتعديل ألوانها وخطوطها.',
  'settings.theme.duplicate': 'نسخ وتخصيص',
  'settings.theme.copyName': '{name} (مخصّصة)',
  'settings.theme.importedName': 'سمة مستوردة',
  'settings.theme.contrastWarn': 'تباين منخفض بين النص والخلفية: قد يصعب قراءة هذه السمة.',
  'settings.theme.group.surfaces': 'الأسطح',
  'settings.theme.group.text': 'النص',
  'settings.theme.group.borders': 'الحدود',
  'settings.theme.group.accents': 'ألوان التمييز',
  'settings.theme.showShades': 'إظهار جميع درجات التمييز',
  'settings.theme.hideShades': 'إخفاء جميع درجات التمييز',
  'settings.theme.fontsHeading': 'الخطوط',
  'settings.theme.fontRole.title': 'العنوان',
  'settings.theme.fontRole.heading': 'العنوان الفرعي',
  'settings.theme.fontRole.body': 'المتن',
  'settings.theme.fontRole.mono': 'خط أحادي المسافة',
  'settings.theme.fontRole.serif': 'خط مذيّل',
  'settings.theme.fontCurrent': 'الحالي',
  'settings.theme.actions': 'إدارة السمة',
  'settings.theme.reset': 'إعادة تعيين التجاوزات',
  'settings.theme.delete': 'حذف السمة',
  'settings.theme.export': 'نسخ JSON',
  'settings.theme.copied': 'تم النسخ!',
  'settings.theme.import': 'استيراد سمة',
  'settings.theme.importHint': 'الصق JSON الخاص بسمة مُصدَّرة لإضافتها كسمة مخصّصة.',
  'settings.theme.importApply': 'استيراد',
  'settings.theme.importError': 'تعذّر تحليل JSON لهذه السمة.',
  'settings.appearance.title': 'المظهر',
  'settings.appearance.themeHeading': 'الموضوع',
  'settings.appearance.themeAria': 'الموضوع',
  'settings.appearance.modeLight': 'فاتح',
  'settings.appearance.modeLightDesc': 'أسطح ساطعة، نص داكن.',
  'settings.appearance.modeDark': 'داكنة',
  'settings.appearance.modeDarkDesc': 'الأسطح المعتمة، تكون أسهل على العيون بعد الغسق.',
  'settings.appearance.modeSystem': 'نظام المطابقة',
  'settings.appearance.modeSystemDesc': 'اتبع إعداد مظهر نظام التشغيل لديك.',
  'settings.appearance.helperText':
    'يعمل الوضع الداكن على تحويل التطبيق بأكمله - الدردشة والإعدادات واللوحات - إلى لوحة معتمة. "نظام المطابقة" يتتبع مظهر نظام التشغيل الخاص بك وتحديثاته مباشرة.',
  'settings.appearance.fontSizeHeading': 'حجم الخط',
  'settings.appearance.fontSizeAria': 'حجم الخط',
  'settings.appearance.fontSizeSmall': 'صغير',
  'settings.appearance.fontSizeSmallDesc': 'نص مضغوط: لعرض المزيد على الشاشة.',
  'settings.appearance.fontSizeMedium': 'متوسط',
  'settings.appearance.fontSizeMediumDesc': 'الحجم الافتراضي المتوازن.',
  'settings.appearance.fontSizeLarge': 'كبير',
  'settings.appearance.fontSizeLargeDesc': 'نص أكبر لقراءة أسهل.',
  'settings.appearance.fontSizeXLarge': 'كبير جدًا',
  'settings.appearance.fontSizeXLargeDesc': 'أكبر حجم للنص لأقصى قدر من الوضوح.',
  'settings.appearance.fontSizeHelperText':
    'يضبط حجم النص في التطبيق بأكمله (المحادثة والإعدادات واللوحات) بشكل مستقل عن إعداد خط نظامك.',
  'settings.appearance.fontSizeCustomLabel': 'حجم مخصص',
  'settings.appearance.fontSizeCustomAria': 'حجم الخط المخصص بالبكسل',
  'settings.appearance.fontSizeCustomSliderAria': 'شريط تمرير حجم الخط المخصص، بالبكسل',
  'settings.appearance.fontSizeUnit': 'px',
  'settings.appearance.tabBarHeading': 'شريط علامات التبويب السفلي',
  'settings.appearance.tabBarAlwaysShowLabels': 'إظهار التسميات دائمًا',
  'settings.appearance.tabBarAlwaysShowLabelsDesc':
    'عند إيقاف التشغيل، تظهر التسميات فقط عند التمرير أو لعلامة التبويب النشطة.',
  'settings.appearance.chatHeading': 'الدردشة',
  'settings.appearance.assistantTextMode': 'ردود المساعد كنص',
  'settings.appearance.hideAgentInsights': 'إخفاء تفكير الوكيل',
  'settings.appearance.hideAgentInsightsDesc':
    'طيّ الجدول الزمني المباشر لخطوات الوكيل في المحادثة. سيظل رابط "قيد المعالجة" الوامض يتيح لك فتح العملية الكاملة.',
  'settings.appearance.showChatMascot': 'إظهار Tiny على صندوق الرسائل',
  'settings.appearance.showChatMascotDesc':
    'يبقى التميمة واقفة على صندوق الكتابة. عند الإخفاء تصبح المحادثة نصية فقط حتى تعيد تفعيل الخيار.',
  'settings.appearance.assistantTextModeDesc':
    'اعرض ردود المساعد كنص بلا إطار مع إبقاء رسائلك داخل فقاعات.',
  'settings.mascot.active': 'نشط',
  'settings.mascot.characterDesc': 'وصف الشخصية',
  'settings.mascot.characterDraft': 'مسودة',
  'settings.mascot.characterHeading': 'عنوان الشخصية',
  'settings.mascot.customGifError':
    'أدخل رابط صورة HTTPS أو file:// أو رابطًا محليًا (PNG أو GIF أو JPEG أو WebP أو BMP)، أو ارفع ملفًا.',
  'settings.mascot.customGifHeading': 'صورة رمزية مخصصة',
  'settings.mascot.customGifLabel': 'رابط الصورة الرمزية المخصصة',
  'settings.mascot.customGifPlaceholder': 'https://example.com/avatar.png',
  'settings.mascot.customGifUpload': 'رفع صورة',
  'settings.mascot.customGifInvalidType':
    'نوع الملف غير مدعوم. ارفع صورة PNG أو GIF أو JPEG أو WebP أو BMP.',
  'settings.mascot.customGifTooLarge': 'الصورة كبيرة جدًا. ارفع ملفًا حتى 1.5 ميغابايت.',
  'settings.mascot.customGifReadError': 'تعذّر قراءة الصورة. جرّب ملفًا آخر.',
  'settings.mascot.characterPreview': 'معاينة',
  'settings.mascot.characterStates': 'تنص على',
  'settings.mascot.characterVisemes': 'vimeses',
  'settings.mascot.colorAria': 'OpenHuman اللون',
  'settings.mascot.colorDesc': 'وصف اللون',
  'settings.mascot.colorHeading': 'عنوان اللون',
  'settings.mascot.colorBlack': 'أسود',
  'settings.mascot.colorBurgundy': 'عنابي',
  'settings.mascot.colorCustom': 'العرف',
  'settings.mascot.colorNavy': 'بحري',
  'settings.mascot.primaryColor': 'اللون الابتدائي',
  'settings.mascot.secondaryColor': 'اللون الثانوي',
  'settings.mascot.colorYellow': 'أصفر',
  'settings.mascot.libraryUnavailable': 'مكتبة OpenHuman غير متاحة',
  'settings.mascot.title': 'OpenHuman',
  'settings.mascot.loadingLibrary': 'جارٍ تحميل مكتبة OpenHuman…',
  'settings.mascot.loadDetailError': 'تعذر تحميل التميمة.',
  'settings.mascot.loadLibraryError': 'تعذر تحميل مكتبة التميمة.',
  'settings.mascot.localDefault': 'OpenHuman المحلي (افتراضي)',
  'settings.mascot.menuTitle': 'التميمة',
  'settings.mascot.menuDesc': 'اختر لون التميمة المستخدم في جميع أنحاء التطبيق',
  'settings.mascot.noCharacters': 'لا توجد شخصيات OpenHuman متاحة بعد',
  'settings.mascot.noColorVariants': 'لا توجد ألوان متاحة',
  'settings.mascot.secondaryHeading': 'ثنائي الاجتماع (تميمة ثانية)',
  'settings.mascot.secondaryDesc':
    'أضِف تميمة ثانية للاجتماعات. عند تعيين اثنتين تظهران معًا وتتناوبان في الحديث. اتركها بلا لتميمة واحدة.',
  'settings.mascot.secondaryNone': 'بلا (تميمة واحدة)',
  'settings.mascot.perMascotVoiceHeading': 'أصوات لكل تميمة',
  'settings.mascot.primaryVoiceLabel': 'صوت التميمة الأولى',
  'settings.mascot.secondaryVoiceLabel': 'صوت التميمة الثانية',
  'settings.mascot.voice.current': 'الحالي',
  'settings.mascot.voice.customDesc':
    'ابحث عن معرّفات الصوت في api.elevenlabs.io/v1/voices أو لوحة تحكم ElevenLabs الخاصة بك. يُخزَّن المعرّف فقط: يبقى مفتاح API الخاص بك على الخادم.',
  'settings.mascot.voice.customHeading': 'معرّف صوت مخصص',
  'settings.mascot.voice.customOption': 'آخر (لصق معرّف الصوت)…',
  'settings.mascot.voice.customPlaceholder': 'على سبيل المثال. 21m00Tcm4TlvDq8ikWAM',
  'settings.mascot.voice.desc':
    'اختر صوت ElevenLabs الذي تستخدمه الشخصية للردود المنطوقة. صفِّ حسب الجنس، اختر من القائمة المنسّقة، الصق معرّفاً مخصصاً، أو دع التطبيق يختار صوتاً يطابق لغة الواجهة.',
  'settings.mascot.voice.genderFemale': 'أنثى',
  'settings.mascot.voice.genderHeading': 'جنس الصوت',
  'settings.mascot.voice.genderMale': 'ذكر',
  'settings.mascot.voice.heading': 'الصوت',
  'settings.mascot.voice.preset': 'إعداد الصوت المسبق',
  'settings.mascot.voice.presetHeading': 'إعداد الصوت المسبق',
  'settings.mascot.voice.preview': 'معاينة الصوت',
  'settings.mascot.voice.previewError': 'تعذّرت معاينة الصوت',
  'settings.mascot.voice.previewText': 'مرحبا، أنا مساعدتك. هذا عرض صوتي',
  'settings.mascot.voice.previewing': 'جاري المعاينة…',
  'settings.mascot.voice.reset': 'إعادة تعيين إلى الافتراضي',
  'settings.mascot.voice.useLocaleDefault': 'مطابقة لغة التطبيق',
  'settings.mascot.voice.useLocaleDefaultDesc': 'اختيار صوت تلقائياً للغة الواجهة الحالية.',
  'settings.persona.title': 'Persona',
  'settings.persona.menuTitle': 'Persona',
  'settings.persona.menuDesc': 'الاسم، الشخصية، الأفاتار، والصوت - مساعدك كهوية واحدة',
  'settings.persona.identityHeading': 'الهوية',
  'settings.persona.identityDesc':
    'اسم عرض ووصف قصير لمساعدك تظهر في التطبيق، ولا تغير كيفية تغيير أسباب المساعد.',
  'settings.persona.displayNameLabel': 'اسم التلاعب',
  'settings.persona.displayNamePlaceholder': 'e.g',
  'settings.persona.descriptionLabel': 'الوصف',
  'settings.persona.descriptionPlaceholder': 'Xqx0xx. مساعد هادئ ومختصر لفريقي',
  'settings.persona.soul.heading': 'الشخصية (x0x.md)',
  'settings.persona.soul.desc':
    'الشخصية تدفع المساعد يتبع في كل محادثة تم إنقاذ (إيديتس) إلى مكان عملك ويبدأ العمل على الرد التالي',
  'settings.persona.soul.editorLabel': 'SOUL',
  'settings.persona.soul.reset': 'إعادة إلى الافتراضي',
  'settings.persona.soul.usingDefault': 'باستخدام الخزنة',
  'settings.persona.soul.loadError': 'لا يمكن تحميل Xqx0xx',
  'settings.persona.soul.saveError': 'لا يُمكنُ أَنْ يَوفّرَ Xqx0xxx',
  'settings.persona.soul.resetError': 'لا يمكن إعادة تشغيل Xqx0xx',
  'settings.persona.builder.modeLabel': 'وضع محرر الشخصية',
  'settings.persona.builder.modeGuided': 'موجّه',
  'settings.persona.builder.modeAdvanced': 'متقدّم',
  'settings.persona.builder.intro':
    'املأ بضعة حقول وسنكتبها في شخصيتك نيابةً عنك. لا حاجة إلى ماركداون.',
  'settings.persona.builder.personalityLabel': 'الشخصية',
  'settings.persona.builder.personalityPlaceholder':
    'مثال: ودود وفضولي ومباشر. صادق عند عدم اليقين.',
  'settings.persona.builder.voiceLabel': 'أسلوب التواصل',
  'settings.persona.builder.voicePlaceholder': 'مثال: ابدأ بالإجابة، واجعلها موجزة، وطابق نبرتي.',
  'settings.persona.builder.aboutLabel': 'نبذة عنك',
  'settings.persona.builder.aboutPlaceholder':
    'مثال: أدير استوديو تصميم صغيرًا وأفضّل اللغة البسيطة.',
  'settings.persona.builder.preservedNote':
    'تُحفظ أي أقسام أخرى كتبتها بنفسك: انتقل إلى «متقدّم» لرؤية الشخصية كاملة.',
  'settings.persona.builder.securityNote': 'هل تريد تحديد ما يُسمح للمساعد بفعله؟',
  'settings.persona.builder.securityLink': 'فتح وصول الوكيل',
  'settings.persona.templates.heading': 'ابدأ من قالب',
  'settings.persona.templates.desc':
    'اختر نقطة بداية: تملأ الشخصية وأسلوب التواصل. يمكنك تعديل كل شيء لاحقًا.',
  'settings.persona.templates.doctor.label': 'مساعد سريري',
  'settings.persona.templates.doctor.desc': 'دقيق، يذكر المصادر، ينبّه إلى عدم اليقين',
  'settings.persona.templates.researcher.label': 'مساعد بحثي',
  'settings.persona.templates.researcher.desc': 'صارم، منظّم، يعتمد على الأدلة',
  'settings.persona.templates.executive.label': 'مساعد تنفيذي',
  'settings.persona.templates.executive.desc': 'موجز، حاسم، موجّه نحو العمل',
  'settings.persona.templates.teacher.label': 'معلّم',
  'settings.persona.templates.teacher.desc': 'صبور، يشرح خطوة بخطوة',
  'settings.persona.templates.student.label': 'رفيق دراسة',
  'settings.persona.templates.student.desc': 'محفّز، يطرح أسئلة، لغة بسيطة',
  'settings.persona.templates.family.label': 'مساعد عائلي',
  'settings.persona.templates.family.desc': 'ودود، لطيف، آمن لكل الأعمار',
  'settings.persona.appearanceHeading': 'صوت الأفاتار',
  'settings.persona.appearanceDesc':
    'لون الماسكوت، العرف Xqx0x avatar، وصوت الرد مصمم في أماكن مكوت.',
  'settings.persona.openMascotSettings': 'فتح الماسكوت',
  'settings.memoryWindow.balanced.badge': 'موصى به',
  'settings.memoryWindow.balanced.hint':
    'افتراضي معقول: استمرارية جيدة دون استهلاك رموز إضافية في كل تشغيل.',
  'settings.memoryWindow.balanced.label': 'متوازن',
  'settings.memoryWindow.description':
    'مقدار السياق المحفوظ الذي يحقنه OpenHuman في كل تشغيل وكيل جديد. النوافذ الأكبر تمنح الوكيل وعيًا أكبر بالمحادثات السابقة، لكنها تستخدم رموزًا أكثر وتكلّف أكثر في كل تشغيل.',
  'settings.memoryWindow.extended.badge': 'سياق أكثر',
  'settings.memoryWindow.extended.hint':
    'حقن ذاكرة طويلة المدى أكثر في كل تشغيل. تكلفة رموز أعلى لكل دور.',
  'settings.memoryWindow.extended.label': 'موسّع',
  'settings.memoryWindow.maximum.badge': 'الأعلى تكلفة',
  'settings.memoryWindow.maximum.hint':
    'أكبر نافذة آمنة. أفضل استمرارية، مع فاتورة رموز أعلى بشكل ملحوظ في كل تشغيل.',
  'settings.memoryWindow.maximum.label': 'أقصى',
  'settings.memoryWindow.minimal.badge': 'الأرخص',
  'settings.memoryWindow.minimal.hint':
    'أصغر نافذة ذاكرة. الأرخص والأسرع وأقل استمرارية بين عمليات التشغيل.',
  'settings.memoryWindow.minimal.label': 'الحد الأدنى',
  'settings.memoryWindow.title': 'نافذة الذاكرة طويلة الأمد',
  'settings.agentbox.title': 'AgentBox',
  'settings.agentbox.desc': 'حالة محول سوق GMI Cloud وإعداد المزود',
  'settings.agentbox.intro':
    'حالة للقراءة فقط لمحول سوق AgentBox. يتم تعيين الوضع ومزود GMI MaaS عبر متغيرات البيئة عند بدء تشغيل النواة.',
  'settings.agentbox.modeLabel': 'وضع السوق',
  'settings.agentbox.providerHeading': 'مزود GMI MaaS',
  'settings.agentbox.slug': 'معرّف المزود',
  'settings.agentbox.baseUrl': 'عنوان URL الأساسي',
  'settings.agentbox.model': 'النموذج',
  'settings.agentbox.notConfigured':
    'غير مُهيأ. عيّن متغيرات البيئة GMI_MAAS_BASE_URL وGMI_MAAS_API_KEY وGMI_MODELS.',
  'settings.agentbox.unavailable': 'حالة AgentBox غير متوفرة',
  'settings.modelHealth.title': 'نموذج الصحة',
  'settings.modelHealth.desc':
    'الجودة حسب النموذج، ومعدل الهلوسة، ومقارنة التكاليف بين النماذج النشطة',
  'settings.modelHealth.allStatuses': 'جميع الحالات',
  'settings.modelHealth.models': 'النماذج',
  'settings.modelHealth.loading': 'بيانات نموذجية لتحديد الموقع',
  'settings.modelHealth.empty': 'لا توجد نماذج مسجلة',
  'settings.modelHealth.col.model': 'النموذج النموذجي',
  'settings.modelHealth.col.quality': 'النوعية',
  'settings.modelHealth.col.halluc': '(هلوس) المعدل',
  'settings.modelHealth.col.cost': 'التكلفة/١٠٠',
  'settings.modelHealth.col.agents': 'العملاء',
  'settings.modelHealth.col.status': 'الحالة',
  'settings.modelHealth.badge.keep': 'استمر',
  'settings.modelHealth.badge.replace': 'يستعاض عن عبارة:',
  'settings.modelHealth.badge.staging': 'اختبار الطعن',
  'settings.modelHealth.badge.vision': 'الرؤية فقط',
  'settings.modelHealth.swap': 'ماذا؟',
  'settings.modelHealth.modal.title': 'استبدال النموذج؟',
  'settings.modelHealth.modal.hallucRate': 'معدل الهلوسة',
  'settings.modelHealth.modal.cancel': 'إلغاء',
  'settings.modelHealth.modal.apply': 'استبدال التطبيق',
  'settings.modelHealth.tag.cheaper': 'CHEAPER',
  'settings.modelHealth.tag.better': 'BETTER',
  'skills.card.moreActions': 'مزيد من الإجراءات',
  'skills.channelIcon.discord': 'Discord',
  'skills.channelIcon.imessage': 'iMessage',
  'skills.channelIcon.telegram': 'Telegram',
  'skills.channelIcon.web': 'الويب',
  'skills.channelIcon.yuanbao': 'Yuanbao',
  'skills.composio.poweredBy': 'مدعوم من Composio',
  'skills.composio.staleStatusTitle': 'تظهر الاتصالات حالة قديمة',
  'skills.create.allowedTools': 'الأدوات المسموح بها',
  'skills.create.allowedToolsHelp': 'تم عرضها في المادة الأمامية SKILL.md كـ',
  'skills.create.allowedToolsPlaceholder': 'عقدة_exec، جلب',
  'skills.create.author': 'المؤلف',
  'skills.create.authorPlaceholder': 'اسمك',
  'skills.create.commaSeparated': '(مفصولة بفاصلة)',
  'skills.create.createBtn': 'إنشاء مهارة',
  'skills.create.createError': 'تعذّر إنشاء المهارة',
  'skills.create.creating': 'جارٍ الإنشاء…',
  'skills.create.description': 'الوصف',
  'skills.create.descriptionPlaceholder': 'ما الذي تفعله هذه المهارة؟',
  'skills.create.optional': '(اختياري)',
  'skills.create.inputs.heading': 'Inputs',
  'skills.create.inputs.help':
    'أعلن عن المعاملات التي تحتاجها المهارة. سيعرض تشغيل المهارات نموذجاً لهذه المعاملات عند التشغيل.',
  'skills.create.inputs.add': 'إضافة إدخال',
  'skills.create.inputs.row.name': 'اسم الإدخال',
  'skills.create.inputs.row.namePlaceholder': 'مثال: repo',
  'skills.create.inputs.row.nameError':
    'الأحرف والأرقام والشرطات السفلية والشرطات فقط؛ يجب أن يبدأ بحرف.',
  'skills.create.inputs.row.description': 'وصف الإدخال',
  'skills.create.inputs.row.descriptionPlaceholder': 'ما الذي يذهب في هذا الحقل؟',
  'skills.create.inputs.row.type': 'Type',
  'skills.create.inputs.row.required': 'Required',
  'skills.create.inputs.row.remove': 'حذف الإدخال',
  'skills.create.inputs.type.string': 'Text',
  'skills.create.inputs.type.integer': 'Number',
  'skills.create.inputs.type.boolean': 'نعم / لا',
  'skills.create.license': 'الترخيص',
  'skills.create.licensePlaceholder': 'MIT',
  'skills.create.name': 'الاسم',
  'skills.create.namePlaceholder': 'مثال: يومية التداول',
  'skills.create.scope': 'النطاق',
  'skills.create.scopeProjectHint': '/.openhuman/skills/',
  'skills.create.scopeUserHint':
    'مكتوب في ~/.openhuman/skills/<slug>/SKILL.md: متاح في جميع مساحات العمل.',
  'skills.create.slugLabel': 'تسمية المعرف',
  'skills.create.subtitle': 'SKILL.md',
  'skills.create.tags': 'الوسوم',
  'skills.create.tagsPlaceholder': 'تداول، بحث',
  'skills.create.title': 'مهارة جديدة',
  'skills.detail.allowedTools': 'الأدوات المسموح بها',
  'skills.detail.author': 'المؤلف',
  'skills.detail.license': 'الترخيص',
  'skills.detail.bundledResources': 'الموارد المجمّعة',
  'skills.detail.description': 'الوصف',
  'skills.detail.closeAriaLabel': 'إغلاق تفاصيل المهارة',
  'skills.detail.location': 'الموقع',
  'skills.detail.noBundledResources': 'لا توجد موارد مجمّعة.',
  'skills.detail.platforms': 'المنصات',
  'skills.detail.relatedSkills': 'مهارات ذات صلة',
  'skills.detail.source': 'رابط المصدر',
  'skills.detail.sourceFormat': 'التنسيق',
  'skills.detail.stars': 'النجوم',
  'skills.detail.tags': 'العلامات',
  'skills.detail.warnings': 'التحذيرات',
  'skills.detail.version': 'الإصدار',
  'skills.install.errors.alreadyInstalledHint':
    'توجد بالفعل مهارة بهذه البزاقة في مساحة العمل. قم بإزالته أولاً أو قم بتغيير المادة الأمامية `metadata.id` / `name`.',
  'skills.install.errors.alreadyInstalledTitle': 'تم تثبيت المهارة بالفعل',
  'skills.install.errors.fetchFailedHint':
    'لم يكتمل الطلب بنجاح. تحقق من نقاط URL في ملف عام يمكن الوصول إليه، ومن أن المضيف قد قام بإرجاع استجابة 2xx.',
  'skills.install.errors.fetchFailedTitle': 'فشل الجلب',
  'skills.install.errors.fetchTimedOutHint':
    'لم يستجب المضيف البعيد في الوقت المناسب. حاول مرة أخرى أو ارفع المهلة (1-600 ثانية).',
  'skills.install.errors.fetchTimedOutTitle': 'انتهت مهلة الجلب',
  'skills.install.errors.fetchTooLargeHint':
    'يجب أن يكون حجم SKILL.md أقل من 1 ميجابايت. قم بتقسيم الموارد المجمعة إلى ملفات "مراجع/" أو "نصوص برمجية/" بدلاً من تضمينها.',
  'skills.install.errors.fetchTooLargeTitle': 'SKILL.md كبير جدًا',
  'skills.install.errors.genericHint': 'أرجعت الواجهة الخلفية خطأً. يتم عرض الرسالة الأولية أدناه.',
  'skills.install.errors.genericTitle': 'تعذر تثبيت المهارة',
  'skills.install.errors.invalidSkillHint':
    'يجب أن تكون المادة الأمامية YAML صالحة مع حقول `اسم` و`وصف` غير فارغة، ومنتهية بـ `---`.',
  'skills.install.errors.invalidSkillTitle': 'لم يقم SKILL.md بتحليل',
  'skills.install.errors.invalidUrlHint':
    'يُسمح فقط بـ HTTPS URLs العامة. يتم حظر مضيفي البيانات الخاصة والاسترجاعية والبيانات التعريفية.',
  'skills.install.errors.invalidUrlTitle': 'URL مرفوض',
  'skills.install.errors.unsupportedUrlHint':
    'تعمل فقط الروابط المباشرة `.md`. بالنسبة إلى GitHub، قم بالارتباط بملف (github.com/owner/repo/blob/.../SKILL.md) - لم يتم تثبيت جذور الشجرة والريبو.',
  'skills.install.errors.unsupportedUrlTitle': 'URL النموذج غير مدعوم',
  'skills.install.errors.writeFailedHint':
    'دليل مهارات مساحة العمل غير قابل للكتابة. تحقق من أذونات نظام الملفات لـ `<workspace>/.openhuman/skills/`.',
  'skills.install.errors.writeFailedTitle': 'تعذر كتابة SKILL.md',
  'skills.install.fetchLog': 'جلب السجل',
  'skills.install.fetchingPrefix': 'جلب',
  'skills.install.fetchingSuffix': 'قد يستغرق ذلك حتى المهلة التي قمت بتكوينها.',
  'skills.install.installBtn': 'جارٍ التثبيت…',
  'skills.install.installComplete': 'اكتمل التثبيت',
  'skills.install.installing': 'جارٍ التثبيت…',
  'skills.install.parseWarnings': 'تحذيرات التحليل',
  'skills.install.rawError': 'خطأ خام',
  'skills.install.subtitleMiddle': 'عبر HTTPS وتثبيته ضمن',
  'skills.install.subtitlePrefix': 'جلب',
  'skills.install.subtitleSuffix':
    'HTTPS واحد فقط؛ تم حظر المضيفين الخاصين والمضيفين الاسترجاعيين.',
  'skills.install.successDiscovered': 'تم اكتشاف {count} مهارات جديدة.',
  'skills.install.successNoNewIds':
    'تم تثبيت المهارة، ولكن لم تظهر معرفات مهارة جديدة - قد يحتوي الكتالوج بالفعل على مهارة بنفس البزاقة.',
  'skills.install.timeoutHint': '(ثوانٍ، اختياري)',
  'skills.install.timeoutHelp': 'الافتراضي هو 60 ثانية. يتم تثبيت القيم خارج 1-600 من جانب الخادم.',
  'skills.install.timeoutInvalid': 'يجب أن يكون عددًا صحيحًا بين 1 و600.',
  'skills.install.timeoutLabel': 'تسمية المهلة',
  'skills.install.timeoutPlaceholder': '60',
  'skills.install.title': 'تثبيت مهارة من رابط',
  'skills.install.urlHelpMiddle': 'ملف.',
  'skills.install.urlHelpPrefix': 'الرابط المباشر إلى',
  'skills.install.urlHelpSuffix': 'URLs إعادة الكتابة التلقائية إلى',
  'skills.install.urlInvalidPrefix': 'URL يجب أن يكون رابط',
  'skills.install.urlInvalidSuffix': 'جيد التنسيق.',
  'skills.install.urlLabel': 'رابط المهارة',
  'skills.install.urlPlaceholder': 'https://raw.githubusercontent.com/owner/repo/main/SKILL.md',
  'skills.meetingBots.bannerDesc': 'وصف اللافتة',
  'skills.meetingBots.bannerTitle': 'عنوان اللافتة',
  'skills.meetingBots.busyTitle': 'OpenHuman مشغول',
  'skills.meetingBots.comingSoon': 'قريبًا',
  'skills.meetingBots.couldNotLeaveTitle': 'تعذّر مغادرة الاجتماع',
  'skills.meetingBots.couldNotStartTitle': 'تعذّر بدء OpenHuman',
  'skills.meetingBots.displayName': 'الاسم المعروض',
  'skills.meetingBots.failedToStart': 'فشل تشغيل OpenHuman.',
  'skills.meetingBots.joiningMessage': 'يجب أن يظهر كمشارك في غضون ثوانٍ.',
  'skills.meetingBots.joiningTitle': 'OpenHuman ينضم إلى الاجتماع',
  'skills.meetingBots.meetingLink': 'رابط الاجتماع',
  'skills.meetingBots.modalAriaLabel': 'إرسال OpenHuman إلى اجتماع',
  'skills.meetingBots.modalDesc': 'وصف النافذة',
  'skills.meetingBots.modalTitle': 'إرسال OpenHuman إلى اجتماع',
  'skills.meetingBots.newBadge': 'شارة جديدة',
  'skills.meetingBots.platformComingSoon': '{label} الدعم قريبًا.',
  'skills.meetingBots.platformHints.gmeet': 'meet.google.com/abc-defg-hij',
  'skills.meetingBots.platformHints.teams': 'Teams.microsoft.com/...',
  'skills.meetingBots.platformHints.webex': 'webex.com/meet/...',
  'skills.meetingBots.platformHints.zoom': 'Zoom.us/j/...',
  'skills.meetingBots.platforms.gmeet': 'Google لقاء',
  'skills.meetingBots.platforms.teams': 'Microsoft Teams',
  'skills.meetingBots.platforms.webex': 'Webex',
  'skills.meetingBots.platforms.zoom': 'تكبير',
  'skills.meetingBots.sendTo': 'إرسال إلى',
  'skills.meetingBots.serverOverloaded':
    'يشهد OpenHuman ضغطًا كبيرًا في الوقت الحالي. يُرجى المحاولة مرة أخرى بعد بضع دقائق.',
  'skills.meetingBots.soonSuffix': 'قريبًا',
  'skills.meetingBots.starting': 'جارٍ البدء…',
  'skills.meetingBots.recentCallsAriaLabel': 'مكالمات الاجتماعات الأخيرة',
  'skills.meetingBots.recentCallsHeading': 'المكالمات الأخيرة',
  'skills.meetingBots.recentCallsEmpty': 'لا توجد مكالمات سابقة بعد: سيظهر سجل اجتماعاتك هنا.',
  'skills.meetingBots.recentCallsLoading': 'جارٍ التحميل\u2026',
  'skills.meetingBots.recentCallAddedBy': 'أضافه {name}',
  'skills.meetingBots.recentCallParticipants': 'مع {names}',
  'skills.meetingBots.recentCallTurnSingular': '{count} دور',
  'skills.meetingBots.recentCallTurnPlural': '{count} أدوار',
  'skills.meetingBots.recentCallDuration': '{seconds} ث في المكالمة',
  'skills.meetingBots.callDetailLoading': 'جارٍ تحميل النص…',
  'skills.meetingBots.callDetailError': 'تعذّر تحميل النص.',
  'skills.meetingBots.callDetailRetry': 'إعادة المحاولة',
  'skills.meetingBots.callDetailEmpty': 'لم يُسجَّل أي نص أو ملخّص لهذه المكالمة.',
  'skills.meetingBots.callSummaryHeading': 'الملخّص',
  'skills.meetingBots.callKeyPointsHeading': 'النقاط الرئيسية',
  'skills.meetingBots.callActionItemsHeading': 'بنود الإجراءات',
  'skills.meetingBots.callTranscriptHeading': 'النص',
  'skills.meetingBots.liveBadge': 'مباشر',
  'skills.meetingBots.liveTitle': 'في اجتماع',
  'skills.meetingBots.liveStatusJoining': 'جارٍ الانضمام\u2026',
  'skills.meetingBots.liveStatusActive': 'مباشر في الاجتماع',
  'skills.meetingBots.liveStatusListening': 'الاستماع (صامت)',
  'skills.meetingBots.liveStatusEnded': 'انتهى الاجتماع',
  'skills.meetingBots.liveStatusError': 'فشل الانضمام',
  'skills.meetingBots.liveTranscriptHeading': 'النص المباشر',
  'skills.meetingBots.liveTranscriptEmpty': 'في انتظار الكلام…',
  'skills.meetingBots.leaveButton': 'مغادرة',
  'skills.meetingBots.leavingButton': 'جارٍ المغادرة…',
  'skills.meetingBots.respondToParticipant': 'اسمك في هذا الاجتماع',
  'skills.meetingBots.respondToParticipantHint': 'مثال: أحمد (اسمك في المكالمة)',
  'skills.meetingBots.replyName.label': 'اسمك في الاجتماعات',
  'skills.meetingBots.replyName.description':
    'الاسم الذي يستمع إليه المساعد ويرد عليه. أدخل اسمك كما يظهر في المكالمة: يُطبَّق على كل اجتماع ينضم إليه.',
  'skills.meetingBots.replyName.placeholder': 'مثال: أليكس كيم',
  'skills.meetingBots.respondToParticipantDesc':
    'أدخل اسمك الظاهر بالضبط في الاجتماع. لن يستجيب البوت إلا عندما تنطق باسمه (عبارة التنشيط).',
  'skills.meetingBots.wakePhrase': 'عبارة التنشيط',
  'skills.meetingBots.wakePhraseHint': 'مرحباً OpenHuman',
  'skills.meetingBots.wakePhraseDesc': 'يجب أن يقول المشارك هذا قبل أن يرد البوت.',
  'skills.meetingBots.activeMode': 'الرد عندما أناديه',
  'skills.meetingBots.activeModeDesc':
    'عند التفعيل، يرد البوت بصوت مسموع بعد أن تقول عبارة التنبيه. عند الإيقاف، يكتفي بالاستماع وتدوين النص.',
  'skills.meetingBots.history.allPlatforms': 'جميع المنصات',
  'skills.meetingBots.history.copyTranscript': 'نسخ',
  'skills.meetingBots.history.downloadTranscript': 'تنزيل',
  'skills.meetingBots.history.earlier': 'سابقًا',
  'skills.meetingBots.history.participantCount': '{count} مشارك',
  'skills.meetingBots.history.participantCountPlural': '{count} مشاركين',
  'skills.meetingBots.history.runWithOpenHuman': 'تشغيل مع OpenHuman',
  'skills.meetingBots.history.searchPlaceholder': 'البحث في المكالمات…',
  'skills.meetingBots.history.selectPrompt': 'اختر مكالمة لعرض ملخصها ونصها.',
  'skills.meetingBots.history.today': 'اليوم',
  'skills.meetingBots.history.yesterday': 'أمس',
  'skills.meetingBots.upcoming.heading': 'القادمة',
  'skills.meetingBots.upcoming.when': 'الوقت',
  'skills.meetingBots.upcoming.meeting': 'الاجتماع',
  'skills.meetingBots.upcoming.platform': 'المنصة',
  'skills.meetingBots.upcoming.people': 'الأشخاص',
  'skills.meetingBots.upcoming.joinPolicy': 'سياسة الانضمام',
  'skills.meetingBots.upcoming.joinNow': 'انضم الآن',
  'skills.meetingBots.upcoming.joinNowAriaLabel': 'انضم إلى {title}',
  'skills.meetingBots.upcoming.join': 'انضم',
  'skills.meetingBots.upcoming.auto': 'تلقائي',
  'skills.meetingBots.upcoming.ask': 'اسأل',
  'skills.meetingBots.upcoming.skip': 'تخطَّ',
  'skills.meetingBots.upcoming.today': 'اليوم',
  'skills.meetingBots.upcoming.tomorrow': 'غداً',
  'skills.meetingBots.upcoming.empty':
    'لا توجد اجتماعات قادمة: قم بربط Google Calendar لرؤيتها هنا.',
  'skills.meetingBots.upcoming.error': 'تعذّر تحميل الاجتماعات القادمة.',
  'skills.meetingBots.upcoming.retry': 'إعادة المحاولة',
  'skills.meetingBots.upcoming.refresh': 'تحديث',
  'skills.meetingBots.upcoming.filterAll': 'كل المنصات',
  'skills.meetingBots.upcoming.participants': '{count} مشاركون',
  'skills.meetingBots.upcoming.imminent': 'يبدأ قريباً',
  'skills.meetingBots.upcoming.autoJoinsAt': 'ينضم تلقائيًا ~في {time}',
  'skills.meetingBots.upcoming.asksAtStart': 'يسأل عند البدء',
  'skills.meetingBots.upcoming.watchCalendarHint':
    "فعِّل 'مراقبة التقويم' في الإعدادات الافتراضية (أيقونة الترس) حتى يصبح الانضمام التلقائي/السؤال فعالاً: وإلا فإن هذه السياسات محفوظة لكنها لن تُفعَّل.",
  'skills.meetingBots.relative.now': 'الآن',
  'skills.meetingBots.relative.inMinutes': 'في {count} د',
  'skills.meetingBots.relative.inHours': 'في {count} س',
  'skills.meetingBots.relative.minutesAgo': 'منذ {count} د',
  'skills.meetingBots.relative.hoursAgo': 'منذ {count} س',
  'skills.meetingBots.relative.daysAgo': 'منذ {count} ي',
  'skills.meetingBots.relative.yesterday': 'أمس',
  'skills.meetingBots.defaults.drawerTitle': 'إعدادات الاجتماع الافتراضية',
  'skills.meetingBots.defaults.closeDrawer': 'إغلاق',
  'skills.meetingBots.defaults.openDefaults': 'إعدادات الاجتماع',
  'skills.meetingBots.defaults.watchCalendar': 'مراقبة التقويم',
  'skills.meetingBots.defaults.watchCalendarDesc':
    'اسمح لـ OpenHuman بمراقبة التقويم المتصل حتى يتمكن من الانضمام تلقائياً أو مطالبتك بالاجتماعات بناءً على السياسات أدناه. هذا منفصل عن إشعارات تذكير الاجتماعات.',
  'skills.meetingBots.defaults.globalPolicy': 'سياسة الانضمام التلقائي العامة',
  'skills.meetingBots.defaults.perPlatformTitle': 'إعدادات خاصة بالمنصة',
  'skills.meetingBots.defaults.perPlatformDesc': 'تجاوز السياسة العامة لمنصات محددة.',
  'skills.meetingBots.defaults.useDefault': 'استخدام الافتراضي',
  'skills.resource.preview.closeAriaLabel': 'إغلاق المعاينة',
  'skills.resource.preview.failed': 'فشلت المعاينة',
  'skills.resource.preview.loading': 'جارٍ تحميل المعاينة…',
  'skills.resource.tree.assets': 'الأصول',
  'skills.resource.tree.examples': 'أمثلة',
  'skills.resource.tree.other': 'أخرى',
  'skills.resource.tree.prompts': 'المطالبات',
  'skills.resource.tree.references': 'المراجع',
  'skills.resource.tree.scripts': 'السكربتات',
  'skills.resource.tree.templates': 'القوالب',
  'skills.resource.tree.empty': 'لا توجد موارد مجمّعة.',
  'skills.search.placeholder': 'بحث',
  'skills.setup.voice.activation': 'التفعيل',
  'skills.setup.voice.activeDescPrefix': 'Fn',
  'skills.setup.voice.activeDescSuffix': 'Fn',
  'skills.setup.voice.activeTitle': 'ذكاء الصوت نشط',
  'skills.setup.voice.customizeSettings': 'تخصيص الإعدادات',
  'skills.setup.voice.downloadSttBtn': 'تنزيل نموذج STT',
  'skills.setup.voice.enableDesc': 'وصف التفعيل',
  'skills.setup.voice.hotkey': 'المفتاح الساخن',
  'skills.setup.voice.startBtn': 'جارٍ البدء...',
  'skills.setup.voice.startError': 'فشل تشغيل خادم الصوت',
  'skills.setup.voice.starting': 'جارٍ البدء...',
  'skills.setup.voice.stepEnable': 'تشغيل خادم الصوت',
  'skills.setup.voice.stepSetup': 'يلزم تنزيل النموذج',
  'skills.setup.voice.stepSuccess': 'جاهز للانطلاق',
  'skills.setup.voice.sttNotReady': 'نموذج تحويل الكلام إلى نص غير جاهز',
  'skills.setup.voice.sttNotReadyDesc':
    'يتطلب ذكاء الصوت نموذج Whisper محليًا للنسخ. نزّله من إعدادات النموذج المحلي.',
  'skills.setup.voice.sttReady': 'نموذج تحويل الكلام إلى نص جاهز',
  'skills.setup.voice.sttReturnHint': 'تلميح العودة لـ STT',
  'skills.setup.voice.title': 'ذكاء الصوت',
  'skills.uninstall.couldNotUninstall': 'تعذّر إلغاء التثبيت',
  'skills.uninstall.description':
    'هذا يحذف دليل المهارة نهائيًا وجميع موارده المرفقة. سيتوقف الوكيل عن رؤيتها في الدور التالي.',
  'skills.uninstall.title': 'إلغاء التثبيت',
  'skills.uninstall.uninstallBtn': 'إلغاء التثبيت',
  'skills.uninstall.uninstalling': 'جارٍ إلغاء التثبيت…',
  'upsell.global.limitMessage': 'قم بترقية خطتك أو أضف رصيدًا للمتابعة',
  'upsell.global.limitTitle': 'أنت',
  'upsell.global.nearLimitMessage':
    'لقد استخدمت {pct}% من حد الاستخدام. قم بالترقية للحصول على حدود أعلى.',
  'upsell.global.nearLimitTitle': 'الاقتراب من حد الاستخدام',
  'upsell.usageLimit.bodyBudget':
    'لقد وصلت إلى حدّك الأسبوعي.{reset} قم بترقية خطتك أو شحن الرصيد لتجنّب الحدود.',
  'upsell.usageLimit.bodyRate':
    'لقد وصلت إلى حدّ معدّل الاستدلال لـ 10 ساعات.{reset} قم بالترقية للحصول على حدود أعلى.',
  'upsell.usageLimit.heading': 'تم الوصول إلى حد الاستخدام',
  'upsell.usageLimit.notNow': 'ليس الآن',
  'upsell.usageLimit.perWindow': '{amount}',
  'upsell.usageLimit.planIncludes': '{plan}',
  'upsell.usageLimit.resetsIn': 'يُعاد التعيين {time}.',
  'upsell.usageLimit.upgradePlan': 'ترقية الخطة',
  'upsell.usageLimit.weeklyInference': '{amount}',
  'walkthrough.steps.startChat.title': 'ابدأ من الدردشة',
  'walkthrough.steps.startChat.content':
    'الدردشة هي نقطة البداية. تفتح النوافذ الجديدة بالترحيب نفسه والإجراءات السريعة التي رأيتها بعد الإعداد.',
  'walkthrough.steps.sayHello.title': 'قل مرحباً',
  'walkthrough.steps.sayHello.content': 'اضغط هنا لبدء محادثة مع مساعد الذكاء الاصطناعي في أي وقت.',
  'walkthrough.steps.meetAi.title': 'تعرّف إلى الذكاء الاصطناعي',
  'walkthrough.steps.meetAi.content':
    'هنا تجري المحادثات. اطرح الأسئلة، واحصل على الملخصات، أو طوّر الأفكار. يبقى كل شيء قابلاً للبحث.',
  'walkthrough.steps.connectWorld.title': 'صِل عالمك',
  'walkthrough.steps.connectWorld.content':
    'Gmail وSlack وWhatsApp والمزيد: كل اتصال يمنح مساعدك قدرات جديدة.',
  'walkthrough.steps.messagingApps.title': 'تحدث حيث أنت بالفعل',
  'walkthrough.steps.messagingApps.content':
    'اربط WhatsApp وTelegram وSlack وDiscord حتى يتمكن مساعدك من الوصول إليك في أي مكان.',
  'walkthrough.steps.settings.title': 'اجعله مناسباً لك',
  'walkthrough.steps.settings.content':
    'التفضيلات والخصوصية والإشعارات كلها هنا. يمكنك إعادة تشغيل هذه الجولة من هذه الصفحة في أي وقت.',
  'walkthrough.steps.chatTab.title': 'ارجع إلى الدردشة',
  'walkthrough.steps.chatTab.content': 'استخدم تبويب Chat عندما تريد الرجوع إلى محادثاتك.',
  'walkthrough.steps.humanTab.title': 'تعرّف إلى ملف Human',
  'walkthrough.steps.humanTab.content': 'يجمع Human سياقك الشخصي وهويتك والملف الذي يراه المساعد.',
  'walkthrough.steps.brainTab.title': 'افتح Brain',
  'walkthrough.steps.brainTab.content':
    'Brain هو مخطط الذاكرة: المكان الذي تفحص فيه ما يعرفه OpenHuman وكيف ترتبط الأفكار.',
  'walkthrough.steps.agentWorldTab.title': 'استكشف Agent World',
  'walkthrough.steps.agentWorldTab.content':
    'Agent World هو مكان الوكلاء القابلين لإعادة الاستخدام والأتمتة المشتركة.',
  'walkthrough.steps.connectionsTab.title': 'إدارة الاتصالات',
  'walkthrough.steps.connectionsTab.content':
    'Connections متاح دائماً في التنقل الرئيسي عندما تريد إضافة الخدمات أو تعديلها.',
  'walkthrough.steps.feedbackTab.title': 'إرسال ملاحظات',
  'walkthrough.steps.feedbackTab.content':
    'يوفر Feedback مكاناً مباشراً للإبلاغ عن المشاكل أو طلب التحسينات.',
  'walkthrough.steps.allSet.title': 'كل شيء جاهز!',
  'walkthrough.steps.allSet.content':
    'ترك لك المساعد رسالة ترحيب: هذه مساحتك للدردشة وطرح الأسئلة وتطوير الأفكار. استمتع!',
  'walkthrough.tooltip.letsGo': 'هيا بنا!',
  'walkthrough.tooltip.next': 'التالي →',
  'walkthrough.tooltip.skip': 'تخطّي الجولة',
  'walkthrough.tooltip.stepCounter': '{n} من {total}',
  'webhooks.activity.empty': 'فارغ',
  'webhooks.activity.title': 'النشاط الأخير',
  'webhooks.composioHistory.empty': 'فارغ',
  'webhooks.composioHistory.metadataId': 'معرف البيانات الوصفية',
  'webhooks.composioHistory.metadataUuid': 'UUID البيانات الوصفية',
  'webhooks.composioHistory.payload': 'البيانات',
  'webhooks.composioHistory.title': 'سجل مشغّلات ComposeIO',
  'webhooks.tunnels.active': 'نشط',
  'webhooks.tunnels.createFailed': 'فشل إنشاء النفق',
  'webhooks.tunnels.creating': 'جارٍ الإنشاء...',
  'webhooks.tunnels.deleteFailed': 'فشل حذف النفق',
  'webhooks.tunnels.descriptionPlaceholder': 'الوصف (اختياري)',
  'webhooks.tunnels.echo': 'صدى',
  'webhooks.tunnels.empty': 'فارغ',
  'webhooks.tunnels.enableEcho': 'تفعيل الصدى',
  'webhooks.tunnels.inactive': 'غير نشط',
  'webhooks.tunnels.namePlaceholder': 'اسم النفق (مثال: telegram-bot)',
  'webhooks.tunnels.newTunnel': 'نفق جديد',
  'webhooks.tunnels.removeEcho': 'إزالة الصدى',
  'webhooks.tunnels.title': 'أنفاق Webhook',
  'webhooks.tunnels.toggleFailed': 'فشل تبديل الصدى',
  'composio.directModeRequiresKey': 'فشل الحفظ. الوضع المباشر يتطلب مفتاح API غير فارغ.',
  'composio.integrationSlugsHelp': 'التكامل المفصول بفواصل الرخويات، على سبيل المثال.',
  'composio.integrationSlugsExample': 'gmail، slack',
  'composio.integrationSlugsCaseInsensitive': 'غير حساس لحالة الأحرف.',
  'composio.integrationSlugsPlaceholder': 'gmail، slack، ...',
  'composio.notYetRouted': 'لم يتم توجيهه بعد',
  'composio.triggers.loading': 'جارٍ التحميل…',
  'conversations.taskKanban.todo': 'للتنفيذ',
  'chat.addReaction': 'إضافة تفاعل',
  'chat.agentProfile.create': 'إنشاء ملف تعريف الوكيل',
  'chat.agentProfile.createFailed': 'تعذر إنشاء ملف تعريف الوكيل.',
  'chat.agentProfile.customDescription': 'ملف تعريف الوكيل المخصص',
  'chat.agentProfile.defaultAgentLabel': 'المنسق',
  'chat.agentProfile.exists': 'ملف تعريف الوكيل "{name}" موجود بالفعل.',
  'chat.agentProfile.label': 'ملف تعريف الوكيل',
  'chat.agentProfile.quick': 'سريع',
  'chat.agentProfile.reasoning': 'تفكير',
  'chat.agentProfile.namePlaceholder': 'اسم ملف التعريف',
  'chat.agentProfile.promptStylePlaceholder': 'نمط المطالبة',
  'chat.agentProfile.allowedToolsPlaceholder': 'الأدوات المسموح بها',
  'chat.backToThread': 'العودة إلى {title}',
  'chat.parentThread': 'الموضوع الأصلي',
  'chat.removeReaction': 'إزالة {emoji}',
  'settings.composio.loading': 'جارٍ التحميل…',
  'settings.mascot.noCharactersAvailable': 'لا توجد شخصيات OpenHuman متاحة بعد',
  'skills.uninstall.confirmTitle': 'إلغاء تثبيت {name}؟',
  'conversations.taskKanban.blocked': 'محظور',
  'conversations.taskKanban.done': 'مكتمل',
  'conversations.taskKanban.pending': 'تنتهي',
  'conversations.taskKanban.working': 'العمل',
  'conversations.taskKanban.awaitingApproval': 'في انتظار الموافقة',
  'conversations.taskKanban.ready': 'جاهز',
  'conversations.taskKanban.rejected': 'مرفوض',
  'conversations.taskKanban.inProgress': 'قيد التنفيذ',
  'conversations.taskKanban.awaitingApprovalColumn': 'في انتظار الموافقة',
  'conversations.taskKanban.blockedColumn': 'محظور',
  'conversations.taskKanban.evidenceBadge': 'الأدلة ({count})',
  'conversations.taskKanban.needsInput': 'هذه المهام تحتاج إلى مدخلاتك',
  'conversations.taskKanban.emptyColumn': 'لا توجد مهام',
  'conversations.taskKanban.dragHint': 'اسحب للتنقل بين الأعمدة',
  'conversations.taskKanban.movingCard': 'جارٍ النقل…',
  'conversations.taskKanban.statusBadge.ready': 'جاهز للبدء',
  'conversations.taskKanban.statusBadge.rejected': 'مرفوض',
  'intelligence.memoryChunk.detail.copiedHint': 'تم النسخ',
  'settings.composio.notYetRouted': 'لم يتم توجيهه بعد',
  'settings.localModel.download.manageExternal':
    'إدارة هذا النموذج في وقت التشغيل الخارجي الخاص بك.',
  'settings.localModel.status.manageOllamaExternal':
    'أدِر عملية Ollama وعمليات تحميل النماذج خارج OpenHuman، ثم أعد تشغيل التشخيصات.',
  'settings.localModel.status.ollamaDocs': 'وثائق Ollama',
  'settings.localModel.status.thenRetry':
    'للحصول على تعليمات الإعداد، ثم أعد المحاولة عندما يصبح وقت التشغيل قابلاً للوصول.',
  'devOptions.menuAi': 'تكوين الذكاء الاصطناعي',
  'devOptions.menuAiDesc': 'موفرو السحابة، ونماذج Ollama المحلية، والتوجيه لكل حمل عمل',
  'devOptions.menuMessaging': 'قنوات المراسلة',
  'devOptions.menuMessagingDesc': 'تكوين أوضاع المصادقة Telegram/Discord وتوجيه القناة الافتراضية',
  'devOptions.menuTools': 'الأدوات',
  'devOptions.menuToolsDesc': 'تمكين أو تعطيل الإمكانات التي يمكن أن يستخدمها OpenHuman نيابة عنك',
  'devOptions.menuAgentChat': 'دردشة الوكيل',
  'devOptions.menuAgentChatDesc': 'محادثة وكيل الاختبار مع تجاوزات النموذج ودرجة الحرارة',
  'devOptions.menuCronJobs': 'وظائف Cron',
  'devOptions.menuCronJobsDesc': 'عرض المهام المجدولة وتكوينها لمهارات وقت التشغيل',
  'devOptions.menuLocalModelDebug': 'تصحيح أخطاء النموذج المحلي',
  'devOptions.menuLocalModelDebugDesc':
    'Ollama التكوين وتنزيلات الأصول واختبارات النماذج والتشخيصات',
  'devOptions.menuWebhooksDebug': 'خطافات الويب',
  'devOptions.menuWebhooksDebugDesc': 'فحص تسجيلات خطاف الويب لوقت التشغيل وسجلات الطلبات الملتقطة',
  'devOptions.menuIntelligence': 'الذكاء',
  'devOptions.menuIntelligenceDesc': 'مساحة عمل الذاكرة ومحرك العقل الباطن والأحلام والإعدادات',
  'devOptions.menuNotificationRouting': 'توجيه الإشعارات',
  'devOptions.menuNotificationRoutingDesc':
    'تسجيل أهمية الذكاء الاصطناعي وتصعيد المنسق لتنبيهات التكامل',
  'devOptions.menuComposeIOTriggers': 'مشغلات ComposeIO',
  'devOptions.menuComposeIOTriggersDesc': 'عرض سجل وأرشيف مشغلات ComposeIO',
  'devOptions.menuComposioRouting': 'Composio التوجيه (الوضع المباشر)',
  'devOptions.menuComposioRoutingDesc':
    'أحضر مفتاح Composio API الخاص بك وقم بتوجيه المكالمات مباشرة إلى backend.composio.dev',
  'devOptions.menuComposioTriggers': 'مشغلات التكامل',
  'devOptions.menuComposioTriggersDesc':
    'تكوين إعدادات فرز الذكاء الاصطناعي لمشغلات التكامل Composio',
  'memory.sourceFilterAria': 'التصفية حسب المصدر',
  'calls.comingSoonDescription': 'المكالمات بمساعدة الذكاء الاصطناعي قادمة قريباً. ابقَ على اطلاع.',
  'whatsapp.title': 'WhatsApp',
  'subconscious.priority.critical': 'حرجة',
  'subconscious.priority.important': 'مهم',
  'subconscious.priority.normal': 'عادي',
  'subconscious.durationSeconds': '{seconds} ثانية',
  'subconscious.durationMilliseconds': '{milliseconds} مللي ثانية',
  'settings.appearance': 'المظهر',
  'settings.appearanceDesc': 'اختر لونًا فاتحًا أو داكنًا أو قم بمطابقة سمة النظام لديك',
  'settings.mascot': 'التميمة',
  'settings.mascotDesc': 'اختر لون التميمة المستخدم عبر التطبيق',
  'pages.settings.account.walletBalances': 'أرصدة المحفظة',
  'pages.settings.account.walletBalancesDesc': 'عرض أرصدة السلاسل المتعددة لمحفظتك المحلية',
  'walletBalances.title': 'أرصدة المحفظة',
  'walletBalances.refresh': 'Refresh',
  'walletBalances.loading': 'جارٍ تحميل الأرصدة…',
  'walletBalances.retry': 'Retry',
  'walletBalances.emptyState': 'لا توجد حسابات محفظة بعد: أعدّ محفظة في عبارة الاسترداد.',
  'walletBalances.copyAddress': 'نسخ العنوان',
  'walletBalances.providerMissing': 'الموفر غير متاح',
  'walletBalances.rawBalance': 'الخام: {raw}',
  'walletBalances.errorGeneric':
    'تعذّر تحميل أرصدة المحفظة. أعدّ محفظتك في عبارة الاسترداد وحاول مجدداً.',
  'walletBalances.setupHint':
    'لم تُعدّ عبارة الاسترداد بعد. أعدّها لتفعيل محفظتك وعرض الأرصدة المباشرة.',
  'walletBalances.setupCta': 'إعداد عبارة الاسترداد',
  'walletBalances.notSetUp': 'لم تُعد',
  'walletBalances.send': 'إرسال',
  'walletBalances.receive': 'استلام',
  'walletReceive.scanHint': 'امسح هذا الرمز أو انسخ العنوان أدناه لاستلام الأموال.',
  'walletReceive.addressLabel': 'عنوان {network}',
  'walletReceive.onlyChainWarning':
    'أرسل أصول {network} فقط إلى هذا العنوان. قد يؤدي إرسال أصول من شبكة أخرى إلى خسارة دائمة.',
  'walletSend.available': 'المتاح',
  'walletSend.recipient': 'عنوان المستلم',
  'walletSend.recipientPlaceholder': 'الصق عنوان الوجهة',
  'walletSend.recipientRequired': 'أدخل عنوان المستلم',
  'walletSend.amount': 'المبلغ',
  'walletSend.invalidAmount': 'أدخل مبلغاً صالحاً',
  'walletSend.review': 'مراجعة',
  'walletSend.preparing': 'جارٍ التحضير…',
  'walletSend.confirmHint': 'راجع التفاصيل أدناه. يتم التوقيع محلياً: لا يتم بث أي شيء حتى تؤكد.',
  'walletSend.estimatedFee': 'رسوم الشبكة المقدّرة',
  'walletSend.confirmSend': 'تأكيد وإرسال',
  'walletSend.sending': 'جارٍ الإرسال…',
  'walletSend.sent': 'تم إرسال المعاملة',
  'walletSend.txHash': 'تجزئة المعاملة',
  'walletSend.viewExplorer': 'العرض في المستكشف',
  'walletSend.done': 'تم',
  'walletSend.genericError': 'تعذّر إكمال التحويل. يرجى المحاولة مرة أخرى.',
  'settings.taskSources.title': 'المصادر',
  'settings.integrations.title': 'التكاملات',
  'settings.integrations.menuDesc': 'مصادر المهام وتوجيه Composio ومشغلات الويب هوك',
  'settings.taskSources.subtitle': 'سحب المهام من أدواتك على لوحة العميل (تود)',
  'settings.taskSources.description':
    'اجمع عناصر العمل من GitHub وNotion وLinear وClickUp، وأثرها، وقم بتوجيهها إلى لوحة مهام الوكيل.',
  'settings.taskSources.connectHint': 'مصادر المهمة تستخدم حساباتك المرتبطة إربطهم تحت الدمج أولاً',
  'settings.taskSources.disabledBanner':
    'وتُعوق مصادر المهام في البيئات. تمكنهم من الاقتراع تلقائياً',
  'settings.taskSources.loadError': 'عدم تحميل مصادر المهام',
  'settings.taskSources.addTitle': 'يضاف مصدر مهمة',
  'settings.taskSources.provider': 'Provider',
  'settings.taskSources.name': 'الاسم (اختياري)',
  'settings.taskSources.namePlaceholder': 'Xqx0xx. قضاياي المفتوحة',
  'settings.taskSources.github.repo': 'المستودع (المالك/الاسم، اختياري)',
  'settings.taskSources.github.labels': 'التصنيفات (مفصولة بفاصلة)',
  'settings.taskSources.notion.database': 'قاعدة البيانات (على متنها)',
  'settings.taskSources.notion.browseDatabases': 'تصفّح قواعد البيانات',
  'settings.taskSources.notion.loadingDatabases': 'جارٍ تحميل قواعد البيانات…',
  'settings.taskSources.notion.selectDatabase': 'اختر قاعدة بيانات…',
  'settings.taskSources.notion.noDatabases': 'لا توجد قواعد بيانات لهذا الاتصال.',
  'settings.taskSources.linear.team': 'هوية الفريق (اختياري)',
  'settings.taskSources.clickup.team': 'مكان العمل (الفريق)',
  'settings.taskSources.assignedToMe': 'فقط البنود الموكلة لي',
  'settings.taskSources.add': 'المصدر',
  'settings.taskSources.adding': 'إضافة...',
  'settings.taskSources.preview': 'Preview',
  'settings.taskSources.previewResult': 'مُهمة (مُهمات) مُطابقة لهذا التصفية',
  'settings.taskSources.fetchNow': 'أحضر الآن',
  'settings.taskSources.fetching': '....',
  'settings.taskSources.fetchResult':
    'تم توجيه {routed} من أصل {fetched} مهمة/مهام؛ تمت إزالة {pruned} مهمة/مهام قديمة',
  'settings.taskSources.syncAll': 'مزامنة الكل',
  'settings.taskSources.syncing': 'جارٍ المزامنة…',
  'settings.taskSources.configured': 'المصادر المحظورة',
  'settings.taskSources.empty': 'لم يتم تشكيل مصادر المهمة بعد',
  'settings.taskSources.proactive': 'استباقي',
  'settings.taskSources.lastFetch': 'آخر مرة',
  'settings.taskSources.never': 'أبداً',
  'settings.taskSources.statusEnabled': 'Enabled',
  'settings.taskSources.statusDisabled': 'المعوقين',
  'settings.taskSources.enable': 'التمكين',
  'settings.taskSources.disable': 'العجز',
  'settings.taskSources.remove': 'إزالة الألغام',
  'settings.taskSources.removeConfirm':
    'إزالة مصدر المهمة هذا؟ وسيتم حذف كل تاريخ المهمة المستغل ولا يمكن التخلي عنه.',
  'settings.taskSources.refresh': 'التجديد',
  'settings.taskSources.providers.github': 'GitHub',
  'settings.taskSources.providers.notion': 'Notion',
  'settings.taskSources.providers.linear': 'Linear',
  'settings.taskSources.providers.clickup': 'ClickUp',
  'skills.dashboard.enable': 'تفعيل سير العمل المجدول',
  'skills.dashboard.disable': 'تعطيل سير العمل المجدول',
  'skills.dashboard.lastRun': 'آخر تشغيل',
  'skills.dashboard.nextRun': 'التشغيل التالي',
  'skills.dashboard.cardOpenRunner': 'فتح في المشغّل',
  'skills.new.title': 'إنشاء سير عمل',
  'settings.agents.title': 'العملاء',
  'settings.agents.subtitle': 'إدارة الوكلاء المتاحين للوفد - الفشل المبنية ووكلاء العرف الخاص بك.',
  'settings.agents.menuDesc': 'إدارة الوكلاء المضمنين والمخصصين',
  'settings.agents.newAgent': 'عميل جديد',
  'settings.agents.loadError': 'لا يمكن تحميل العملاء',
  'settings.agents.empty': 'لا عملاء بعد الآن',
  'settings.agents.sourceDefault': 'البناء',
  'settings.agents.sourceCustom': 'العرف',
  'settings.agents.enable': 'وكيل تمكين',
  'settings.agents.disable': 'وكيل مخرب',
  'settings.agents.edit': 'Edit',
  'settings.agents.delete': 'Delete',
  'settings.agents.reset': 'إعادة إلى الافتراضي',
  'settings.agents.modelLabel': 'النموذج النموذجي',
  'settings.agents.toolsLabel': 'الأدوات',
  'settings.agents.toolsAll': 'جميع الأدوات',
  'settings.agents.toolsCount': 'أدوات xx0xxx',
  'settings.agents.actionFailed': 'لم أستطع تحديث العميل',
  'settings.agents.orchestratorLocked': 'المقسم مُتاح دائماً',
  'settings.agents.editor.createTitle': 'عميل جديد',
  'settings.agents.editor.editTitle': 'وكيل إديت',
  'settings.agents.editor.id': 'ID',
  'settings.agents.editor.idHint': 'رسائل أقل، أرقام، فقط',
  'settings.agents.editor.name': 'الاسم',
  'settings.agents.editor.description': 'الوصف',
  'settings.agents.editor.model': 'النموذج (اختياري)',
  'settings.agents.editor.modelPlaceholder': 'الورثة، التلميح: فاسد، أو نموذج id',
  'settings.agents.editor.systemPrompt': 'النظام السريع (اختياري)',
  'settings.agents.editor.tools': 'الأدوات المسموح بها',
  'settings.agents.editor.toolsHint': 'اسم أداة واحدة لكل خط استخدام * لجميع الأدوات.',
  'settings.agents.editor.defaultsNote': 'تحرير عميل مبني ينقذ تجاوز يمكنك إعادة ضبطه لاحقاً',
  'settings.agents.editor.save': 'أنقذ',
  'settings.agents.editor.create': 'وكيل خلق',
  'settings.agents.editor.saving': 'إنقاذ...',
  'nav.workflows': 'Workflows',
  'workflows.title': 'سير العمل',
  'workflows.subtitle':
    'إجراءات قابلة لإعادة الاستخدام والتشغيل: هدف مع خطوات تحقيقه. أنشئ واحدة، أو ثبّتها من رابط، أو افتح سير عمل لتشغيله.',
  'workflows.createNew': 'سير عمل جديد',
  'workflows.listHeading': 'مسارات العمل',
  'workflows.delete': 'حذف سير العمل',
  'workflows.deleteError': 'فشل حذف سير العمل',
  'workflows.warnings': '{count} تحذير(ات)',
  'workflows.empty.title': 'لا توجد سير عمل بعد',
  'workflows.empty.body': 'أنشئ سير عمل لتحديد القواعد والنصوص البرمجية لمراحل دورة حياة المهام.',
  'workflows.create.title': 'سير عمل جديد',
  'workflows.create.subtitle': 'حدد مجموعة قواعد مرتبطة بدورة الحياة للوكيل.',
  'workflows.create.name': 'الاسم',
  'workflows.create.namePlaceholder': 'مثال: سير عمل مشروع Python',
  'workflows.create.description': 'الوصف',
  'workflows.create.descriptionPlaceholder': 'ماذا يفعل سير العمل هذا؟',
  'workflows.create.whenToUse': 'متى يُستخدم',
  'workflows.create.whenToUsePlaceholder': 'متى يجب أن يستخدم الوكيل سير العمل هذا؟',
  'workflows.create.optional': '(اختياري)',
  'workflows.create.createBtn': 'إنشاء سير عمل',
  'workflows.create.creating': 'جارٍ الإنشاء…',
  'workflows.create.createError': 'تعذّر إنشاء سير العمل',
  'workflows.create.successTitle': 'تم إنشاء سير العمل',
  'workflows.create.successMessage': 'تم الإنشاء بنجاح.',
  'workflows.deleteConfirm.title': 'حذف سير العمل',
  'workflows.deleteConfirm.body': 'إزالة "{name}"؟ لا يمكن التراجع عن هذا.',
  'workflows.detail.tags': 'الوسوم',
  'workflows.detail.location': 'الموقع',
  'workflows.detail.warnings': 'التحذيرات',
  'workflows.detail.phases': 'المراحل',
  'workflows.detail.noPhases': 'لم يتم تحديد مراحل.',
  'workflows.detail.loadError': 'فشل تحميل سير العمل الكامل',
  'workflows.phase.rules': 'القواعد',
  'workflows.phase.rules.empty': 'لا توجد قواعد.',
  'workflows.phase.scripts': 'البرامج النصية',
  'workflows.phase.scripts.empty': 'لا توجد نصوص برمجية.',
  'workflows.phase.toolScope': 'نطاق الأدوات',
  'workflows.phase.toolScope.allow': 'سماح',
  'workflows.phase.toolScope.deny': 'رفض',
  'workflows.phase.toolScope.inherited': 'موروث من الإعداد الافتراضي لسير العمل.',
  'workflows.phase.toolScope.empty': 'لا توجد قيود على الأدوات.',
  'workflows.phase.context': 'Context',
  'workflows.phase.context.empty': 'لا يوجد مزودو سياق.',
  'settings.agentsSection.title': 'Agents',
  'settings.agentsSection.description':
    'إدارة عواملك واستقلاليتها وما يمكنها الوصول إليه على هذا الجهاز.',
  'settings.agentsSection.menuDesc': 'السجل، الاستقلالية ووصول نظام التشغيل',
  'settings.cryptoSection.title': 'العملات المشفرة',
  'settings.cryptoSection.description':
    'أدر عبارة الاسترداد الخاصة بك واعرض الأرصدة عبر حسابات محفظتك.',
  'settings.cryptoSection.menuDesc': 'عبارة الاسترداد وأرصدة المحفظة',
  'settings.notificationsHub.title': 'الإشعارات',
  'settings.notificationsHub.description':
    'اطّلع على صندوق التنبيهات وأدر تفضيلات الإشعارات والتوجيه.',
  'settings.notificationsHub.menuDesc': 'صندوق التنبيهات وتفضيلات الإشعارات',
  'settings.notificationsHub.settingsItem': 'إعدادات الإشعارات',
  'settings.notificationsHub.settingsItemDesc': 'التفضيلات والتوجيه',
  'settings.agents.editor.notFound': 'العامل غير موجود.',
  'settings.agents.editor.modelInherit': 'موروث (الافتراضي للمنصة)',
  'settings.agents.editor.modelHints': 'تلميحات التوجيه',
  'settings.agents.editor.modelTiers': 'مستويات النموذج',
  'settings.agents.editor.modelCustom': 'معرّف نموذج مخصص…',
  'settings.agents.editor.modelCustomPlaceholder': 'مثال: anthropic/claude-sonnet-4',
  'settings.agents.editor.selectTools': 'إضافة أدوات',
  'settings.agents.editor.toolsAllSelected': 'كل الأدوات',
  'settings.agents.editor.toolsNoneSelected': 'لم يتم اختيار أي أدوات',
  'settings.agents.editor.removeToolAria': 'إزالة {tool}',
  'settings.agents.editor.toolsModalTitle': 'الأدوات المسموح بها',
  'settings.agents.editor.toolsSelectedCount': '{count} محددة',
  'settings.agents.editor.toolsSearchPlaceholder': 'البحث في الأدوات…',
  'settings.agents.editor.toolsAllowAll': 'السماح بجميع الأدوات (*)',
  'settings.agents.editor.toolsAllowAllHint': 'يمكن لهذا العامل استخدام كل الأدوات المتاحة.',
  'settings.agents.editor.toolsLoading': 'جارٍ تحميل الأدوات…',
  'settings.agents.editor.toolsLoadError': 'تعذّر تحميل الأدوات',
  'settings.agents.editor.toolsEmpty': 'لا توجد أدوات تطابق بحثك.',
  'settings.agents.editor.toolsDone': 'Done',
  'settings.agents.editor.builtInReadonly':
    'لا يمكن تعديل العوامل المدمجة. يمكنك تفعيلها أو تعطيلها أو إعادة ضبطها من قائمة العوامل.',
  // Chat: agent-generated artifacts (#2779)
  'chat.artifact.aria': 'الملف: {title}',
  'chat.artifact.generating': 'جارٍ إنشاء {kind}…',
  'chat.artifact.ready': 'جاهز',
  'chat.artifact.failed': 'فشل الإنشاء',
  'chat.artifact.download': 'تنزيل',
  'chat.artifact.downloading': 'جارٍ التنزيل…',
  'chat.artifact.downloaded': 'تم الحفظ في {path}',
  'chat.artifact.download_failed': 'فشل التنزيل: {reason}',
  'chat.artifact.retry': 'إعادة المحاولة',
  'chat.artifact.reveal': 'عرض في المجلد',
  'chat.artifact.show_more': 'عرض المزيد',
  'chat.artifact.show_less': 'عرض أقل',

  // Chat: files panel (#3024)
  'chat.files.chip.aria.one': 'ملف واحد في هذه المحادثة',
  'chat.files.chip.aria.other': '{count} ملفات في هذه المحادثة',
  'chat.files.panel.aria': 'ملفات في هذه المحادثة',
  'chat.files.panel.title': 'الملفات ({count})',
  'chat.files.panel.empty': 'لا توجد ملفات بعد. اطلب من الوكيل إنشاء واحد.',
  'chat.files.panel.close': 'إغلاق لوحة الملفات',
  'chat.files.delete.aria': 'حذف {title}',
  'chat.files.delete.confirm': 'هل تريد حذف هذا الملف؟',
  'chat.files.delete.cancel': 'إلغاء',
  'chat.files.delete.action': 'حذف',
  'chat.files.delete.failed': 'تعذّر حذف الملف. حاول مرة أخرى.',
  'chat.files.error.not_desktop': 'التنزيلات متاحة فقط في تطبيق سطح المكتب.',
  'chat.files.error.missing_artifact_id': 'معرّف الملف مفقود.',
  'chat.files.error.missing_artifact_path': 'مسار الملف مفقود من استجابة النظام.',
  'chat.files.error.resolve_failed': 'تعذّر تحديد الملف. حاول مرة أخرى.',
  'chat.files.error.download_failed': 'فشل التنزيل. حاول مرة أخرى.',
  'chat.files.error.delete_failed': 'تعذّر حذف الملف. حاول مرة أخرى.',
  'memory.tab.council': 'Council',
  'activity.tabs.automations': 'أتمتة',
  'activity.tabs.automationsDescription':
    'إجراءات قابلة لإعادة الاستخدام والتشغيل: هدف مع الخطوات للوصول إليه.',
  'activity.tabs.backgroundActivity': 'اللاوعي',
  'activity.tabs.alerts': 'التنبيهات',

  'intelligence.agents.title': 'مكتبة الوكلاء',
  'intelligence.agents.subtitle':
    'استعرض المتخصصين القابلين للتشغيل وأرسل مهمة واحدة إلى وكيل محدد.',
  'intelligence.agents.refresh': 'تحديث',
  'intelligence.agents.loading': 'جارٍ تحميل الوكلاء…',
  'intelligence.agents.failedToLoad': 'تعذر تحميل الوكلاء',
  'intelligence.agents.empty': 'لا توجد وكلاء قابلة للتشغيل.',
  'intelligence.agents.readOnly': 'قراءة فقط',
  'intelligence.agents.writeCapable': 'يمكنه الكتابة',
  'intelligence.agents.allTools': 'كل الأدوات',
  'intelligence.agents.toolCountOne': '{count} أداة',
  'intelligence.agents.toolCountOther': '{count} أدوات',
  'intelligence.agents.subagentCountOne': '{count} وكيل فرعي',
  'intelligence.agents.subagentCountOther': '{count} وكلاء فرعيين',
  'intelligence.agents.startChat': 'بدء الدردشة',
  'intelligence.agents.startChatPrompt':
    'ابدأ دردشة مع هذا الوكيل. عرّف بتخصصك، واسأل عمّا تحتاج إلى معرفته، ثم انتظر مهمتي.',
  'intelligence.agents.copyId': 'نسخ المعرّف',
  'intelligence.agents.copied': 'تم النسخ',
  'intelligence.agents.taskPlaceholder': 'مهمة لهذا الوكيل',
  'intelligence.agents.runTask': 'تشغيل المهمة',
  'intelligence.agents.running': 'قيد التشغيل…',
  'intelligence.agents.runFailed': 'تعذر بدء الوكيل المحدد',
  'intelligence.agents.model.inherit': 'وراثة',
  'intelligence.agents.tier.chat': 'دردشة',
  'intelligence.agents.tier.reasoning': 'استدلال',
  'intelligence.agents.tier.worker': 'عامل',
  'graphCohesion.brokerBadge': 'وسيط',
  'graphCohesion.brokerTitle':
    'ثقب بنيوي: جيران هذا الكيان غير مترابطين فيما بينهم: وهو الرابط الوحيد بينهم.',
  'graphCohesion.colCohesion': 'التماسك',
  'graphCohesion.colEntity': 'الكيان',
  'graphCohesion.colLinks': 'روابط',
  'graphCohesion.colRank': '#',
  'graphCohesion.empty': 'لا يوجد رسم معرفة بعد.',
  'graphCohesion.emptyHint': 'كلما سجّل المساعد حقائق مترابطة عنك، ستظهر هنا بنية تجميعها.',
  'graphCohesion.errorPrefix': 'تعذّر تحميل الرسم البياني:',
  'graphCohesion.intro':
    'مدى تماسك الجوار حول كل كيان. الوسطاء (كيانات لا يرتبط جيرانها ببعضهم) هم النقاط الوحيدة التي تربط بين عناقيد كانت ستظل منفصلة، وهو ما لا يمكن لفرز التكرار أو PageRank الكشف عنه.',
  'graphCohesion.loading': 'يجري حساب التماسك…',
  'graphCohesion.metricConnections': 'الاتصالات',
  'graphCohesion.metricEntities': 'الكيانات',
  'graphCohesion.metricTriangles': 'مثلثات',
  'graphCohesion.namespaceAll': 'كل مساحات الأسماء',
  'graphCohesion.namespaceLabel': 'مساحة الأسماء',
  'graphCohesion.noBrokers': 'لا توجد بعد كيانات بصلتين أو أكثر.',
  'graphCohesion.rankedHeading': 'الوسطاء: أكثر الجوارات تخلخلًا',
  'graphCohesion.retry': 'إعادة المحاولة',
  'graphCohesion.summaryCaption': 'متوسط التجميع {avg} · التعدّي {transitivity}',
  'graphCohesion.title': 'تماسك الرسم البياني',
  'memory.tab.cohesion': 'Cohesion',

  'harnessInit.title': 'جارٍ الإعداد',

  'announcement.gotIt': 'حسناً',
  'harnessInit.subtitle': 'يقوم OpenHuman بتجهيز المكونات التي يحتاجها عند التشغيل الأول.',
  'harnessInit.stepPython': 'بيئة تشغيل Python',
  'harnessInit.stepSpacy': 'النموذج اللغوي',
  'harnessInit.stepNode': 'بيئة تشغيل Node.js',
  'harnessInit.statePending': 'في الانتظار',
  'harnessInit.stateRunning': 'جارٍ التثبيت…',
  'harnessInit.stateDone': 'جاهز',
  'harnessInit.stateSkipped': 'تم التخطي',
  'harnessInit.stateFailed': 'فشل',
  'harnessInit.failedMessage':
    'لم تكتمل بعض خطوات الإعداد. يمكنك إعادة المحاولة أو المتابعة: سيستخدم OpenHuman بديلاً مدمجاً.',
  'harnessInit.retry': 'إعادة المحاولة',
  'harnessInit.continueAnyway': 'المتابعة على أي حال',
  'harnessInit.runInBackground': 'التشغيل في الخلفية',
  'harnessInit.backgroundHint': 'يمكنك مواصلة استخدام OpenHuman حتى ينتهي هذا.',

  'keyring.consent.title': 'التخزين الآمن غير متاح',
  'keyring.consent.description':
    'سلسلة مفاتيح نظام التشغيل غير متاحة. يحتاج OpenHuman إلى إذنك لتخزين الأسرار باستخدام التخزين المشفّر المحلي بدلاً من ذلك.',
  'keyring.consent.reasonPrefix': 'السبب:',
  'keyring.consent.showDetails': 'ماذا يعني هذا؟',
  'keyring.consent.hideDetails': 'إخفاء التفاصيل',
  'keyring.consent.tradeoffTitle': 'مقايضة أمنية',
  'keyring.consent.tradeoffBody':
    'مع التخزين المشفّر المحلي، تُشفَّر أسرارك على القرص باستخدام مفتاح رئيسي مخزَّن بجانب البيانات. يُعدّ هذا أقل أماناً من OS Keychain الذي يستخدم حماية مدعومة بالأجهزة. قد تتضمن النسخ الاحتياطية أو مزامنة الملفات البيانات المشفّرة.',
  'keyring.consent.consentButton': 'استخدام التخزين المشفّر المحلي',
  'keyring.consent.retryButton': 'إعادة المحاولة مع OS Keychain',
  'keyring.consent.declineButton': 'رفض',
  'keyring.consent.retrying': 'جارٍ إعادة المحاولة…',
  'keyring.consent.error': 'فشل حفظ التفضيل. يرجى المحاولة مرة أخرى.',
  'keyring.consent.retryFailed': 'سلسلة المفاتيح لا تزال غير متاحة.',
  'keyring.settings.title': 'الأمان',
  'keyring.settings.storageMode': 'وضع تخزين الأسرار',
  'keyring.settings.mode.osKeychain': 'سلسلة مفاتيح النظام',
  'keyring.settings.mode.encryptedFile': 'مشفَّر محلياً',
  'keyring.settings.mode.consentPending': 'غير مُهيَّأ',
  'keyring.settings.mode.declined': 'مرفوض',
  'keyring.settings.availability': 'توفّر سلسلة المفاتيح',
  'keyring.settings.available': 'OS Keychain متاح',
  'keyring.settings.unavailable': 'OS Keychain غير متاح',
  'keyring.settings.backend': 'الواجهة الخلفية',
  'keyring.settings.retryButton': 'إعادة محاولة الكشف عن سلسلة المفاتيح',
  'keyring.settings.retryFailed': 'فشلت إعادة المحاولة. سلسلة المفاتيح لا تزال غير متاحة.',
  'keyring.settings.consentTitle': 'موافقة التخزين',
  'keyring.settings.consentDescription':
    'اختر كيفية تخزين الأسرار عندما لا تكون سلسلة مفاتيح نظام التشغيل متاحة.',
  'keyring.settings.grantConsent': 'السماح بالتخزين المشفّر المحلي',
  'keyring.settings.revokeConsent': 'رفض التخزين المحلي',
  'pages.settings.account.security': 'الأمان',
  'pages.settings.account.securityDesc': 'وضع تخزين الأسرار وحالة سلسلة المفاتيح',
  // #002 memory-pipeline-hardening: degraded badges + typed remediation.
  'memoryTree.status.statusDegraded': 'متدهور',
  'memoryTree.status.statusBudgetExhausted': 'متوقف مؤقتًا: انتهت ميزانية التضمينات',
  'memoryTree.status.degradedRecall': 'الاسترجاع الدلالي معطّل',
  'memoryTree.status.degradedStructure': 'بنية الويكي غير مكتملة',
  'memoryTree.status.extractionCoverage': 'تغطية الاستخراج: {pct}% من الأجزاء لها بنية',
  'memory.health.remediation.budget_exhausted':
    'استنفدت تضمينات الذاكرة الميزانية المُدارة. أعدّ تضمينات Ollama المحلية (الاتصالات → مفاتيح API → التضمينات) أو أضف مفتاح API الخاص بك للتضمينات لمواصلة بناء الذاكرة.',
  'memory.health.remediation.auth_missing':
    'لم يتم العثور على بيانات اعتماد التضمينات. سجّل الدخول إلى OpenHuman، أو أعدّ تضمينات Ollama المحلية في الاتصالات → مفاتيح API → التضمينات.',
  'memory.health.remediation.auth_invalid':
    'تم رفض بيانات اعتماد التضمينات الخاصة بك. أعد المصادقة، أو بدّل إلى تضمينات Ollama المحلية في الاتصالات → مفاتيح API → التضمينات.',
  'memory.health.remediation.embeddings_unconfigured':
    'لم يتم تكوين أي مزوّد تضمينات، لذا فإن الاسترجاع الدلالي معطّل. أعدّ تضمينات Ollama المحلية (موصى به) أو أضف مفتاح تضمينات في الاتصالات → مفاتيح API → التضمينات.',
  'memory.health.remediation.embedding_dim_mismatch':
    'يعيد نموذج التضمين حجم متجه خاطئًا (تتوقع الذاكرة 1024 بُعدًا). اختر نموذجًا بـ 1024 بُعدًا، أو اطلب 1024 بُعدًا من مزوّدك.',
  'memory.health.remediation.local_model_unavailable':
    'نموذج محلي مطلوب غير متوفر. ثبّت/شغّل Ollama ونزّل النموذج، أو بدّل هذا الحِمل إلى مزوّد سحابي في الاتصالات → مفاتيح API.',
  'memory.health.remediation.extraction_timeout':
    'يتجاوز نموذج استخراج الذاكرة المهلة الزمنية، لذا فإن بنية الويكي قليلة. بدّل نموذج استخراج الذاكرة إلى نموذج أسرع في الاتصالات → مفاتيح API → LLM.',
  'memory.health.remediation.summarizer_unavailable':
    'لا يتوفر مزوّد تلخيص لميزة إنشاء أشجار التلخيص. فعّل الذكاء الاصطناعي المحلي (Ollama)، أو اضبط memory_tree.cloud_summarization_opt_in=true وهيّئ مزوّد LLM في الاتصالات → مفاتيح API → LLM.',
  'memory.health.remediation.empty_input_refused':
    'تم تخطي عنصر ذاكرة لأن نصه كان فارغًا. لا حاجة لأي إجراء: تستمر العناصر الجديدة في التضمين بشكل طبيعي.',
  'memory.health.remediation.storage_unavailable':
    'تعذّر على OpenHuman الكتابة إلى تخزين الذاكرة: يبدو أن القرص أو بطاقة SD معطوبة أو ممتلئة أو للقراءة فقط. تحقّق من محرك الأقراص وحرّر بعض المساحة؛ ستُستأنف معالجة الذاكرة تلقائيًا بمجرد أن يصبح التخزين قابلاً للكتابة مرة أخرى.',
  'memory.health.remediation.transient':
    'حدث خطأ مؤقت أدى إلى مقاطعة معالجة الذاكرة. ستتم إعادة المحاولة تلقائيًا.',
  'memory.health.remediation.unknown':
    'واجهت معالجة الذاكرة مشكلة. تحقق من الاتصالات → مفاتيح API للتكوين.',
  // Chat: agent-generated artifacts (#2779)

  // Chat composer toolbar
  'composer.attachFile': 'إرفاق ملف',
  'composer.modelSelector': 'النموذج',
  'composer.voiceMode': 'وضع الصوت',
  'composer.qualityHigh': 'عالٍ',
  // Agent activity level
  'activityLevel.title': 'مستوى نشاط الوكيل',
  'activityLevel.description':
    'تحكم في مدى استباقية وكيلك. المستويات الأعلى تستخدم المزيد من الرموز.',
  'activityLevel.off': 'إيقاف',
  'activityLevel.offDesc': 'لا معالجة في الخلفية. يزامن فقط عند الضغط على الزر.',
  'activityLevel.minimal': 'أدنى حد',
  'activityLevel.minimalDesc': 'مزامنة المصادر مرة يوميًا. لا رسائل استباقية.',
  'activityLevel.moderate': 'متوسط',
  'activityLevel.moderateDesc': 'مزامنة كل ساعة. ملخص يومي. يقترح إجراءات.',
  'activityLevel.active': 'نشط',
  'activityLevel.activeDesc': 'مزامنة كل 10 دقائق. يراقب القنوات ويصنف ويصيغ الردود.',
  'activityLevel.alwaysOn': 'دائم التشغيل',
  'activityLevel.alwaysOnDesc': 'مزامنة فورية. استقلالية كاملة ضمن الحدود المحددة.',
  'activityLevel.currentMonth': 'هذا الشهر: ${amount}',
  'activityLevel.saved': 'تم تحديث مستوى النشاط.',
  'activityLevel.default': 'افتراضي',
  'activityLevel.costFree': '0$',
  'activityLevel.costRange': '~${min}–${max}/شهر',

  // Sync budget dialog
  'syncBudget.title': 'ميزانية المزامنة',
  'syncBudget.maxTokens': 'الحد الأقصى للرموز لكل مزامنة',
  'syncBudget.maxTokensHelp': 'توقف المزامنة عند استهلاك هذا العدد من الرموز.',
  'syncBudget.maxCost': 'الحد الأقصى للتكلفة لكل مزامنة (USD)',
  'syncBudget.maxCostHelp': 'حد التكلفة المطلق بالدولار لكل تشغيل مزامنة.',
  'syncBudget.syncDepth': 'عمق المزامنة',
  'syncBudget.syncDepthHelp': 'جلب العناصر من هذه الفترة الزمنية فقط.',
  'syncBudget.days7': 'آخر 7 أيام',
  'syncBudget.days30': 'آخر 30 يومًا',
  'syncBudget.days90': 'آخر 90 يومًا',
  'syncBudget.allTime': 'كل الأوقات',
  'syncBudget.unlimited': 'غير محدود',
  'syncBudget.saved': 'تم حفظ الميزانية.',

  // Sync confirm dialog
  'syncConfirm.title': 'تأكيد المزامنة',
  'syncConfirm.message': 'ستعالج هذه المزامنة ~{items} عناصر (~{tokens} رمز، تقديري ${cost}).',
  'syncConfirm.budgetNote': 'حد الميزانية: ${max}',
  'syncConfirm.proceed': 'المتابعة',
  'syncConfirm.cancel': 'إلغاء',
  'syncConfirm.estimating': 'جارٍ تقدير التكلفة...',

  // Monthly cost badge
  'monthlyCost.badge': '${amount} هذا الشهر',
  'monthlyCost.noData': 'لا مزامنات هذا الشهر',

  // Onboarding: Custom > Activity
  'onboarding.custom.stepperActivity': 'النشاط',
  'onboarding.custom.stepperVault': 'الخزينة',
  'onboarding.custom.activity.title': 'نشاط الوكيل',
  'onboarding.custom.activity.subtitle': 'مدى استباقية وكيلك في المراقبة والتصرف في الخلفية.',
  'onboarding.custom.activity.defaultDesc': 'نشاط متوسط: مزامنة كل ساعة، ملخص يومي.',
  'onboarding.custom.activity.configureDesc':
    'اختر مستوى نشاطك الخاص. الإعداد في الإعدادات › مستوى نشاط الوكيل.',
  'onboarding.custom.vault.title': 'إعداد الذاكرة والخزينة',
  'onboarding.custom.vault.subtitle':
    'تأكيد موضع كتابة ملاحظات الذاكرة، وكيفية قراءة البيانات المصدر، وسلامة مسار الخزينة.',
  'onboarding.custom.vault.defaultDesc':
    'استخدم الإعدادات الافتراضية لذاكرة OpenHuman المُدارة. يمكن مراجعة مسار الخزينة وصحة المزامنة لاحقًا.',
  'onboarding.custom.vault.configureDesc':
    'راجع ملكية الخزينة، وشغّل فحوصات الصحة، واضبط عناصر التحكم في الذاكرة الآن.',
  'onboarding.custom.vault.localDisabledReason':
    'يتطلب الإعداد المُدار تسجيل الدخول إلى OpenHuman وغير متاح في الوضع المحلي.',
  'onboarding.custom.vault.exitError': 'تعذّر إتمام الإعداد. يُرجى المحاولة مجددًا.',
  'vaultHealth.title': 'قائمة فحص صحة الخزينة',
  'vaultHealth.setupTitle': 'صحة إعداد الخزينة',
  'vaultHealth.workspaceVault': 'خزينة مساحة العمل:',
  'vaultHealth.refresh': 'تحديث',
  'vaultHealth.refreshing': 'جارٍ التحديث…',
  'vaultHealth.revealFolder': 'إظهار المجلد',
  'vaultHealth.openInObsidian': 'فتح في Obsidian',
  'vaultHealth.installObsidian': 'تثبيت Obsidian',
  'vaultHealth.openObsidianError': 'تعذّر فتح Obsidian',
  'vaultHealth.revealError': 'تعذّر إظهار مجلد الخزينة',
  'vaultHealth.downloadError': 'تعذّر فتح صفحة تنزيل Obsidian',
  'vaultHealth.loadError': 'تعذّر تحميل صحة الخزينة:',
  'vaultHealth.lastSync': 'آخر مزامنة:',
  'vaultHealth.passed': 'ناجح',
  'vaultHealth.needsAttention': 'يحتاج إلى انتباه',
  'vaultHealth.existsLabel': 'مسار خزينة مساحة العمل موجود',
  'vaultHealth.existsRecovery':
    'مجلد الخزينة مفقود. ابدأ مزامنة أو أنشئ هذا المجلد، ثم حدّث هذه القائمة.',
  'vaultHealth.writableLabel': 'الخزينة قابلة للكتابة بواسطة OpenHuman',
  'vaultHealth.writableRecovery':
    'لا يستطيع OpenHuman الكتابة في هذه الخزينة بعد. امنح أذونات الكتابة ثم حدّث.',
  'vaultHealth.obsidianLabel': 'الخزينة مسجّلة في Obsidian',
  'vaultHealth.obsidianRecovery':
    'في Obsidian، اختر "فتح المجلد كخزينة" لهذا المسار، ثم حدّث هذه القائمة.',
  'vaultHealth.pipelineLabel': 'مسار الذاكرة سليم',
  'vaultHealth.pipelineRecovery':
    'مسار الذاكرة متوقف أو في حالة خطأ. أعد تفعيل المزامنة التلقائية في حالة شجرة الذاكرة وأعد المحاولة.',
  'vaultHealth.timeNever': 'قط',
  'vaultHealth.timeJustNow': 'الآن',
  'vaultHealth.timeMinAgo': 'منذ {n} دقيقة',
  'vaultHealth.timeHrAgo': 'منذ {n} ساعة',
  'vaultHealth.timeDayAgo': 'منذ {n} يوم',
  'vaultHealth.timeDaysAgo': 'منذ {n} أيام',
  'memoryData.howItWorks': 'كيف يعمل تخزين الذاكرة',
  'memoryData.workspaceVault': 'خزينة مساحة العمل · كتابة',
  'memoryData.workspaceVaultDesc':
    'يكتب OpenHuman ملاحظات الذاكرة المُولَّدة إلى memory_tree/content.',
  'memoryData.connectedSources': 'المصادر المتصلة · قراءة',
  'memoryData.connectedSourcesDesc':
    'تُستورد المجلدات وصناديق البريد والمحادثات والمستودعات لفهرسة الذاكرة: ولا تُعاد كتابة ملفاتها الأصلية أبدًا.',
  'memoryData.internalFiles': 'ملفات شجرة الذاكرة الداخلية',
  'memoryData.internalFilesDesc':
    'تُدار الفهارس وحالة قائمة الانتظار والملخصات بواسطة OpenHuman للحفاظ على سلامة الاسترجاع والمزامنة.',
  'memoryData.windowError': 'نافذة الذاكرة',
  'memoryData.windowUpdated': 'تم تحديث نافذة الذاكرة',
  'memoryData.windowUpdatedMsg': 'تم الضبط على {window}.',
  'skills.create.whenToUse': 'متى يُستخدم',
  'skills.create.whenToUsePlaceholder': 'مثال: عندما يطلب المستخدم تنظيم صندوق الوارد',
  'skills.create.whenToUseHelp':
    'المُحفِّز الذي يعتمد عليه الوكيل لتقرير تشغيل سير العمل هذا. اتركه فارغًا لإعادة استخدام الوصف.',
  'skills.create.inputs.row.descriptionError': 'يلزم وصف لكل إدخال.',
  'skills.detail.run': 'تشغيل',
  'skills.detail.runAriaLabel': 'تشغيل سير العمل هذا',
  'skills.run.title': 'سير العمل',
  'workflows.installFromUrl': 'التثبيت من رابط',
  // Security banner (approval-gate host-aware boot state)
  'security.approvalGateDisabled.title': 'تم تعطيل بوابة الموافقة',
  'security.approvalGateDisabled.body':
    'تم تعيين OPENHUMAN_APPROVAL_GATE=0 في بيئتك. ستعمل الأدوات ذات التأثير الخارجي دون طلب تأكيد.',
  'security.approvalGateOverrideIgnored.title': 'تم حظر التجاوز',
  'security.approvalGateOverrideIgnored.body':
    'تم اكتشاف تجاوز OPENHUMAN_APPROVAL_GATE=0 لكنه تم تجاهله: يحافظ تطبيق سطح المكتب دائمًا على تفعيل بوابة الموافقة.',

  // Run queue
  'runQueue.mode.interrupt': 'مقاطعة',
  'runQueue.mode.steer': 'توجيه',
  'runQueue.mode.followup': 'متابعة',
  'runQueue.mode.collect': 'إضافة سياق',
  'runQueue.queued': 'تم وضع الرسالة في الانتظار',
  'runQueue.steerHint': 'وجّه الدور الحالي',
  'runQueue.followupHint': 'أضف إلى قائمة الانتظار كمتابعة',
  'runQueue.collectHint': 'إضافة كسياق إضافي',
  'runQueue.status': '{total} في الانتظار',
  'runQueue.cleared': 'تم مسح قائمة الانتظار',
  'notch.ready': 'جاهز',
  'notch.processing': 'جارٍ المعالجة…',
  'notch.listening': 'أستمع…',
  'notch.thinking': 'أفكر…',
  'notch.speaking': 'أتحدث…',
  'notch.transcribing': 'أفسّر…',
  'notch.executing': 'أنفّذ…',
  'memory.tab.orchestration': 'التنسيق',
  'memory.tab.orchestrationDescription':
    'شغّل سير عمل متعدد الوكلاء: وزّع سؤالاً على وكلاء متوازين، وتحقّق من نتائجهم بشكل متبادل، وراقب اكتمال كل مرحلة لتتجمّع في إجابة واحدة مُركَّبة.',
  'orchestration.subtitle':
    'ابدأ سير عمل متعدد الوكلاء، وراقب تقدّم مراحله، واقرأ النتيجة المُركَّبة.',
  'orchestration.loading': 'جارٍ تحميل سير العمل…',
  'orchestration.failedToLoad': 'تعذّر تحميل سير العمل',
  'orchestration.definitions': 'سير العمل المتاح',
  'orchestration.noDefinitions': 'لا توجد تعريفات سير عمل متاحة.',
  'orchestration.approvalRequired': 'الموافقة مطلوبة',
  'orchestration.start': 'بدء',
  'orchestration.confirmStart': 'بدء التشغيل',
  'orchestration.starting': 'جارٍ البدء…',
  'orchestration.questionLabel': 'سؤال البحث (اختياري)',
  'orchestration.questionPlaceholder': 'ما الذي يجب أن يبحث فيه الوكلاء؟',
  'orchestration.runProgress': 'تقدّم التشغيل',
  'orchestration.recentRuns': 'عمليات التشغيل الأخيرة',
  'orchestration.noRuns': 'لا توجد عمليات تشغيل لسير العمل بعد.',
  'orchestration.close': 'إغلاق',
  'orchestration.tier.readOnly': 'للقراءة فقط',
  'orchestration.tier.standard': 'قياسي',
  'orchestration.tier.editCapable': 'قادر على التحرير',
  'orchestration.approval.title': 'الموافقة على تشغيل سير العمل هذا',
  'orchestration.approval.body':
    'هذا تشغيل عالي التكلفة أو عالي التزامن ويتطلّب موافقتك الصريحة قبل أن يبدأ:',
  'orchestration.approval.reason.tier': 'يمكن لوكلائه تنفيذ إجراءات تتجاوز البحث للقراءة فقط.',
  'orchestration.approval.reason.concurrency': 'يشغّل العديد من الوكلاء في الوقت نفسه.',
  'orchestration.approval.reason.children': 'قد يُنشئ عدداً كبيراً جداً من الوكلاء إجمالاً.',
  'orchestration.approval.tier': 'مستوى الأمان',
  'orchestration.approval.concurrency': 'التزامن',
  'orchestration.approval.maxChildren': 'الحد الأقصى للوكلاء',
  'orchestration.approval.approve': 'الموافقة والبدء',
  'orchestration.approval.starting': 'جارٍ البدء…',
  'orchestration.approval.cancel': 'إلغاء',
  'orchestration.runStatus.pending': 'قيد الانتظار',
  'orchestration.runStatus.running': 'قيد التشغيل',
  'orchestration.runStatus.completed': 'مكتمل',
  'orchestration.runStatus.failed': 'فشل',
  'orchestration.runStatus.cancelled': 'مُلغى',
  'orchestration.runStatus.interrupted': 'مُقاطع',
  'orchestration.phaseStatus.pending': 'قيد الانتظار',
  'orchestration.phaseStatus.running': 'قيد التشغيل',
  'orchestration.phaseStatus.completed': 'مكتملة',
  'orchestration.phaseStatus.failed': 'فشلت',
  'orchestration.detail.stop': 'إيقاف',
  'orchestration.detail.resume': 'استئناف',
  'orchestration.detail.agents': 'وكلاء',
  'orchestration.detail.childRefs': 'الوكلاء الفرعيون',
  'orchestration.detail.synthesis': 'التركيب النهائي',
  // ── Agent Profiles ───────────────────────────────────────────────────────
  'settings.profiles.title': 'ملفات الوكيل',
  'settings.profiles.subtitle': 'وكلاء بطابع خاص: لكل منهم روحه وذاكرته وموصّلاته ومهاراته.',
  'settings.profiles.menuDesc': 'أنشئ ملفات الوكيل وأدِرها',
  'settings.profiles.new': 'ملف جديد',
  'settings.profiles.empty': 'لا توجد ملفات وكيل بعد',
  'settings.profiles.loadError': 'تعذّر تحميل الملفات',
  'settings.profiles.active': 'نشط',
  'settings.profiles.setActive': 'تعيين كنشط',
  'settings.profiles.sourceBuiltIn': 'مدمج',
  'settings.profiles.sourceCustom': 'مخصّص',
  'settings.profiles.deleteConfirm': 'حذف هذا الملف؟ لا يمكن التراجع عن ذلك.',
  'settings.profiles.editor.createTitle': 'ملف جديد',
  'settings.profiles.editor.editTitle': 'تحرير الملف',
  'settings.profiles.editor.name': 'الاسم',
  'settings.profiles.editor.id': 'المعرّف',
  'settings.profiles.editor.idHint': 'أحرف صغيرة وأرقام وشرطات فقط.',
  'settings.profiles.editor.description': 'الوصف',
  'settings.profiles.editor.soul': 'الروح (SOUL.md)',
  'settings.profiles.editor.soulHint':
    'هوية مخصّصة لهذا الملف. عند تركه فارغًا يُستخدم ملف SOUL.md الخاص بمساحة العمل.',
  'settings.profiles.editor.baseAgent': 'الوكيل الأساسي',
  'settings.profiles.editor.baseAgentHint':
    'تعريف الوكيل الذي يعمل به هذا الملف (مثل orchestrator).',
  'settings.profiles.editor.model': 'النموذج',
  'settings.profiles.editor.modelHint': 'تجاوز اختياري للنموذج. عند تركه فارغًا يَرِث الافتراضي.',
  'settings.profiles.editor.temperature': 'درجة الحرارة',
  'settings.profiles.editor.systemPromptSuffix': 'لاحقة موجّه النظام',
  'settings.profiles.editor.agentConversations': 'استدعاء محادثات الوكيل',
  'settings.profiles.editor.agentConversationsHint':
    'تضمين ذاكرة المحادثات السابقة والمتقاطعة في سياق هذا الملف.',
  'settings.profiles.editor.memorySources': 'مصادر الذاكرة',
  'settings.profiles.editor.memorySourcesHint': 'مصادر الذاكرة التي يستدعي منها هذا الملف.',
  'settings.profiles.editor.connectors': 'الموصّلات',
  'settings.profiles.editor.connectorsHint': 'حِزم أدوات Composio التي يمكن لهذا الملف استخدامها.',
  'settings.profiles.editor.skills': 'المهارات',
  'settings.profiles.editor.skillsHint': 'سير العمل الذي يمكن لهذا الملف سرده وتشغيله.',
  'settings.profiles.editor.mcpServers': 'خوادم MCP',
  'settings.profiles.editor.mcpServersHint': 'خوادم MCP التي يمكن لهذا الملف الوصول إليها.',
  'settings.profiles.editor.dedicatedMemory': 'ذاكرة مخصصة',
  'settings.profiles.editor.dedicatedMemoryHint':
    'امنح هذا الملف ذاكرته الخاصة بدلاً من مشاركة الذاكرة الافتراضية.',
  'settings.profiles.editor.dedicatedWorkspace': 'مساحة عمل مخصصة',
  'settings.profiles.editor.dedicatedWorkspaceHint':
    'امنح هذا الملف مجلد عمل خاص به لعمليات الملفات والأدوات.',
  'settings.profiles.editor.soulMdFile': 'ملف SOUL.md',
  'settings.profiles.editor.workspaceDir': 'مجلد مساحة العمل',
  'settings.profiles.editor.skillsDir': 'دليل المهارات',
  'settings.profiles.editor.skillsDirHint':
    'ملفات SKILL.md الموضوعة هنا خاصة بهذا الملف الشخصي وحده.',
  'settings.profiles.editor.all': 'الكل',
  'settings.profiles.editor.selected': 'محدّد',
  'settings.profiles.editor.addPlaceholder': 'اكتب معرّفًا ثم اضغط Enter',
  'settings.profiles.editor.removeAria': 'إزالة {item}',
  'settings.profiles.editor.notFound': 'الملف غير موجود',
  'settings.profiles.editor.saving': 'جارٍ الحفظ…',
  'settings.profiles.editor.idRequired': 'لا يمكن أن يكون معرّف الملف فارغًا',
  'agentworld.jobs.applyModal.title': 'التقدم للوظيفة',
  'agentworld.jobs.applyModal.successHeading': 'تم تقديم العرض بنجاح!',
  'agentworld.jobs.applyModal.successBody': 'سيراجع ناشر الوظيفة طلبك.',
  'agentworld.jobs.applyModal.coverLetterLabel': 'خطاب التغطية',
  'agentworld.jobs.applyModal.coverLetterPlaceholder': 'صف خبرتك وسبب ملاءمتك لهذا الدور',
  'agentworld.jobs.applyModal.bidAmountLabel': 'مبلغ العطاء',
  'agentworld.jobs.applyModal.bidAmountPlaceholder': 'مثال: 450 USDC',
  'agentworld.jobs.applyModal.deliveryLabel': 'وقت التسليم المتوقع',
  'agentworld.jobs.applyModal.deliveryPlaceholder': 'مثال: أسبوعان',
  'agentworld.feed.live': 'مباشر',
  'agentworld.jobs.applyModal.cancel': 'إلغاء',
  'agentworld.jobs.applyModal.submit': 'إرسال الطلب',
  'agentworld.jobs.applyModal.submitting': 'جارٍ التقديم…',
  'agentworld.messaging.live': 'مباشر',
  'agentworld.messaging.missingSignalBundle':
    'لم يفعّل هذا المستخدم الرسائل المشفرة بعد. اطلب منه فتح Agent World وتفعيل الرسائل المباشرة الآمنة قبل إرسال رسالة.',
  'agentworld.messaging.notAContact':
    'لا يمكنك مراسلة هذا الشخص حتى يصبح جهة اتصال. أرسل طلب جهة اتصال وحاول مرة أخرى بعد قبوله.',
  'agentworld.messaging.sendContactRequest': 'إرسال طلب جهة اتصال',
  'agentworld.messaging.contactRequestSending': 'جارٍ إرسال الطلب…',
  'agentworld.messaging.contactRequestSent': 'تم إرسال طلب جهة الاتصال. يمكنك مراسلته بعد قبوله.',
  'agentworld.messaging.contactRequestFailed':
    'تعذّر إرسال طلب جهة الاتصال. يُرجى المحاولة مرة أخرى.',

  // User-actionable runtime errors (#3931)
  'userErrors.title': 'إجراء مطلوب',
  'userErrors.dismiss': 'تجاهل',
  'userErrors.action.openBilling': 'فتح الفوترة',
  'userErrors.action.openProviderSettings': 'إعدادات المزود',
  'userErrors.action.openEmbeddingsSettings': 'إعداد التضمينات',
  'userErrors.budgetExceeded.title': 'تم استنفاد الميزانية المُدارة',
  'userErrors.budgetExceeded.body': 'نفدت الميزانية المُدارة. أضف ميزانية أو غيّر خطتك.',
  'userErrors.insufficientCredits.title': 'مطلوب رصيد المزود',
  'userErrors.insufficientCredits.body': 'نفد رصيد المزود. أعد الشحن أو حدّث مفتاح API.',
  'userErrors.apiKeyMissing.title': 'مطلوب مفتاح API',
  'userErrors.apiKeyMissing.body':
    'لا يوجد مفتاح API لمزوّد الذكاء الاصطناعي. أضِفه في إعدادات المزوّد للمتابعة.',
  'userErrors.localModelUnavailable.title': 'النموذج المحلي غير متاح',
  'userErrors.localModelUnavailable.body':
    'لا يمكن الوصول إلى Ollama على النقطة الطرفية المُهيأة، أو أن النموذج المطلوب غير مثبّت عليها. شغّل Ollama ونزّل النموذج على تلك النقطة الطرفية، أو حوّل هذا العمل إلى مزوّد سحابي.',
  'userErrors.scope.chat': 'الدردشة',
  'userErrors.scope.cron': 'مهمة مجدوَلة',
  'userErrors.scope.workspace': 'مساحة العمل',
  'userErrors.memoryBudgetExhausted.title': 'توقفت الذاكرة عن النمو',
  'userErrors.memoryBudgetExhausted.body':
    'انتهت ميزانية التضمينات لديك، لذلك لم يعد المحتوى الجديد يُضاف إلى الذاكرة. أعدّ تضمينات محلية أو أضف مفتاح API الخاص بك للمتابعة.',
  'memoryBudget.approachingTitle': 'الذاكرة تقترب من حد التضمينات',
  'memoryBudget.approachingMessage':
    'لقد استخدمت {pct}% من ميزانية التضمينات. أعدّ تضمينات محلية أو أضف مفتاح API الخاص بك كي تستمر الذاكرة في النمو دون انقطاع.',
  'memoryBudget.exhaustedTitle': 'توقفت الذاكرة عن النمو',
  'memoryBudget.exhaustedMessage':
    'انتهت ميزانية التضمينات لديك، لذلك لم يعد المحتوى الجديد يُضاف إلى الذاكرة. أعدّ تضمينات محلية أو أضف مفتاح API الخاص بك للمتابعة.',
  'memoryBudget.cta': 'إعداد التضمينات',
  'userErrors.scope.memory': 'الذاكرة',
  // Agent World: Identity trading (confirm-before-spend + balance gate)
  'agentWorld.trading.amountLabel': 'المبلغ',
  'agentWorld.trading.networkLabel': 'الشبكة',
  'agentWorld.trading.balanceLabel': 'رصيدك',
  'agentWorld.trading.walletLabel': 'المحفظة',
  'agentWorld.trading.balanceUnknown': 'غير معروف',
  'agentWorld.trading.cancel': 'إلغاء',
  'agentWorld.trading.addFunds': 'إضافة أموال',
  'agentWorld.trading.confirmPay': 'تأكيد والدفع',
  'agentWorld.trading.confirmCommit': 'تأكيد',
  'agentWorld.trading.continue': 'متابعة',
  'agentWorld.trading.submitting': 'جارٍ الإرسال…',
  'agentWorld.trading.placeBid': 'تقديم عرض السعر',
  'agentWorld.trading.submitOffer': 'تقديم العرض',
  'agentWorld.trading.bidTitlePrefix': 'عرض سعر على',
  'agentWorld.trading.offerTitlePrefix': 'عرض لـ',
  'agentWorld.trading.bidReviewTitlePrefix': 'تأكيد عرض السعر على',
  'agentWorld.trading.offerReviewTitlePrefix': 'تأكيد العرض لـ',
  'agentWorld.trading.spendInsufficient':
    'الرصيد غير كافٍ لإتمام هذه الدفعة. أضف أموالاً إلى محفظتك للمتابعة.',
  'agentWorld.trading.spendBroadcastNote': 'ستوقّع محفظتك هذه الدفعة وتبثّها على',
  'agentWorld.trading.commitInsufficientWarning':
    'قد لا يغطي رصيدك هذا الالتزام في حال قبوله. لا يزال بإمكانك تقديمه: لن تُحوّل الأموال إلا عند القبول.',
  'agentWorld.trading.commitSettleNote': 'هذا التزام موقّع: لن تُحوّل الأموال إلا إذا تم قبوله.',
  'agentWorld.trading.commitReviewSubtitle': 'راجع التزامك قبل تقديمه.',
  'agentWorld.trading.balanceUnverified':
    'تعذّر علينا التحقق من رصيد محفظتك. لا يزال بإمكانك المتابعة: يتم التحقق من الدفعة عند تقديمها.',
  'agentWorld.trading.amountTooManyDecimals':
    'يحتوي هذا المبلغ على عدد كبير جدًا من المنازل العشرية.',
  'agentWorld.trading.amountMustBePositive': 'أدخل مبلغًا أكبر من صفر.',
  'agentWorld.trading.amountInvalid': 'أدخل مبلغًا صالحًا.',

  // Code block chrome
  'codeBlock.copy': 'نسخ',
  'codeBlock.copied': 'تم النسخ!',
  'flows.editor.undo': 'تراجع',
  'flows.editor.redo': 'إعادة',
  'flows.editor.onboardingTitle': 'أنشئ سير عملك',
  'flows.editor.onboardingBody':
    'أضِف عقدة من اللوحة على اليسار، ثم اسحب بين النقاط على كل بطاقة لربطها.',
  'flows.palette.search': 'البحث عن العقد…',
  'flows.palette.noResults': 'لا توجد عقد مطابقة',
  'flows.palette.group.triggers': 'المشغّلات',
  'flows.palette.group.actions': 'الإجراءات',
  'flows.palette.group.logic': 'المنطق',
  'flows.list.duplicate': 'تكرار',
  'flows.list.duplicated': 'تم تكرار سير العمل',
  'flows.list.delete': 'حذف',
  'flows.list.deleted': 'تم حذف سير العمل',
  'flows.list.moreActions': 'المزيد من الإجراءات',
  'flows.delete.title': 'حذف سير العمل؟',
  'flows.delete.body': 'سيتم حذف "{name}" وسجل تشغيله نهائيًا. لا يمكن التراجع عن ذلك.',
  'flows.delete.cancel': 'إلغاء',
  'flows.delete.confirm': 'حذف',
  'flows.delete.deleting': 'جارٍ الحذف…',
  'flows.canvas.renameLabel': 'إعادة تسمية سير العمل',
  'memorySources.codingSessions.title': 'جلسات وكلاء البرمجة',
  'memorySources.codingSessions.description':
    'حوّل قرارات وتصحيحات Codex وClaude Code إلى ذاكرة شخصية خاصة.',
  'memorySources.codingSessions.importAll': 'استيراد كل الجلسات',
  'memorySources.codingSessions.draining': 'جارٍ الاستيراد… الدفعة {passes}',
  'memorySources.codingSessions.stop': 'إيقاف',
  'memorySources.codingSessions.progress': 'تم استيراد {processed} جلسة · {observations} ملاحظة',
  'memorySources.codingSessions.remaining': 'يتبقى نحو {remaining}',
  'memorySources.codingSessions.stopped': 'تم إيقاف الاستيراد مؤقتًا',
  'memorySources.codingSessions.stoppedMessage':
    'تم استيراد {processed} جلسة. شغّل الاستيراد مرة أخرى لمتابعة الـ {remaining} المتبقية.',
  'memorySources.codingSessions.claude': 'كلود كود',
  'memorySources.codingSessions.codex': 'Codex',
  'memorySources.codingSessions.counts': '{files} جلسات · {evidence} مداخلات بشرية',
  'memorySources.codingSessions.notFound': 'لم يُعثر على سجل محلي',
  'memorySources.codingSessions.scanning': 'جارٍ فحص سجل الجلسات المحلي…',
  'memorySources.codingSessions.truncated': 'اقتصر الفحص على أول 1,000 ملف جلسة.',
  'memorySources.codingSessions.complete': 'تم استيعاب جلسات البرمجة',
  'memorySources.codingSessions.completeMessage':
    'أنتجت {processed} جلسات {observations} ملاحظات شخصية.',
  'memorySources.codingSessions.partialFailure':
    'فشلت {failed} جلسات بينما تمت معالجة {processed}. شغّل الاستيعاب مرة أخرى لإعادة المحاولة.',
  'memorySources.codingSessions.failed': 'فشل استيعاب جلسات البرمجة',
  'flows.canvas.sidePanelToggle': 'اللوحة الجانبية',
  'flows.canvas.legendTab': 'يدوي',

  // Privacy status pill + per-action egress disclosure (#4437 / S3)
  'privacy.status.ariaLabel': 'حالة الخصوصية',
  'privacy.status.external': 'خارج الجهاز',
  'privacy.status.local': 'على الجهاز',
  // Data Sync layered pipeline status (GH-4690)
  'sync.pipeline.ingestedOnly': 'تم الاستيعاب فقط',
  'sync.pipeline.storedWithoutVectors': 'مخزَّن بدون متجهات. البحث الدلالي غير متاح.',
  'sync.pipeline.signInToEnable': 'سجّل الدخول للتفعيل',
  'sync.pipeline.extractionFailed': 'فشل استخراج بنية الذاكرة. قد يكون الويكي غير مكتمل.',
  'sync.pipeline.treeDegraded': 'شجرة الذاكرة متدهورة. قد يُرجع الاسترجاع نتائج قديمة.',
  'sync.pipeline.viewHealth': 'عرض حالة الذاكرة',
  'notifications.configRecovered.title': 'تمت استعادة ملف الإعدادات',
  'notifications.configRecovered.body':
    'تعذّرت قراءة ملف الإعدادات، لذا تمت استعادته من نسخة احتياطية أو إعادة تعيينه إلى الإعدادات الافتراضية. تم الاحتفاظ بالملف غير القابل للقراءة باللاحقة ".corrupted" في حال احتجت إليه.',
};

export default messages;
